webpackJsonp([35783957827783],{

/***/ 226:
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__dirname) {'use strict';
	
	module.exports = {
	    siteMetadata: {
	        title: 'Papahānaumokuākea Project'
	    },
	    plugins: [{
	        resolve: 'gatsby-source-filesystem',
	        options: {
	            path: __dirname + '/src/pages',
	            name: 'pages'
	        }
	    }, {
	        resolve: 'gatsby-source-filesystem',
	        options: {
	            name: 'img',
	            path: __dirname + '/src/img'
	        }
	    }, {
	        resolve: 'gatsby-plugin-google-analytics',
	        options: {
	            trackingId: "UA-117103650-1",
	            // Puts tracking script in the head instead of the body
	            head: true,
	            // Setting this parameter is optional
	            anonymize: true,
	            // Setting this parameter is also optional
	            respectDNT: true
	        }
	    }, {
	        resolve: 'gatsby-plugin-mailchimp',
	        options: {
	            endpoint: 'https://patrickteachingart.us11.list-manage.com/subscribe/post?u=00bb906f4310de403db0d029c&amp;id=a3f38ddde1' // see instructions section below
	        }
	    }, 'gatsby-plugin-react-helmet', 'gatsby-transformer-sharp', 'gatsby-plugin-sharp', 'gatsby-plugin-styled-components']
	};
	/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ }),

/***/ 106:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var emptyObject = __webpack_require__(39);
	var _invariant = __webpack_require__(2);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ }),

/***/ 321:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * This is the web browser implementation of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = __webpack_require__(322);
	exports.log = log;
	exports.formatArgs = formatArgs;
	exports.save = save;
	exports.load = load;
	exports.useColors = useColors;
	exports.storage = 'undefined' != typeof chrome
	               && 'undefined' != typeof chrome.storage
	                  ? chrome.storage.local
	                  : localstorage();
	
	/**
	 * Colors.
	 */
	
	exports.colors = [
	  'lightseagreen',
	  'forestgreen',
	  'goldenrod',
	  'dodgerblue',
	  'darkorchid',
	  'crimson'
	];
	
	/**
	 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
	 * and the Firebug extension (any Firefox version) are known
	 * to support "%c" CSS customizations.
	 *
	 * TODO: add a `localStorage` variable to explicitly enable/disable colors
	 */
	
	function useColors() {
	  // NB: In an Electron preload script, document will be defined but not fully
	  // initialized. Since we know we're in Chrome, we'll just detect this case
	  // explicitly
	  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
	    return true;
	  }
	
	  // is webkit? http://stackoverflow.com/a/16459606/376773
	  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
	  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
	    // is firebug? http://stackoverflow.com/a/398120/376773
	    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
	    // is firefox >= v31?
	    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
	    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
	    // double check webkit in userAgent just in case we are in a worker
	    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
	}
	
	/**
	 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
	 */
	
	exports.formatters.j = function(v) {
	  try {
	    return JSON.stringify(v);
	  } catch (err) {
	    return '[UnexpectedJSONParseError]: ' + err.message;
	  }
	};
	
	
	/**
	 * Colorize log arguments if enabled.
	 *
	 * @api public
	 */
	
	function formatArgs(args) {
	  var useColors = this.useColors;
	
	  args[0] = (useColors ? '%c' : '')
	    + this.namespace
	    + (useColors ? ' %c' : ' ')
	    + args[0]
	    + (useColors ? '%c ' : ' ')
	    + '+' + exports.humanize(this.diff);
	
	  if (!useColors) return;
	
	  var c = 'color: ' + this.color;
	  args.splice(1, 0, c, 'color: inherit')
	
	  // the final "%c" is somewhat tricky, because there could be other
	  // arguments passed either before or after the %c, so we need to
	  // figure out the correct index to insert the CSS into
	  var index = 0;
	  var lastC = 0;
	  args[0].replace(/%[a-zA-Z%]/g, function(match) {
	    if ('%%' === match) return;
	    index++;
	    if ('%c' === match) {
	      // we only are interested in the *last* %c
	      // (the user may have provided their own)
	      lastC = index;
	    }
	  });
	
	  args.splice(lastC, 0, c);
	}
	
	/**
	 * Invokes `console.log()` when available.
	 * No-op when `console.log` is not a "function".
	 *
	 * @api public
	 */
	
	function log() {
	  // this hackery is required for IE8/9, where
	  // the `console.log` function doesn't have 'apply'
	  return 'object' === typeof console
	    && console.log
	    && Function.prototype.apply.call(console.log, console, arguments);
	}
	
	/**
	 * Save `namespaces`.
	 *
	 * @param {String} namespaces
	 * @api private
	 */
	
	function save(namespaces) {
	  try {
	    if (null == namespaces) {
	      exports.storage.removeItem('debug');
	    } else {
	      exports.storage.debug = namespaces;
	    }
	  } catch(e) {}
	}
	
	/**
	 * Load `namespaces`.
	 *
	 * @return {String} returns the previously persisted debug modes
	 * @api private
	 */
	
	function load() {
	  var r;
	  try {
	    r = exports.storage.debug;
	  } catch(e) {}
	
	  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
	  if (!r && typeof process !== 'undefined' && 'env' in process) {
	    r = ({"NODE_ENV":"production","PUBLIC_DIR":"/opt/build/repo/public"}).DEBUG;
	  }
	
	  return r;
	}
	
	/**
	 * Enable namespaces listed in `localStorage.debug` initially.
	 */
	
	exports.enable(load());
	
	/**
	 * Localstorage attempts to return the localstorage.
	 *
	 * This is necessary because safari throws
	 * when a user disables cookies/localstorage
	 * and you attempt to access it.
	 *
	 * @return {LocalStorage}
	 * @api private
	 */
	
	function localstorage() {
	  try {
	    return window.localStorage;
	  } catch (e) {}
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),

/***/ 322:
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * This is the common logic for both the Node.js and web browser
	 * implementations of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
	exports.coerce = coerce;
	exports.disable = disable;
	exports.enable = enable;
	exports.enabled = enabled;
	exports.humanize = __webpack_require__(370);
	
	/**
	 * The currently active debug mode names, and names to skip.
	 */
	
	exports.names = [];
	exports.skips = [];
	
	/**
	 * Map of special "%n" handling functions, for the debug "format" argument.
	 *
	 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
	 */
	
	exports.formatters = {};
	
	/**
	 * Previous log timestamp.
	 */
	
	var prevTime;
	
	/**
	 * Select a color.
	 * @param {String} namespace
	 * @return {Number}
	 * @api private
	 */
	
	function selectColor(namespace) {
	  var hash = 0, i;
	
	  for (i in namespace) {
	    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
	    hash |= 0; // Convert to 32bit integer
	  }
	
	  return exports.colors[Math.abs(hash) % exports.colors.length];
	}
	
	/**
	 * Create a debugger with the given `namespace`.
	 *
	 * @param {String} namespace
	 * @return {Function}
	 * @api public
	 */
	
	function createDebug(namespace) {
	
	  function debug() {
	    // disabled?
	    if (!debug.enabled) return;
	
	    var self = debug;
	
	    // set `diff` timestamp
	    var curr = +new Date();
	    var ms = curr - (prevTime || curr);
	    self.diff = ms;
	    self.prev = prevTime;
	    self.curr = curr;
	    prevTime = curr;
	
	    // turn the `arguments` into a proper Array
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	
	    args[0] = exports.coerce(args[0]);
	
	    if ('string' !== typeof args[0]) {
	      // anything else let's inspect with %O
	      args.unshift('%O');
	    }
	
	    // apply any `formatters` transformations
	    var index = 0;
	    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
	      // if we encounter an escaped % then don't increase the array index
	      if (match === '%%') return match;
	      index++;
	      var formatter = exports.formatters[format];
	      if ('function' === typeof formatter) {
	        var val = args[index];
	        match = formatter.call(self, val);
	
	        // now we need to remove `args[index]` since it's inlined in the `format`
	        args.splice(index, 1);
	        index--;
	      }
	      return match;
	    });
	
	    // apply env-specific formatting (colors, etc.)
	    exports.formatArgs.call(self, args);
	
	    var logFn = debug.log || exports.log || console.log.bind(console);
	    logFn.apply(self, args);
	  }
	
	  debug.namespace = namespace;
	  debug.enabled = exports.enabled(namespace);
	  debug.useColors = exports.useColors();
	  debug.color = selectColor(namespace);
	
	  // env-specific initialization logic for debug instances
	  if ('function' === typeof exports.init) {
	    exports.init(debug);
	  }
	
	  return debug;
	}
	
	/**
	 * Enables a debug mode by namespaces. This can include modes
	 * separated by a colon and wildcards.
	 *
	 * @param {String} namespaces
	 * @api public
	 */
	
	function enable(namespaces) {
	  exports.save(namespaces);
	
	  exports.names = [];
	  exports.skips = [];
	
	  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
	  var len = split.length;
	
	  for (var i = 0; i < len; i++) {
	    if (!split[i]) continue; // ignore empty strings
	    namespaces = split[i].replace(/\*/g, '.*?');
	    if (namespaces[0] === '-') {
	      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
	    } else {
	      exports.names.push(new RegExp('^' + namespaces + '$'));
	    }
	  }
	}
	
	/**
	 * Disable debug output.
	 *
	 * @api public
	 */
	
	function disable() {
	  exports.enable('');
	}
	
	/**
	 * Returns true if the given mode name is enabled, false otherwise.
	 *
	 * @param {String} name
	 * @return {Boolean}
	 * @api public
	 */
	
	function enabled(name) {
	  var i, len;
	  for (i = 0, len = exports.skips.length; i < len; i++) {
	    if (exports.skips[i].test(name)) {
	      return false;
	    }
	  }
	  for (i = 0, len = exports.names.length; i < len; i++) {
	    if (exports.names[i].test(name)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * Coerce `val`.
	 *
	 * @param {Mixed} val
	 * @return {Mixed}
	 * @api private
	 */
	
	function coerce(val) {
	  if (val instanceof Error) return val.stack || val.message;
	  return val;
	}


/***/ }),

/***/ 107:
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(109);
	var isArguments = __webpack_require__(108);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),

/***/ 108:
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),

/***/ 109:
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),

/***/ 329:
/***/ (function(module, exports) {

	"use strict";
	
	var tester = /^[-!#$%&'*+\/0-9=?A-Z^_a-z{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/;
	// Thanks to:
	// http://fightingforalostcause.net/misc/2006/compare-email-regex.php
	// http://thedailywtf.com/Articles/Validating_Email_Addresses.aspx
	// http://stackoverflow.com/questions/201323/what-is-the-best-regular-expression-for-validating-email-addresses/201378#201378
	exports.validate = function(email)
	{
		if (!email)
			return false;
			
		if(email.length>254)
			return false;
	
		var valid = tester.test(email);
		if(!valid)
			return false;
	
		// Further checking of some things regex can't handle
		var parts = email.split("@");
		if(parts[0].length>64)
			return false;
	
		var domainParts = parts[1].split(".");
		if(domainParts.some(function(part) { return part.length>63; }))
			return false;
	
		return true;
	}

/***/ }),

/***/ 111:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 355:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _gatsbyConfig = __webpack_require__(226);
	
	var _gatsbyConfig2 = _interopRequireDefault(_gatsbyConfig);
	
	var _jsonp = __webpack_require__(175);
	
	var _jsonp2 = _interopRequireDefault(_jsonp);
	
	var _emailValidator = __webpack_require__(329);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * make a jsonp request to user's mailchimp list
	 * url is a concatenated string of user's gatsby-config.js
	 * options, along with any MC list fields as query params
	 */
	
	var subscribeEmailToMailchimp = function subscribeEmailToMailchimp(url) {
	  return new Promise(function (resolve, reject) {
	    // `param` object avoids CORS issues
	    return (0, _jsonp2.default)(url, { param: 'c' }, function (err, data) {
	      if (err) reject(err);
	      if (data) resolve(data);
	    });
	  });
	};
	
	/*
	 * parse the plugin options to use in our jsonp request
	 */
	
	var getPluginOptions = function getPluginOptions() {
	  // find gatsby-mailchimp plugin options (MC list settings)
	  var options = _gatsbyConfig2.default.plugins.find(function (plugin) {
	    return plugin.resolve === 'gatsby-plugin-mailchimp';
	  }).options;
	
	  var isString = typeof options.endpoint === 'string';
	  if (!isString) {
	    throw 'Mailchimp endpoint required and must be of type string. See repo README for more info.';
	  }
	  return options;
	};
	
	/*
	 * build a query string of MC list fields
	 * ex: '&KEY1=value1&KEY2=value2'
	 * (toUpperCase because that's what MC requires)
	 */
	
	var convertListFields = function convertListFields(fields) {
	  var queryParams = '';
	  for (var field in fields) {
	    queryParams = queryParams.concat('&' + field.toUpperCase() + '=' + fields[field]);
	  }
	  return queryParams;
	};
	
	/*
	 * accept email (String) and additional, optional
	 * Mailchimp list fields (Object)
	 * then make jsonp req with data
	 */
	
	var addToMailchimp = function addToMailchimp(email, fields) {
	  var isEmailValid = (0, _emailValidator.validate)(email);
	  var emailEncoded = encodeURIComponent(email);
	  if (!isEmailValid) {
	    throw 'gatsy-plugin-mailchimp: email must be of type string and a valid email address. See README for more information.';
	  }
	
	  // generate Mailchimp endpoint for jsonp request
	  // note, we change `/post` to `/post-json`
	  // otherwise, Mailchomp returns an error
	
	  var _getPluginOptions = getPluginOptions(),
	      endpoint = _getPluginOptions.endpoint;
	
	  endpoint = endpoint.replace(/\/post/g, '/post-json');
	
	  var queryParams = '&EMAIL=' + emailEncoded + convertListFields(fields);
	  var url = '' + endpoint + queryParams;
	  return subscribeEmailToMailchimp(url);
	};
	
	exports.default = addToMailchimp;

/***/ }),

/***/ 70:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.hoistNonReactStatics = factory());
	}(this, (function () {
	    'use strict';
	    
	    var REACT_STATICS = {
	        childContextTypes: true,
	        contextTypes: true,
	        defaultProps: true,
	        displayName: true,
	        getDefaultProps: true,
	        getDerivedStateFromProps: true,
	        mixins: true,
	        propTypes: true,
	        type: true
	    };
	    
	    var KNOWN_STATICS = {
	        name: true,
	        length: true,
	        prototype: true,
	        caller: true,
	        callee: true,
	        arguments: true,
	        arity: true
	    };
	    
	    var defineProperty = Object.defineProperty;
	    var getOwnPropertyNames = Object.getOwnPropertyNames;
	    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	    var getPrototypeOf = Object.getPrototypeOf;
	    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	    
	    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	            
	            if (objectPrototype) {
	                var inheritedComponent = getPrototypeOf(sourceComponent);
	                if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	                }
	            }
	            
	            var keys = getOwnPropertyNames(sourceComponent);
	            
	            if (getOwnPropertySymbols) {
	                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	            }
	            
	            for (var i = 0; i < keys.length; ++i) {
	                var key = keys[i];
	                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                    try { // Avoid failures from read-only properties
	                        defineProperty(targetComponent, key, descriptor);
	                    } catch (e) {}
	                }
	            }
	            
	            return targetComponent;
	        }
	        
	        return targetComponent;
	    };
	})));


/***/ }),

/***/ 175:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies
	 */
	
	var debug = __webpack_require__(321)('jsonp');
	
	/**
	 * Module exports.
	 */
	
	module.exports = jsonp;
	
	/**
	 * Callback index.
	 */
	
	var count = 0;
	
	/**
	 * Noop function.
	 */
	
	function noop(){}
	
	/**
	 * JSONP handler
	 *
	 * Options:
	 *  - param {String} qs parameter (`callback`)
	 *  - prefix {String} qs parameter (`__jp`)
	 *  - name {String} qs parameter (`prefix` + incr)
	 *  - timeout {Number} how long after a timeout error is emitted (`60000`)
	 *
	 * @param {String} url
	 * @param {Object|Function} optional options / callback
	 * @param {Function} optional callback
	 */
	
	function jsonp(url, opts, fn){
	  if ('function' == typeof opts) {
	    fn = opts;
	    opts = {};
	  }
	  if (!opts) opts = {};
	
	  var prefix = opts.prefix || '__jp';
	
	  // use the callback name that was passed if one was provided.
	  // otherwise generate a unique name by incrementing our counter.
	  var id = opts.name || (prefix + (count++));
	
	  var param = opts.param || 'callback';
	  var timeout = null != opts.timeout ? opts.timeout : 60000;
	  var enc = encodeURIComponent;
	  var target = document.getElementsByTagName('script')[0] || document.head;
	  var script;
	  var timer;
	
	
	  if (timeout) {
	    timer = setTimeout(function(){
	      cleanup();
	      if (fn) fn(new Error('Timeout'));
	    }, timeout);
	  }
	
	  function cleanup(){
	    if (script.parentNode) script.parentNode.removeChild(script);
	    window[id] = noop;
	    if (timer) clearTimeout(timer);
	  }
	
	  function cancel(){
	    if (window[id]) {
	      cleanup();
	    }
	  }
	
	  window[id] = function(data){
	    debug('jsonp got', data);
	    cleanup();
	    if (fn) fn(null, data);
	  };
	
	  // add qs component
	  url += (~url.indexOf('?') ? '&' : '?') + param + '=' + enc(id);
	  url = url.replace('?&', '?');
	
	  debug('jsonp req "%s"', url);
	
	  // create script
	  script = document.createElement('script');
	  script.src = url;
	  target.parentNode.insertBefore(script, target);
	
	  return cancel;
	}


/***/ }),

/***/ 370:
/***/ (function(module, exports) {

	/**
	 * Helpers.
	 */
	
	var s = 1000;
	var m = s * 60;
	var h = m * 60;
	var d = h * 24;
	var y = d * 365.25;
	
	/**
	 * Parse or format the given `val`.
	 *
	 * Options:
	 *
	 *  - `long` verbose formatting [false]
	 *
	 * @param {String|Number} val
	 * @param {Object} [options]
	 * @throws {Error} throw an error if val is not a non-empty string or a number
	 * @return {String|Number}
	 * @api public
	 */
	
	module.exports = function(val, options) {
	  options = options || {};
	  var type = typeof val;
	  if (type === 'string' && val.length > 0) {
	    return parse(val);
	  } else if (type === 'number' && isNaN(val) === false) {
	    return options.long ? fmtLong(val) : fmtShort(val);
	  }
	  throw new Error(
	    'val is not a non-empty string or a valid number. val=' +
	      JSON.stringify(val)
	  );
	};
	
	/**
	 * Parse the given `str` and return milliseconds.
	 *
	 * @param {String} str
	 * @return {Number}
	 * @api private
	 */
	
	function parse(str) {
	  str = String(str);
	  if (str.length > 100) {
	    return;
	  }
	  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
	    str
	  );
	  if (!match) {
	    return;
	  }
	  var n = parseFloat(match[1]);
	  var type = (match[2] || 'ms').toLowerCase();
	  switch (type) {
	    case 'years':
	    case 'year':
	    case 'yrs':
	    case 'yr':
	    case 'y':
	      return n * y;
	    case 'days':
	    case 'day':
	    case 'd':
	      return n * d;
	    case 'hours':
	    case 'hour':
	    case 'hrs':
	    case 'hr':
	    case 'h':
	      return n * h;
	    case 'minutes':
	    case 'minute':
	    case 'mins':
	    case 'min':
	    case 'm':
	      return n * m;
	    case 'seconds':
	    case 'second':
	    case 'secs':
	    case 'sec':
	    case 's':
	      return n * s;
	    case 'milliseconds':
	    case 'millisecond':
	    case 'msecs':
	    case 'msec':
	    case 'ms':
	      return n;
	    default:
	      return undefined;
	  }
	}
	
	/**
	 * Short format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtShort(ms) {
	  if (ms >= d) {
	    return Math.round(ms / d) + 'd';
	  }
	  if (ms >= h) {
	    return Math.round(ms / h) + 'h';
	  }
	  if (ms >= m) {
	    return Math.round(ms / m) + 'm';
	  }
	  if (ms >= s) {
	    return Math.round(ms / s) + 's';
	  }
	  return ms + 'ms';
	}
	
	/**
	 * Long format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtLong(ms) {
	  return plural(ms, d, 'day') ||
	    plural(ms, h, 'hour') ||
	    plural(ms, m, 'minute') ||
	    plural(ms, s, 'second') ||
	    ms + ' ms';
	}
	
	/**
	 * Pluralization helper.
	 */
	
	function plural(ms, n, name) {
	  if (ms < n) {
	    return;
	  }
	  if (ms < n * 1.5) {
	    return Math.floor(ms / n) + ' ' + name;
	  }
	  return Math.ceil(ms / n) + ' ' + name + 's';
	}


/***/ }),

/***/ 4:
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),

/***/ 27:
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),

/***/ 133:
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(10);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(140);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(107);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(134);
	
	var _HelmetConstants = __webpack_require__(58);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ 58:
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 134:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(4);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(58);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 135:
/***/ (function(module, exports) {

	/** @license React v16.6.1
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';Object.defineProperty(exports,"__esModule",{value:!0});
	var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,r=b?Symbol.for("react.memo"):
	60115,t=b?Symbol.for("react.lazy"):60116;function u(a){if("object"===typeof a&&null!==a){var q=a.$$typeof;switch(q){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return q}}case d:return q}}}function v(a){return u(a)===m}exports.typeOf=u;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;
	exports.Profiler=g;exports.Portal=d;exports.StrictMode=f;exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n)};exports.isAsyncMode=function(a){return v(a)||u(a)===l};exports.isConcurrentMode=v;exports.isContextConsumer=function(a){return u(a)===k};exports.isContextProvider=function(a){return u(a)===h};
	exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return u(a)===n};exports.isFragment=function(a){return u(a)===e};exports.isProfiler=function(a){return u(a)===g};exports.isPortal=function(a){return u(a)===d};exports.isStrictMode=function(a){return u(a)===f};


/***/ }),

/***/ 136:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(135);
	} else {
	  module.exports = require('./cjs/react-is.development.js');
	}


/***/ }),

/***/ 437:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// a basic form
	var SimpleForm = function SimpleForm(_ref) {
	  var status = _ref.status,
	      message = _ref.message,
	      className = _ref.className,
	      style = _ref.style,
	      onSubmitted = _ref.onSubmitted;
	
	  var input = void 0;
	  var submit = function submit() {
	    return input && input.value.indexOf("@") > -1 && onSubmitted({
	      EMAIL: input.value
	    });
	  };
	
	  return _react2.default.createElement(
	    "div",
	    { className: className, style: style },
	    status === "sending" && _react2.default.createElement(
	      "div",
	      { style: { color: "blue" } },
	      "sending..."
	    ),
	    status === "error" && _react2.default.createElement("div", {
	      style: { color: "red" },
	      dangerouslySetInnerHTML: { __html: message }
	    }),
	    status === "success" && _react2.default.createElement("div", {
	      style: { color: "green" },
	      dangerouslySetInnerHTML: { __html: message }
	    }),
	    _react2.default.createElement("input", {
	      ref: function ref(node) {
	        return input = node;
	      },
	      type: "email",
	      placeholder: "Your email"
	    }),
	    _react2.default.createElement(
	      "button",
	      { onClick: submit },
	      "Submit"
	    )
	  );
	};
	
	exports.default = SimpleForm;
	module.exports = exports["default"];

/***/ }),

/***/ 438:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(10);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _jsonp = __webpack_require__(175);
	
	var _jsonp2 = _interopRequireDefault(_jsonp);
	
	var _toQuerystring = __webpack_require__(481);
	
	var _toQuerystring2 = _interopRequireDefault(_toQuerystring);
	
	var _SimpleForm = __webpack_require__(437);
	
	var _SimpleForm2 = _interopRequireDefault(_SimpleForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getAjaxUrl = function getAjaxUrl(url) {
	  return url.replace("/post?", "/post-json?");
	};
	
	var MailchimpSubscribe = function (_React$Component) {
	  _inherits(MailchimpSubscribe, _React$Component);
	
	  function MailchimpSubscribe() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MailchimpSubscribe);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      status: null,
	      message: null
	    }, _this.subscribe = function (data) {
	      var params = (0, _toQuerystring2.default)(data);
	      var url = getAjaxUrl(_this.props.url) + "&" + params;
	      _this.setState({
	        status: "sending",
	        message: null
	      }, function () {
	        return (0, _jsonp2.default)(url, {
	          param: "c"
	        }, function (err, data) {
	          console.log("err, data", err, data);
	          if (err) {
	            _this.setState({
	              status: "error",
	              message: err
	            });
	          } else if (data.result !== "success") {
	            _this.setState({
	              status: "error",
	              message: data.msg
	            });
	          } else {
	            _this.setState({
	              status: "success",
	              message: data.msg
	            });
	          }
	        });
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  MailchimpSubscribe.prototype.render = function render() {
	    return this.props.render({
	      subscribe: this.subscribe,
	      status: this.state.status,
	      message: this.state.message
	    });
	  };
	
	  return MailchimpSubscribe;
	}(_react2.default.Component);
	
	MailchimpSubscribe.propTypes =  false ? {
	  render: _propTypes2.default.func,
	  url: _propTypes2.default.string.isRequired
	} : {};
	
	MailchimpSubscribe.defaultProps = {
	  render: function render(_ref) {
	    var subscribe = _ref.subscribe,
	        status = _ref.status,
	        message = _ref.message;
	    return _react2.default.createElement(_SimpleForm2.default, {
	      status: status,
	      message: message,
	      onSubmitted: function onSubmitted(formData) {
	        return subscribe(formData);
	      }
	    });
	  }
	};
	
	exports.default = MailchimpSubscribe;
	module.exports = exports["default"];

/***/ }),

/***/ 140:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _exenv = __webpack_require__(111);
	
	var _exenv2 = _interopRequireDefault(_exenv);
	
	var _shallowequal = __webpack_require__(141);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	module.exports = function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !(0, _shallowequal2.default)(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(_react.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = _exenv2.default.canUseDOM;
	
	
	    return SideEffect;
	  };
	};

/***/ }),

/***/ 460:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(10);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var pendingCalls = [];
	var initialized = false;
	
	var soundManager = void 0;
	// Allow server side rendering
	if (typeof window !== 'undefined') {
	  if (false) {
	    var _require = require('soundmanager2');
	
	    soundManager = _require.soundManager;
	  } else {
	    var _require2 = __webpack_require__(480);
	
	    soundManager = _require2.soundManager;
	  }
	
	  soundManager.onready(function () {
	    pendingCalls.slice().forEach(function (cb) {
	      return cb();
	    });
	  });
	}
	
	function _createSound(options, cb) {
	  if (soundManager.ok()) {
	    cb(soundManager.createSound(options));
	    return function () {};
	  } else {
	    if (!initialized) {
	      initialized = true;
	      soundManager.beginDelayedInit();
	    }
	
	    var call = function call() {
	      cb(soundManager.createSound(options));
	    };
	
	    pendingCalls.push(call);
	
	    return function () {
	      pendingCalls.splice(pendingCalls.indexOf(call), 1);
	    };
	  }
	}
	
	function noop() {}
	
	var playStatuses = {
	  PLAYING: 'PLAYING',
	  STOPPED: 'STOPPED',
	  PAUSED: 'PAUSED'
	};
	
	var Sound = function (_React$Component) {
	  _inherits(Sound, _React$Component);
	
	  function Sound() {
	    _classCallCheck(this, Sound);
	
	    return _possibleConstructorReturn(this, (Sound.__proto__ || Object.getPrototypeOf(Sound)).apply(this, arguments));
	  }
	
	  _createClass(Sound, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.createSound(function (sound) {
	        return _this2.updateSound(sound);
	      });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.removeSound();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var _this3 = this;
	
	      if (this.props.url !== prevProps.url) {
	        this.createSound(function (sound) {
	          return _this3.updateSound(sound, prevProps);
	        });
	      } else {
	        this.updateSound(this.sound);
	      }
	    }
	  }, {
	    key: 'updateSound',
	    value: function updateSound(sound) {
	      var prevProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      if (!sound) {
	        return;
	      }
	
	      if (this.props.playStatus === playStatuses.PLAYING) {
	        if (sound.playState === 0) {
	          sound.play();
	        }
	
	        if (sound.paused) {
	          sound.resume();
	        }
	      } else if (this.props.playStatus === playStatuses.STOPPED) {
	        if (sound.playState !== 0) {
	          sound.stop();
	        }
	      } else {
	        // this.props.playStatus === playStatuses.PAUSED
	        if (!sound.paused) {
	          sound.pause();
	        }
	      }
	
	      if (this.props.playFromPosition != null) {
	        if (this.props.playFromPosition !== prevProps.playFromPosition) {
	          sound.setPosition(this.props.playFromPosition);
	        }
	      }
	
	      if (this.props.position != null) {
	        if (sound.position !== this.props.position && Math.round(sound.position) !== Math.round(this.props.position)) {
	
	          sound.setPosition(this.props.position);
	        }
	      }
	
	      if (this.props.volume !== prevProps.volume) {
	        sound.setVolume(this.props.volume);
	      }
	
	      if (this.props.playbackRate !== prevProps.playbackRate) {
	        sound.setPlaybackRate(this.props.playbackRate);
	      }
	    }
	  }, {
	    key: 'createSound',
	    value: function createSound(callback) {
	      var _this4 = this;
	
	      this.removeSound();
	
	      var instance = this;
	
	      if (!this.props.url) {
	        return;
	      }
	
	      this.stopCreatingSound = _createSound({
	        url: this.props.url,
	        autoLoad: this.props.autoLoad,
	        volume: this.props.volume,
	        position: this.props.playFromPosition || this.props.position || 0,
	        playbackRate: this.props.playbackRate,
	        whileloading: function whileloading() {
	          instance.props.onLoading(this);
	        },
	        whileplaying: function whileplaying() {
	          instance.props.onPlaying(this);
	        },
	        onerror: function onerror(errorCode, description) {
	          instance.props.onError(errorCode, description, this);
	        },
	        onload: function onload() {
	          instance.props.onLoad(this);
	        },
	        onpause: function onpause() {
	          instance.props.onPause(this);
	        },
	        onresume: function onresume() {
	          instance.props.onResume(this);
	        },
	        onstop: function onstop() {
	          instance.props.onStop(this);
	        },
	        onfinish: function onfinish() {
	          if (instance.props.loop && instance.props.playStatus === playStatuses.PLAYING) {
	            instance.sound.play();
	          } else {
	            instance.props.onFinishedPlaying();
	          }
	        },
	        onbufferchange: function onbufferchange() {
	          instance.props.onBufferChange(this.isBuffering);
	        }
	      }, function (sound) {
	        _this4.sound = sound;
	        callback(sound);
	      });
	    }
	  }, {
	    key: 'removeSound',
	    value: function removeSound() {
	      if (this.stopCreatingSound) {
	        this.stopCreatingSound();
	        delete this.stopCreatingSound;
	      }
	
	      if (this.sound) {
	        try {
	          this.sound.destruct();
	        } catch (e) {} // eslint-disable-line
	
	        delete this.sound;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return Sound;
	}(_react2.default.Component);
	
	Sound.status = playStatuses;
	Sound.propTypes = {
	  url: _propTypes2.default.string.isRequired,
	  playStatus: _propTypes2.default.oneOf(Object.keys(playStatuses)).isRequired,
	  position: _propTypes2.default.number,
	  playFromPosition: _propTypes2.default.number,
	  volume: _propTypes2.default.number,
	  playbackRate: _propTypes2.default.number,
	  onError: _propTypes2.default.func,
	  onLoading: _propTypes2.default.func,
	  onLoad: _propTypes2.default.func,
	  onPlaying: _propTypes2.default.func,
	  onPause: _propTypes2.default.func,
	  onResume: _propTypes2.default.func,
	  onStop: _propTypes2.default.func,
	  onFinishedPlaying: _propTypes2.default.func,
	  onBufferChange: _propTypes2.default.func,
	  autoLoad: _propTypes2.default.bool,
	  loop: _propTypes2.default.bool
	};
	Sound.defaultProps = {
	  volume: 100,
	  playbackRate: 1,
	  onError: noop,
	  onLoading: noop,
	  onPlaying: noop,
	  onLoad: noop,
	  onPause: noop,
	  onResume: noop,
	  onStop: noop,
	  onFinishedPlaying: noop,
	  onBufferChange: noop,
	  autoLoad: false,
	  loop: false
	};
	exports.default = Sound;

/***/ }),

/***/ 330:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 475:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* ===============================
	                                                                                                                                                                                                                                                                   * Rodal v1.6.1 https://chenjiahan.github.com/rodal
	                                                                                                                                                                                                                                                                   * =============================== */
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(10);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// env
	var inBrowser = typeof window !== 'undefined';
	var UA = inBrowser && window.navigator.userAgent.toLowerCase();
	var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
	
	var Dialog = function Dialog(props) {
	    var animation = (props.animationType === 'enter' ? props.enterAnimation : props.leaveAnimation) || props.animation;
	    var className = 'rodal-dialog rodal-' + animation + '-' + props.animationType;
	    var CloseButton = props.showCloseButton ? _react2.default.createElement('span', { className: 'rodal-close', onClick: props.onClose }) : null;
	    var width = props.width,
	        height = props.height,
	        measure = props.measure,
	        duration = props.duration,
	        customStyles = props.customStyles;
	
	    var style = {
	        width: width + measure,
	        height: height + measure,
	        animationDuration: duration + 'ms',
	        WebkitAnimationDuration: duration + 'ms'
	    };
	    var mergedStyles = _extends({}, style, customStyles);
	
	    return _react2.default.createElement(
	        'div',
	        { style: mergedStyles, className: className },
	        props.children,
	        CloseButton
	    );
	};
	
	var Rodal = function (_React$Component) {
	    _inherits(Rodal, _React$Component);
	
	    function Rodal() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Rodal);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Rodal.__proto__ || Object.getPrototypeOf(Rodal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            isShow: false,
	            animationType: 'leave'
	        }, _this.onKeyUp = function (event) {
	            if (_this.props.closeOnEsc && event.keyCode === 27) {
	                _this.props.onClose();
	            }
	        }, _this.animationEnd = function (event) {
	            if (_this.state.animationType === 'leave') {
	                _this.setState({ isShow: false });
	            } else if (_this.props.closeOnEsc) {
	                _this.el.focus();
	            }
	
	            if (event.target === _this.el) {
	                var onAnimationEnd = _this.props.onAnimationEnd;
	
	                onAnimationEnd && onAnimationEnd();
	            }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Rodal, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            if (this.props.visible) {
	                this.enter();
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (!this.props.visible && nextProps.visible) {
	                this.enter();
	            } else if (this.props.visible && !nextProps.visible) {
	                this.leave();
	            }
	        }
	    }, {
	        key: 'enter',
	        value: function enter() {
	            this.setState({
	                isShow: true,
	                animationType: 'enter'
	            });
	        }
	    }, {
	        key: 'leave',
	        value: function leave() {
	            this.setState(isIE9 ? { isShow: false } : { animationType: 'leave' });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var props = this.props,
	                state = this.state;
	
	            var onClick = props.closeMaskOnClick ? props.onClose : null;
	            var mask = props.showMask ? _react2.default.createElement('div', { className: 'rodal-mask', style: props.customMaskStyles, onClick: onClick }) : null;
	            var style = {
	                display: state.isShow ? '' : 'none',
	                animationDuration: props.duration + 'ms',
	                WebkitAnimationDuration: props.duration + 'ms'
	            };
	
	            return _react2.default.createElement(
	                'div',
	                {
	                    style: style,
	                    className: "rodal rodal-fade-" + state.animationType + ' ' + props.className,
	                    onAnimationEnd: this.animationEnd,
	                    tabIndex: '-1',
	                    ref: function ref(el) {
	                        _this2.el = el;
	                    },
	                    onKeyUp: this.onKeyUp
	                },
	                mask,
	                _react2.default.createElement(
	                    Dialog,
	                    _extends({}, props, { animationType: state.animationType }),
	                    props.children
	                )
	            );
	        }
	    }]);
	
	    return Rodal;
	}(_react2.default.Component);
	
	Rodal.propTypes = {
	    width: _propTypes2.default.number,
	    height: _propTypes2.default.number,
	    measure: _propTypes2.default.string,
	    visible: _propTypes2.default.bool,
	    showMask: _propTypes2.default.bool,
	    closeOnEsc: _propTypes2.default.bool,
	    closeMaskOnClick: _propTypes2.default.bool,
	    showCloseButton: _propTypes2.default.bool,
	    animation: _propTypes2.default.string,
	    enterAnimation: _propTypes2.default.string,
	    leaveAnimation: _propTypes2.default.string,
	    duration: _propTypes2.default.number,
	    className: _propTypes2.default.string,
	    customStyles: _propTypes2.default.object,
	    customMaskStyles: _propTypes2.default.object,
	    onClose: _propTypes2.default.func.isRequired,
	    onAnimationEnd: _propTypes2.default.func
	};
	Rodal.defaultProps = {
	    width: 400,
	    height: 240,
	    measure: 'px',
	    visible: false,
	    showMask: true,
	    closeOnEsc: false,
	    closeMaskOnClick: true,
	    showCloseButton: true,
	    animation: 'zoom',
	    enterAnimation: '',
	    leaveAnimation: '',
	    duration: 300,
	    className: '',
	    customStyles: {},
	    customMaskStyles: {}
	};
	exports.default = Rodal;


/***/ }),

/***/ 141:
/***/ (function(module, exports) {

	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	
	    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	    if(ret !== void 0) {
	        return !!ret;
	    }
	
	    if(objA === objB) {
	        return true;
	    }
	
	    if(typeof objA !== 'object' || !objA ||
	       typeof objB !== 'object' || !objB) {
	        return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if(keysA.length !== keysB.length) {
	        return false;
	    }
	
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	    // Test for A's keys different from B.
	    for(var idx = 0; idx < keysA.length; idx++) {
	
	        var key = keysA[idx];
	
	        if(!bHasOwnProperty(key)) {
	            return false;
	        }
	
	        var valueA = objA[key];
	        var valueB = objB[key];
	
	        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	        if(ret === false ||
	           ret === void 0 && valueA !== valueB) {
	            return false;
	        }
	
	    }
	
	    return true;
	
	};


/***/ }),

/***/ 479:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {/*! smooth-scroll v12.1.5 | (c) 2017 Chris Ferdinandi | MIT License | http://github.com/cferdinandi/smooth-scroll */
	!(function(e,t){ true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function(){return t(e)}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"==typeof exports?module.exports=t(e):e.SmoothScroll=t(e)})("undefined"!=typeof global?global:"undefined"!=typeof window?window:this,(function(e){"use strict";var t="querySelector"in document&&"addEventListener"in e&&"requestAnimationFrame"in e&&"closest"in e.Element.prototype,n={ignore:"[data-scroll-ignore]",header:null,speed:500,offset:0,easing:"easeInOutCubic",customEasing:null,before:function(){},after:function(){}},o=function(){for(var e={},t=0,n=arguments.length;t<n;t++){var o=arguments[t];!(function(t){for(var n in t)t.hasOwnProperty(n)&&(e[n]=t[n])})(o)}return e},a=function(t){return parseInt(e.getComputedStyle(t).height,10)},r=function(e){"#"===e.charAt(0)&&(e=e.substr(1));for(var t,n=String(e),o=n.length,a=-1,r="",i=n.charCodeAt(0);++a<o;){if(0===(t=n.charCodeAt(a)))throw new InvalidCharacterError("Invalid character: the input contains U+0000.");t>=1&&t<=31||127==t||0===a&&t>=48&&t<=57||1===a&&t>=48&&t<=57&&45===i?r+="\\"+t.toString(16)+" ":r+=t>=128||45===t||95===t||t>=48&&t<=57||t>=65&&t<=90||t>=97&&t<=122?n.charAt(a):"\\"+n.charAt(a)}return"#"+r},i=function(e,t){var n;return"easeInQuad"===e.easing&&(n=t*t),"easeOutQuad"===e.easing&&(n=t*(2-t)),"easeInOutQuad"===e.easing&&(n=t<.5?2*t*t:(4-2*t)*t-1),"easeInCubic"===e.easing&&(n=t*t*t),"easeOutCubic"===e.easing&&(n=--t*t*t+1),"easeInOutCubic"===e.easing&&(n=t<.5?4*t*t*t:(t-1)*(2*t-2)*(2*t-2)+1),"easeInQuart"===e.easing&&(n=t*t*t*t),"easeOutQuart"===e.easing&&(n=1- --t*t*t*t),"easeInOutQuart"===e.easing&&(n=t<.5?8*t*t*t*t:1-8*--t*t*t*t),"easeInQuint"===e.easing&&(n=t*t*t*t*t),"easeOutQuint"===e.easing&&(n=1+--t*t*t*t*t),"easeInOutQuint"===e.easing&&(n=t<.5?16*t*t*t*t*t:1+16*--t*t*t*t*t),e.customEasing&&(n=e.customEasing(t)),n||t},u=function(){return Math.max(document.body.scrollHeight,document.documentElement.scrollHeight,document.body.offsetHeight,document.documentElement.offsetHeight,document.body.clientHeight,document.documentElement.clientHeight)},c=function(e,t,n){var o=0;if(e.offsetParent)do{o+=e.offsetTop,e=e.offsetParent}while(e);return o=Math.max(o-t-n,0)},s=function(e){return e?a(e)+e.offsetTop:0},l=function(t,n,o){o||(t.focus(),document.activeElement.id!==t.id&&(t.setAttribute("tabindex","-1"),t.focus(),t.style.outline="none"),e.scrollTo(0,n))},f=function(t){return!!("matchMedia"in e&&e.matchMedia("(prefers-reduced-motion)").matches)};return function(a,d){var m,h,g,p,v,b,y,S={};S.cancelScroll=function(){cancelAnimationFrame(y)},S.animateScroll=function(t,a,r){var f=o(m||n,r||{}),d="[object Number]"===Object.prototype.toString.call(t),h=d||!t.tagName?null:t;if(d||h){var g=e.pageYOffset;f.header&&!p&&(p=document.querySelector(f.header)),v||(v=s(p));var b,y,E,I=d?t:c(h,v,parseInt("function"==typeof f.offset?f.offset():f.offset,10)),O=I-g,A=u(),C=0,w=function(n,o){var r=e.pageYOffset;if(n==o||r==o||(g<o&&e.innerHeight+r)>=A)return S.cancelScroll(),l(t,o,d),f.after(t,a),b=null,!0},Q=function(t){b||(b=t),C+=t-b,y=C/parseInt(f.speed,10),y=y>1?1:y,E=g+O*i(f,y),e.scrollTo(0,Math.floor(E)),w(E,I)||(e.requestAnimationFrame(Q),b=t)};0===e.pageYOffset&&e.scrollTo(0,0),f.before(t,a),S.cancelScroll(),e.requestAnimationFrame(Q)}};var E=function(e){h&&(h.id=h.getAttribute("data-scroll-id"),S.animateScroll(h,g),h=null,g=null)},I=function(t){if(!f()&&0===t.button&&!t.metaKey&&!t.ctrlKey&&(g=t.target.closest(a))&&"a"===g.tagName.toLowerCase()&&!t.target.closest(m.ignore)&&g.hostname===e.location.hostname&&g.pathname===e.location.pathname&&/#/.test(g.href)){var n;try{n=r(decodeURIComponent(g.hash))}catch(e){n=r(g.hash)}if("#"===n){t.preventDefault(),h=document.body;var o=h.id?h.id:"smooth-scroll-top";return h.setAttribute("data-scroll-id",o),h.id="",void(e.location.hash.substring(1)===o?E():e.location.hash=o)}h=document.querySelector(n),h&&(h.setAttribute("data-scroll-id",h.id),h.id="",g.hash===e.location.hash&&(t.preventDefault(),E()))}},O=function(e){b||(b=setTimeout((function(){b=null,v=s(p)}),66))};return S.destroy=function(){m&&(document.removeEventListener("click",I,!1),e.removeEventListener("resize",O,!1),S.cancelScroll(),m=null,h=null,g=null,p=null,v=null,b=null,y=null)},S.init=function(a){t&&(S.destroy(),m=o(n,a||{}),p=m.header?document.querySelector(m.header):null,v=s(p),document.addEventListener("click",I,!1),e.addEventListener("hashchange",E,!1),p&&e.addEventListener("resize",O,!1))},S.init(d),S}}));
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 480:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {/** @license
	 *
	 * SoundManager 2: JavaScript Sound for the Web
	 * ----------------------------------------------
	 * http://schillmania.com/projects/soundmanager2/
	 *
	 * Copyright (c) 2007, Scott Schiller. All rights reserved.
	 * Code provided under the BSD License:
	 * http://schillmania.com/projects/soundmanager2/license.txt
	 *
	 * V2.97a.20170601
	 */
	
	(function SM2(window, _undefined) {
	'use strict';
	if (!window || !window.document) {
	  throw new Error('SoundManager requires a browser with window and document objects.');
	}
	var soundManager = null;
	function SoundManager(smURL, smID) {
	  this.setupOptions = {
	    url: (smURL || null),
	    flashVersion: 8,
	    debugMode: true,
	    debugFlash: false,
	    useConsole: true,
	    consoleOnly: true,
	    waitForWindowLoad: false,
	    bgColor: '#ffffff',
	    useHighPerformance: false,
	    flashPollingInterval: null,
	    html5PollingInterval: null,
	    flashLoadTimeout: 1000,
	    wmode: null,
	    allowScriptAccess: 'always',
	    useFlashBlock: false,
	    useHTML5Audio: true,
	    forceUseGlobalHTML5Audio: false,
	    ignoreMobileRestrictions: false,
	    html5Test: /^(probably|maybe)$/i,
	    preferFlash: false,
	    noSWFCache: false,
	    idPrefix: 'sound'
	  };
	  this.defaultOptions = {
	    autoLoad: false,
	    autoPlay: false,
	    from: null,
	    loops: 1,
	    onid3: null,
	    onerror: null,
	    onload: null,
	    whileloading: null,
	    onplay: null,
	    onpause: null,
	    onresume: null,
	    whileplaying: null,
	    onposition: null,
	    onstop: null,
	    onfinish: null,
	    multiShot: true,
	    multiShotEvents: false,
	    position: null,
	    pan: 0,
	    playbackRate: 1,
	    stream: true,
	    to: null,
	    type: null,
	    usePolicyFile: false,
	    volume: 100
	  };
	  this.flash9Options = {
	    onfailure: null,
	    isMovieStar: null,
	    usePeakData: false,
	    useWaveformData: false,
	    useEQData: false,
	    onbufferchange: null,
	    ondataerror: null
	  };
	  this.movieStarOptions = {
	    bufferTime: 3,
	    serverURL: null,
	    onconnect: null,
	    duration: null
	  };
	  this.audioFormats = {
	    mp3: {
	      type: ['audio/mpeg; codecs="mp3"', 'audio/mpeg', 'audio/mp3', 'audio/MPA', 'audio/mpa-robust'],
	      required: true
	    },
	    mp4: {
	      related: ['aac', 'm4a', 'm4b'],
	      type: ['audio/mp4; codecs="mp4a.40.2"', 'audio/aac', 'audio/x-m4a', 'audio/MP4A-LATM', 'audio/mpeg4-generic'],
	      required: false
	    },
	    ogg: {
	      type: ['audio/ogg; codecs=vorbis'],
	      required: false
	    },
	    opus: {
	      type: ['audio/ogg; codecs=opus', 'audio/opus'],
	      required: false
	    },
	    wav: {
	      type: ['audio/wav; codecs="1"', 'audio/wav', 'audio/wave', 'audio/x-wav'],
	      required: false
	    },
	    flac: {
	      type: ['audio/flac'],
	      required: false
	    }
	  };
	  this.movieID = 'sm2-container';
	  this.id = (smID || 'sm2movie');
	  this.debugID = 'soundmanager-debug';
	  this.debugURLParam = /([#?&])debug=1/i;
	  this.versionNumber = 'V2.97a.20170601';
	  this.version = null;
	  this.movieURL = null;
	  this.altURL = null;
	  this.swfLoaded = false;
	  this.enabled = false;
	  this.oMC = null;
	  this.sounds = {};
	  this.soundIDs = [];
	  this.muted = false;
	  this.didFlashBlock = false;
	  this.filePattern = null;
	  this.filePatterns = {
	    flash8: /\.mp3(\?.*)?$/i,
	    flash9: /\.mp3(\?.*)?$/i
	  };
	  this.features = {
	    buffering: false,
	    peakData: false,
	    waveformData: false,
	    eqData: false,
	    movieStar: false
	  };
	  this.sandbox = {
	  };
	  this.html5 = {
	    usingFlash: null
	  };
	  this.flash = {};
	  this.html5Only = false;
	  this.ignoreFlash = false;
	  var SMSound,
	  sm2 = this, globalHTML5Audio = null, flash = null, sm = 'soundManager', smc = sm + ': ', h5 = 'HTML5::', id, ua = navigator.userAgent, wl = window.location.href.toString(), doc = document, doNothing, setProperties, init, fV, on_queue = [], debugOpen = true, debugTS, didAppend = false, appendSuccess = false, didInit = false, disabled = false, windowLoaded = false, _wDS, wdCount = 0, initComplete, mixin, assign, extraOptions, addOnEvent, processOnEvents, initUserOnload, delayWaitForEI, waitForEI, rebootIntoHTML5, setVersionInfo, handleFocus, strings, initMovie, domContentLoaded, winOnLoad, didDCLoaded, getDocument, createMovie, catchError, setPolling, initDebug, debugLevels = ['log', 'info', 'warn', 'error'], defaultFlashVersion = 8, disableObject, failSafely, normalizeMovieURL, oRemoved = null, oRemovedHTML = null, str, flashBlockHandler, getSWFCSS, swfCSS, toggleDebug, loopFix, policyFix, complain, idCheck, waitingForEI = false, initPending = false, startTimer, stopTimer, timerExecute, h5TimerCount = 0, h5IntervalTimer = null, parseURL, messages = [],
	  canIgnoreFlash, needsFlash = null, featureCheck, html5OK, html5CanPlay, html5ErrorCodes, html5Ext, html5Unload, domContentLoadedIE, testHTML5, event, slice = Array.prototype.slice, useGlobalHTML5Audio = false, lastGlobalHTML5URL, hasFlash, detectFlash, badSafariFix, html5_events, showSupport, flushMessages, wrapCallback, idCounter = 0, didSetup, msecScale = 1000,
	  is_iDevice = ua.match(/(ipad|iphone|ipod)/i), isAndroid = ua.match(/android/i), isIE = ua.match(/msie|trident/i),
	  isWebkit = ua.match(/webkit/i),
	  isSafari = (ua.match(/safari/i) && !ua.match(/chrome/i)),
	  isOpera = (ua.match(/opera/i)),
	  mobileHTML5 = (ua.match(/(mobile|pre\/|xoom)/i) || is_iDevice || isAndroid),
	  isBadSafari = (!wl.match(/usehtml5audio/i) && !wl.match(/sm2-ignorebadua/i) && isSafari && !ua.match(/silk/i) && ua.match(/OS\sX\s10_6_([3-7])/i)),
	  hasConsole = (window.console !== _undefined && console.log !== _undefined),
	  isFocused = (doc.hasFocus !== _undefined ? doc.hasFocus() : null),
	  tryInitOnFocus = (isSafari && (doc.hasFocus === _undefined || !doc.hasFocus())),
	  okToDisable = !tryInitOnFocus,
	  flashMIME = /(mp3|mp4|mpa|m4a|m4b)/i,
	  emptyURL = 'about:blank',
	  emptyWAV = 'data:audio/wave;base64,/UklGRiYAAABXQVZFZm10IBAAAAABAAEARKwAAIhYAQACABAAZGF0YQIAAAD//w==',
	  overHTTP = (doc.location ? doc.location.protocol.match(/http/i) : null),
	  http = (!overHTTP ? '//' : ''),
	  netStreamMimeTypes = /^\s*audio\/(?:x-)?(?:mpeg4|aac|flv|mov|mp4|m4v|m4a|m4b|mp4v|3gp|3g2)\s*(?:$|;)/i,
	  netStreamTypes = ['mpeg4', 'aac', 'flv', 'mov', 'mp4', 'm4v', 'f4v', 'm4a', 'm4b', 'mp4v', '3gp', '3g2'],
	  netStreamPattern = new RegExp('\\.(' + netStreamTypes.join('|') + ')(\\?.*)?$', 'i');
	  this.mimePattern = /^\s*audio\/(?:x-)?(?:mp(?:eg|3))\s*(?:$|;)/i;
	  this.useAltURL = !overHTTP;
	  swfCSS = {
	    swfBox: 'sm2-object-box',
	    swfDefault: 'movieContainer',
	    swfError: 'swf_error',
	    swfTimedout: 'swf_timedout',
	    swfLoaded: 'swf_loaded',
	    swfUnblocked: 'swf_unblocked',
	    sm2Debug: 'sm2_debug',
	    highPerf: 'high_performance',
	    flashDebug: 'flash_debug'
	  };
	  html5ErrorCodes = [
	    null,
	    'MEDIA_ERR_ABORTED',
	    'MEDIA_ERR_NETWORK',
	    'MEDIA_ERR_DECODE',
	    'MEDIA_ERR_SRC_NOT_SUPPORTED'
	  ];
	  this.hasHTML5 = (function() {
	    try {
	      return (Audio !== _undefined && (isOpera && opera !== _undefined && opera.version() < 10 ? new Audio(null) : new Audio()).canPlayType !== _undefined);
	    } catch(e) {
	      return false;
	    }
	  }());
	  this.setup = function(options) {
	    var noURL = (!sm2.url);
	    if (options !== _undefined && didInit && needsFlash && sm2.ok() && (options.flashVersion !== _undefined || options.url !== _undefined || options.html5Test !== _undefined)) {
	    }
	    assign(options);
	    if (!useGlobalHTML5Audio) {
	      if (mobileHTML5) {
	        if (!sm2.setupOptions.ignoreMobileRestrictions || sm2.setupOptions.forceUseGlobalHTML5Audio) {
	          messages.push(strings.globalHTML5);
	          useGlobalHTML5Audio = true;
	        }
	      } else if (sm2.setupOptions.forceUseGlobalHTML5Audio) {
	        messages.push(strings.globalHTML5);
	        useGlobalHTML5Audio = true;
	      }
	    }
	    if (!didSetup && mobileHTML5) {
	      if (sm2.setupOptions.ignoreMobileRestrictions) {
	        messages.push(strings.ignoreMobile);
	      } else {
	        sm2.setupOptions.useHTML5Audio = true;
	        sm2.setupOptions.preferFlash = false;
	        if (is_iDevice) {
	          sm2.ignoreFlash = true;
	        } else if ((isAndroid && !ua.match(/android\s2\.3/i)) || !isAndroid) {
	          useGlobalHTML5Audio = true;
	        }
	      }
	    }
	    if (options) {
	      if (noURL && didDCLoaded && options.url !== _undefined) {
	        sm2.beginDelayedInit();
	      }
	      if (!didDCLoaded && options.url !== _undefined && doc.readyState === 'complete') {
	        setTimeout(domContentLoaded, 1);
	      }
	    }
	    didSetup = true;
	    return sm2;
	  };
	  this.ok = function() {
	    return (needsFlash ? (didInit && !disabled) : (sm2.useHTML5Audio && sm2.hasHTML5));
	  };
	  this.supported = this.ok;
	  this.getMovie = function(movie_id) {
	    return id(movie_id) || doc[movie_id] || window[movie_id];
	  };
	  this.createSound = function(oOptions, _url) {
	    var cs, cs_string, options, oSound = null;
	    if (!didInit || !sm2.ok()) {
	      return false;
	    }
	    if (_url !== _undefined) {
	      oOptions = {
	        id: oOptions,
	        url: _url
	      };
	    }
	    options = mixin(oOptions);
	    options.url = parseURL(options.url);
	    if (options.id === _undefined) {
	      options.id = sm2.setupOptions.idPrefix + (idCounter++);
	    }
	    if (idCheck(options.id, true)) {
	      return sm2.sounds[options.id];
	    }
	    function make() {
	      options = loopFix(options);
	      sm2.sounds[options.id] = new SMSound(options);
	      sm2.soundIDs.push(options.id);
	      return sm2.sounds[options.id];
	    }
	    if (html5OK(options)) {
	      oSound = make();
	      oSound._setup_html5(options);
	    } else {
	      if (sm2.html5Only) {
	        return make();
	      }
	      if (sm2.html5.usingFlash && options.url && options.url.match(/data:/i)) {
	        return make();
	      }
	      if (fV > 8) {
	        if (options.isMovieStar === null) {
	          options.isMovieStar = !!(options.serverURL || (options.type ? options.type.match(netStreamMimeTypes) : false) || (options.url && options.url.match(netStreamPattern)));
	        }
	      }
	      options = policyFix(options, cs);
	      oSound = make();
	      if (fV === 8) {
	        flash._createSound(options.id, options.loops || 1, options.usePolicyFile);
	      } else {
	        flash._createSound(options.id, options.url, options.usePeakData, options.useWaveformData, options.useEQData, options.isMovieStar, (options.isMovieStar ? options.bufferTime : false), options.loops || 1, options.serverURL, options.duration || null, options.autoPlay, true, options.autoLoad, options.usePolicyFile);
	        if (!options.serverURL) {
	          oSound.connected = true;
	          if (options.onconnect) {
	            options.onconnect.apply(oSound);
	          }
	        }
	      }
	      if (!options.serverURL && (options.autoLoad || options.autoPlay)) {
	        oSound.load(options);
	      }
	    }
	    if (!options.serverURL && options.autoPlay) {
	      oSound.play();
	    }
	    return oSound;
	  };
	  this.destroySound = function(sID, _bFromSound) {
	    if (!idCheck(sID)) return false;
	    var oS = sm2.sounds[sID], i;
	    oS.stop();
	    oS._iO = {};
	    oS.unload();
	    for (i = 0; i < sm2.soundIDs.length; i++) {
	      if (sm2.soundIDs[i] === sID) {
	        sm2.soundIDs.splice(i, 1);
	        break;
	      }
	    }
	    if (!_bFromSound) {
	      oS.destruct(true);
	    }
	    oS = null;
	    delete sm2.sounds[sID];
	    return true;
	  };
	  this.load = function(sID, oOptions) {
	    if (!idCheck(sID)) return false;
	    return sm2.sounds[sID].load(oOptions);
	  };
	  this.unload = function(sID) {
	    if (!idCheck(sID)) return false;
	    return sm2.sounds[sID].unload();
	  };
	  this.onPosition = function(sID, nPosition, oMethod, oScope) {
	    if (!idCheck(sID)) return false;
	    return sm2.sounds[sID].onposition(nPosition, oMethod, oScope);
	  };
	  this.onposition = this.onPosition;
	  this.clearOnPosition = function(sID, nPosition, oMethod) {
	    if (!idCheck(sID)) return false;
	    return sm2.sounds[sID].clearOnPosition(nPosition, oMethod);
	  };
	  this.play = function(sID, oOptions) {
	    var result = null,
	        overloaded = (oOptions && !(oOptions instanceof Object));
	    if (!didInit || !sm2.ok()) {
	      return false;
	    }
	    if (!idCheck(sID, overloaded)) {
	      if (!overloaded) return false;
	      if (overloaded) {
	        oOptions = {
	          url: oOptions
	        };
	      }
	      if (oOptions && oOptions.url) {
	        oOptions.id = sID;
	        result = sm2.createSound(oOptions).play();
	      }
	    } else if (overloaded) {
	      oOptions = {
	        url: oOptions
	      };
	    }
	    if (result === null) {
	      result = sm2.sounds[sID].play(oOptions);
	    }
	    return result;
	  };
	  this.start = this.play;
	  this.setPlaybackRate = function(sID, rate, allowOverride) {
	    if (!idCheck(sID)) return false;
	    return sm2.sounds[sID].setPlaybackRate(rate, allowOverride);
	  };
	  this.setPosition = function(sID, nMsecOffset) {
	    if (!idCheck(sID)) return false;
	    return sm2.sounds[sID].setPosition(nMsecOffset);
	  };
	  this.stop = function(sID) {
	    if (!idCheck(sID)) return false;
	    return sm2.sounds[sID].stop();
	  };
	  this.stopAll = function() {
	    var oSound;
	    for (oSound in sm2.sounds) {
	      if (sm2.sounds.hasOwnProperty(oSound)) {
	        sm2.sounds[oSound].stop();
	      }
	    }
	  };
	  this.pause = function(sID) {
	    if (!idCheck(sID)) return false;
	    return sm2.sounds[sID].pause();
	  };
	  this.pauseAll = function() {
	    var i;
	    for (i = sm2.soundIDs.length - 1; i >= 0; i--) {
	      sm2.sounds[sm2.soundIDs[i]].pause();
	    }
	  };
	  this.resume = function(sID) {
	    if (!idCheck(sID)) return false;
	    return sm2.sounds[sID].resume();
	  };
	  this.resumeAll = function() {
	    var i;
	    for (i = sm2.soundIDs.length - 1; i >= 0; i--) {
	      sm2.sounds[sm2.soundIDs[i]].resume();
	    }
	  };
	  this.togglePause = function(sID) {
	    if (!idCheck(sID)) return false;
	    return sm2.sounds[sID].togglePause();
	  };
	  this.setPan = function(sID, nPan) {
	    if (!idCheck(sID)) return false;
	    return sm2.sounds[sID].setPan(nPan);
	  };
	  this.setVolume = function(sID, nVol) {
	    var i, j;
	    if (sID !== _undefined && !isNaN(sID) && nVol === _undefined) {
	      for (i = 0, j = sm2.soundIDs.length; i < j; i++) {
	        sm2.sounds[sm2.soundIDs[i]].setVolume(sID);
	      }
	      return false;
	    }
	    if (!idCheck(sID)) return false;
	    return sm2.sounds[sID].setVolume(nVol);
	  };
	  this.mute = function(sID) {
	    var i = 0;
	    if (sID instanceof String) {
	      sID = null;
	    }
	    if (!sID) {
	      for (i = sm2.soundIDs.length - 1; i >= 0; i--) {
	        sm2.sounds[sm2.soundIDs[i]].mute();
	      }
	      sm2.muted = true;
	    } else {
	      if (!idCheck(sID)) return false;
	      return sm2.sounds[sID].mute();
	    }
	    return true;
	  };
	  this.muteAll = function() {
	    sm2.mute();
	  };
	  this.unmute = function(sID) {
	    var i;
	    if (sID instanceof String) {
	      sID = null;
	    }
	    if (!sID) {
	      for (i = sm2.soundIDs.length - 1; i >= 0; i--) {
	        sm2.sounds[sm2.soundIDs[i]].unmute();
	      }
	      sm2.muted = false;
	    } else {
	      if (!idCheck(sID)) return false;
	      return sm2.sounds[sID].unmute();
	    }
	    return true;
	  };
	  this.unmuteAll = function() {
	    sm2.unmute();
	  };
	  this.toggleMute = function(sID) {
	    if (!idCheck(sID)) return false;
	    return sm2.sounds[sID].toggleMute();
	  };
	  this.getMemoryUse = function() {
	    var ram = 0;
	    if (flash && fV !== 8) {
	      ram = parseInt(flash._getMemoryUse(), 10);
	    }
	    return ram;
	  };
	  this.disable = function(bNoDisable) {
	    var i;
	    if (bNoDisable === _undefined) {
	      bNoDisable = false;
	    }
	    if (disabled) return false;
	    disabled = true;
	    for (i = sm2.soundIDs.length - 1; i >= 0; i--) {
	      disableObject(sm2.sounds[sm2.soundIDs[i]]);
	    }
	    disableObject(sm2);
	    initComplete(bNoDisable);
	    event.remove(window, 'load', initUserOnload);
	    return true;
	  };
	  this.canPlayMIME = function(sMIME) {
	    var result;
	    if (sm2.hasHTML5) {
	      result = html5CanPlay({
	        type: sMIME
	      });
	    }
	    if (!result && needsFlash) {
	      result = (sMIME && sm2.ok() ? !!((fV > 8 ? sMIME.match(netStreamMimeTypes) : null) || sMIME.match(sm2.mimePattern)) : null);
	    }
	    return result;
	  };
	  this.canPlayURL = function(sURL) {
	    var result;
	    if (sm2.hasHTML5) {
	      result = html5CanPlay({
	        url: sURL
	      });
	    }
	    if (!result && needsFlash) {
	      result = (sURL && sm2.ok() ? !!(sURL.match(sm2.filePattern)) : null);
	    }
	    return result;
	  };
	  this.canPlayLink = function(oLink) {
	    if (oLink.type !== _undefined && oLink.type && sm2.canPlayMIME(oLink.type)) return true;
	    return sm2.canPlayURL(oLink.href);
	  };
	  this.getSoundById = function(sID, _suppressDebug) {
	    if (!sID) return null;
	    var result = sm2.sounds[sID];
	    return result;
	  };
	  this.onready = function(oMethod, oScope) {
	    var sType = 'onready',
	        result = false;
	    if (typeof oMethod === 'function') {
	      if (!oScope) {
	        oScope = window;
	      }
	      addOnEvent(sType, oMethod, oScope);
	      processOnEvents();
	      result = true;
	    } else {
	      throw str('needFunction', sType);
	    }
	    return result;
	  };
	  this.ontimeout = function(oMethod, oScope) {
	    var sType = 'ontimeout',
	        result = false;
	    if (typeof oMethod === 'function') {
	      if (!oScope) {
	        oScope = window;
	      }
	      addOnEvent(sType, oMethod, oScope);
	      processOnEvents({ type: sType });
	      result = true;
	    } else {
	      throw str('needFunction', sType);
	    }
	    return result;
	  };
	  this._writeDebug = function(sText, sTypeOrObject) {
	    return true;
	  };
	  this._wD = this._writeDebug;
	  this._debug = function() {
	  };
	  this.reboot = function(resetEvents, excludeInit) {
	    var i, j, k;
	    for (i = sm2.soundIDs.length - 1; i >= 0; i--) {
	      sm2.sounds[sm2.soundIDs[i]].destruct();
	    }
	    if (flash) {
	      try {
	        if (isIE) {
	          oRemovedHTML = flash.innerHTML;
	        }
	        oRemoved = flash.parentNode.removeChild(flash);
	      } catch(e) {
	      }
	    }
	    oRemovedHTML = oRemoved = needsFlash = flash = null;
	    sm2.enabled = didDCLoaded = didInit = waitingForEI = initPending = didAppend = appendSuccess = disabled = useGlobalHTML5Audio = sm2.swfLoaded = false;
	    sm2.soundIDs = [];
	    sm2.sounds = {};
	    idCounter = 0;
	    didSetup = false;
	    if (!resetEvents) {
	      for (i in on_queue) {
	        if (on_queue.hasOwnProperty(i)) {
	          for (j = 0, k = on_queue[i].length; j < k; j++) {
	            on_queue[i][j].fired = false;
	          }
	        }
	      }
	    } else {
	      on_queue = [];
	    }
	    sm2.html5 = {
	      usingFlash: null
	    };
	    sm2.flash = {};
	    sm2.html5Only = false;
	    sm2.ignoreFlash = false;
	    window.setTimeout(function() {
	      if (!excludeInit) {
	        sm2.beginDelayedInit();
	      }
	    }, 20);
	    return sm2;
	  };
	  this.reset = function() {
	    return sm2.reboot(true, true);
	  };
	  this.getMoviePercent = function() {
	    return (flash && 'PercentLoaded' in flash ? flash.PercentLoaded() : null);
	  };
	  this.beginDelayedInit = function() {
	    windowLoaded = true;
	    domContentLoaded();
	    setTimeout(function() {
	      if (initPending) return false;
	      createMovie();
	      initMovie();
	      initPending = true;
	      return true;
	    }, 20);
	    delayWaitForEI();
	  };
	  this.destruct = function() {
	    sm2.disable(true);
	  };
	  SMSound = function(oOptions) {
	    var s = this, resetProperties, add_html5_events, remove_html5_events, stop_html5_timer, start_html5_timer, attachOnPosition, onplay_called = false, onPositionItems = [], onPositionFired = 0, detachOnPosition, applyFromTo, lastURL = null, lastHTML5State, urlOmitted;
	    lastHTML5State = {
	      duration: null,
	      time: null
	    };
	    this.id = oOptions.id;
	    this.sID = this.id;
	    this.url = oOptions.url;
	    this.options = mixin(oOptions);
	    this.instanceOptions = this.options;
	    this._iO = this.instanceOptions;
	    this.pan = this.options.pan;
	    this.volume = this.options.volume;
	    this.isHTML5 = false;
	    this._a = null;
	    urlOmitted = (!this.url);
	    this.id3 = {};
	    this._debug = function() {
	    };
	    this.load = function(options) {
	      var oSound = null, instanceOptions;
	      if (options !== _undefined) {
	        s._iO = mixin(options, s.options);
	      } else {
	        options = s.options;
	        s._iO = options;
	        if (lastURL && lastURL !== s.url) {
	          s._iO.url = s.url;
	          s.url = null;
	        }
	      }
	      if (!s._iO.url) {
	        s._iO.url = s.url;
	      }
	      s._iO.url = parseURL(s._iO.url);
	      s.instanceOptions = s._iO;
	      instanceOptions = s._iO;
	      if (!instanceOptions.url && !s.url) {
	        return s;
	      }
	      if (instanceOptions.url === s.url && s.readyState !== 0 && s.readyState !== 2) {
	        if (s.readyState === 3 && instanceOptions.onload) {
	          wrapCallback(s, function() {
	            instanceOptions.onload.apply(s, [(!!s.duration)]);
	          });
	        }
	        return s;
	      }
	      s.loaded = false;
	      s.readyState = 1;
	      s.playState = 0;
	      s.id3 = {};
	      if (html5OK(instanceOptions)) {
	        oSound = s._setup_html5(instanceOptions);
	        if (!oSound._called_load) {
	          s._html5_canplay = false;
	          if (s.url !== instanceOptions.url) {
	            s._a.src = instanceOptions.url;
	            s.setPosition(0);
	          }
	          s._a.autobuffer = 'auto';
	          s._a.preload = 'auto';
	          s._a._called_load = true;
	        } else {
	        }
	      } else {
	        if (sm2.html5Only) {
	          return s;
	        }
	        if (s._iO.url && s._iO.url.match(/data:/i)) {
	          return s;
	        }
	        try {
	          s.isHTML5 = false;
	          s._iO = policyFix(loopFix(instanceOptions));
	          if (s._iO.autoPlay && (s._iO.position || s._iO.from)) {
	            s._iO.autoPlay = false;
	          }
	          instanceOptions = s._iO;
	          if (fV === 8) {
	            flash._load(s.id, instanceOptions.url, instanceOptions.stream, instanceOptions.autoPlay, instanceOptions.usePolicyFile);
	          } else {
	            flash._load(s.id, instanceOptions.url, !!(instanceOptions.stream), !!(instanceOptions.autoPlay), instanceOptions.loops || 1, !!(instanceOptions.autoLoad), instanceOptions.usePolicyFile);
	          }
	        } catch(e) {
	          catchError({
	            type: 'SMSOUND_LOAD_JS_EXCEPTION',
	            fatal: true
	          });
	        }
	      }
	      s.url = instanceOptions.url;
	      return s;
	    };
	    this.unload = function() {
	      if (s.readyState !== 0) {
	        if (!s.isHTML5) {
	          if (fV === 8) {
	            flash._unload(s.id, emptyURL);
	          } else {
	            flash._unload(s.id);
	          }
	        } else {
	          stop_html5_timer();
	          if (s._a) {
	            s._a.pause();
	            lastURL = html5Unload(s._a);
	          }
	        }
	        resetProperties();
	      }
	      return s;
	    };
	    this.destruct = function(_bFromSM) {
	      if (!s.isHTML5) {
	        s._iO.onfailure = null;
	        flash._destroySound(s.id);
	      } else {
	        stop_html5_timer();
	        if (s._a) {
	          s._a.pause();
	          html5Unload(s._a);
	          if (!useGlobalHTML5Audio) {
	            remove_html5_events();
	          }
	          s._a._s = null;
	          s._a = null;
	        }
	      }
	      if (!_bFromSM) {
	        sm2.destroySound(s.id, true);
	      }
	    };
	    this.play = function(options, _updatePlayState) {
	      var fN, allowMulti, a, onready,
	          audioClone, onended, oncanplay,
	          startOK = true;
	      _updatePlayState = (_updatePlayState === _undefined ? true : _updatePlayState);
	      if (!options) {
	        options = {};
	      }
	      if (s.url) {
	        s._iO.url = s.url;
	      }
	      s._iO = mixin(s._iO, s.options);
	      s._iO = mixin(options, s._iO);
	      s._iO.url = parseURL(s._iO.url);
	      s.instanceOptions = s._iO;
	      if (!s.isHTML5 && s._iO.serverURL && !s.connected) {
	        if (!s.getAutoPlay()) {
	          s.setAutoPlay(true);
	        }
	        return s;
	      }
	      if (html5OK(s._iO)) {
	        s._setup_html5(s._iO);
	        start_html5_timer();
	      }
	      if (s.playState === 1 && !s.paused) {
	        allowMulti = s._iO.multiShot;
	        if (!allowMulti) {
	          if (s.isHTML5) {
	            s.setPosition(s._iO.position);
	          }
	          return s;
	        }
	      }
	      if (options.url && options.url !== s.url) {
	        if (!s.readyState && !s.isHTML5 && fV === 8 && urlOmitted) {
	          urlOmitted = false;
	        } else {
	          s.load(s._iO);
	        }
	      }
	      if (!s.loaded) {
	        if (s.readyState === 0) {
	          if (!s.isHTML5 && !sm2.html5Only) {
	            s._iO.autoPlay = true;
	            s.load(s._iO);
	          } else if (s.isHTML5) {
	            s.load(s._iO);
	          } else {
	            return s;
	          }
	          s.instanceOptions = s._iO;
	        } else if (s.readyState === 2) {
	          return s;
	        } else {
	        }
	      } else {
	      }
	      if (!s.isHTML5 && fV === 9 && s.position > 0 && s.position === s.duration) {
	        options.position = 0;
	      }
	      if (s.paused && s.position >= 0 && (!s._iO.serverURL || s.position > 0)) {
	        s.resume();
	      } else {
	        s._iO = mixin(options, s._iO);
	        if (((!s.isHTML5 && s._iO.position !== null && s._iO.position > 0) || (s._iO.from !== null && s._iO.from > 0) || s._iO.to !== null) && s.instanceCount === 0 && s.playState === 0 && !s._iO.serverURL) {
	          onready = function() {
	            s._iO = mixin(options, s._iO);
	            s.play(s._iO);
	          };
	          if (s.isHTML5 && !s._html5_canplay) {
	            s.load({
	              _oncanplay: onready
	            });
	          } else if (!s.isHTML5 && !s.loaded && (!s.readyState || s.readyState !== 2)) {
	            s.load({
	              onload: onready
	            });
	          }
	          s._iO = applyFromTo();
	        }
	        if (!s.instanceCount || s._iO.multiShotEvents || (s.isHTML5 && s._iO.multiShot && !useGlobalHTML5Audio) || (!s.isHTML5 && fV > 8 && !s.getAutoPlay())) {
	          s.instanceCount++;
	        }
	        if (s._iO.onposition && s.playState === 0) {
	          attachOnPosition(s);
	        }
	        s.playState = 1;
	        s.paused = false;
	        s.position = (s._iO.position !== _undefined && !isNaN(s._iO.position) ? s._iO.position : 0);
	        if (!s.isHTML5) {
	          s._iO = policyFix(loopFix(s._iO));
	        }
	        if (s._iO.onplay && _updatePlayState) {
	          s._iO.onplay.apply(s);
	          onplay_called = true;
	        }
	        s.setVolume(s._iO.volume, true);
	        s.setPan(s._iO.pan, true);
	        if (s._iO.playbackRate !== 1) {
	          s.setPlaybackRate(s._iO.playbackRate);
	        }
	        if (!s.isHTML5) {
	          startOK = flash._start(s.id, s._iO.loops || 1, (fV === 9 ? s.position : s.position / msecScale), s._iO.multiShot || false);
	          if (fV === 9 && !startOK) {
	            if (s._iO.onplayerror) {
	              s._iO.onplayerror.apply(s);
	            }
	          }
	        } else if (s.instanceCount < 2) {
	            start_html5_timer();
	            a = s._setup_html5();
	            s.setPosition(s._iO.position);
	            a.play();
	          } else {
	            audioClone = new Audio(s._iO.url);
	            onended = function() {
	              event.remove(audioClone, 'ended', onended);
	              s._onfinish(s);
	              html5Unload(audioClone);
	              audioClone = null;
	            };
	            oncanplay = function() {
	              event.remove(audioClone, 'canplay', oncanplay);
	              try {
	                audioClone.currentTime = s._iO.position / msecScale;
	              } catch(err) {
	              }
	              audioClone.play();
	            };
	            event.add(audioClone, 'ended', onended);
	            if (s._iO.volume !== _undefined) {
	              audioClone.volume = Math.max(0, Math.min(1, s._iO.volume / 100));
	            }
	            if (s.muted) {
	              audioClone.muted = true;
	            }
	            if (s._iO.position) {
	              event.add(audioClone, 'canplay', oncanplay);
	            } else {
	              audioClone.play();
	            }
	          }
	      }
	      return s;
	    };
	    this.start = this.play;
	    this.stop = function(bAll) {
	      var instanceOptions = s._iO,
	          originalPosition;
	      if (s.playState === 1) {
	        s._onbufferchange(0);
	        s._resetOnPosition(0);
	        s.paused = false;
	        if (!s.isHTML5) {
	          s.playState = 0;
	        }
	        detachOnPosition();
	        if (instanceOptions.to) {
	          s.clearOnPosition(instanceOptions.to);
	        }
	        if (!s.isHTML5) {
	          flash._stop(s.id, bAll);
	          if (instanceOptions.serverURL) {
	            s.unload();
	          }
	        } else if (s._a) {
	            originalPosition = s.position;
	            s.setPosition(0);
	            s.position = originalPosition;
	            s._a.pause();
	            s.playState = 0;
	            s._onTimer();
	            stop_html5_timer();
	          }
	        s.instanceCount = 0;
	        s._iO = {};
	        if (instanceOptions.onstop) {
	          instanceOptions.onstop.apply(s);
	        }
	      }
	      return s;
	    };
	    this.setAutoPlay = function(autoPlay) {
	      s._iO.autoPlay = autoPlay;
	      if (!s.isHTML5) {
	        flash._setAutoPlay(s.id, autoPlay);
	        if (autoPlay) {
	          if (!s.instanceCount && s.readyState === 1) {
	            s.instanceCount++;
	          }
	        }
	      }
	    };
	    this.getAutoPlay = function() {
	      return s._iO.autoPlay;
	    };
	    this.setPlaybackRate = function(playbackRate) {
	      var normalizedRate = Math.max(0.5, Math.min(4, playbackRate));
	      if (s.isHTML5) {
	        try {
	          s._iO.playbackRate = normalizedRate;
	          s._a.playbackRate = normalizedRate;
	        } catch(e) {
	        }
	      }
	      return s;
	    };
	    this.setPosition = function(nMsecOffset) {
	      if (nMsecOffset === _undefined) {
	        nMsecOffset = 0;
	      }
	      var position, position1K,
	          offset = (s.isHTML5 ? Math.max(nMsecOffset, 0) : Math.min(s.duration || s._iO.duration, Math.max(nMsecOffset, 0)));
	      s.position = offset;
	      position1K = s.position / msecScale;
	      s._resetOnPosition(s.position);
	      s._iO.position = offset;
	      if (!s.isHTML5) {
	        position = (fV === 9 ? s.position : position1K);
	        if (s.readyState && s.readyState !== 2) {
	          flash._setPosition(s.id, position, (s.paused || !s.playState), s._iO.multiShot);
	        }
	      } else if (s._a) {
	        if (s._html5_canplay) {
	          if (s._a.currentTime.toFixed(3) !== position1K.toFixed(3)) {
	            try {
	              s._a.currentTime = position1K;
	              if (s.playState === 0 || s.paused) {
	                s._a.pause();
	              }
	            } catch(e) {
	            }
	          }
	        } else if (position1K) {
	          return s;
	        }
	        if (s.paused) {
	          s._onTimer(true);
	        }
	      }
	      return s;
	    };
	    this.pause = function(_bCallFlash) {
	      if (s.paused || (s.playState === 0 && s.readyState !== 1)) return s;
	      s.paused = true;
	      if (!s.isHTML5) {
	        if (_bCallFlash || _bCallFlash === _undefined) {
	          flash._pause(s.id, s._iO.multiShot);
	        }
	      } else {
	        s._setup_html5().pause();
	        stop_html5_timer();
	      }
	      if (s._iO.onpause) {
	        s._iO.onpause.apply(s);
	      }
	      return s;
	    };
	    this.resume = function() {
	      var instanceOptions = s._iO;
	      if (!s.paused) return s;
	      s.paused = false;
	      s.playState = 1;
	      if (!s.isHTML5) {
	        if (instanceOptions.isMovieStar && !instanceOptions.serverURL) {
	          s.setPosition(s.position);
	        }
	        flash._pause(s.id, instanceOptions.multiShot);
	      } else {
	        s._setup_html5().play();
	        start_html5_timer();
	      }
	      if (!onplay_called && instanceOptions.onplay) {
	        instanceOptions.onplay.apply(s);
	        onplay_called = true;
	      } else if (instanceOptions.onresume) {
	        instanceOptions.onresume.apply(s);
	      }
	      return s;
	    };
	    this.togglePause = function() {
	      if (s.playState === 0) {
	        s.play({
	          position: (fV === 9 && !s.isHTML5 ? s.position : s.position / msecScale)
	        });
	        return s;
	      }
	      if (s.paused) {
	        s.resume();
	      } else {
	        s.pause();
	      }
	      return s;
	    };
	    this.setPan = function(nPan, bInstanceOnly) {
	      if (nPan === _undefined) {
	        nPan = 0;
	      }
	      if (bInstanceOnly === _undefined) {
	        bInstanceOnly = false;
	      }
	      if (!s.isHTML5) {
	        flash._setPan(s.id, nPan);
	      }
	      s._iO.pan = nPan;
	      if (!bInstanceOnly) {
	        s.pan = nPan;
	        s.options.pan = nPan;
	      }
	      return s;
	    };
	    this.setVolume = function(nVol, _bInstanceOnly) {
	      if (nVol === _undefined) {
	        nVol = 100;
	      }
	      if (_bInstanceOnly === _undefined) {
	        _bInstanceOnly = false;
	      }
	      if (!s.isHTML5) {
	        flash._setVolume(s.id, (sm2.muted && !s.muted) || s.muted ? 0 : nVol);
	      } else if (s._a) {
	        if (sm2.muted && !s.muted) {
	          s.muted = true;
	          s._a.muted = true;
	        }
	        s._a.volume = Math.max(0, Math.min(1, nVol / 100));
	      }
	      s._iO.volume = nVol;
	      if (!_bInstanceOnly) {
	        s.volume = nVol;
	        s.options.volume = nVol;
	      }
	      return s;
	    };
	    this.mute = function() {
	      s.muted = true;
	      if (!s.isHTML5) {
	        flash._setVolume(s.id, 0);
	      } else if (s._a) {
	        s._a.muted = true;
	      }
	      return s;
	    };
	    this.unmute = function() {
	      s.muted = false;
	      var hasIO = (s._iO.volume !== _undefined);
	      if (!s.isHTML5) {
	        flash._setVolume(s.id, hasIO ? s._iO.volume : s.options.volume);
	      } else if (s._a) {
	        s._a.muted = false;
	      }
	      return s;
	    };
	    this.toggleMute = function() {
	      return (s.muted ? s.unmute() : s.mute());
	    };
	    this.onPosition = function(nPosition, oMethod, oScope) {
	      onPositionItems.push({
	        position: parseInt(nPosition, 10),
	        method: oMethod,
	        scope: (oScope !== _undefined ? oScope : s),
	        fired: false
	      });
	      return s;
	    };
	    this.onposition = this.onPosition;
	    this.clearOnPosition = function(nPosition, oMethod) {
	      var i;
	      nPosition = parseInt(nPosition, 10);
	      if (isNaN(nPosition)) {
	        return;
	      }
	      for (i = 0; i < onPositionItems.length; i++) {
	        if (nPosition === onPositionItems[i].position) {
	          if (!oMethod || (oMethod === onPositionItems[i].method)) {
	            if (onPositionItems[i].fired) {
	              onPositionFired--;
	            }
	            onPositionItems.splice(i, 1);
	          }
	        }
	      }
	    };
	    this._processOnPosition = function() {
	      var i, item, j = onPositionItems.length;
	      if (!j || !s.playState || onPositionFired >= j) return false;
	      for (i = j - 1; i >= 0; i--) {
	        item = onPositionItems[i];
	        if (!item.fired && s.position >= item.position) {
	          item.fired = true;
	          onPositionFired++;
	          item.method.apply(item.scope, [item.position]);
	          j = onPositionItems.length;
	        }
	      }
	      return true;
	    };
	    this._resetOnPosition = function(nPosition) {
	      var i, item, j = onPositionItems.length;
	      if (!j) return false;
	      for (i = j - 1; i >= 0; i--) {
	        item = onPositionItems[i];
	        if (item.fired && nPosition <= item.position) {
	          item.fired = false;
	          onPositionFired--;
	        }
	      }
	      return true;
	    };
	    applyFromTo = function() {
	      var instanceOptions = s._iO,
	          f = instanceOptions.from,
	          t = instanceOptions.to,
	          start, end;
	      end = function() {
	        s.clearOnPosition(t, end);
	        s.stop();
	      };
	      start = function() {
	        if (t !== null && !isNaN(t)) {
	          s.onPosition(t, end);
	        }
	      };
	      if (f !== null && !isNaN(f)) {
	        instanceOptions.position = f;
	        instanceOptions.multiShot = false;
	        start();
	      }
	      return instanceOptions;
	    };
	    attachOnPosition = function() {
	      var item,
	          op = s._iO.onposition;
	      if (op) {
	        for (item in op) {
	          if (op.hasOwnProperty(item)) {
	            s.onPosition(parseInt(item, 10), op[item]);
	          }
	        }
	      }
	    };
	    detachOnPosition = function() {
	      var item,
	          op = s._iO.onposition;
	      if (op) {
	        for (item in op) {
	          if (op.hasOwnProperty(item)) {
	            s.clearOnPosition(parseInt(item, 10));
	          }
	        }
	      }
	    };
	    start_html5_timer = function() {
	      if (s.isHTML5) {
	        startTimer(s);
	      }
	    };
	    stop_html5_timer = function() {
	      if (s.isHTML5) {
	        stopTimer(s);
	      }
	    };
	    resetProperties = function(retainPosition) {
	      if (!retainPosition) {
	        onPositionItems = [];
	        onPositionFired = 0;
	      }
	      onplay_called = false;
	      s._hasTimer = null;
	      s._a = null;
	      s._html5_canplay = false;
	      s.bytesLoaded = null;
	      s.bytesTotal = null;
	      s.duration = (s._iO && s._iO.duration ? s._iO.duration : null);
	      s.durationEstimate = null;
	      s.buffered = [];
	      s.eqData = [];
	      s.eqData.left = [];
	      s.eqData.right = [];
	      s.failures = 0;
	      s.isBuffering = false;
	      s.instanceOptions = {};
	      s.instanceCount = 0;
	      s.loaded = false;
	      s.metadata = {};
	      s.readyState = 0;
	      s.muted = false;
	      s.paused = false;
	      s.peakData = {
	        left: 0,
	        right: 0
	      };
	      s.waveformData = {
	        left: [],
	        right: []
	      };
	      s.playState = 0;
	      s.position = null;
	      s.id3 = {};
	    };
	    resetProperties();
	    this._onTimer = function(bForce) {
	      var duration, isNew = false, time, x = {};
	      if (s._hasTimer || bForce) {
	        if (s._a && (bForce || ((s.playState > 0 || s.readyState === 1) && !s.paused))) {
	          duration = s._get_html5_duration();
	          if (duration !== lastHTML5State.duration) {
	            lastHTML5State.duration = duration;
	            s.duration = duration;
	            isNew = true;
	          }
	          s.durationEstimate = s.duration;
	          time = (s._a.currentTime * msecScale || 0);
	          if (time !== lastHTML5State.time) {
	            lastHTML5State.time = time;
	            isNew = true;
	          }
	          if (isNew || bForce) {
	            s._whileplaying(time, x, x, x, x);
	          }
	        }
	      }
	      return isNew;
	    };
	    this._get_html5_duration = function() {
	      var instanceOptions = s._iO,
	          d = (s._a && s._a.duration ? s._a.duration * msecScale : (instanceOptions && instanceOptions.duration ? instanceOptions.duration : null)),
	          result = (d && !isNaN(d) && d !== Infinity ? d : null);
	      return result;
	    };
	    this._apply_loop = function(a, nLoops) {
	      a.loop = (nLoops > 1 ? 'loop' : '');
	    };
	    this._setup_html5 = function(options) {
	      var instanceOptions = mixin(s._iO, options),
	          a = useGlobalHTML5Audio ? globalHTML5Audio : s._a,
	          dURL = decodeURI(instanceOptions.url),
	          sameURL;
	      if (useGlobalHTML5Audio) {
	        if (dURL === decodeURI(lastGlobalHTML5URL)) {
	          sameURL = true;
	        }
	      } else if (dURL === decodeURI(lastURL)) {
	        sameURL = true;
	      }
	      if (a) {
	        if (a._s) {
	          if (useGlobalHTML5Audio) {
	            if (a._s && a._s.playState && !sameURL) {
	              a._s.stop();
	            }
	          } else if (!useGlobalHTML5Audio && dURL === decodeURI(lastURL)) {
	            s._apply_loop(a, instanceOptions.loops);
	            return a;
	          }
	        }
	        if (!sameURL) {
	          if (lastURL) {
	            resetProperties(false);
	          }
	          a.src = instanceOptions.url;
	          s.url = instanceOptions.url;
	          lastURL = instanceOptions.url;
	          lastGlobalHTML5URL = instanceOptions.url;
	          a._called_load = false;
	        }
	      } else {
	        if (instanceOptions.autoLoad || instanceOptions.autoPlay) {
	          s._a = new Audio(instanceOptions.url);
	          s._a.load();
	        } else {
	          s._a = (isOpera && opera.version() < 10 ? new Audio(null) : new Audio());
	        }
	        a = s._a;
	        a._called_load = false;
	        if (useGlobalHTML5Audio) {
	          globalHTML5Audio = a;
	        }
	      }
	      s.isHTML5 = true;
	      s._a = a;
	      a._s = s;
	      add_html5_events();
	      s._apply_loop(a, instanceOptions.loops);
	      if (instanceOptions.autoLoad || instanceOptions.autoPlay) {
	        s.load();
	      } else {
	        a.autobuffer = false;
	        a.preload = 'auto';
	      }
	      return a;
	    };
	    add_html5_events = function() {
	      if (s._a._added_events) return false;
	      var f;
	      function add(oEvt, oFn, bCapture) {
	        return s._a ? s._a.addEventListener(oEvt, oFn, bCapture || false) : null;
	      }
	      s._a._added_events = true;
	      for (f in html5_events) {
	        if (html5_events.hasOwnProperty(f)) {
	          add(f, html5_events[f]);
	        }
	      }
	      return true;
	    };
	    remove_html5_events = function() {
	      var f;
	      function remove(oEvt, oFn, bCapture) {
	        return (s._a ? s._a.removeEventListener(oEvt, oFn, bCapture || false) : null);
	      }
	      s._a._added_events = false;
	      for (f in html5_events) {
	        if (html5_events.hasOwnProperty(f)) {
	          remove(f, html5_events[f]);
	        }
	      }
	    };
	    this._onload = function(nSuccess) {
	      var fN,
	          loadOK = !!nSuccess || (!s.isHTML5 && fV === 8 && s.duration);
	      s.loaded = loadOK;
	      s.readyState = (loadOK ? 3 : 2);
	      s._onbufferchange(0);
	      if (!loadOK && !s.isHTML5) {
	        s._onerror();
	      }
	      if (s._iO.onload) {
	        wrapCallback(s, function() {
	          s._iO.onload.apply(s, [loadOK]);
	        });
	      }
	      return true;
	    };
	    this._onerror = function(errorCode, description) {
	      if (s._iO.onerror) {
	        wrapCallback(s, function() {
	          s._iO.onerror.apply(s, [errorCode, description]);
	        });
	      }
	    };
	    this._onbufferchange = function(nIsBuffering) {
	      if (s.playState === 0) return false;
	      if ((nIsBuffering && s.isBuffering) || (!nIsBuffering && !s.isBuffering)) return false;
	      s.isBuffering = (nIsBuffering === 1);
	      if (s._iO.onbufferchange) {
	        s._iO.onbufferchange.apply(s, [nIsBuffering]);
	      }
	      return true;
	    };
	    this._onsuspend = function() {
	      if (s._iO.onsuspend) {
	        s._iO.onsuspend.apply(s);
	      }
	      return true;
	    };
	    this._onfailure = function(msg, level, code) {
	      s.failures++;
	      if (s._iO.onfailure && s.failures === 1) {
	        s._iO.onfailure(msg, level, code);
	      } else {
	      }
	    };
	    this._onwarning = function(msg, level, code) {
	      if (s._iO.onwarning) {
	        s._iO.onwarning(msg, level, code);
	      }
	    };
	    this._onfinish = function() {
	      var io_onfinish = s._iO.onfinish;
	      s._onbufferchange(0);
	      s._resetOnPosition(0);
	      if (s.instanceCount) {
	        s.instanceCount--;
	        if (!s.instanceCount) {
	          detachOnPosition();
	          s.playState = 0;
	          s.paused = false;
	          s.instanceCount = 0;
	          s.instanceOptions = {};
	          s._iO = {};
	          stop_html5_timer();
	          if (s.isHTML5) {
	            s.position = 0;
	          }
	        }
	        if (!s.instanceCount || s._iO.multiShotEvents) {
	          if (io_onfinish) {
	            wrapCallback(s, function() {
	              io_onfinish.apply(s);
	            });
	          }
	        }
	      }
	    };
	    this._whileloading = function(nBytesLoaded, nBytesTotal, nDuration, nBufferLength) {
	      var instanceOptions = s._iO;
	      s.bytesLoaded = nBytesLoaded;
	      s.bytesTotal = nBytesTotal;
	      s.duration = Math.floor(nDuration);
	      s.bufferLength = nBufferLength;
	      if (!s.isHTML5 && !instanceOptions.isMovieStar) {
	        if (instanceOptions.duration) {
	          s.durationEstimate = (s.duration > instanceOptions.duration) ? s.duration : instanceOptions.duration;
	        } else {
	          s.durationEstimate = parseInt((s.bytesTotal / s.bytesLoaded) * s.duration, 10);
	        }
	      } else {
	        s.durationEstimate = s.duration;
	      }
	      if (!s.isHTML5) {
	        s.buffered = [{
	          start: 0,
	          end: s.duration
	        }];
	      }
	      if ((s.readyState !== 3 || s.isHTML5) && instanceOptions.whileloading) {
	        instanceOptions.whileloading.apply(s);
	      }
	    };
	    this._whileplaying = function(nPosition, oPeakData, oWaveformDataLeft, oWaveformDataRight, oEQData) {
	      var instanceOptions = s._iO,
	          eqLeft;
	      if (isNaN(nPosition) || nPosition === null) return false;
	      s.position = Math.max(0, nPosition);
	      s._processOnPosition();
	      if (!s.isHTML5 && fV > 8) {
	        if (instanceOptions.usePeakData && oPeakData !== _undefined && oPeakData) {
	          s.peakData = {
	            left: oPeakData.leftPeak,
	            right: oPeakData.rightPeak
	          };
	        }
	        if (instanceOptions.useWaveformData && oWaveformDataLeft !== _undefined && oWaveformDataLeft) {
	          s.waveformData = {
	            left: oWaveformDataLeft.split(','),
	            right: oWaveformDataRight.split(',')
	          };
	        }
	        if (instanceOptions.useEQData) {
	          if (oEQData !== _undefined && oEQData && oEQData.leftEQ) {
	            eqLeft = oEQData.leftEQ.split(',');
	            s.eqData = eqLeft;
	            s.eqData.left = eqLeft;
	            if (oEQData.rightEQ !== _undefined && oEQData.rightEQ) {
	              s.eqData.right = oEQData.rightEQ.split(',');
	            }
	          }
	        }
	      }
	      if (s.playState === 1) {
	        if (!s.isHTML5 && fV === 8 && !s.position && s.isBuffering) {
	          s._onbufferchange(0);
	        }
	        if (instanceOptions.whileplaying) {
	          instanceOptions.whileplaying.apply(s);
	        }
	      }
	      return true;
	    };
	    this._oncaptiondata = function(oData) {
	      s.captiondata = oData;
	      if (s._iO.oncaptiondata) {
	        s._iO.oncaptiondata.apply(s, [oData]);
	      }
	    };
	    this._onmetadata = function(oMDProps, oMDData) {
	      var oData = {}, i, j;
	      for (i = 0, j = oMDProps.length; i < j; i++) {
	        oData[oMDProps[i]] = oMDData[i];
	      }
	      s.metadata = oData;
	      if (s._iO.onmetadata) {
	        s._iO.onmetadata.call(s, s.metadata);
	      }
	    };
	    this._onid3 = function(oID3Props, oID3Data) {
	      var oData = [], i, j;
	      for (i = 0, j = oID3Props.length; i < j; i++) {
	        oData[oID3Props[i]] = oID3Data[i];
	      }
	      s.id3 = mixin(s.id3, oData);
	      if (s._iO.onid3) {
	        s._iO.onid3.apply(s);
	      }
	    };
	    this._onconnect = function(bSuccess) {
	      bSuccess = (bSuccess === 1);
	      s.connected = bSuccess;
	      if (bSuccess) {
	        s.failures = 0;
	        if (idCheck(s.id)) {
	          if (s.getAutoPlay()) {
	            s.play(_undefined, s.getAutoPlay());
	          } else if (s._iO.autoLoad) {
	            s.load();
	          }
	        }
	        if (s._iO.onconnect) {
	          s._iO.onconnect.apply(s, [bSuccess]);
	        }
	      }
	    };
	    this._ondataerror = function(sError) {
	      if (s.playState > 0) {
	        if (s._iO.ondataerror) {
	          s._iO.ondataerror.apply(s);
	        }
	      }
	    };
	  };
	  getDocument = function() {
	    return (doc.body || doc.getElementsByTagName('div')[0]);
	  };
	  id = function(sID) {
	    return doc.getElementById(sID);
	  };
	  mixin = function(oMain, oAdd) {
	    var o1 = (oMain || {}), o2, o;
	    o2 = (oAdd === _undefined ? sm2.defaultOptions : oAdd);
	    for (o in o2) {
	      if (o2.hasOwnProperty(o) && o1[o] === _undefined) {
	        if (typeof o2[o] !== 'object' || o2[o] === null) {
	          o1[o] = o2[o];
	        } else {
	          o1[o] = mixin(o1[o], o2[o]);
	        }
	      }
	    }
	    return o1;
	  };
	  wrapCallback = function(oSound, callback) {
	    if (!oSound.isHTML5 && fV === 8) {
	      window.setTimeout(callback, 0);
	    } else {
	      callback();
	    }
	  };
	  extraOptions = {
	    onready: 1,
	    ontimeout: 1,
	    defaultOptions: 1,
	    flash9Options: 1,
	    movieStarOptions: 1
	  };
	  assign = function(o, oParent) {
	    var i,
	        result = true,
	        hasParent = (oParent !== _undefined),
	        setupOptions = sm2.setupOptions,
	        bonusOptions = extraOptions;
	    for (i in o) {
	      if (o.hasOwnProperty(i)) {
	        if (typeof o[i] !== 'object' || o[i] === null || o[i] instanceof Array || o[i] instanceof RegExp) {
	          if (hasParent && bonusOptions[oParent] !== _undefined) {
	            sm2[oParent][i] = o[i];
	          } else if (setupOptions[i] !== _undefined) {
	            sm2.setupOptions[i] = o[i];
	            sm2[i] = o[i];
	          } else if (bonusOptions[i] === _undefined) {
	            result = false;
	          } else if (sm2[i] instanceof Function) {
	            sm2[i].apply(sm2, (o[i] instanceof Array ? o[i] : [o[i]]));
	          } else {
	            sm2[i] = o[i];
	          }
	        } else if (bonusOptions[i] === _undefined) {
	          result = false;
	        } else {
	          return assign(o[i], i);
	        }
	      }
	    }
	    return result;
	  };
	  function preferFlashCheck(kind) {
	    return (sm2.preferFlash && hasFlash && !sm2.ignoreFlash && (sm2.flash[kind] !== _undefined && sm2.flash[kind]));
	  }
	  event = (function() {
	    var old = (window.attachEvent),
	    evt = {
	      add: (old ? 'attachEvent' : 'addEventListener'),
	      remove: (old ? 'detachEvent' : 'removeEventListener')
	    };
	    function getArgs(oArgs) {
	      var args = slice.call(oArgs),
	          len = args.length;
	      if (old) {
	        args[1] = 'on' + args[1];
	        if (len > 3) {
	          args.pop();
	        }
	      } else if (len === 3) {
	        args.push(false);
	      }
	      return args;
	    }
	    function apply(args, sType) {
	      var element = args.shift(),
	          method = [evt[sType]];
	      if (old) {
	        element[method](args[0], args[1]);
	      } else {
	        element[method].apply(element, args);
	      }
	    }
	    function add() {
	      apply(getArgs(arguments), 'add');
	    }
	    function remove() {
	      apply(getArgs(arguments), 'remove');
	    }
	    return {
	      add: add,
	      remove: remove
	    };
	  }());
	  function html5_event(oFn) {
	    return function(e) {
	      var s = this._s,
	          result;
	      if (!s || !s._a) {
	        result = null;
	      } else {
	        result = oFn.call(this, e);
	      }
	      return result;
	    };
	  }
	  html5_events = {
	    abort: html5_event(function() {
	    }),
	    canplay: html5_event(function() {
	      var s = this._s,
	          position1K;
	      if (s._html5_canplay) {
	        return;
	      }
	      s._html5_canplay = true;
	      s._onbufferchange(0);
	      position1K = (s._iO.position !== _undefined && !isNaN(s._iO.position) ? s._iO.position / msecScale : null);
	      if (this.currentTime !== position1K) {
	        try {
	          this.currentTime = position1K;
	        } catch(ee) {
	        }
	      }
	      if (s._iO._oncanplay) {
	        s._iO._oncanplay();
	      }
	    }),
	    canplaythrough: html5_event(function() {
	      var s = this._s;
	      if (!s.loaded) {
	        s._onbufferchange(0);
	        s._whileloading(s.bytesLoaded, s.bytesTotal, s._get_html5_duration());
	        s._onload(true);
	      }
	    }),
	    durationchange: html5_event(function() {
	      var s = this._s,
	          duration;
	      duration = s._get_html5_duration();
	      if (!isNaN(duration) && duration !== s.duration) {
	        s.durationEstimate = s.duration = duration;
	      }
	    }),
	    ended: html5_event(function() {
	      var s = this._s;
	      s._onfinish();
	    }),
	    error: html5_event(function() {
	      var description = (html5ErrorCodes[this.error.code] || null);
	      this._s._onload(false);
	      this._s._onerror(this.error.code, description);
	    }),
	    loadeddata: html5_event(function() {
	      var s = this._s;
	      if (!s._loaded && !isSafari) {
	        s.duration = s._get_html5_duration();
	      }
	    }),
	    loadedmetadata: html5_event(function() {
	    }),
	    loadstart: html5_event(function() {
	      this._s._onbufferchange(1);
	    }),
	    play: html5_event(function() {
	      this._s._onbufferchange(0);
	    }),
	    playing: html5_event(function() {
	      this._s._onbufferchange(0);
	    }),
	    progress: html5_event(function(e) {
	      var s = this._s,
	          i, j, progStr, buffered = 0,
	          isProgress = (e.type === 'progress'),
	          ranges = e.target.buffered,
	          loaded = (e.loaded || 0),
	          total = (e.total || 1);
	      s.buffered = [];
	      if (ranges && ranges.length) {
	        for (i = 0, j = ranges.length; i < j; i++) {
	          s.buffered.push({
	            start: ranges.start(i) * msecScale,
	            end: ranges.end(i) * msecScale
	          });
	        }
	        buffered = (ranges.end(0) - ranges.start(0)) * msecScale;
	        loaded = Math.min(1, buffered / (e.target.duration * msecScale));
	      }
	      if (!isNaN(loaded)) {
	        s._whileloading(loaded, total, s._get_html5_duration());
	        if (loaded && total && loaded === total) {
	          html5_events.canplaythrough.call(this, e);
	        }
	      }
	    }),
	    ratechange: html5_event(function() {
	    }),
	    suspend: html5_event(function(e) {
	      var s = this._s;
	      html5_events.progress.call(this, e);
	      s._onsuspend();
	    }),
	    stalled: html5_event(function() {
	    }),
	    timeupdate: html5_event(function() {
	      this._s._onTimer();
	    }),
	    waiting: html5_event(function() {
	      var s = this._s;
	      s._onbufferchange(1);
	    })
	  };
	  html5OK = function(iO) {
	    var result;
	    if (!iO || (!iO.type && !iO.url && !iO.serverURL)) {
	      result = false;
	    } else if (iO.serverURL || (iO.type && preferFlashCheck(iO.type))) {
	      result = false;
	    } else {
	      result = ((iO.type ? html5CanPlay({ type: iO.type }) : html5CanPlay({ url: iO.url }) || sm2.html5Only || iO.url.match(/data:/i)));
	    }
	    return result;
	  };
	  html5Unload = function(oAudio) {
	    var url;
	    if (oAudio) {
	      url = (isSafari ? emptyURL : (sm2.html5.canPlayType('audio/wav') ? emptyWAV : emptyURL));
	      oAudio.src = url;
	      if (oAudio._called_unload !== _undefined) {
	        oAudio._called_load = false;
	      }
	    }
	    if (useGlobalHTML5Audio) {
	      lastGlobalHTML5URL = null;
	    }
	    return url;
	  };
	  html5CanPlay = function(o) {
	    if (!sm2.useHTML5Audio || !sm2.hasHTML5) return false;
	    var url = (o.url || null),
	        mime = (o.type || null),
	        aF = sm2.audioFormats,
	        result,
	        offset,
	        fileExt,
	        item;
	    if (mime && sm2.html5[mime] !== _undefined) return (sm2.html5[mime] && !preferFlashCheck(mime));
	    if (!html5Ext) {
	      html5Ext = [];
	      for (item in aF) {
	        if (aF.hasOwnProperty(item)) {
	          html5Ext.push(item);
	          if (aF[item].related) {
	            html5Ext = html5Ext.concat(aF[item].related);
	          }
	        }
	      }
	      html5Ext = new RegExp('\\.(' + html5Ext.join('|') + ')(\\?.*)?$', 'i');
	    }
	    fileExt = (url ? url.toLowerCase().match(html5Ext) : null);
	    if (!fileExt || !fileExt.length) {
	      if (!mime) {
	        result = false;
	      } else {
	        offset = mime.indexOf(';');
	        fileExt = (offset !== -1 ? mime.substr(0, offset) : mime).substr(6);
	      }
	    } else {
	      fileExt = fileExt[1];
	    }
	    if (fileExt && sm2.html5[fileExt] !== _undefined) {
	      result = (sm2.html5[fileExt] && !preferFlashCheck(fileExt));
	    } else {
	      mime = 'audio/' + fileExt;
	      result = sm2.html5.canPlayType({ type: mime });
	      sm2.html5[fileExt] = result;
	      result = (result && sm2.html5[mime] && !preferFlashCheck(mime));
	    }
	    return result;
	  };
	  testHTML5 = function() {
	    if (!sm2.useHTML5Audio || !sm2.hasHTML5) {
	      sm2.html5.usingFlash = true;
	      needsFlash = true;
	      return false;
	    }
	    var a = (Audio !== _undefined ? (isOpera && opera.version() < 10 ? new Audio(null) : new Audio()) : null),
	        item, lookup, support = {}, aF, i;
	    function cp(m) {
	      var canPlay, j,
	          result = false,
	          isOK = false;
	      if (!a || typeof a.canPlayType !== 'function') return result;
	      if (m instanceof Array) {
	        for (i = 0, j = m.length; i < j; i++) {
	          if (sm2.html5[m[i]] || a.canPlayType(m[i]).match(sm2.html5Test)) {
	            isOK = true;
	            sm2.html5[m[i]] = true;
	            sm2.flash[m[i]] = !!(m[i].match(flashMIME));
	          }
	        }
	        result = isOK;
	      } else {
	        canPlay = (a && typeof a.canPlayType === 'function' ? a.canPlayType(m) : false);
	        result = !!(canPlay && (canPlay.match(sm2.html5Test)));
	      }
	      return result;
	    }
	    aF = sm2.audioFormats;
	    for (item in aF) {
	      if (aF.hasOwnProperty(item)) {
	        lookup = 'audio/' + item;
	        support[item] = cp(aF[item].type);
	        support[lookup] = support[item];
	        if (item.match(flashMIME)) {
	          sm2.flash[item] = true;
	          sm2.flash[lookup] = true;
	        } else {
	          sm2.flash[item] = false;
	          sm2.flash[lookup] = false;
	        }
	        if (aF[item] && aF[item].related) {
	          for (i = aF[item].related.length - 1; i >= 0; i--) {
	            support['audio/' + aF[item].related[i]] = support[item];
	            sm2.html5[aF[item].related[i]] = support[item];
	            sm2.flash[aF[item].related[i]] = support[item];
	          }
	        }
	      }
	    }
	    support.canPlayType = (a ? cp : null);
	    sm2.html5 = mixin(sm2.html5, support);
	    sm2.html5.usingFlash = featureCheck();
	    needsFlash = sm2.html5.usingFlash;
	    return true;
	  };
	  strings = {
	  };
	  str = function() {
	  };
	  loopFix = function(sOpt) {
	    if (fV === 8 && sOpt.loops > 1 && sOpt.stream) {
	      sOpt.stream = false;
	    }
	    return sOpt;
	  };
	  policyFix = function(sOpt, sPre) {
	    if (sOpt && !sOpt.usePolicyFile && (sOpt.onid3 || sOpt.usePeakData || sOpt.useWaveformData || sOpt.useEQData)) {
	      sOpt.usePolicyFile = true;
	    }
	    return sOpt;
	  };
	  complain = function(sMsg) {
	  };
	  doNothing = function() {
	    return false;
	  };
	  disableObject = function(o) {
	    var oProp;
	    for (oProp in o) {
	      if (o.hasOwnProperty(oProp) && typeof o[oProp] === 'function') {
	        o[oProp] = doNothing;
	      }
	    }
	    oProp = null;
	  };
	  failSafely = function(bNoDisable) {
	    if (bNoDisable === _undefined) {
	      bNoDisable = false;
	    }
	    if (disabled || bNoDisable) {
	      sm2.disable(bNoDisable);
	    }
	  };
	  normalizeMovieURL = function(movieURL) {
	    var urlParams = null, url;
	    if (movieURL) {
	      if (movieURL.match(/\.swf(\?.*)?$/i)) {
	        urlParams = movieURL.substr(movieURL.toLowerCase().lastIndexOf('.swf?') + 4);
	        if (urlParams) return movieURL;
	      } else if (movieURL.lastIndexOf('/') !== movieURL.length - 1) {
	        movieURL += '/';
	      }
	    }
	    url = (movieURL && movieURL.lastIndexOf('/') !== -1 ? movieURL.substr(0, movieURL.lastIndexOf('/') + 1) : './') + sm2.movieURL;
	    if (sm2.noSWFCache) {
	      url += ('?ts=' + new Date().getTime());
	    }
	    return url;
	  };
	  setVersionInfo = function() {
	    fV = parseInt(sm2.flashVersion, 10);
	    if (fV !== 8 && fV !== 9) {
	      sm2.flashVersion = fV = defaultFlashVersion;
	    }
	    var isDebug = (sm2.debugMode || sm2.debugFlash ? '_debug.swf' : '.swf');
	    if (sm2.useHTML5Audio && !sm2.html5Only && sm2.audioFormats.mp4.required && fV < 9) {
	      sm2.flashVersion = fV = 9;
	    }
	    sm2.version = sm2.versionNumber + (sm2.html5Only ? ' (HTML5-only mode)' : (fV === 9 ? ' (AS3/Flash 9)' : ' (AS2/Flash 8)'));
	    if (fV > 8) {
	      sm2.defaultOptions = mixin(sm2.defaultOptions, sm2.flash9Options);
	      sm2.features.buffering = true;
	      sm2.defaultOptions = mixin(sm2.defaultOptions, sm2.movieStarOptions);
	      sm2.filePatterns.flash9 = new RegExp('\\.(mp3|' + netStreamTypes.join('|') + ')(\\?.*)?$', 'i');
	      sm2.features.movieStar = true;
	    } else {
	      sm2.features.movieStar = false;
	    }
	    sm2.filePattern = sm2.filePatterns[(fV !== 8 ? 'flash9' : 'flash8')];
	    sm2.movieURL = (fV === 8 ? 'soundmanager2.swf' : 'soundmanager2_flash9.swf').replace('.swf', isDebug);
	    sm2.features.peakData = sm2.features.waveformData = sm2.features.eqData = (fV > 8);
	  };
	  setPolling = function(bPolling, bHighPerformance) {
	    if (!flash) {
	      return;
	    }
	    flash._setPolling(bPolling, bHighPerformance);
	  };
	  initDebug = function() {
	  };
	  idCheck = this.getSoundById;
	  getSWFCSS = function() {
	    var css = [];
	    if (sm2.debugMode) {
	      css.push(swfCSS.sm2Debug);
	    }
	    if (sm2.debugFlash) {
	      css.push(swfCSS.flashDebug);
	    }
	    if (sm2.useHighPerformance) {
	      css.push(swfCSS.highPerf);
	    }
	    return css.join(' ');
	  };
	  flashBlockHandler = function() {
	    var name = str('fbHandler'),
	        p = sm2.getMoviePercent(),
	        css = swfCSS,
	        error = {
	          type: 'FLASHBLOCK'
	        };
	    if (sm2.html5Only) {
	      return;
	    }
	    if (!sm2.ok()) {
	      if (needsFlash) {
	        sm2.oMC.className = getSWFCSS() + ' ' + css.swfDefault + ' ' + (p === null ? css.swfTimedout : css.swfError);
	      }
	      sm2.didFlashBlock = true;
	      processOnEvents({
	        type: 'ontimeout',
	        ignoreInit: true,
	        error: error
	      });
	      catchError(error);
	    } else {
	      if (sm2.oMC) {
	        sm2.oMC.className = [getSWFCSS(), css.swfDefault, css.swfLoaded + (sm2.didFlashBlock ? ' ' + css.swfUnblocked : '')].join(' ');
	      }
	    }
	  };
	  addOnEvent = function(sType, oMethod, oScope) {
	    if (on_queue[sType] === _undefined) {
	      on_queue[sType] = [];
	    }
	    on_queue[sType].push({
	      method: oMethod,
	      scope: (oScope || null),
	      fired: false
	    });
	  };
	  processOnEvents = function(oOptions) {
	    if (!oOptions) {
	      oOptions = {
	        type: (sm2.ok() ? 'onready' : 'ontimeout')
	      };
	    }
	    if (!didInit && oOptions && !oOptions.ignoreInit) return false;
	    if (oOptions.type === 'ontimeout' && (sm2.ok() || (disabled && !oOptions.ignoreInit))) return false;
	    var status = {
	          success: (oOptions && oOptions.ignoreInit ? sm2.ok() : !disabled)
	        },
	        srcQueue = (oOptions && oOptions.type ? on_queue[oOptions.type] || [] : []),
	        queue = [], i, j,
	        args = [status],
	        canRetry = (needsFlash && !sm2.ok());
	    if (oOptions.error) {
	      args[0].error = oOptions.error;
	    }
	    for (i = 0, j = srcQueue.length; i < j; i++) {
	      if (srcQueue[i].fired !== true) {
	        queue.push(srcQueue[i]);
	      }
	    }
	    if (queue.length) {
	      for (i = 0, j = queue.length; i < j; i++) {
	        if (queue[i].scope) {
	          queue[i].method.apply(queue[i].scope, args);
	        } else {
	          queue[i].method.apply(this, args);
	        }
	        if (!canRetry) {
	          queue[i].fired = true;
	        }
	      }
	    }
	    return true;
	  };
	  initUserOnload = function() {
	    window.setTimeout(function() {
	      if (sm2.useFlashBlock) {
	        flashBlockHandler();
	      }
	      processOnEvents();
	      if (typeof sm2.onload === 'function') {
	        sm2.onload.apply(window);
	      }
	      if (sm2.waitForWindowLoad) {
	        event.add(window, 'load', initUserOnload);
	      }
	    }, 1);
	  };
	  detectFlash = function() {
	    if (hasFlash !== _undefined) return hasFlash;
	    var hasPlugin = false, n = navigator, obj, type, types, AX = window.ActiveXObject;
	    var nP;
	    try {
	      nP = n.plugins;
	    } catch(e) {
	      nP = undefined;
	    }
	    if (nP && nP.length) {
	      type = 'application/x-shockwave-flash';
	      types = n.mimeTypes;
	      if (types && types[type] && types[type].enabledPlugin && types[type].enabledPlugin.description) {
	        hasPlugin = true;
	      }
	    } else if (AX !== _undefined && !ua.match(/MSAppHost/i)) {
	      try {
	        obj = new AX('ShockwaveFlash.ShockwaveFlash');
	      } catch(e) {
	        obj = null;
	      }
	      hasPlugin = (!!obj);
	      obj = null;
	    }
	    hasFlash = hasPlugin;
	    return hasPlugin;
	  };
	  featureCheck = function() {
	    var flashNeeded,
	        item,
	        formats = sm2.audioFormats,
	        isSpecial = (is_iDevice && !!(ua.match(/os (1|2|3_0|3_1)\s/i)));
	    if (isSpecial) {
	      sm2.hasHTML5 = false;
	      sm2.html5Only = true;
	      if (sm2.oMC) {
	        sm2.oMC.style.display = 'none';
	      }
	    } else if (sm2.useHTML5Audio) {
	        if (!sm2.html5 || !sm2.html5.canPlayType) {
	          sm2.hasHTML5 = false;
	        }
	      }
	    if (sm2.useHTML5Audio && sm2.hasHTML5) {
	      canIgnoreFlash = true;
	      for (item in formats) {
	        if (formats.hasOwnProperty(item)) {
	          if (formats[item].required) {
	            if (!sm2.html5.canPlayType(formats[item].type)) {
	              canIgnoreFlash = false;
	              flashNeeded = true;
	            } else if (sm2.preferFlash && (sm2.flash[item] || sm2.flash[formats[item].type])) {
	              flashNeeded = true;
	            }
	          }
	        }
	      }
	    }
	    if (sm2.ignoreFlash) {
	      flashNeeded = false;
	      canIgnoreFlash = true;
	    }
	    sm2.html5Only = (sm2.hasHTML5 && sm2.useHTML5Audio && !flashNeeded);
	    return (!sm2.html5Only);
	  };
	  parseURL = function(url) {
	    var i, j, urlResult = 0, result;
	    if (url instanceof Array) {
	      for (i = 0, j = url.length; i < j; i++) {
	        if (url[i] instanceof Object) {
	          if (sm2.canPlayMIME(url[i].type)) {
	            urlResult = i;
	            break;
	          }
	        } else if (sm2.canPlayURL(url[i])) {
	          urlResult = i;
	          break;
	        }
	      }
	      if (url[urlResult].url) {
	        url[urlResult] = url[urlResult].url;
	      }
	      result = url[urlResult];
	    } else {
	      result = url;
	    }
	    return result;
	  };
	  startTimer = function(oSound) {
	    if (!oSound._hasTimer) {
	      oSound._hasTimer = true;
	      if (!mobileHTML5 && sm2.html5PollingInterval) {
	        if (h5IntervalTimer === null && h5TimerCount === 0) {
	          h5IntervalTimer = setInterval(timerExecute, sm2.html5PollingInterval);
	        }
	        h5TimerCount++;
	      }
	    }
	  };
	  stopTimer = function(oSound) {
	    if (oSound._hasTimer) {
	      oSound._hasTimer = false;
	      if (!mobileHTML5 && sm2.html5PollingInterval) {
	        h5TimerCount--;
	      }
	    }
	  };
	  timerExecute = function() {
	    var i;
	    if (h5IntervalTimer !== null && !h5TimerCount) {
	      clearInterval(h5IntervalTimer);
	      h5IntervalTimer = null;
	      return;
	    }
	    for (i = sm2.soundIDs.length - 1; i >= 0; i--) {
	      if (sm2.sounds[sm2.soundIDs[i]].isHTML5 && sm2.sounds[sm2.soundIDs[i]]._hasTimer) {
	        sm2.sounds[sm2.soundIDs[i]]._onTimer();
	      }
	    }
	  };
	  catchError = function(options) {
	    options = (options !== _undefined ? options : {});
	    if (typeof sm2.onerror === 'function') {
	      sm2.onerror.apply(window, [{
	        type: (options.type !== _undefined ? options.type : null)
	      }]);
	    }
	    if (options.fatal !== _undefined && options.fatal) {
	      sm2.disable();
	    }
	  };
	  badSafariFix = function() {
	    if (!isBadSafari || !detectFlash()) {
	      return;
	    }
	    var aF = sm2.audioFormats, i, item;
	    for (item in aF) {
	      if (aF.hasOwnProperty(item)) {
	        if (item === 'mp3' || item === 'mp4') {
	          sm2.html5[item] = false;
	          if (aF[item] && aF[item].related) {
	            for (i = aF[item].related.length - 1; i >= 0; i--) {
	              sm2.html5[aF[item].related[i]] = false;
	            }
	          }
	        }
	      }
	    }
	  };
	  this._setSandboxType = function(sandboxType) {
	  };
	  this._externalInterfaceOK = function(swfVersion) {
	    if (sm2.swfLoaded) {
	      return;
	    }
	    var e;
	    sm2.swfLoaded = true;
	    tryInitOnFocus = false;
	    if (isBadSafari) {
	      badSafariFix();
	    }
	    setTimeout(init, isIE ? 100 : 1);
	  };
	  createMovie = function(movieID, movieURL) {
	    if (didAppend && appendSuccess) return false;
	    function initMsg() {
	    }
	    if (sm2.html5Only) {
	      setVersionInfo();
	      initMsg();
	      sm2.oMC = id(sm2.movieID);
	      init();
	      didAppend = true;
	      appendSuccess = true;
	      return false;
	    }
	    var remoteURL = (movieURL || sm2.url),
	    localURL = (sm2.altURL || remoteURL),
	    swfTitle = 'JS/Flash audio component (SoundManager 2)',
	    oTarget = getDocument(),
	    extraClass = getSWFCSS(),
	    isRTL = null,
	    html = doc.getElementsByTagName('html')[0],
	    oEmbed, oMovie, tmp, movieHTML, oEl, s, x, sClass;
	    isRTL = (html && html.dir && html.dir.match(/rtl/i));
	    movieID = (movieID === _undefined ? sm2.id : movieID);
	    function param(name, value) {
	      return '<param name="' + name + '" value="' + value + '" />';
	    }
	    setVersionInfo();
	    sm2.url = normalizeMovieURL(overHTTP ? remoteURL : localURL);
	    movieURL = sm2.url;
	    sm2.wmode = (!sm2.wmode && sm2.useHighPerformance ? 'transparent' : sm2.wmode);
	    if (sm2.wmode !== null && (ua.match(/msie 8/i) || (!isIE && !sm2.useHighPerformance)) && navigator.platform.match(/win32|win64/i)) {
	      messages.push(strings.spcWmode);
	      sm2.wmode = null;
	    }
	    oEmbed = {
	      name: movieID,
	      id: movieID,
	      src: movieURL,
	      quality: 'high',
	      allowScriptAccess: sm2.allowScriptAccess,
	      bgcolor: sm2.bgColor,
	      pluginspage: http + 'www.macromedia.com/go/getflashplayer',
	      title: swfTitle,
	      type: 'application/x-shockwave-flash',
	      wmode: sm2.wmode,
	      hasPriority: 'true'
	    };
	    if (sm2.debugFlash) {
	      oEmbed.FlashVars = 'debug=1';
	    }
	    if (!sm2.wmode) {
	      delete oEmbed.wmode;
	    }
	    if (isIE) {
	      oMovie = doc.createElement('div');
	      movieHTML = [
	        '<object id="' + movieID + '" data="' + movieURL + '" type="' + oEmbed.type + '" title="' + oEmbed.title + '" classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000" codebase="http://download.macromedia.com/pub/shockwave/cabs/flash/swflash.cab#version=6,0,40,0">',
	        param('movie', movieURL),
	        param('AllowScriptAccess', sm2.allowScriptAccess),
	        param('quality', oEmbed.quality),
	        (sm2.wmode ? param('wmode', sm2.wmode) : ''),
	        param('bgcolor', sm2.bgColor),
	        param('hasPriority', 'true'),
	        (sm2.debugFlash ? param('FlashVars', oEmbed.FlashVars) : ''),
	        '</object>'
	      ].join('');
	    } else {
	      oMovie = doc.createElement('embed');
	      for (tmp in oEmbed) {
	        if (oEmbed.hasOwnProperty(tmp)) {
	          oMovie.setAttribute(tmp, oEmbed[tmp]);
	        }
	      }
	    }
	    initDebug();
	    extraClass = getSWFCSS();
	    oTarget = getDocument();
	    if (oTarget) {
	      sm2.oMC = (id(sm2.movieID) || doc.createElement('div'));
	      if (!sm2.oMC.id) {
	        sm2.oMC.id = sm2.movieID;
	        sm2.oMC.className = swfCSS.swfDefault + ' ' + extraClass;
	        s = null;
	        oEl = null;
	        if (!sm2.useFlashBlock) {
	          if (sm2.useHighPerformance) {
	            s = {
	              position: 'fixed',
	              width: '8px',
	              height: '8px',
	              bottom: '0px',
	              left: '0px',
	              overflow: 'hidden'
	            };
	          } else {
	            s = {
	              position: 'absolute',
	              width: '6px',
	              height: '6px',
	              top: '-9999px',
	              left: '-9999px'
	            };
	            if (isRTL) {
	              s.left = Math.abs(parseInt(s.left, 10)) + 'px';
	            }
	          }
	        }
	        if (isWebkit) {
	          sm2.oMC.style.zIndex = 10000;
	        }
	        if (!sm2.debugFlash) {
	          for (x in s) {
	            if (s.hasOwnProperty(x)) {
	              sm2.oMC.style[x] = s[x];
	            }
	          }
	        }
	        try {
	          if (!isIE) {
	            sm2.oMC.appendChild(oMovie);
	          }
	          oTarget.appendChild(sm2.oMC);
	          if (isIE) {
	            oEl = sm2.oMC.appendChild(doc.createElement('div'));
	            oEl.className = swfCSS.swfBox;
	            oEl.innerHTML = movieHTML;
	          }
	          appendSuccess = true;
	        } catch(e) {
	          throw new Error(str('domError') + ' \n' + e.toString());
	        }
	      } else {
	        sClass = sm2.oMC.className;
	        sm2.oMC.className = (sClass ? sClass + ' ' : swfCSS.swfDefault) + (extraClass ? ' ' + extraClass : '');
	        sm2.oMC.appendChild(oMovie);
	        if (isIE) {
	          oEl = sm2.oMC.appendChild(doc.createElement('div'));
	          oEl.className = swfCSS.swfBox;
	          oEl.innerHTML = movieHTML;
	        }
	        appendSuccess = true;
	      }
	    }
	    didAppend = true;
	    initMsg();
	    return true;
	  };
	  initMovie = function() {
	    if (sm2.html5Only) {
	      createMovie();
	      return false;
	    }
	    if (flash) return false;
	    if (!sm2.url) {
	       return false;
	    }
	    flash = sm2.getMovie(sm2.id);
	    if (!flash) {
	      if (!oRemoved) {
	        createMovie(sm2.id, sm2.url);
	      } else {
	        if (!isIE) {
	          sm2.oMC.appendChild(oRemoved);
	        } else {
	          sm2.oMC.innerHTML = oRemovedHTML;
	        }
	        oRemoved = null;
	        didAppend = true;
	      }
	      flash = sm2.getMovie(sm2.id);
	    }
	    if (typeof sm2.oninitmovie === 'function') {
	      setTimeout(sm2.oninitmovie, 1);
	    }
	    return true;
	  };
	  delayWaitForEI = function() {
	    setTimeout(waitForEI, 1000);
	  };
	  rebootIntoHTML5 = function() {
	    window.setTimeout(function() {
	      sm2.setup({
	        preferFlash: false
	      }).reboot();
	      sm2.didFlashBlock = true;
	      sm2.beginDelayedInit();
	    }, 1);
	  };
	  waitForEI = function() {
	    var p,
	        loadIncomplete = false;
	    if (!sm2.url) {
	      return;
	    }
	    if (waitingForEI) {
	      return;
	    }
	    waitingForEI = true;
	    event.remove(window, 'load', delayWaitForEI);
	    if (hasFlash && tryInitOnFocus && !isFocused) {
	      return;
	    }
	    if (!didInit) {
	      p = sm2.getMoviePercent();
	      if (p > 0 && p < 100) {
	        loadIncomplete = true;
	      }
	    }
	    setTimeout(function() {
	      p = sm2.getMoviePercent();
	      if (loadIncomplete) {
	        waitingForEI = false;
	        window.setTimeout(delayWaitForEI, 1);
	        return;
	      }
	      if (!didInit && okToDisable) {
	        if (p === null) {
	          if (sm2.useFlashBlock || sm2.flashLoadTimeout === 0) {
	            if (sm2.useFlashBlock) {
	              flashBlockHandler();
	            }
	          } else if (!sm2.useFlashBlock && canIgnoreFlash) {
	            rebootIntoHTML5();
	          } else {
	            processOnEvents({
	              type: 'ontimeout',
	              ignoreInit: true,
	              error: {
	                type: 'INIT_FLASHBLOCK'
	              }
	            });
	          }
	        } else if (sm2.flashLoadTimeout === 0) {
	        } else if (!sm2.useFlashBlock && canIgnoreFlash) {
	          rebootIntoHTML5();
	        } else {
	          failSafely(true);
	        }
	      }
	    }, sm2.flashLoadTimeout);
	  };
	  handleFocus = function() {
	    function cleanup() {
	      event.remove(window, 'focus', handleFocus);
	    }
	    if (isFocused || !tryInitOnFocus) {
	      cleanup();
	      return true;
	    }
	    okToDisable = true;
	    isFocused = true;
	    waitingForEI = false;
	    delayWaitForEI();
	    cleanup();
	    return true;
	  };
	  flushMessages = function() {
	  };
	  showSupport = function() {
	  };
	  initComplete = function(bNoDisable) {
	    if (didInit) return false;
	    if (sm2.html5Only) {
	      didInit = true;
	      initUserOnload();
	      return true;
	    }
	    var wasTimeout = (sm2.useFlashBlock && sm2.flashLoadTimeout && !sm2.getMoviePercent()),
	        result = true,
	        error;
	    if (!wasTimeout) {
	      didInit = true;
	    }
	    error = {
	      type: (!hasFlash && needsFlash ? 'NO_FLASH' : 'INIT_TIMEOUT')
	    };
	    if (disabled || bNoDisable) {
	      if (sm2.useFlashBlock && sm2.oMC) {
	        sm2.oMC.className = getSWFCSS() + ' ' + (sm2.getMoviePercent() === null ? swfCSS.swfTimedout : swfCSS.swfError);
	      }
	      processOnEvents({
	        type: 'ontimeout',
	        error: error,
	        ignoreInit: true
	      });
	      catchError(error);
	      result = false;
	    } else {
	    }
	    if (!disabled) {
	      if (sm2.waitForWindowLoad && !windowLoaded) {
	        event.add(window, 'load', initUserOnload);
	      } else {
	        initUserOnload();
	      }
	    }
	    return result;
	  };
	  setProperties = function() {
	    var i,
	        o = sm2.setupOptions;
	    for (i in o) {
	      if (o.hasOwnProperty(i)) {
	        if (sm2[i] === _undefined) {
	          sm2[i] = o[i];
	        } else if (sm2[i] !== o[i]) {
	          sm2.setupOptions[i] = sm2[i];
	        }
	      }
	    }
	  };
	  init = function() {
	    if (didInit) {
	      return false;
	    }
	    function cleanup() {
	      event.remove(window, 'load', sm2.beginDelayedInit);
	    }
	    if (sm2.html5Only) {
	      if (!didInit) {
	        cleanup();
	        sm2.enabled = true;
	        initComplete();
	      }
	      return true;
	    }
	    initMovie();
	    try {
	      flash._externalInterfaceTest(false);
	      setPolling(true, (sm2.flashPollingInterval || (sm2.useHighPerformance ? 10 : 50)));
	      if (!sm2.debugMode) {
	        flash._disableDebug();
	      }
	      sm2.enabled = true;
	      if (!sm2.html5Only) {
	        event.add(window, 'unload', doNothing);
	      }
	    } catch(e) {
	      catchError({
	        type: 'JS_TO_FLASH_EXCEPTION',
	        fatal: true
	      });
	      failSafely(true);
	      initComplete();
	      return false;
	    }
	    initComplete();
	    cleanup();
	    return true;
	  };
	  domContentLoaded = function() {
	    if (didDCLoaded) return false;
	    didDCLoaded = true;
	    setProperties();
	    initDebug();
	    if (!hasFlash && sm2.hasHTML5) {
	      sm2.setup({
	        useHTML5Audio: true,
	        preferFlash: false
	      });
	    }
	    testHTML5();
	    if (!hasFlash && needsFlash) {
	      messages.push(strings.needFlash);
	      sm2.setup({
	        flashLoadTimeout: 1
	      });
	    }
	    if (doc.removeEventListener) {
	      doc.removeEventListener('DOMContentLoaded', domContentLoaded, false);
	    }
	    initMovie();
	    return true;
	  };
	  domContentLoadedIE = function() {
	    if (doc.readyState === 'complete') {
	      domContentLoaded();
	      doc.detachEvent('onreadystatechange', domContentLoadedIE);
	    }
	    return true;
	  };
	  winOnLoad = function() {
	    windowLoaded = true;
	    domContentLoaded();
	    event.remove(window, 'load', winOnLoad);
	  };
	  detectFlash();
	  event.add(window, 'focus', handleFocus);
	  event.add(window, 'load', delayWaitForEI);
	  event.add(window, 'load', winOnLoad);
	  if (doc.addEventListener) {
	    doc.addEventListener('DOMContentLoaded', domContentLoaded, false);
	  } else if (doc.attachEvent) {
	    doc.attachEvent('onreadystatechange', domContentLoadedIE);
	  } else {
	    catchError({
	      type: 'NO_DOM2_EVENTS',
	      fatal: true
	    });
	  }
	}
	// SM2_DEFER details: http://www.schillmania.com/projects/soundmanager2/doc/getstarted/#lazy-loading
	if (window.SM2_DEFER === _undefined || !SM2_DEFER) {
	  soundManager = new SoundManager();
	}
	if (typeof module === 'object' && module && typeof module.exports === 'object') {
	  module.exports.SoundManager = SoundManager;
	  module.exports.soundManager = soundManager;
	} else if (true) {
	  !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	    function getInstance(smBuilder) {
	      if (!window.soundManager && smBuilder instanceof Function) {
	        var instance = smBuilder(SoundManager);
	        if (instance instanceof SoundManager) {
	          window.soundManager = instance;
	        }
	      }
	      return window.soundManager;
	    }
	    return {
	      constructor: SoundManager,
	      getInstance: getInstance
	    };
	  }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	// standard browser case
	// constructor
	window.SoundManager = SoundManager;
	// public API, flash callbacks etc.
	window.soundManager = soundManager;
	}(window));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(23)(module)))

/***/ }),

/***/ 7:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, module) {'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var hyphenate = _interopDefault(__webpack_require__(113));
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var Stylis = _interopDefault(__webpack_require__(143));
	var _insertRulePlugin = _interopDefault(__webpack_require__(142));
	var PropTypes = _interopDefault(__webpack_require__(10));
	var hoistStatics = _interopDefault(__webpack_require__(70));
	var reactIs = __webpack_require__(136);
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	};
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	var objectWithoutProperties = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	// 
	var isPlainObject = (function (x) {
	  return (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object' && x.constructor === Object;
	});
	
	// 
	
	
	/**
	 * Parse errors.md and turn it into a simple hash of code: message
	 */
	var ERRORS =  false ? {
	  "1": "Cannot create styled-component for component: %s.\n\n",
	  "2": "Can't collect styles once you've consumed a `ServerStyleSheet`'s styles! `ServerStyleSheet` is a one off instance for each server-side render cycle.\n\n* Are you trying to reuse it across renders?\n* Are you accidentally calling collectStyles twice?\n\n",
	  "3": "Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.\n\n",
	  "4": "The `StyleSheetManager` expects a valid target or sheet prop!\n\n* Does this error occur on the client and is your target falsy?\n* Does this error occur on the server and is the sheet falsy?\n\n",
	  "5": "The clone method cannot be used on the client!\n\n* Are you running in a client-like environment on the server?\n* Are you trying to run SSR on the client?\n\n",
	  "6": "Trying to insert a new style tag, but the given Node is unmounted!\n\n* Are you using a custom target that isn't mounted?\n* Does your document not have a valid head element?\n* Have you accidentally removed a style tag manually?\n\n",
	  "7": "ThemeProvider: Please return an object from your \"theme\" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n",
	  "8": "ThemeProvider: Please make your \"theme\" prop an object.\n\n",
	  "9": "Missing document `<head>`\n\n",
	  "10": "Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021\n\n",
	  "11": "A plain React class (%s) has been interpolated into styles, probably as a component selector (https://www.styled-components.com/docs/advanced#referring-to-other-components). Only styled-component classes can be targeted in this fashion."
	} : {};
	
	/**
	 * super basic version of sprintf
	 */
	function format() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  var a = args[0];
	  var b = [];
	  var c = void 0;
	
	  for (c = 1; c < args.length; c += 1) {
	    b.push(args[c]);
	  }
	
	  b.forEach(function (d) {
	    a = a.replace(/%[a-z]/, d);
	  });
	
	  return a;
	}
	
	/**
	 * Create an error file out of errors.md for development and a simple web link to the full errors
	 * in production mode.
	 */
	
	var StyledComponentsError = function (_Error) {
	  inherits(StyledComponentsError, _Error);
	
	  function StyledComponentsError(code) {
	    classCallCheck(this, StyledComponentsError);
	
	    for (var _len2 = arguments.length, interpolations = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	      interpolations[_key2 - 1] = arguments[_key2];
	    }
	
	    if (true) {
	      var _this = possibleConstructorReturn(this, _Error.call(this, 'An error occurred. See https://github.com/styled-components/styled-components/blob/master/src/utils/errors.md#' + code + ' for more information. ' + (interpolations ? 'Additional arguments: ' + interpolations.join(', ') : '')));
	    } else {
	      var _this = possibleConstructorReturn(this, _Error.call(this, format.apply(undefined, [ERRORS[code]].concat(interpolations))));
	    }
	    return possibleConstructorReturn(_this);
	  }
	
	  return StyledComponentsError;
	}(Error);
	
	// 
	
	var objToCss = function objToCss(obj, prevKey) {
	  var css = Object.keys(obj).filter(function (key) {
	    var chunk = obj[key];
	    return chunk !== undefined && chunk !== null && chunk !== false && chunk !== '';
	  }).map(function (key) {
	    if (isPlainObject(obj[key])) return objToCss(obj[key], key);
	    return hyphenate(key) + ': ' + obj[key] + ';';
	  }).join(' ');
	  return prevKey ? prevKey + ' {\n  ' + css + '\n}' : css;
	};
	
	var flatten = function flatten(chunks, executionContext) {
	  return chunks.reduce(function (ruleSet, chunk) {
	    /* Remove falsey values */
	    if (chunk === undefined || chunk === null || chunk === false || chunk === '') {
	      return ruleSet;
	    }
	
	    /* Flatten ruleSet */
	    if (Array.isArray(chunk)) {
	      ruleSet.push.apply(ruleSet, flatten(chunk, executionContext));
	      return ruleSet;
	    }
	
	    /* Handle other components */
	    if (chunk.hasOwnProperty('styledComponentId')) {
	      // $FlowFixMe not sure how to make this pass
	      ruleSet.push('.' + chunk.styledComponentId);
	      return ruleSet;
	    }
	
	    /* Either execute or defer the function */
	    if (typeof chunk === 'function') {
	      if (executionContext) {
	        var nextChunk = chunk(executionContext);
	        /* Throw if a React Element was given styles */
	        if (React__default.isValidElement(nextChunk)) {
	          var elementName = chunk.displayName || chunk.name;
	          throw new StyledComponentsError(11, elementName);
	        }
	        ruleSet.push.apply(ruleSet, flatten([nextChunk], executionContext));
	      } else ruleSet.push(chunk);
	
	      return ruleSet;
	    }
	
	    /* Handle objects */
	    ruleSet.push(
	    // $FlowFixMe have to add %checks somehow to isPlainObject
	    isPlainObject(chunk) ? objToCss(chunk) : chunk.toString());
	
	    return ruleSet;
	  }, []);
	};
	
	// 
	
	var COMMENT_REGEX = /^\s*\/\/.*$/gm;
	
	// NOTE: This stylis instance is only used to split rules from SSR'd style tags
	var stylisSplitter = new Stylis({
	  global: false,
	  cascade: true,
	  keyframe: false,
	  prefix: false,
	  compress: false,
	  semicolon: true
	});
	
	var stylis = new Stylis({
	  global: false,
	  cascade: true,
	  keyframe: false,
	  prefix: true,
	  compress: false,
	  semicolon: false // NOTE: This means "autocomplete missing semicolons"
	});
	
	// Wrap `insertRulePlugin to build a list of rules,
	// and then make our own plugin to return the rules. This
	// makes it easier to hook into the existing SSR architecture
	
	var parsingRules = [];
	// eslint-disable-next-line consistent-return
	var returnRulesPlugin = function returnRulesPlugin(context) {
	  if (context === -2) {
	    var parsedRules = parsingRules;
	    parsingRules = [];
	    return parsedRules;
	  }
	};
	
	var parseRulesPlugin = _insertRulePlugin(function (rule) {
	  parsingRules.push(rule);
	});
	
	stylis.use([parseRulesPlugin, returnRulesPlugin]);
	stylisSplitter.use([parseRulesPlugin, returnRulesPlugin]);
	
	var stringifyRules = function stringifyRules(rules, selector, prefix) {
	  var flatCSS = rules.join('').replace(COMMENT_REGEX, ''); // replace JS comments
	
	  var cssStr = selector && prefix ? prefix + ' ' + selector + ' { ' + flatCSS + ' }' : flatCSS;
	
	  return stylis(prefix || !selector ? '' : selector, cssStr);
	};
	
	var splitByRules = function splitByRules(css) {
	  return stylisSplitter('', css);
	};
	
	// 
	
	function isStyledComponent(target) /* : %checks */{
	  return (
	    // $FlowFixMe TODO: flow for styledComponentId
	    typeof target === 'function' && typeof target.styledComponentId === 'string'
	  );
	}
	
	// 
	
	/* This function is DEPRECATED and will be removed on the next major version release.
	 * It was needed to rehydrate all style blocks prepended to chunks before React
	 * tries to rehydrate its HTML stream. Since the master StyleSheet will now detect
	 * the use of streamed style tags and will perform the rehydration earlier when needed
	 * this function will not be needed anymore */
	function consolidateStreamedStyles() {
	  if (false) {
	    // eslint-disable-next-line no-console
	    console.warn('styled-components automatically does streaming SSR rehydration now.\n' + 'Calling consolidateStreamedStyles manually is no longer necessary and a noop now.\n' + '- Please remove the consolidateStreamedStyles call from your client.');
	  }
	}
	
	// 
	/* eslint-disable no-bitwise */
	
	/* This is the "capacity" of our alphabet i.e. 2x26 for all letters plus their capitalised
	 * counterparts */
	var charsLength = 52;
	
	/* start at 75 for 'a' until 'z' (25) and then start at 65 for capitalised letters */
	var getAlphabeticChar = function getAlphabeticChar(code) {
	  return String.fromCharCode(code + (code > 25 ? 39 : 97));
	};
	
	/* input a number, usually a hash and convert it to base-52 */
	var generateAlphabeticName = function generateAlphabeticName(code) {
	  var name = '';
	  var x = void 0;
	
	  /* get a char and divide by alphabet-length */
	  for (x = code; x > charsLength; x = Math.floor(x / charsLength)) {
	    name = getAlphabeticChar(x % charsLength) + name;
	  }
	
	  return getAlphabeticChar(x % charsLength) + name;
	};
	
	// 
	
	var interleave = (function (strings, interpolations) {
	  var result = [strings[0]];
	
	  for (var i = 0, len = interpolations.length; i < len; i += 1) {
	    result.push(interpolations[i], strings[i + 1]);
	  }
	
	  return result;
	});
	
	// 
	var EMPTY_ARRAY = Object.freeze([]);
	var EMPTY_OBJECT = Object.freeze({});
	
	// 
	
	var css = (function (styles) {
	  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    interpolations[_key - 1] = arguments[_key];
	  }
	
	  if (typeof styles === 'function' || isPlainObject(styles)) {
	    // $FlowFixMe
	    return flatten(interleave(EMPTY_ARRAY, [styles].concat(interpolations)));
	  }
	
	  // $FlowFixMe
	  return flatten(interleave(styles, interpolations));
	});
	
	// 
	
	
	var SC_ATTR = typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_DIR":"/opt/build/repo/public"}).SC_ATTR || 'data-styled-components';
	var SC_STREAM_ATTR = 'data-styled-streamed';
	var CONTEXT_KEY = '__styled-components-stylesheet__';
	
	var IS_BROWSER = typeof window !== 'undefined' && 'HTMLElement' in window;
	
	var DISABLE_SPEEDY = ("production") !== 'production';
	
	// 
	var SC_COMPONENT_ID = /^[^\S\n]*?\/\* sc-component-id:\s*(\S+)\s+\*\//gm;
	
	var extractComps = (function (maybeCSS) {
	  var css = '' + (maybeCSS || ''); // Definitely a string, and a clone
	  var existingComponents = [];
	  css.replace(SC_COMPONENT_ID, function (match, componentId, matchIndex) {
	    existingComponents.push({ componentId: componentId, matchIndex: matchIndex });
	    return match;
	  });
	  return existingComponents.map(function (_ref, i) {
	    var componentId = _ref.componentId,
	        matchIndex = _ref.matchIndex;
	
	    var nextComp = existingComponents[i + 1];
	    var cssFromDOM = nextComp ? css.slice(matchIndex, nextComp.matchIndex) : css.slice(matchIndex);
	    return { componentId: componentId, cssFromDOM: cssFromDOM };
	  });
	});
	
	// 
	/* eslint-disable camelcase, no-undef */
	
	var getNonce = (function () {
	  return typeof __webpack_nonce__ !== 'undefined' ? __webpack_nonce__ : null;
	});
	
	// 
	// Helper to call a given function, only once
	var once = (function (cb) {
	  var called = false;
	
	  return function () {
	    if (!called) {
	      called = true;
	      cb();
	    }
	  };
	});
	
	// 
	/* These are helpers for the StyleTags to keep track of the injected
	 * rule names for each (component) ID that they're keeping track of.
	 * They're crucial for detecting whether a name has already been
	 * injected.
	 * (This excludes rehydrated names) */
	
	/* adds a new ID:name pairing to a names dictionary */
	var addNameForId = function addNameForId(names, id, name) {
	  if (name) {
	    // eslint-disable-next-line no-param-reassign
	    var namesForId = names[id] || (names[id] = Object.create(null));
	    namesForId[name] = true;
	  }
	};
	
	/* resets an ID entirely by overwriting it in the dictionary */
	var resetIdNames = function resetIdNames(names, id) {
	  // eslint-disable-next-line no-param-reassign
	  names[id] = Object.create(null);
	};
	
	/* factory for a names dictionary checking the existance of an ID:name pairing */
	var hasNameForId = function hasNameForId(names) {
	  return function (id, name) {
	    return names[id] !== undefined && names[id][name];
	  };
	};
	
	/* stringifies names for the html/element output */
	var stringifyNames = function stringifyNames(names) {
	  var str = '';
	  // eslint-disable-next-line guard-for-in
	  for (var id in names) {
	    str += Object.keys(names[id]).join(' ') + ' ';
	  }
	  return str.trim();
	};
	
	/* clones the nested names dictionary */
	var cloneNames = function cloneNames(names) {
	  var clone = Object.create(null);
	  // eslint-disable-next-line guard-for-in
	  for (var id in names) {
	    clone[id] = _extends({}, names[id]);
	  }
	  return clone;
	};
	
	// 
	
	/* These are helpers that deal with the insertRule (aka speedy) API
	 * They are used in the StyleTags and specifically the speedy tag
	 */
	
	/* retrieve a sheet for a given style tag */
	var sheetForTag = function sheetForTag(tag) {
	  // $FlowFixMe
	  if (tag.sheet) return tag.sheet;
	
	  /* Firefox quirk requires us to step through all stylesheets to find one owned by the given tag */
	  var size = document.styleSheets.length;
	  for (var i = 0; i < size; i += 1) {
	    var sheet = document.styleSheets[i];
	    // $FlowFixMe
	    if (sheet.ownerNode === tag) return sheet;
	  }
	
	  /* we should always be able to find a tag */
	  throw new StyledComponentsError(10);
	};
	
	/* insert a rule safely and return whether it was actually injected */
	var safeInsertRule = function safeInsertRule(sheet, cssRule, index) {
	  /* abort early if cssRule string is falsy */
	  if (!cssRule) return false;
	
	  var maxIndex = sheet.cssRules.length;
	
	  try {
	    /* use insertRule and cap passed index with maxIndex (no of cssRules) */
	    sheet.insertRule(cssRule, index <= maxIndex ? index : maxIndex);
	  } catch (err) {
	    /* any error indicates an invalid rule */
	    return false;
	  }
	
	  return true;
	};
	
	/* deletes `size` rules starting from `removalIndex` */
	var deleteRules = function deleteRules(sheet, removalIndex, size) {
	  var lowerBound = removalIndex - size;
	  for (var i = removalIndex; i > lowerBound; i -= 1) {
	    sheet.deleteRule(i);
	  }
	};
	
	// 
	
	/* this marker separates component styles and is important for rehydration */
	var makeTextMarker = function makeTextMarker(id) {
	  return '\n/* sc-component-id: ' + id + ' */\n';
	};
	
	/* add up all numbers in array up until and including the index */
	var addUpUntilIndex = function addUpUntilIndex(sizes, index) {
	  var totalUpToIndex = 0;
	  for (var i = 0; i <= index; i += 1) {
	    totalUpToIndex += sizes[i];
	  }
	
	  return totalUpToIndex;
	};
	
	/* create a new style tag after lastEl */
	var makeStyleTag = function makeStyleTag(target, tagEl, insertBefore) {
	  var el = document.createElement('style');
	  el.setAttribute(SC_ATTR, '');
	
	  var nonce = getNonce();
	  if (nonce) {
	    el.setAttribute('nonce', nonce);
	  }
	
	  /* Work around insertRule quirk in EdgeHTML */
	  el.appendChild(document.createTextNode(''));
	
	  if (target && !tagEl) {
	    /* Append to target when no previous element was passed */
	    target.appendChild(el);
	  } else {
	    if (!tagEl || !target || !tagEl.parentNode) {
	      throw new StyledComponentsError(6);
	    }
	
	    /* Insert new style tag after the previous one */
	    tagEl.parentNode.insertBefore(el, insertBefore ? tagEl : tagEl.nextSibling);
	  }
	
	  return el;
	};
	
	/* takes a css factory function and outputs an html styled tag factory */
	var wrapAsHtmlTag = function wrapAsHtmlTag(css, names) {
	  return function (additionalAttrs) {
	    var nonce = getNonce();
	    var attrs = [nonce && 'nonce="' + nonce + '"', SC_ATTR + '="' + stringifyNames(names) + '"', additionalAttrs];
	
	    var htmlAttr = attrs.filter(Boolean).join(' ');
	    return '<style ' + htmlAttr + '>' + css() + '</style>';
	  };
	};
	
	/* takes a css factory function and outputs an element factory */
	var wrapAsElement = function wrapAsElement(css, names) {
	  return function () {
	    var _props;
	
	    var props = (_props = {}, _props[SC_ATTR] = stringifyNames(names), _props);
	
	    var nonce = getNonce();
	    if (nonce) {
	      // $FlowFixMe
	      props.nonce = nonce;
	    }
	
	    // eslint-disable-next-line react/no-danger
	    return React__default.createElement('style', _extends({}, props, { dangerouslySetInnerHTML: { __html: css() } }));
	  };
	};
	
	var getIdsFromMarkersFactory = function getIdsFromMarkersFactory(markers) {
	  return function () {
	    return Object.keys(markers);
	  };
	};
	
	/* speedy tags utilise insertRule */
	var makeSpeedyTag = function makeSpeedyTag(el, getImportRuleTag) {
	  var names = Object.create(null);
	  var markers = Object.create(null);
	  var sizes = [];
	
	  var extractImport = getImportRuleTag !== undefined;
	  /* indicates whther getImportRuleTag was called */
	  var usedImportRuleTag = false;
	
	  var insertMarker = function insertMarker(id) {
	    var prev = markers[id];
	    if (prev !== undefined) {
	      return prev;
	    }
	
	    markers[id] = sizes.length;
	    sizes.push(0);
	    resetIdNames(names, id);
	
	    return markers[id];
	  };
	
	  var insertRules = function insertRules(id, cssRules, name) {
	    var marker = insertMarker(id);
	    var sheet = sheetForTag(el);
	    var insertIndex = addUpUntilIndex(sizes, marker);
	
	    var injectedRules = 0;
	    var importRules = [];
	    var cssRulesSize = cssRules.length;
	
	    for (var i = 0; i < cssRulesSize; i += 1) {
	      var cssRule = cssRules[i];
	      var mayHaveImport = extractImport; /* @import rules are reordered to appear first */
	      if (mayHaveImport && cssRule.indexOf('@import') !== -1) {
	        importRules.push(cssRule);
	      } else if (safeInsertRule(sheet, cssRule, insertIndex + injectedRules)) {
	        mayHaveImport = false;
	        injectedRules += 1;
	      }
	    }
	
	    if (extractImport && importRules.length > 0) {
	      usedImportRuleTag = true;
	      // $FlowFixMe
	      getImportRuleTag().insertRules(id + '-import', importRules);
	    }
	
	    sizes[marker] += injectedRules; /* add up no of injected rules */
	    addNameForId(names, id, name);
	  };
	
	  var removeRules = function removeRules(id) {
	    var marker = markers[id];
	    if (marker === undefined) return;
	
	    var size = sizes[marker];
	    var sheet = sheetForTag(el);
	    var removalIndex = addUpUntilIndex(sizes, marker);
	    deleteRules(sheet, removalIndex, size);
	    sizes[marker] = 0;
	    resetIdNames(names, id);
	
	    if (extractImport && usedImportRuleTag) {
	      // $FlowFixMe
	      getImportRuleTag().removeRules(id + '-import');
	    }
	  };
	
	  var css = function css() {
	    var _sheetForTag = sheetForTag(el),
	        cssRules = _sheetForTag.cssRules;
	
	    var str = '';
	
	    // eslint-disable-next-line guard-for-in
	    for (var id in markers) {
	      str += makeTextMarker(id);
	      var marker = markers[id];
	      var end = addUpUntilIndex(sizes, marker);
	      var size = sizes[marker];
	      for (var i = end - size; i < end; i += 1) {
	        var rule = cssRules[i];
	        if (rule !== undefined) {
	          str += rule.cssText;
	        }
	      }
	    }
	
	    return str;
	  };
	
	  return {
	    clone: function clone() {
	      throw new StyledComponentsError(5);
	    },
	
	    css: css,
	    getIds: getIdsFromMarkersFactory(markers),
	    hasNameForId: hasNameForId(names),
	    insertMarker: insertMarker,
	    insertRules: insertRules,
	    removeRules: removeRules,
	    sealed: false,
	    styleTag: el,
	    toElement: wrapAsElement(css, names),
	    toHTML: wrapAsHtmlTag(css, names)
	  };
	};
	
	var makeTextNode = function makeTextNode(id) {
	  return document.createTextNode(makeTextMarker(id));
	};
	
	var makeBrowserTag = function makeBrowserTag(el, getImportRuleTag) {
	  var names = Object.create(null);
	  var markers = Object.create(null);
	
	  var extractImport = getImportRuleTag !== undefined;
	
	  /* indicates whther getImportRuleTag was called */
	  var usedImportRuleTag = false;
	
	  var insertMarker = function insertMarker(id) {
	    var prev = markers[id];
	    if (prev !== undefined) {
	      return prev;
	    }
	
	    markers[id] = makeTextNode(id);
	    el.appendChild(markers[id]);
	    names[id] = Object.create(null);
	
	    return markers[id];
	  };
	
	  var insertRules = function insertRules(id, cssRules, name) {
	    var marker = insertMarker(id);
	    var importRules = [];
	    var cssRulesSize = cssRules.length;
	
	    for (var i = 0; i < cssRulesSize; i += 1) {
	      var rule = cssRules[i];
	      var mayHaveImport = extractImport;
	      if (mayHaveImport && rule.indexOf('@import') !== -1) {
	        importRules.push(rule);
	      } else {
	        mayHaveImport = false;
	        var separator = i === cssRulesSize - 1 ? '' : ' ';
	        marker.appendData('' + rule + separator);
	      }
	    }
	
	    addNameForId(names, id, name);
	
	    if (extractImport && importRules.length > 0) {
	      usedImportRuleTag = true;
	      // $FlowFixMe
	      getImportRuleTag().insertRules(id + '-import', importRules);
	    }
	  };
	
	  var removeRules = function removeRules(id) {
	    var marker = markers[id];
	    if (marker === undefined) return;
	
	    /* create new empty text node and replace the current one */
	    var newMarker = makeTextNode(id);
	    el.replaceChild(newMarker, marker);
	    markers[id] = newMarker;
	    resetIdNames(names, id);
	
	    if (extractImport && usedImportRuleTag) {
	      // $FlowFixMe
	      getImportRuleTag().removeRules(id + '-import');
	    }
	  };
	
	  var css = function css() {
	    var str = '';
	    // eslint-disable-next-line guard-for-in
	    for (var id in markers) {
	      str += markers[id].data;
	    }
	    return str;
	  };
	
	  return {
	    clone: function clone() {
	      throw new StyledComponentsError(5);
	    },
	
	    css: css,
	    getIds: getIdsFromMarkersFactory(markers),
	    hasNameForId: hasNameForId(names),
	    insertMarker: insertMarker,
	    insertRules: insertRules,
	    removeRules: removeRules,
	    sealed: false,
	    styleTag: el,
	    toElement: wrapAsElement(css, names),
	    toHTML: wrapAsHtmlTag(css, names)
	  };
	};
	
	var makeServerTagInternal = function makeServerTagInternal(namesArg, markersArg) {
	  var names = namesArg === undefined ? Object.create(null) : namesArg;
	  var markers = markersArg === undefined ? Object.create(null) : markersArg;
	
	  var insertMarker = function insertMarker(id) {
	    var prev = markers[id];
	    if (prev !== undefined) {
	      return prev;
	    }
	
	    return markers[id] = [''];
	  };
	
	  var insertRules = function insertRules(id, cssRules, name) {
	    var marker = insertMarker(id);
	    marker[0] += cssRules.join(' ');
	    addNameForId(names, id, name);
	  };
	
	  var removeRules = function removeRules(id) {
	    var marker = markers[id];
	    if (marker === undefined) return;
	    marker[0] = '';
	    resetIdNames(names, id);
	  };
	
	  var css = function css() {
	    var str = '';
	    // eslint-disable-next-line guard-for-in
	    for (var id in markers) {
	      var cssForId = markers[id][0];
	      if (cssForId) {
	        str += makeTextMarker(id) + cssForId;
	      }
	    }
	    return str;
	  };
	
	  var clone = function clone() {
	    var namesClone = cloneNames(names);
	    var markersClone = Object.create(null);
	
	    // eslint-disable-next-line guard-for-in
	    for (var id in markers) {
	      markersClone[id] = [markers[id][0]];
	    }
	
	    return makeServerTagInternal(namesClone, markersClone);
	  };
	
	  var tag = {
	    clone: clone,
	    css: css,
	    getIds: getIdsFromMarkersFactory(markers),
	    hasNameForId: hasNameForId(names),
	    insertMarker: insertMarker,
	    insertRules: insertRules,
	    removeRules: removeRules,
	    sealed: false,
	    styleTag: null,
	    toElement: wrapAsElement(css, names),
	    toHTML: wrapAsHtmlTag(css, names)
	  };
	
	  return tag;
	};
	
	var makeServerTag = function makeServerTag() {
	  return makeServerTagInternal();
	};
	
	var makeTag = function makeTag(target, tagEl, forceServer, insertBefore, getImportRuleTag) {
	  if (IS_BROWSER && !forceServer) {
	    var el = makeStyleTag(target, tagEl, insertBefore);
	
	    if (DISABLE_SPEEDY) {
	      return makeBrowserTag(el, getImportRuleTag);
	    } else {
	      return makeSpeedyTag(el, getImportRuleTag);
	    }
	  }
	
	  return makeServerTag();
	};
	
	/* wraps a given tag so that rehydration is performed once when necessary */
	var makeRehydrationTag = function makeRehydrationTag(tag, els, extracted, immediateRehydration) {
	  /* rehydration function that adds all rules to the new tag */
	  var rehydrate = once(function () {
	    /* add all extracted components to the new tag */
	    for (var i = 0, len = extracted.length; i < len; i += 1) {
	      var _extracted$i = extracted[i],
	          componentId = _extracted$i.componentId,
	          cssFromDOM = _extracted$i.cssFromDOM;
	
	      var cssRules = splitByRules(cssFromDOM);
	      tag.insertRules(componentId, cssRules);
	    }
	
	    /* remove old HTMLStyleElements, since they have been rehydrated */
	    for (var _i = 0, _len = els.length; _i < _len; _i += 1) {
	      var el = els[_i];
	      if (el.parentNode) {
	        el.parentNode.removeChild(el);
	      }
	    }
	  });
	
	  if (immediateRehydration) rehydrate();
	
	  return _extends({}, tag, {
	    /* add rehydration hook to insertion methods */
	    insertMarker: function insertMarker(id) {
	      rehydrate();
	      return tag.insertMarker(id);
	    },
	    insertRules: function insertRules(id, cssRules, name) {
	      rehydrate();
	      return tag.insertRules(id, cssRules, name);
	    }
	  });
	};
	
	// 
	
	var SPLIT_REGEX = /\s+/;
	
	/* determine the maximum number of components before tags are sharded */
	var MAX_SIZE = void 0;
	if (IS_BROWSER) {
	  /* in speedy mode we can keep a lot more rules in a sheet before a slowdown can be expected */
	  MAX_SIZE = DISABLE_SPEEDY ? 40 : 1000;
	} else {
	  /* for servers we do not need to shard at all */
	  MAX_SIZE = -1;
	}
	
	var sheetRunningId = 0;
	var master = void 0;
	
	var StyleSheet = function () {
	  /* a map from ids to tags */
	  /* deferred rules for a given id */
	  /* this is used for not reinjecting rules via hasNameForId() */
	  /* when rules for an id are removed using remove() we have to ignore rehydratedNames for it */
	  /* a list of tags belonging to this StyleSheet */
	  /* a tag for import rules */
	  /* current capacity until a new tag must be created */
	  /* children (aka clones) of this StyleSheet inheriting all and future injections */
	
	  function StyleSheet() {
	    var _this = this;
	
	    var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : IS_BROWSER ? document.head : null;
	    var forceServer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	    classCallCheck(this, StyleSheet);
	
	    this.getImportRuleTag = function () {
	      var importRuleTag = _this.importRuleTag;
	
	      if (importRuleTag !== undefined) {
	        return importRuleTag;
	      }
	
	      var firstTag = _this.tags[0];
	      var insertBefore = true;
	
	      return _this.importRuleTag = makeTag(_this.target, firstTag ? firstTag.styleTag : null, _this.forceServer, insertBefore);
	    };
	
	    sheetRunningId += 1;
	    this.id = sheetRunningId;
	    this.forceServer = forceServer;
	    this.target = forceServer ? null : target;
	    this.tagMap = {};
	    this.deferred = {};
	    this.rehydratedNames = {};
	    this.ignoreRehydratedNames = {};
	    this.tags = [];
	    this.capacity = 1;
	    this.clones = [];
	  }
	
	  /* rehydrate all SSR'd style tags */
	
	
	  StyleSheet.prototype.rehydrate = function rehydrate() {
	    if (!IS_BROWSER || this.forceServer) {
	      return this;
	    }
	
	    var els = [];
	    var extracted = [];
	    var isStreamed = false;
	
	    /* retrieve all of our SSR style elements from the DOM */
	    var nodes = document.querySelectorAll('style[' + SC_ATTR + ']');
	    var nodesSize = nodes.length;
	
	    /* abort rehydration if no previous style tags were found */
	    if (nodesSize === 0) {
	      return this;
	    }
	
	    for (var i = 0; i < nodesSize; i += 1) {
	      // $FlowFixMe: We can trust that all elements in this query are style elements
	      var el = nodes[i];
	
	      /* check if style tag is a streamed tag */
	      if (!isStreamed) isStreamed = !!el.getAttribute(SC_STREAM_ATTR);
	
	      /* retrieve all component names */
	      var elNames = (el.getAttribute(SC_ATTR) || '').trim().split(SPLIT_REGEX);
	      var elNamesSize = elNames.length;
	      for (var j = 0; j < elNamesSize; j += 1) {
	        var name = elNames[j];
	        /* add rehydrated name to sheet to avoid readding styles */
	        this.rehydratedNames[name] = true;
	      }
	
	      /* extract all components and their CSS */
	      extracted.push.apply(extracted, extractComps(el.textContent));
	
	      /* store original HTMLStyleElement */
	      els.push(el);
	    }
	
	    /* abort rehydration if nothing was extracted */
	    var extractedSize = extracted.length;
	    if (extractedSize === 0) {
	      return this;
	    }
	
	    /* create a tag to be used for rehydration */
	    var tag = this.makeTag(null);
	    var rehydrationTag = makeRehydrationTag(tag, els, extracted, isStreamed);
	
	    /* reset capacity and adjust MAX_SIZE by the initial size of the rehydration */
	    this.capacity = Math.max(1, MAX_SIZE - extractedSize);
	    this.tags.push(rehydrationTag);
	
	    /* retrieve all component ids */
	    for (var _j = 0; _j < extractedSize; _j += 1) {
	      this.tagMap[extracted[_j].componentId] = rehydrationTag;
	    }
	
	    return this;
	  };
	
	  /* retrieve a "master" instance of StyleSheet which is typically used when no other is available
	   * The master StyleSheet is targeted by injectGlobal, keyframes, and components outside of any
	    * StyleSheetManager's context */
	
	
	  /* reset the internal "master" instance */
	  StyleSheet.reset = function reset() {
	    var forceServer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    master = new StyleSheet(undefined, forceServer).rehydrate();
	  };
	
	  /* adds "children" to the StyleSheet that inherit all of the parents' rules
	   * while their own rules do not affect the parent */
	
	
	  StyleSheet.prototype.clone = function clone() {
	    var sheet = new StyleSheet(this.target, this.forceServer);
	
	    /* add to clone array */
	    this.clones.push(sheet);
	
	    /* clone all tags */
	    sheet.tags = this.tags.map(function (tag) {
	      var ids = tag.getIds();
	      var newTag = tag.clone();
	
	      /* reconstruct tagMap */
	      for (var i = 0; i < ids.length; i += 1) {
	        sheet.tagMap[ids[i]] = newTag;
	      }
	
	      return newTag;
	    });
	
	    /* clone other maps */
	    sheet.rehydratedNames = _extends({}, this.rehydratedNames);
	    sheet.deferred = _extends({}, this.deferred);
	
	    return sheet;
	  };
	
	  /* force StyleSheet to create a new tag on the next injection */
	
	
	  StyleSheet.prototype.sealAllTags = function sealAllTags() {
	    this.capacity = 1;
	
	    this.tags.forEach(function (tag) {
	      // eslint-disable-next-line no-param-reassign
	      tag.sealed = true;
	    });
	  };
	
	  StyleSheet.prototype.makeTag = function makeTag$$1(tag) {
	    var lastEl = tag ? tag.styleTag : null;
	    var insertBefore = false;
	
	    return makeTag(this.target, lastEl, this.forceServer, insertBefore, this.getImportRuleTag);
	  };
	
	  /* get a tag for a given componentId, assign the componentId to one, or shard */
	  StyleSheet.prototype.getTagForId = function getTagForId(id) {
	    /* simply return a tag, when the componentId was already assigned one */
	    var prev = this.tagMap[id];
	    if (prev !== undefined && !prev.sealed) {
	      return prev;
	    }
	
	    var tag = this.tags[this.tags.length - 1];
	
	    /* shard (create a new tag) if the tag is exhausted (See MAX_SIZE) */
	    this.capacity -= 1;
	
	    if (this.capacity === 0) {
	      this.capacity = MAX_SIZE;
	      tag = this.makeTag(tag);
	      this.tags.push(tag);
	    }
	
	    return this.tagMap[id] = tag;
	  };
	
	  /* mainly for injectGlobal to check for its id */
	
	
	  StyleSheet.prototype.hasId = function hasId(id) {
	    return this.tagMap[id] !== undefined;
	  };
	
	  /* caching layer checking id+name to already have a corresponding tag and injected rules */
	
	
	  StyleSheet.prototype.hasNameForId = function hasNameForId(id, name) {
	    /* exception for rehydrated names which are checked separately */
	    if (this.ignoreRehydratedNames[id] === undefined && this.rehydratedNames[name]) {
	      return true;
	    }
	
	    var tag = this.tagMap[id];
	    return tag !== undefined && tag.hasNameForId(id, name);
	  };
	
	  /* registers a componentId and registers it on its tag */
	
	
	  StyleSheet.prototype.deferredInject = function deferredInject(id, cssRules) {
	    /* don't inject when the id is already registered */
	    if (this.tagMap[id] !== undefined) return;
	
	    var clones = this.clones;
	
	    for (var i = 0; i < clones.length; i += 1) {
	      clones[i].deferredInject(id, cssRules);
	    }
	
	    this.getTagForId(id).insertMarker(id);
	    this.deferred[id] = cssRules;
	  };
	
	  /* injects rules for a given id with a name that will need to be cached */
	
	
	  StyleSheet.prototype.inject = function inject(id, cssRules, name) {
	    var clones = this.clones;
	
	
	    for (var i = 0; i < clones.length; i += 1) {
	      clones[i].inject(id, cssRules, name);
	    }
	
	    var tag = this.getTagForId(id);
	
	    /* add deferred rules for component */
	    if (this.deferred[id] !== undefined) {
	      // Combine passed cssRules with previously deferred CSS rules
	      // NOTE: We cannot mutate the deferred array itself as all clones
	      // do the same (see clones[i].inject)
	      var rules = this.deferred[id].concat(cssRules);
	      tag.insertRules(id, rules, name);
	
	      this.deferred[id] = undefined;
	    } else {
	      tag.insertRules(id, cssRules, name);
	    }
	  };
	
	  /* removes all rules for a given id, which doesn't remove its marker but resets it */
	
	
	  StyleSheet.prototype.remove = function remove(id) {
	    var tag = this.tagMap[id];
	    if (tag === undefined) return;
	
	    var clones = this.clones;
	
	    for (var i = 0; i < clones.length; i += 1) {
	      clones[i].remove(id);
	    }
	
	    /* remove all rules from the tag */
	    tag.removeRules(id);
	    /* ignore possible rehydrated names */
	    this.ignoreRehydratedNames[id] = true;
	    /* delete possible deferred rules */
	    this.deferred[id] = undefined;
	  };
	
	  StyleSheet.prototype.toHTML = function toHTML() {
	    return this.tags.map(function (tag) {
	      return tag.toHTML();
	    }).join('');
	  };
	
	  StyleSheet.prototype.toReactElements = function toReactElements() {
	    var id = this.id;
	
	
	    return this.tags.map(function (tag, i) {
	      var key = 'sc-' + id + '-' + i;
	      return React.cloneElement(tag.toElement(), { key: key });
	    });
	  };
	
	  createClass(StyleSheet, null, [{
	    key: 'master',
	    get: function get$$1() {
	      return master || (master = new StyleSheet().rehydrate());
	    }
	
	    /* NOTE: This is just for backwards-compatibility with jest-styled-components */
	
	  }, {
	    key: 'instance',
	    get: function get$$1() {
	      return StyleSheet.master;
	    }
	  }]);
	  return StyleSheet;
	}();
	
	var _StyleSheetManager$ch;
	
	var StyleSheetManager = function (_Component) {
	  inherits(StyleSheetManager, _Component);
	
	  function StyleSheetManager() {
	    classCallCheck(this, StyleSheetManager);
	    return possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  StyleSheetManager.prototype.getChildContext = function getChildContext() {
	    var _ref;
	
	    return _ref = {}, _ref[CONTEXT_KEY] = this.sheetInstance, _ref;
	  };
	
	  StyleSheetManager.prototype.componentWillMount = function componentWillMount() {
	    if (this.props.sheet) {
	      this.sheetInstance = this.props.sheet;
	    } else if (this.props.target) {
	      this.sheetInstance = new StyleSheet(this.props.target);
	    } else {
	      throw new StyledComponentsError(4);
	    }
	  };
	
	  StyleSheetManager.prototype.render = function render() {
	    /* eslint-disable react/prop-types */
	    // Flow v0.43.1 will report an error accessing the `children` property,
	    // but v0.47.0 will not. It is necessary to use a type cast instead of
	    // a "fixme" comment to satisfy both Flow versions.
	    return React__default.Children.only(this.props.children);
	  };
	
	  return StyleSheetManager;
	}(React.Component);
	
	StyleSheetManager.childContextTypes = (_StyleSheetManager$ch = {}, _StyleSheetManager$ch[CONTEXT_KEY] = PropTypes.oneOfType([PropTypes.instanceOf(StyleSheet), PropTypes.instanceOf(ServerStyleSheet)]).isRequired, _StyleSheetManager$ch);
	 false ? StyleSheetManager.propTypes = {
	  sheet: PropTypes.oneOfType([PropTypes.instanceOf(StyleSheet), PropTypes.instanceOf(ServerStyleSheet)]),
	  target: PropTypes.shape({
	    appendChild: PropTypes.func.isRequired
	  })
	} : void 0;
	
	// 
	
	var ServerStyleSheet = function () {
	  function ServerStyleSheet() {
	    classCallCheck(this, ServerStyleSheet);
	
	    /* The master sheet might be reset, so keep a reference here */
	    this.masterSheet = StyleSheet.master;
	    this.instance = this.masterSheet.clone();
	    this.closed = false;
	  }
	
	  ServerStyleSheet.prototype.complete = function complete() {
	    if (!this.closed) {
	      /* Remove closed StyleSheets from the master sheet */
	      var index = this.masterSheet.clones.indexOf(this.instance);
	      this.masterSheet.clones.splice(index, 1);
	      this.closed = true;
	    }
	  };
	
	  ServerStyleSheet.prototype.collectStyles = function collectStyles(children) {
	    if (this.closed) {
	      throw new StyledComponentsError(2);
	    }
	
	    return React__default.createElement(
	      StyleSheetManager,
	      { sheet: this.instance },
	      children
	    );
	  };
	
	  ServerStyleSheet.prototype.getStyleTags = function getStyleTags() {
	    this.complete();
	    return this.instance.toHTML();
	  };
	
	  ServerStyleSheet.prototype.getStyleElement = function getStyleElement() {
	    this.complete();
	    return this.instance.toReactElements();
	  };
	
	  ServerStyleSheet.prototype.interleaveWithNodeStream = function interleaveWithNodeStream(readableStream) {
	    var _this = this;
	
	    {
	      throw new StyledComponentsError(3);
	    }
	
	    /* the tag index keeps track of which tags have already been emitted */
	    var instance = this.instance;
	
	    var instanceTagIndex = 0;
	
	    var streamAttr = SC_STREAM_ATTR + '="true"';
	
	    var transformer = new stream.Transform({
	      transform: function appendStyleChunks(chunk, /* encoding */_, callback) {
	        var tags = instance.tags;
	
	        var html = '';
	
	        /* retrieve html for each new style tag */
	        for (; instanceTagIndex < tags.length; instanceTagIndex += 1) {
	          var tag = tags[instanceTagIndex];
	          html += tag.toHTML(streamAttr);
	        }
	
	        /* force our StyleSheets to emit entirely new tags */
	        instance.sealAllTags();
	
	        /* prepend style html to chunk */
	        this.push(html + chunk);
	        callback();
	      }
	    });
	
	    readableStream.on('end', function () {
	      return _this.complete();
	    });
	    readableStream.on('error', function (err) {
	      _this.complete();
	
	      // forward the error to the transform stream
	      transformer.emit('error', err);
	    });
	
	    return readableStream.pipe(transformer);
	  };
	
	  return ServerStyleSheet;
	}();
	
	// 
	
	var LIMIT = 200;
	
	var createWarnTooManyClasses = (function (displayName) {
	  var generatedClasses = {};
	  var warningSeen = false;
	
	  return function (className) {
	    if (!warningSeen) {
	      generatedClasses[className] = true;
	      if (Object.keys(generatedClasses).length >= LIMIT) {
	        // Unable to find latestRule in test environment.
	        /* eslint-disable no-console, prefer-template */
	        console.warn('Over ' + LIMIT + ' classes were generated for component ' + displayName + '. \n' + 'Consider using the attrs method, together with a style object for frequently changed styles.\n' + 'Example:\n' + '  const Component = styled.div.attrs({\n' + '    style: ({ background }) => ({\n' + '      background,\n' + '    }),\n' + '  })`width: 100%;`\n\n' + '  <Component />');
	        warningSeen = true;
	        generatedClasses = {};
	      }
	    }
	  };
	});
	
	// 
	
	var determineTheme = (function (props, fallbackTheme, defaultProps) {
	  // Props should take precedence over ThemeProvider, which should take precedence over
	  // defaultProps, but React automatically puts defaultProps on props.
	
	  /* eslint-disable react/prop-types */
	  var isDefaultTheme = defaultProps && props.theme === defaultProps.theme;
	  var theme = props.theme && !isDefaultTheme ? props.theme : fallbackTheme;
	  /* eslint-enable */
	
	  return theme;
	});
	
	// 
	var escapeRegex = /[[\].#*$><+~=|^:(),"'`-]+/g;
	var dashesAtEnds = /(^-|-$)/g;
	
	/**
	 * TODO: Explore using CSS.escape when it becomes more available
	 * in evergreen browsers.
	 */
	function escape(str) {
	  return str
	  // Replace all possible CSS selectors
	  .replace(escapeRegex, '-')
	
	  // Remove extraneous hyphens at the start and end
	  .replace(dashesAtEnds, '');
	}
	
	// 
	
	function getComponentName(target) {
	  return target.displayName || target.name || 'Component';
	}
	
	// 
	
	function isTag(target) /* : %checks */{
	  return typeof target === 'string';
	}
	
	// 
	
	function generateDisplayName(target) {
	  return isTag(target) ? 'styled.' + target : 'Styled(' + getComponentName(target) + ')';
	}
	
	// 
	/* eslint-disable max-len */
	/**
	 * Trying to avoid the unknown-prop errors on styled components by filtering by
	 * React's attribute whitelist.
	 *
	 * To regenerate this regex:
	 *
	 * 1. `npm i -g regexgen` (https://github.com/devongovett/regexgen)
	 * 2. Run `regexgen` with the list of space-separated words below as input
	 * 3. Surround the emitted regex with this: `/^(GENERATED_REGEX)$/` -- this will ensure a full string match
	 *    and no false positives from partials
	 * */
	/*
	children dangerouslySetInnerHTML key ref autoFocus defaultValue valueLink defaultChecked checkedLink innerHTML suppressContentEditableWarning onFocusIn onFocusOut className onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown onKeyPress onKeyUp onFocus onBlur onChange onInput onInvalid onSubmit onReset onClick onContextMenu onDoubleClick onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onAnimationStart onAnimationEnd onAnimationIteration onTransitionEnd onCopyCapture onCutCapture onPasteCapture onCompositionEndCapture onCompositionStartCapture onCompositionUpdateCapture onKeyDownCapture onKeyPressCapture onKeyUpCapture onFocusCapture onBlurCapture onChangeCapture onInputCapture onSubmitCapture onResetCapture onClickCapture onContextMenuCapture onDoubleClickCapture onDragCapture onDragEndCapture onDragEnterCapture onDragExitCapture onDragLeaveCapture onDragOverCapture onDragStartCapture onDropCapture onMouseDownCapture onMouseEnterCapture onMouseLeaveCapture onMouseMoveCapture onMouseOutCapture onMouseOverCapture onMouseUpCapture onSelectCapture onTouchCancelCapture onTouchEndCapture onTouchMoveCapture onTouchStartCapture onScrollCapture onWheelCapture onAbortCapture onCanPlayCapture onCanPlayThroughCapture onDurationChangeCapture onEmptiedCapture onEncryptedCapture onEndedCapture onErrorCapture onLoadedDataCapture onLoadedMetadataCapture onLoadStartCapture onPauseCapture onPlayCapture onPlayingCapture onProgressCapture onRateChangeCapture onSeekedCapture onSeekingCapture onStalledCapture onSuspendCapture onTimeUpdateCapture onVolumeChangeCapture onWaitingCapture onLoadCapture onAnimationStartCapture onAnimationEndCapture onAnimationIterationCapture onTransitionEndCapture accept acceptCharset accessKey action allowFullScreen allowTransparency alt as async autoComplete autoPlay capture cellPadding cellSpacing charSet challenge checked cite classID className cols colSpan content contentEditable contextMenu controlsList controls coords crossOrigin data dateTime default defer dir disabled download draggable encType form formAction formEncType formMethod formNoValidate formTarget frameBorder headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media mediaGroup method min minLength multiple muted name nonce noValidate open optimum pattern placeholder playsInline poster preload profile radioGroup readOnly referrerPolicy rel required reversed role rows rowSpan sandbox scope scoped scrolling seamless selected shape size sizes span spellCheck src srcDoc srcLang srcSet start step style summary tabIndex target title type useMap value width wmode wrap about datatype inlist prefix property resource typeof vocab autoCapitalize autoCorrect autoSave color itemProp itemScope itemType itemID itemRef results security unselectable accentHeight accumulate additive alignmentBaseline allowReorder alphabetic amplitude arabicForm ascent attributeName attributeType autoReverse azimuth baseFrequency baseProfile baselineShift bbox begin bias by calcMode capHeight clip clipPath clipRule clipPathUnits colorInterpolation colorInterpolationFilters colorProfile colorRendering contentScriptType contentStyleType cursor cx cy d decelerate descent diffuseConstant direction display divisor dominantBaseline dur dx dy edgeMode elevation enableBackground end exponent externalResourcesRequired fill fillOpacity fillRule filter filterRes filterUnits floodColor floodOpacity focusable fontFamily fontSize fontSizeAdjust fontStretch fontStyle fontVariant fontWeight format from fx fy g1 g2 glyphName glyphOrientationHorizontal glyphOrientationVertical glyphRef gradientTransform gradientUnits hanging horizAdvX horizOriginX ideographic imageRendering in in2 intercept k k1 k2 k3 k4 kernelMatrix kernelUnitLength kerning keyPoints keySplines keyTimes lengthAdjust letterSpacing lightingColor limitingConeAngle local markerEnd markerMid markerStart markerHeight markerUnits markerWidth mask maskContentUnits maskUnits mathematical mode numOctaves offset opacity operator order orient orientation origin overflow overlinePosition overlineThickness paintOrder panose1 pathLength patternContentUnits patternTransform patternUnits pointerEvents points pointsAtX pointsAtY pointsAtZ preserveAlpha preserveAspectRatio primitiveUnits r radius refX refY renderingIntent repeatCount repeatDur requiredExtensions requiredFeatures restart result rotate rx ry scale seed shapeRendering slope spacing specularConstant specularExponent speed spreadMethod startOffset stdDeviation stemh stemv stitchTiles stopColor stopOpacity strikethroughPosition strikethroughThickness string stroke strokeDasharray strokeDashoffset strokeLinecap strokeLinejoin strokeMiterlimit strokeOpacity strokeWidth surfaceScale systemLanguage tableValues targetX targetY textAnchor textDecoration textRendering textLength to transform u1 u2 underlinePosition underlineThickness unicode unicodeBidi unicodeRange unitsPerEm vAlphabetic vHanging vIdeographic vMathematical values vectorEffect version vertAdvY vertOriginX vertOriginY viewBox viewTarget visibility widths wordSpacing writingMode x xHeight x1 x2 xChannelSelector xlinkActuate xlinkArcrole xlinkHref xlinkRole xlinkShow xlinkTitle xlinkType xmlBase xmlns xmlnsXlink xmlLang xmlSpace y y1 y2 yChannelSelector z zoomAndPan onPointerDown onPointerMove onPointerUp onPointerCancel onGotPointerCapture onLostPointerCapture onPointerEnter onPointerLeave onPointerOver onPointerOut class for autofocus allow allowUserMedia allowPaymentRequest
	*/
	/* eslint-enable max-len */
	
	var ATTRIBUTE_REGEX = /^((?:s(?:uppressContentEditableWarn|croll|pac)|(?:shape|image|text)Render|(?:letter|word)Spac|vHang|hang)ing|(?:on(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:Animation|Touch|Load|Drag)Start|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|Lo(?:stPointer|ad)|TimeUpdate|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|GotPointer|MouseDown|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|KeyPress|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|P(?:rogress|laying)|DragEnd|Key(?:Down|Up)|(?:MouseU|Dro)p|(?:Wait|Seek)ing|Scroll|Focus|Paste|Abort|Drag|Play|Blur)Captur|alignmentBaselin|(?:limitingConeAng|xlink(?:(?:Arcr|R)o|Tit)|s(?:urfaceSca|ty|ca)|unselectab|baseProfi|fontSty|(?:focus|dragg)ab|multip|profi|tit)l|d(?:ominantBaselin|efaultValu)|onPointerLeav|a(?:uto(?:Capitaliz|Revers|Sav)|dditiv)|(?:(?:formNoValid|xlinkActu|noValid|accumul|rot)a|autoComple|decelera)t|(?:(?:attribute|item)T|datat)yp|onPointerMov|(?:attribute|glyph)Nam|playsInlin|(?:writing|input|edge)Mod|(?:formE|e)ncTyp|(?:amplitu|mo)d|(?:xlinkTy|itemSco|keyTy|slo)p|(?:xmlSpa|non)c|fillRul|(?:dateTi|na)m|r(?:esourc|ol)|xmlBas|wmod)e|(?:glyphOrientationHorizont|loc)al|(?:externalResourcesRequir|select|revers|mut)ed|c(?:o(?:lorInterpolationFilter|ord)s|o(?:lor(?:Interpolation)?|nt(?:rols|ent))|(?:ontentS(?:cript|tyle)Typ|o(?:ntentEditab|lorProfi)l|l(?:assNam|ipRul)|a(?:lcMod|ptur)|it)e|olorRendering|l(?:ipPathUnits|assID)|(?:ontrolsLis|apHeigh)t|h(?:eckedLink|a(?:llenge|rSet)|ildren|ecked)|ell(?:Spac|Padd)ing|o(?:ntextMenu|ls)|(?:rossOrigi|olSpa)n|l(?:ip(?:Path)?|ass)|ursor|[xy])|glyphOrientationVertical|d(?:angerouslySetInnerHTML|efaultChecked|ownload|isabled|isplay|[xy])|(?:s(?:trikethroughThickn|eaml)es|(?:und|ov)erlineThicknes|r(?:equiredExtension|adiu)|(?:requiredFeatur|tableValu|stitchTil|numOctav|filterR)e|key(?:(?:Splin|Tim)e|Param)|auto[Ff]ocu|header|bia)s|(?:(?:st(?:rikethroughPosi|dDevia)|(?:und|ov)erlinePosi|(?:textDecor|elev)a|orienta)tio|(?:strokeLinejo|orig)i|on(?:PointerDow|FocusI)|formActio|zoomAndPa|directio|(?:vers|act)io|rowSpa|begi|ico)n|o(?:n(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:Animation|Touch|Load|Drag)Start|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|TimeUpdate|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|MouseDown|P(?:rogress|laying)|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|KeyPress|DragEnd|Key(?:Down|Up)|(?:Wait|Seek)ing|(?:MouseU|Dro)p|Scroll|Paste|Focus|Abort|Drag|Play|Load|Blur)|rient)|p(?:reserveAspectRatio|ointsAt[X-Z]|anose1)|(?:(?:allowPaymentReque|(?:fontSize|length)Adju|manife)s|strokeMiterlimi|(?:(?:specularE|e)xpon|renderingInt|asc)en|(?:specularConsta|repeatCou|fontVaria)n|d(?:iffuseConsta|esce)n|baselineShif|vectorEffec|onPointerOu|(?:(?:mar(?:ker|gin)|x)H|accentH|fontW)eigh|markerStar|a(?:utoCorrec|bou)|onFocusOu|intercep|restar|forma|inlis|heigh|lis)t|(?:patternContent|ma(?:sk(?:Content)?|rker)|primitive|gradient|pattern|filter)Units|(?:(?:allowTranspar|baseFrequ)enc|re(?:ferrerPolic|adOnl)|(?:(?:st(?:roke|op)O|floodO|fillO|o)pac|integr|secur)it|visibilit|fontFamil|accessKe|propert|summar)y|(?:gradientT|patternT|t)ransform|(?:(?:st(?:rokeDasho|artO)|o)ffs|acceptChars|formTarg|viewTarg|srcS)et|(?:[xy]ChannelSelect|lightingCol|textAnch|floodCol|stopCol|operat|htmlF)or|(?:(?:enableBackgrou|markerE)n|s(?:p(?:readMetho|ee)|ee)|formMetho|(?:markerM|onInval)i|preloa|metho|kin)d|k(?:ernel(?:UnitLength|Matrix)|[1-4])|strokeDasharray|(?:onPointerCanc|lab)el|(?:allowFullScre|hidd)en|a(?:l(?:lowUserMedia|phabetic|t)|rabicForm|sync)|systemLanguage|(?:(?:o(?:nPointer(?:Ent|Ov)|rd)|allowReord|placehold|frameBord|paintOrd|post)e|repeatDu|d(?:efe|u))r|(?:pointerEve|keyPoi)nts|preserveAlpha|(?:strokeLineca|onPointerU|itemPro|useMa|wra|loo)p|v(?:Mathematical|ert(?:Origin[XY]|AdvY)|alues|ocab)|unicodeRange|h(?:oriz(?:Origin|Adv)X|ttpEquiv)|(?:vI|i)deographic|mathematical|u(?:nicodeBidi|[12])|(?:fontStretc|hig)h|vAlphabetic|(?:(?:mar(?:ker|gin)W|strokeW)id|azimu)th|(?:xmlnsXl|valueL)ink|mediaGroup|spellCheck|(?:text|m(?:in|ax))Length|(?:unitsPerE|optimu|fro)m|r(?:adioGroup|e(?:sults|f[XY]|l)|ows|[xy])|pathLength|(?:xlinkHr|glyphR)ef|innerHTML|xlinkShow|f(?:o(?:ntSize|rm?)|il(?:ter|l))|(?:tabInde|(?:sand|b)bo|viewBo)x|autoPlay|r(?:e(?:quired|sult|f))?|(?:(?:href|xml|src)La|kerni)ng|o(?:verflow|pen)|i(?:temRef|n2|s)|p(?:attern|oints)|unicode|d(?:efault|ata|ir)?|divisor|t(?:arget[XY]|o)|(?:stri|la)ng|(?:width|size)s|prefix|typeof|srcDoc|s(?:coped|te(?:m[hv]|p)|pan)|s(?:t(?:roke|art)|hape|cope|rc)|a(?:ccept|llow|s)|itemID|t(?:arget|ype)|m(?:edia|a(?:sk|x)|in)|value|width|x(?:mlns)?|size|href|k(?:ey)?|end|low|by|x[12]|y[12]|g[12]|i[dn]|f[xy]|[yz])$/;
	/* From DOMProperty */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040';
	var isCustomAttribute = RegExp.prototype.test.bind(new RegExp('^(x|data|aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$'));
	
	var validAttr = (function (name) {
	  return ATTRIBUTE_REGEX.test(name) || isCustomAttribute(name.toLowerCase());
	});
	
	// 
	
	function hasInInheritanceChain(child, parent) {
	  var target = child;
	
	  while (target) {
	    target = Object.getPrototypeOf(target);
	
	    if (target && target === parent) {
	      return true;
	    }
	  }
	
	  return false;
	}
	
	// 
	/**
	 * Creates a broadcast that can be listened to, i.e. simple event emitter
	 *
	 * @see https://github.com/ReactTraining/react-broadcast
	 */
	
	var createBroadcast = function createBroadcast(initialState) {
	  var listeners = {};
	  var id = 0;
	  var state = initialState;
	
	  function publish(nextState) {
	    state = nextState;
	
	    // eslint-disable-next-line guard-for-in, no-restricted-syntax
	    for (var key in listeners) {
	      var listener = listeners[key];
	      if (listener === undefined) {
	        // eslint-disable-next-line no-continue
	        continue;
	      }
	
	      listener(state);
	    }
	  }
	
	  function subscribe(listener) {
	    var currentId = id;
	    listeners[currentId] = listener;
	    id += 1;
	    listener(state);
	    return currentId;
	  }
	
	  function unsubscribe(unsubID) {
	    listeners[unsubID] = undefined;
	  }
	
	  return { publish: publish, subscribe: subscribe, unsubscribe: unsubscribe };
	};
	
	var _contextShape, _ThemeProvider$contex;
	
	// NOTE: DO NOT CHANGE, changing this is a semver major change!
	var CHANNEL = '__styled-components__';
	var CHANNEL_NEXT = CHANNEL + 'next__';
	
	var CONTEXT_CHANNEL_SHAPE = PropTypes.shape({
	  getTheme: PropTypes.func,
	  subscribe: PropTypes.func,
	  unsubscribe: PropTypes.func
	});
	
	var contextShape = (_contextShape = {}, _contextShape[CHANNEL] = PropTypes.func, _contextShape[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _contextShape);
	
	var warnChannelDeprecated = void 0;
	if (false) {
	  warnChannelDeprecated = once(function () {
	    // eslint-disable-next-line no-console
	    console.warn('Warning: Usage of `context.' + CHANNEL + '` as a function is deprecated. It will be replaced with the object on `.context.' + CHANNEL_NEXT + '` in a future version.');
	  });
	}
	
	var isFunction = function isFunction(test) {
	  return typeof test === 'function';
	};
	
	/**
	 * Provide a theme to an entire react component tree via context and event listeners (have to do
	 * both context and event emitter as pure components block context updates)
	 */
	
	var ThemeProvider = function (_Component) {
	  inherits(ThemeProvider, _Component);
	
	  function ThemeProvider() {
	    classCallCheck(this, ThemeProvider);
	
	    var _this = possibleConstructorReturn(this, _Component.call(this));
	
	    _this.unsubscribeToOuterId = -1;
	
	    _this.getTheme = _this.getTheme.bind(_this);
	    return _this;
	  }
	
	  ThemeProvider.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    // If there is a ThemeProvider wrapper anywhere around this theme provider, merge this theme
	    // with the outer theme
	    var outerContext = this.context[CHANNEL_NEXT];
	    if (outerContext !== undefined) {
	      this.unsubscribeToOuterId = outerContext.subscribe(function (theme) {
	        _this2.outerTheme = theme;
	
	        if (_this2.broadcast !== undefined) {
	          _this2.publish(_this2.props.theme);
	        }
	      });
	    }
	
	    this.broadcast = createBroadcast(this.getTheme());
	  };
	
	  ThemeProvider.prototype.getChildContext = function getChildContext() {
	    var _this3 = this,
	        _babelHelpers$extends;
	
	    return _extends({}, this.context, (_babelHelpers$extends = {}, _babelHelpers$extends[CHANNEL_NEXT] = {
	      getTheme: this.getTheme,
	      subscribe: this.broadcast.subscribe,
	      unsubscribe: this.broadcast.unsubscribe
	    }, _babelHelpers$extends[CHANNEL] = function (subscriber) {
	      if (false) {
	        warnChannelDeprecated();
	      }
	
	      // Patch the old `subscribe` provide via `CHANNEL` for older clients.
	      var unsubscribeId = _this3.broadcast.subscribe(subscriber);
	      return function () {
	        return _this3.broadcast.unsubscribe(unsubscribeId);
	      };
	    }, _babelHelpers$extends));
	  };
	
	  ThemeProvider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this.props.theme !== nextProps.theme) {
	      this.publish(nextProps.theme);
	    }
	  };
	
	  ThemeProvider.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.unsubscribeToOuterId !== -1) {
	      this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeToOuterId);
	    }
	  };
	
	  // Get the theme from the props, supporting both (outerTheme) => {} as well as object notation
	
	
	  ThemeProvider.prototype.getTheme = function getTheme(passedTheme) {
	    var theme = passedTheme || this.props.theme;
	
	    if (isFunction(theme)) {
	      var mergedTheme = theme(this.outerTheme);
	
	      if (false) {
	        throw new StyledComponentsError(7);
	      }
	
	      return mergedTheme;
	    }
	
	    if (theme === null || Array.isArray(theme) || (typeof theme === 'undefined' ? 'undefined' : _typeof(theme)) !== 'object') {
	      throw new StyledComponentsError(8);
	    }
	
	    return _extends({}, this.outerTheme, theme);
	  };
	
	  ThemeProvider.prototype.publish = function publish(theme) {
	    this.broadcast.publish(this.getTheme(theme));
	  };
	
	  ThemeProvider.prototype.render = function render() {
	    if (!this.props.children) {
	      return null;
	    }
	
	    return React__default.Children.only(this.props.children);
	  };
	
	  return ThemeProvider;
	}(React.Component);
	
	ThemeProvider.childContextTypes = contextShape;
	ThemeProvider.contextTypes = (_ThemeProvider$contex = {}, _ThemeProvider$contex[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _ThemeProvider$contex);
	
	var _babelHelpers$extends;
	
	// HACK for generating all static styles without needing to allocate
	// an empty execution context every single time...
	var STATIC_EXECUTION_CONTEXT = {};
	
	var modifiedContextShape = _extends({}, contextShape, (_babelHelpers$extends = {}, _babelHelpers$extends[CONTEXT_KEY] = PropTypes.oneOfType([PropTypes.instanceOf(StyleSheet), PropTypes.instanceOf(ServerStyleSheet)]), _babelHelpers$extends));
	
	var identifiers = {};
	
	/* We depend on components having unique IDs */
	var generateId = function generateId(ComponentStyle, _displayName, parentComponentId) {
	  var displayName = typeof _displayName !== 'string' ? 'sc' : escape(_displayName);
	
	  /**
	   * This ensures uniqueness if two components happen to share
	   * the same displayName.
	   */
	  var nr = (identifiers[displayName] || 0) + 1;
	  identifiers[displayName] = nr;
	
	  var componentId = displayName + '-' + ComponentStyle.generateName(displayName + nr);
	
	  return parentComponentId !== undefined ? parentComponentId + '-' + componentId : componentId;
	};
	
	var warnExtendDeprecated = function warnExtendDeprecated() {};
	if (false) {
	  warnExtendDeprecated = once(function () {
	    // eslint-disable-next-line no-console
	    console.warn('Warning: The "extend" API will be removed in the upcoming v4.0 release. Use styled(StyledComponent) instead. You can find more information here: https://github.com/styled-components/styled-components/issues/1546');
	  });
	}
	
	// $FlowFixMe
	
	var BaseStyledComponent = function (_Component) {
	  inherits(BaseStyledComponent, _Component);
	
	  function BaseStyledComponent() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, BaseStyledComponent);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.attrs = {}, _this.state = {
	      theme: null,
	      generatedClassName: ''
	    }, _this.unsubscribeId = -1, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  BaseStyledComponent.prototype.unsubscribeFromContext = function unsubscribeFromContext() {
	    if (this.unsubscribeId !== -1) {
	      this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
	    }
	  };
	
	  BaseStyledComponent.prototype.buildExecutionContext = function buildExecutionContext(theme, props) {
	    var attrs = this.constructor.attrs;
	
	    var context = _extends({}, props, { theme: theme });
	    if (attrs === undefined) {
	      return context;
	    }
	
	    this.attrs = Object.keys(attrs).reduce(function (acc, key) {
	      var attr = attrs[key];
	
	      // eslint-disable-next-line no-param-reassign
	      acc[key] = typeof attr === 'function' && !hasInInheritanceChain(attr, React.Component) ? attr(context) : attr;
	      return acc;
	    }, {});
	
	    return _extends({}, context, this.attrs);
	  };
	
	  BaseStyledComponent.prototype.generateAndInjectStyles = function generateAndInjectStyles(theme, props) {
	    var _constructor = this.constructor,
	        attrs = _constructor.attrs,
	        componentStyle = _constructor.componentStyle,
	        warnTooManyClasses = _constructor.warnTooManyClasses;
	
	    var styleSheet = this.context[CONTEXT_KEY] || StyleSheet.master;
	
	    // statically styled-components don't need to build an execution context object,
	    // and shouldn't be increasing the number of class names
	    if (componentStyle.isStatic && attrs === undefined) {
	      return componentStyle.generateAndInjectStyles(STATIC_EXECUTION_CONTEXT, styleSheet);
	    } else {
	      var executionContext = this.buildExecutionContext(theme, props);
	      var className = componentStyle.generateAndInjectStyles(executionContext, styleSheet);
	
	      if (false) {
	        warnTooManyClasses(className);
	      }
	
	      return className;
	    }
	  };
	
	  BaseStyledComponent.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    var componentStyle = this.constructor.componentStyle;
	
	    var styledContext = this.context[CHANNEL_NEXT];
	
	    // If this is a statically-styled component, we don't need to the theme
	    // to generate or build styles.
	    if (componentStyle.isStatic) {
	      var generatedClassName = this.generateAndInjectStyles(STATIC_EXECUTION_CONTEXT, this.props);
	      this.setState({ generatedClassName: generatedClassName });
	      // If there is a theme in the context, subscribe to the event emitter. This
	      // is necessary due to pure components blocking context updates, this circumvents
	      // that by updating when an event is emitted
	    } else if (styledContext !== undefined) {
	      var subscribe = styledContext.subscribe;
	
	      this.unsubscribeId = subscribe(function (nextTheme) {
	        // This will be called once immediately
	        var theme = determineTheme(_this2.props, nextTheme, _this2.constructor.defaultProps);
	
	        var generatedClassName = _this2.generateAndInjectStyles(theme, _this2.props);
	
	        _this2.setState({ theme: theme, generatedClassName: generatedClassName });
	      });
	    } else {
	      // eslint-disable-next-line react/prop-types
	      var theme = this.props.theme || EMPTY_OBJECT;
	      var _generatedClassName = this.generateAndInjectStyles(theme, this.props);
	      this.setState({ theme: theme, generatedClassName: _generatedClassName });
	    }
	  };
	
	  BaseStyledComponent.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _this3 = this;
	
	    // If this is a statically-styled component, we don't need to listen to
	    // props changes to update styles
	    var componentStyle = this.constructor.componentStyle;
	
	    if (componentStyle.isStatic) {
	      return;
	    }
	
	    this.setState(function (prevState) {
	      var theme = determineTheme(nextProps, prevState.theme, _this3.constructor.defaultProps);
	      var generatedClassName = _this3.generateAndInjectStyles(theme, nextProps);
	
	      return { theme: theme, generatedClassName: generatedClassName };
	    });
	  };
	
	  BaseStyledComponent.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unsubscribeFromContext();
	  };
	
	  BaseStyledComponent.prototype.render = function render() {
	    // eslint-disable-next-line react/prop-types
	    var innerRef = this.props.innerRef;
	    var generatedClassName = this.state.generatedClassName;
	    var _constructor2 = this.constructor,
	        styledComponentId = _constructor2.styledComponentId,
	        target = _constructor2.target;
	
	
	    var isTargetTag = isTag(target);
	
	    var className = [
	    // eslint-disable-next-line react/prop-types
	    this.props.className, styledComponentId, this.attrs.className, generatedClassName].filter(Boolean).join(' ');
	
	    var baseProps = _extends({}, this.attrs, {
	      className: className
	    });
	
	    if (isStyledComponent(target)) {
	      baseProps.innerRef = innerRef;
	    } else {
	      baseProps.ref = innerRef;
	    }
	
	    var propsForElement = baseProps;
	    var key = void 0;
	
	    for (key in this.props) {
	      // Don't pass through non HTML tags through to HTML elements
	      // always omit innerRef
	      if (key !== 'innerRef' && key !== 'className' && (!isTargetTag || validAttr(key))) {
	        propsForElement[key] = key === 'style' && key in this.attrs ? _extends({}, this.attrs[key], this.props[key]) : this.props[key];
	      }
	    }
	
	    return React.createElement(target, propsForElement);
	  };
	
	  return BaseStyledComponent;
	}(React.Component);
	
	var _StyledComponent = (function (ComponentStyle, constructWithOptions) {
	  var createStyledComponent = function createStyledComponent(target, options, rules) {
	    var _options$isClass = options.isClass,
	        isClass = _options$isClass === undefined ? !isTag(target) : _options$isClass,
	        _options$displayName = options.displayName,
	        displayName = _options$displayName === undefined ? generateDisplayName(target) : _options$displayName,
	        _options$componentId = options.componentId,
	        componentId = _options$componentId === undefined ? generateId(ComponentStyle, options.displayName, options.parentComponentId) : _options$componentId,
	        _options$ParentCompon = options.ParentComponent,
	        ParentComponent = _options$ParentCompon === undefined ? BaseStyledComponent : _options$ParentCompon,
	        extendingRules = options.rules,
	        attrs = options.attrs;
	
	
	    var styledComponentId = options.displayName && options.componentId ? escape(options.displayName) + '-' + options.componentId : options.componentId || componentId;
	
	    var componentStyle = new ComponentStyle(extendingRules === undefined ? rules : extendingRules.concat(rules), attrs, styledComponentId);
	
	    var StyledComponent = function (_ParentComponent) {
	      inherits(StyledComponent, _ParentComponent);
	
	      function StyledComponent() {
	        classCallCheck(this, StyledComponent);
	        return possibleConstructorReturn(this, _ParentComponent.apply(this, arguments));
	      }
	
	      StyledComponent.withComponent = function withComponent(tag) {
	        var previousComponentId = options.componentId,
	            optionsToCopy = objectWithoutProperties(options, ['componentId']);
	
	
	        var newComponentId = previousComponentId && previousComponentId + '-' + (isTag(tag) ? tag : escape(getComponentName(tag)));
	
	        var newOptions = _extends({}, optionsToCopy, {
	          componentId: newComponentId,
	          ParentComponent: StyledComponent
	        });
	
	        return createStyledComponent(tag, newOptions, rules);
	      };
	
	      createClass(StyledComponent, null, [{
	        key: 'extend',
	        get: function get$$1() {
	          var rulesFromOptions = options.rules,
	              parentComponentId = options.componentId,
	              optionsToCopy = objectWithoutProperties(options, ['rules', 'componentId']);
	
	
	          var newRules = rulesFromOptions === undefined ? rules : rulesFromOptions.concat(rules);
	
	          var newOptions = _extends({}, optionsToCopy, {
	            rules: newRules,
	            parentComponentId: parentComponentId,
	            ParentComponent: StyledComponent
	          });
	
	          warnExtendDeprecated();
	
	          return constructWithOptions(createStyledComponent, target, newOptions);
	        }
	      }]);
	      return StyledComponent;
	    }(ParentComponent);
	
	    StyledComponent.attrs = attrs;
	    StyledComponent.componentStyle = componentStyle;
	    StyledComponent.contextTypes = modifiedContextShape;
	    StyledComponent.displayName = displayName;
	    StyledComponent.styledComponentId = styledComponentId;
	    StyledComponent.target = target;
	
	
	    if (false) {
	      StyledComponent.warnTooManyClasses = createWarnTooManyClasses(displayName);
	    }
	
	    if (isClass) {
	      hoistStatics(StyledComponent, target, {
	        // all SC-specific things should not be hoisted
	        attrs: true,
	        componentStyle: true,
	        displayName: true,
	        extend: true,
	        styledComponentId: true,
	        target: true,
	        warnTooManyClasses: true,
	        withComponent: true
	      });
	    }
	
	    return StyledComponent;
	  };
	
	  return createStyledComponent;
	});
	
	// Source: https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
	function murmurhash(str) {
	  var l = str.length | 0,
	      h = l | 0,
	      i = 0,
	      k;
	
	  while (l >= 4) {
	    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
	
	    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	    k ^= k >>> 24;
	    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	
	    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
	
	    l -= 4;
	    ++i;
	  }
	
	  switch (l) {
	    case 3:
	      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
	    case 2:
	      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
	    case 1:
	      h ^= str.charCodeAt(i) & 0xff;
	      h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	  }
	
	  h ^= h >>> 13;
	  h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	  h ^= h >>> 15;
	
	  return h >>> 0;
	}
	
	// 
	
	var areStylesCacheable = IS_BROWSER;
	
	var isStaticRules = function isStaticRules(rules, attrs) {
	  for (var i = 0, len = rules.length; i < len; i += 1) {
	    var rule = rules[i];
	
	    // recursive case
	    if (Array.isArray(rule) && !isStaticRules(rule)) {
	      return false;
	    } else if (typeof rule === 'function' && !isStyledComponent(rule)) {
	      // functions are allowed to be static if they're just being
	      // used to get the classname of a nested styled component
	      return false;
	    }
	  }
	
	  if (attrs !== undefined) {
	    // eslint-disable-next-line guard-for-in, no-restricted-syntax
	    for (var key in attrs) {
	      if (typeof attrs[key] === 'function') {
	        return false;
	      }
	    }
	  }
	
	  return true;
	};
	
	var isHMREnabled = typeof module !== 'undefined' && module.hot && ("production") !== 'production';
	
	/*
	 ComponentStyle is all the CSS-specific stuff, not
	 the React-specific stuff.
	 */
	var _ComponentStyle = (function (nameGenerator, flatten, stringifyRules) {
	  /* combines hashStr (murmurhash) and nameGenerator for convenience */
	  var generateRuleHash = function generateRuleHash(str) {
	    return nameGenerator(murmurhash(str));
	  };
	
	  var ComponentStyle = function () {
	    function ComponentStyle(rules, attrs, componentId) {
	      classCallCheck(this, ComponentStyle);
	
	      this.rules = rules;
	      this.isStatic = !isHMREnabled && isStaticRules(rules, attrs);
	      this.componentId = componentId;
	
	      if (!StyleSheet.master.hasId(componentId)) {
	        var placeholder =  false ? ['.' + componentId + ' {}'] : [];
	
	        StyleSheet.master.deferredInject(componentId, placeholder);
	      }
	    }
	
	    /*
	     * Flattens a rule set into valid CSS
	     * Hashes it, wraps the whole chunk in a .hash1234 {}
	     * Returns the hash to be injected on render()
	     * */
	
	
	    ComponentStyle.prototype.generateAndInjectStyles = function generateAndInjectStyles(executionContext, styleSheet) {
	      var isStatic = this.isStatic,
	          componentId = this.componentId,
	          lastClassName = this.lastClassName;
	
	      if (areStylesCacheable && isStatic && lastClassName !== undefined && styleSheet.hasNameForId(componentId, lastClassName)) {
	        return lastClassName;
	      }
	
	      var flatCSS = flatten(this.rules, executionContext);
	      var name = generateRuleHash(this.componentId + flatCSS.join(''));
	
	      if (!styleSheet.hasNameForId(componentId, name)) {
	        styleSheet.inject(this.componentId, stringifyRules(flatCSS, '.' + name), name);
	      }
	
	      this.lastClassName = name;
	      return name;
	    };
	
	    ComponentStyle.generateName = function generateName(str) {
	      return generateRuleHash(str);
	    };
	
	    return ComponentStyle;
	  }();
	
	  return ComponentStyle;
	});
	
	// 
	// Thanks to ReactDOMFactories for this handy list!
	
	var domElements = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr',
	
	// SVG
	'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];
	
	// 
	
	var _styled = (function (styledComponent, constructWithOptions) {
	  var styled = function styled(tag) {
	    return constructWithOptions(styledComponent, tag);
	  };
	
	  // Shorthands for all valid HTML Elements
	  domElements.forEach(function (domElement) {
	    styled[domElement] = styled(domElement);
	  });
	
	  return styled;
	});
	
	// 
	
	var replaceWhitespace = function replaceWhitespace(str) {
	  return str.replace(/\s|\\n/g, '');
	};
	
	var _keyframes = (function (nameGenerator, stringifyRules, css) {
	  return function () {
	    var styleSheet = StyleSheet.master;
	    var rules = css.apply(undefined, arguments);
	    var name = nameGenerator(murmurhash(replaceWhitespace(JSON.stringify(rules))));
	    var id = 'sc-keyframes-' + name;
	
	    if (!styleSheet.hasNameForId(id, name)) {
	      styleSheet.inject(id, stringifyRules(rules, name, '@keyframes'), name);
	    }
	
	    return name;
	  };
	});
	
	// 
	
	var _injectGlobal = (function (stringifyRules, css) {
	  var injectGlobal = function injectGlobal() {
	    var styleSheet = StyleSheet.master;
	    var rules = css.apply(undefined, arguments);
	    var hash = murmurhash(JSON.stringify(rules));
	    var id = 'sc-global-' + hash;
	
	    if (!styleSheet.hasId(id)) {
	      styleSheet.inject(id, stringifyRules(rules));
	    }
	  };
	
	  return injectGlobal;
	});
	
	// 
	
	var _constructWithOptions = (function (css) {
	  var constructWithOptions = function constructWithOptions(componentConstructor, tag) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_OBJECT;
	
	    if (!reactIs.isValidElementType(tag)) {
	      throw new StyledComponentsError(1, String(tag));
	    }
	
	    /* This is callable directly as a template function */
	    // $FlowFixMe: Not typed to avoid destructuring arguments
	    var templateFunction = function templateFunction() {
	      return componentConstructor(tag, options, css.apply(undefined, arguments));
	    };
	
	    /* If config methods are called, wrap up a new template function and merge options */
	    templateFunction.withConfig = function (config) {
	      return constructWithOptions(componentConstructor, tag, _extends({}, options, config));
	    };
	    templateFunction.attrs = function (attrs) {
	      return constructWithOptions(componentConstructor, tag, _extends({}, options, {
	        attrs: _extends({}, options.attrs || EMPTY_OBJECT, attrs)
	      }));
	    };
	
	    return templateFunction;
	  };
	
	  return constructWithOptions;
	});
	
	// 
	
	var withTheme = (function (Component) {
	  var isStatelessFunctionalComponent = typeof Component === 'function' &&
	  // $FlowFixMe TODO: flow for prototype
	  !(Component.prototype && 'isReactComponent' in Component.prototype);
	
	  // NOTE: We can't pass a ref to a stateless functional component
	  var shouldSetInnerRef = isStyledComponent(Component) || isStatelessFunctionalComponent;
	
	  var WithTheme = function (_React$Component) {
	    inherits(WithTheme, _React$Component);
	
	    function WithTheme() {
	      var _temp, _this, _ret;
	
	      classCallCheck(this, WithTheme);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = EMPTY_OBJECT, _this.unsubscribeId = -1, _temp), possibleConstructorReturn(_this, _ret);
	    }
	
	    // NOTE: This is so that isStyledComponent passes for the innerRef unwrapping
	
	
	    WithTheme.prototype.componentWillMount = function componentWillMount() {
	      var _this2 = this;
	
	      var defaultProps = this.constructor.defaultProps;
	
	      var styledContext = this.context[CHANNEL_NEXT];
	      var themeProp = determineTheme(this.props, undefined, defaultProps);
	      if (styledContext === undefined && themeProp === undefined && ("production") !== 'production') {
	        // eslint-disable-next-line no-console
	        console.warn('[withTheme] You are not using a ThemeProvider nor passing a theme prop or a theme in defaultProps');
	      } else if (styledContext === undefined && themeProp !== undefined) {
	        this.setState({ theme: themeProp });
	      } else {
	        var subscribe = styledContext.subscribe;
	
	        this.unsubscribeId = subscribe(function (nextTheme) {
	          var theme = determineTheme(_this2.props, nextTheme, defaultProps);
	          _this2.setState({ theme: theme });
	        });
	      }
	    };
	
	    WithTheme.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      var defaultProps = this.constructor.defaultProps;
	
	      this.setState(function (oldState) {
	        var theme = determineTheme(nextProps, oldState.theme, defaultProps);
	
	        return { theme: theme };
	      });
	    };
	
	    WithTheme.prototype.componentWillUnmount = function componentWillUnmount() {
	      if (this.unsubscribeId !== -1) {
	        this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
	      }
	    };
	
	    WithTheme.prototype.render = function render() {
	      var props = _extends({
	        theme: this.state.theme
	      }, this.props);
	
	      if (!shouldSetInnerRef) {
	        props.ref = props.innerRef;
	        delete props.innerRef;
	      }
	
	      return React__default.createElement(Component, props);
	    };
	
	    return WithTheme;
	  }(React__default.Component);
	
	  WithTheme.contextTypes = contextShape;
	  WithTheme.displayName = 'WithTheme(' + getComponentName(Component) + ')';
	  WithTheme.styledComponentId = 'withTheme';
	
	
	  return hoistStatics(WithTheme, Component);
	});
	
	// 
	
	/* eslint-disable */
	var __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS = {
	  StyleSheet: StyleSheet
	};
	
	// 
	
	/* Warning if you've imported this file on React Native */
	if (false) {
	  // eslint-disable-next-line no-console
	  console.warn("It looks like you've imported 'styled-components' on React Native.\n" + "Perhaps you're looking to import 'styled-components/native'?\n" + 'Read more about this at https://www.styled-components.com/docs/basics#react-native');
	}
	
	/* Warning if there are several instances of styled-components */
	if (false) {
	  window['__styled-components-init__'] = window['__styled-components-init__'] || 0;
	
	  if (window['__styled-components-init__'] === 1) {
	    // eslint-disable-next-line no-console
	    console.warn("It looks like there are several instances of 'styled-components' initialized in this application. " + 'This may cause dynamic styles not rendering properly, errors happening during rehydration process ' + 'and makes your application bigger without a good reason.\n\n' + 'See https://s-c.sh/2BAXzed for more info.');
	  }
	
	  window['__styled-components-init__'] += 1;
	}
	
	/* Instantiate singletons */
	var ComponentStyle = _ComponentStyle(generateAlphabeticName, flatten, stringifyRules);
	var constructWithOptions = _constructWithOptions(css);
	var StyledComponent = _StyledComponent(ComponentStyle, constructWithOptions);
	
	/* Instantiate exported singletons */
	var keyframes = _keyframes(generateAlphabeticName, stringifyRules, css);
	var injectGlobal = _injectGlobal(stringifyRules, css);
	var styled = _styled(StyledComponent, constructWithOptions);
	
	exports.default = styled;
	exports.css = css;
	exports.keyframes = keyframes;
	exports.injectGlobal = injectGlobal;
	exports.isStyledComponent = isStyledComponent;
	exports.consolidateStreamedStyles = consolidateStreamedStyles;
	exports.ThemeProvider = ThemeProvider;
	exports.withTheme = withTheme;
	exports.ServerStyleSheet = ServerStyleSheet;
	exports.StyleSheetManager = StyleSheetManager;
	exports.__DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS = __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS;
	//# sourceMappingURL=styled-components.browser.cjs.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27), __webpack_require__(23)(module)))

/***/ }),

/***/ 142:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {(function (factory) {
		 true ? (module['exports'] = factory()) :
			typeof define === 'function' && define['amd'] ? define(factory()) :
				(window['stylisRuleSheet'] = factory())
	}(function () {
	
		'use strict'
	
		return function (insertRule) {
			var delimiter = '/*|*/'
			var needle = delimiter+'}'
	
			function toSheet (block) {
				if (block)
					try {
						insertRule(block + '}')
					} catch (e) {}
			}
	
			return function ruleSheet (context, content, selectors, parents, line, column, length, ns, depth, at) {
				switch (context) {
					// property
					case 1:
						// @import
						if (depth === 0 && content.charCodeAt(0) === 64)
							return insertRule(content+';'), ''
						break
					// selector
					case 2:
						if (ns === 0)
							return content + delimiter
						break
					// at-rule
					case 3:
						switch (ns) {
							// @font-face, @page
							case 102:
							case 112:
								return insertRule(selectors[0]+content), ''
							default:
								return content + (at === 0 ? delimiter : '')
						}
					case -2:
						content.split(needle).forEach(toSheet)
				}
			}
		}
	}))
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(23)(module)))

/***/ }),

/***/ 143:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/*
	 *          __        ___
	 *    _____/ /___  __/ (_)____
	 *   / ___/ __/ / / / / / ___/
	 *  (__  ) /_/ /_/ / / (__  )
	 * /____/\__/\__, /_/_/____/
	 *          /____/
	 *
	 * light - weight css preprocessor @licence MIT
	 */
	(function (factory) {/* eslint-disable */
		 true ? (module['exports'] = factory(null)) :
			typeof define === 'function' && define['amd'] ? define(factory(null)) :
				(window['stylis'] = factory(null))
	}(/** @param {*=} options */function factory (options) {/* eslint-disable */
	
		'use strict'
	
		/**
		 * Notes
		 *
		 * The ['<method name>'] pattern is used to support closure compiler
		 * the jsdoc signatures are also used to the same effect
		 *
		 * ----
		 *
		 * int + int + int === n4 [faster]
		 *
		 * vs
		 *
		 * int === n1 && int === n2 && int === n3
		 *
		 * ----
		 *
		 * switch (int) { case ints...} [faster]
		 *
		 * vs
		 *
		 * if (int == 1 && int === 2 ...)
		 *
		 * ----
		 *
		 * The (first*n1 + second*n2 + third*n3) format used in the property parser
		 * is a simple way to hash the sequence of characters
		 * taking into account the index they occur in
		 * since any number of 3 character sequences could produce duplicates.
		 *
		 * On the other hand sequences that are directly tied to the index of the character
		 * resolve a far more accurate measure, it's also faster
		 * to evaluate one condition in a switch statement
		 * than three in an if statement regardless of the added math.
		 *
		 * This allows the vendor prefixer to be both small and fast.
		 */
	
		var nullptn = /^\0+/g /* matches leading null characters */
		var formatptn = /[\0\r\f]/g /* matches new line, null and formfeed characters */
		var colonptn = /: */g /* splits animation rules */
		var cursorptn = /zoo|gra/ /* assert cursor varient */
		var transformptn = /([,: ])(transform)/g /* vendor prefix transform, older webkit */
		var animationptn = /,+\s*(?![^(]*[)])/g /* splits multiple shorthand notation animations */
		var propertiesptn = / +\s*(?![^(]*[)])/g /* animation properties */
		var elementptn = / *[\0] */g /* selector elements */
		var selectorptn = /,\r+?/g /* splits selectors */
		var andptn = /([\t\r\n ])*\f?&/g /* match & */
		var escapeptn = /:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g /* matches :global(.*) */
		var invalidptn = /\W+/g /* removes invalid characters from keyframes */
		var keyframeptn = /@(k\w+)\s*(\S*)\s*/ /* matches @keyframes $1 */
		var plcholdrptn = /::(place)/g /* match ::placeholder varient */
		var readonlyptn = /:(read-only)/g /* match :read-only varient */
		var beforeptn = /\s+(?=[{\];=:>])/g /* matches \s before ] ; = : */
		var afterptn = /([[}=:>])\s+/g /* matches \s after characters [ } = : */
		var tailptn = /(\{[^{]+?);(?=\})/g /* matches tail semi-colons ;} */
		var whiteptn = /\s{2,}/g /* matches repeating whitespace */
		var pseudoptn = /([^\(])(:+) */g /* pseudo element */
		var writingptn = /[svh]\w+-[tblr]{2}/ /* match writing mode property values */
		var gradientptn = /([\w-]+t\()/g /* match *gradient property */
		var supportsptn = /\(\s*(.*)\s*\)/g /* match supports (groups) */
		var propertyptn = /([\s\S]*?);/g /* match properties leading semicolon */
		var selfptn = /-self|flex-/g /* match flex- and -self in align-self: flex-*; */
		var pseudofmt = /[^]*?(:[rp][el]a[\w-]+)[^]*/ /* extrats :readonly or :placholder from selector */
		var trimptn = /[ \t]+$/ /* match tail whitspace */
		var dimensionptn = /stretch|:\s*\w+\-(?:conte|avail)/ /* match max/min/fit-content, fill-available */
		var imgsrcptn = /([^-])(image-set\()/
	
		/* vendors */
		var webkit = '-webkit-'
		var moz = '-moz-'
		var ms = '-ms-'
	
		/* character codes */
		var SEMICOLON = 59 /* ; */
		var CLOSEBRACES = 125 /* } */
		var OPENBRACES = 123 /* { */
		var OPENPARENTHESES = 40 /* ( */
		var CLOSEPARENTHESES = 41 /* ) */
		var OPENBRACKET = 91 /* [ */
		var CLOSEBRACKET = 93 /* ] */
		var NEWLINE = 10 /* \n */
		var CARRIAGE = 13 /* \r */
		var TAB = 9 /* \t */
		var AT = 64 /* @ */
		var SPACE = 32 /*   */
		var AND = 38 /* & */
		var DASH = 45 /* - */
		var UNDERSCORE = 95 /* _ */
		var STAR = 42 /* * */
		var COMMA = 44 /* , */
		var COLON = 58 /* : */
		var SINGLEQUOTE = 39 /* ' */
		var DOUBLEQUOTE = 34 /* " */
		var FOWARDSLASH = 47 /* / */
		var GREATERTHAN = 62 /* > */
		var PLUS = 43 /* + */
		var TILDE = 126 /* ~ */
		var NULL = 0 /* \0 */
		var FORMFEED = 12 /* \f */
		var VERTICALTAB = 11 /* \v */
	
		/* special identifiers */
		var KEYFRAME = 107 /* k */
		var MEDIA = 109 /* m */
		var SUPPORTS = 115 /* s */
		var PLACEHOLDER = 112 /* p */
		var READONLY = 111 /* o */
		var IMPORT = 105 /* <at>i */
		var CHARSET = 99 /* <at>c */
		var DOCUMENT = 100 /* <at>d */
		var PAGE = 112 /* <at>p */
	
		var column = 1 /* current column */
		var line = 1 /* current line numebr */
		var pattern = 0 /* :pattern */
	
		var cascade = 1 /* #id h1 h2 vs h1#id h2#id  */
		var prefix = 1 /* vendor prefix */
		var escape = 1 /* escape :global() pattern */
		var compress = 0 /* compress output */
		var semicolon = 0 /* no/semicolon option */
		var preserve = 0 /* preserve empty selectors */
	
		/* empty reference */
		var array = []
	
		/* plugins */
		var plugins = []
		var plugged = 0
		var should = null
	
		/* plugin context */
		var POSTS = -2
		var PREPS = -1
		var UNKWN = 0
		var PROPS = 1
		var BLCKS = 2
		var ATRUL = 3
	
		/* plugin newline context */
		var unkwn = 0
	
		/* keyframe animation */
		var keyed = 1
		var key = ''
	
		/* selector namespace */
		var nscopealt = ''
		var nscope = ''
	
		/**
		 * Compile
		 *
		 * @param {Array<string>} parent
		 * @param {Array<string>} current
		 * @param {string} body
		 * @param {number} id
		 * @param {number} depth
		 * @return {string}
		 */
		function compile (parent, current, body, id, depth) {
			var bracket = 0 /* brackets [] */
			var comment = 0 /* comments /* // or /* */
			var parentheses = 0 /* functions () */
			var quote = 0 /* quotes '', "" */
	
			var first = 0 /* first character code */
			var second = 0 /* second character code */
			var code = 0 /* current character code */
			var tail = 0 /* previous character code */
			var trail = 0 /* character before previous code */
			var peak = 0 /* previous non-whitespace code */
	
			var counter = 0 /* count sequence termination */
			var context = 0 /* track current context */
			var atrule = 0 /* track @at-rule context */
			var pseudo = 0 /* track pseudo token index */
			var caret = 0 /* current character index */
			var format = 0 /* control character formating context */
			var insert = 0 /* auto semicolon insertion */
			var invert = 0 /* inverted selector pattern */
			var length = 0 /* generic length address */
			var eof = body.length /* end of file(length) */
			var eol = eof - 1 /* end of file(characters) */
	
			var char = '' /* current character */
			var chars = '' /* current buffer of characters */
			var child = '' /* next buffer of characters */
			var out = '' /* compiled body */
			var children = '' /* compiled children */
			var flat = '' /* compiled leafs */
			var selector /* generic selector address */
			var result /* generic address */
	
			// ...build body
			while (caret < eof) {
				code = body.charCodeAt(caret)
	
				// eof varient
				if (caret === eol) {
					// last character + noop context, add synthetic padding for noop context to terminate
					if (comment + quote + parentheses + bracket !== 0) {
						if (comment !== 0) {
							code = comment === FOWARDSLASH ? NEWLINE : FOWARDSLASH
						}
	
						quote = parentheses = bracket = 0
						eof++
						eol++
					}
				}
	
				if (comment + quote + parentheses + bracket === 0) {
					// eof varient
					if (caret === eol) {
						if (format > 0) {
							chars = chars.replace(formatptn, '')
						}
	
						if (chars.trim().length > 0) {
							switch (code) {
								case SPACE:
								case TAB:
								case SEMICOLON:
								case CARRIAGE:
								case NEWLINE: {
									break
								}
								default: {
									chars += body.charAt(caret)
								}
							}
	
							code = SEMICOLON
						}
					}
	
					// auto semicolon insertion
					if (insert === 1) {
						switch (code) {
							// false flags
							case OPENBRACES:
							case CLOSEBRACES:
							case SEMICOLON:
							case DOUBLEQUOTE:
							case SINGLEQUOTE:
							case OPENPARENTHESES:
							case CLOSEPARENTHESES:
							case COMMA: {
								insert = 0
							}
							// ignore
							case TAB:
							case CARRIAGE:
							case NEWLINE:
							case SPACE: {
								break
							}
							// valid
							default: {
								insert = 0
								length = caret
								first = code
								caret--
								code = SEMICOLON
	
								while (length < eof) {
									switch (body.charCodeAt(length++)) {
										case NEWLINE:
										case CARRIAGE:
										case SEMICOLON: {
											++caret
											code = first
											length = eof
											break
										}
										case COLON: {
											if (format > 0) {
												++caret
												code = first
											}
										}
										case OPENBRACES: {
											length = eof
										}
									}
								}
							}
						}
					}
	
					// token varient
					switch (code) {
						case OPENBRACES: {
							chars = chars.trim()
							first = chars.charCodeAt(0)
							counter = 1
							length = ++caret
	
							while (caret < eof) {
								switch (code = body.charCodeAt(caret)) {
									case OPENBRACES: {
										counter++
										break
									}
									case CLOSEBRACES: {
										counter--
										break
									}
									case FOWARDSLASH: {
										switch (second = body.charCodeAt(caret + 1)) {
											// /*, //
											case STAR:
											case FOWARDSLASH: {
												caret = delimited(second, caret, eol, body)
											}
										}
										break
									}
									// given "[" === 91 & "]" === 93 hence forth 91 + 1 + 1 === 93
									case OPENBRACKET: {
										code++
									}
									// given "(" === 40 & ")" === 41 hence forth 40 + 1 === 41
									case OPENPARENTHESES: {
										code++
									}
									// quote tail delimiter is identical to the head delimiter hence noop,
									// fallthrough clauses have been shifted to the correct tail delimiter
									case DOUBLEQUOTE:
									case SINGLEQUOTE: {
										while (caret++ < eol) {
											if (body.charCodeAt(caret) === code) {
												break
											}
										}
									}
								}
	
								if (counter === 0) {
									break
								}
	
								caret++
							}
	
							child = body.substring(length, caret)
	
							if (first === NULL) {
								first = (chars = chars.replace(nullptn, '').trim()).charCodeAt(0)
							}
	
							switch (first) {
								// @at-rule
								case AT: {
									if (format > 0) {
										chars = chars.replace(formatptn, '')
									}
	
									second = chars.charCodeAt(1)
	
									switch (second) {
										case DOCUMENT:
										case MEDIA:
										case SUPPORTS:
										case DASH: {
											selector = current
											break
										}
										default: {
											selector = array
										}
									}
	
									child = compile(current, selector, child, second, depth+1)
									length = child.length
	
									// preserve empty @at-rule
									if (preserve > 0 && length === 0) {
										length = chars.length
									}
	
									// execute plugins, @at-rule context
									if (plugged > 0) {
										selector = select(array, chars, invert)
										result = proxy(ATRUL, child, selector, current, line, column, length, second, depth, id)
										chars = selector.join('')
	
										if (result !== void 0) {
											if ((length = (child = result.trim()).length) === 0) {
												second = 0
												child = ''
											}
										}
									}
	
									if (length > 0) {
										switch (second) {
											case SUPPORTS: {
												chars = chars.replace(supportsptn, supports)
											}
											case DOCUMENT:
											case MEDIA:
											case DASH: {
												child = chars + '{' + child + '}'
												break
											}
											case KEYFRAME: {
												chars = chars.replace(keyframeptn, '$1 $2' + (keyed > 0 ? key : ''))
												child = chars + '{' + child + '}'
	
												if (prefix === 1 || (prefix === 2 && vendor('@'+child, 3))) {
													child = '@' + webkit + child + '@' + child
												} else {
													child = '@' + child
												}
												break
											}
											default: {
												child = chars + child
	
												if (id === PAGE) {
													child = (out += child, '')
												}
											}
										}
									} else {
										child = ''
									}
	
									break
								}
								// selector
								default: {
									child = compile(current, select(current, chars, invert), child, id, depth+1)
								}
							}
	
							children += child
	
							// reset
							context = 0
							insert = 0
							pseudo = 0
							format = 0
							invert = 0
							atrule = 0
							chars = ''
							child = ''
							code = body.charCodeAt(++caret)
							break
						}
						case CLOSEBRACES:
						case SEMICOLON: {
							chars = (format > 0 ? chars.replace(formatptn, '') : chars).trim()
	
							if ((length = chars.length) > 1) {
								// monkey-patch missing colon
								if (pseudo === 0) {
									first = chars.charCodeAt(0)
	
									// first character is a letter or dash, buffer has a space character
									if ((first === DASH || first > 96 && first < 123)) {
										length = (chars = chars.replace(' ', ':')).length
									}
								}
	
								// execute plugins, property context
								if (plugged > 0) {
									if ((result = proxy(PROPS, chars, current, parent, line, column, out.length, id, depth, id)) !== void 0) {
										if ((length = (chars = result.trim()).length) === 0) {
											chars = '\0\0'
										}
									}
								}
	
								first = chars.charCodeAt(0)
								second = chars.charCodeAt(1)
	
								switch (first) {
									case NULL: {
										break
									}
									case AT: {
										if (second === IMPORT || second === CHARSET) {
											flat += chars + body.charAt(caret)
											break
										}
									}
									default: {
										if (chars.charCodeAt(length-1) === COLON) {
											break
										}
	
										out += property(chars, first, second, chars.charCodeAt(2))
									}
								}
							}
	
							// reset
							context = 0
							insert = 0
							pseudo = 0
							format = 0
							invert = 0
							chars = ''
							code = body.charCodeAt(++caret)
							break
						}
					}
				}
	
				// parse characters
				switch (code) {
					case CARRIAGE:
					case NEWLINE: {
						// auto insert semicolon
						if (comment + quote + parentheses + bracket + semicolon === 0) {
							// valid non-whitespace characters that
							// may precede a newline
							switch (peak) {
								case CLOSEPARENTHESES:
								case SINGLEQUOTE:
								case DOUBLEQUOTE:
								case AT:
								case TILDE:
								case GREATERTHAN:
								case STAR:
								case PLUS:
								case FOWARDSLASH:
								case DASH:
								case COLON:
								case COMMA:
								case SEMICOLON:
								case OPENBRACES:
								case CLOSEBRACES: {
									break
								}
								default: {
									// current buffer has a colon
									if (pseudo > 0) {
										insert = 1
									}
								}
							}
						}
	
						// terminate line comment
						if (comment === FOWARDSLASH) {
							comment = 0
						} else if (cascade + context === 0 && id !== KEYFRAME && chars.length > 0) {
							format = 1
							chars += '\0'
						}
	
						// execute plugins, newline context
						if (plugged * unkwn > 0) {
							proxy(UNKWN, chars, current, parent, line, column, out.length, id, depth, id)
						}
	
						// next line, reset column position
						column = 1
						line++
						break
					}
					case SEMICOLON:
					case CLOSEBRACES: {
						if (comment + quote + parentheses + bracket === 0) {
							column++
							break
						}
					}
					default: {
						// increment column position
						column++
	
						// current character
						char = body.charAt(caret)
	
						// remove comments, escape functions, strings, attributes and prepare selectors
						switch (code) {
							case TAB:
							case SPACE: {
								if (quote + bracket + comment === 0) {
									switch (tail) {
										case COMMA:
										case COLON:
										case TAB:
										case SPACE: {
											char = ''
											break
										}
										default: {
											if (code !== SPACE) {
												char = ' '
											}
										}
									}
								}
								break
							}
							// escape breaking control characters
							case NULL: {
								char = '\\0'
								break
							}
							case FORMFEED: {
								char = '\\f'
								break
							}
							case VERTICALTAB: {
								char = '\\v'
								break
							}
							// &
							case AND: {
								// inverted selector pattern i.e html &
								if (quote + comment + bracket === 0 && cascade > 0) {
									invert = 1
									format = 1
									char = '\f' + char
								}
								break
							}
							// ::p<l>aceholder, l
							// :read-on<l>y, l
							case 108: {
								if (quote + comment + bracket + pattern === 0 && pseudo > 0) {
									switch (caret - pseudo) {
										// ::placeholder
										case 2: {
											if (tail === PLACEHOLDER && body.charCodeAt(caret-3) === COLON) {
												pattern = tail
											}
										}
										// :read-only
										case 8: {
											if (trail === READONLY) {
												pattern = trail
											}
										}
									}
								}
								break
							}
							// :<pattern>
							case COLON: {
								if (quote + comment + bracket === 0) {
									pseudo = caret
								}
								break
							}
							// selectors
							case COMMA: {
								if (comment + parentheses + quote + bracket === 0) {
									format = 1
									char += '\r'
								}
								break
							}
							// quotes
							case DOUBLEQUOTE:
							case SINGLEQUOTE: {
								if (comment === 0) {
									quote = quote === code ? 0 : (quote === 0 ? code : quote)
								}
								break
							}
							// attributes
							case OPENBRACKET: {
								if (quote + comment + parentheses === 0) {
									bracket++
								}
								break
							}
							case CLOSEBRACKET: {
								if (quote + comment + parentheses === 0) {
									bracket--
								}
								break
							}
							// functions
							case CLOSEPARENTHESES: {
								if (quote + comment + bracket === 0) {
									parentheses--
								}
								break
							}
							case OPENPARENTHESES: {
								if (quote + comment + bracket === 0) {
									if (context === 0) {
										switch (tail*2 + trail*3) {
											// :matches
											case 533: {
												break
											}
											// :global, :not, :nth-child etc...
											default: {
												counter = 0
												context = 1
											}
										}
									}
	
									parentheses++
								}
								break
							}
							case AT: {
								if (comment + parentheses + quote + bracket + pseudo + atrule === 0) {
									atrule = 1
								}
								break
							}
							// block/line comments
							case STAR:
							case FOWARDSLASH: {
								if (quote + bracket + parentheses > 0) {
									break
								}
	
								switch (comment) {
									// initialize line/block comment context
									case 0: {
										switch (code*2 + body.charCodeAt(caret+1)*3) {
											// //
											case 235: {
												comment = FOWARDSLASH
												break
											}
											// /*
											case 220: {
												length = caret
												comment = STAR
												break
											}
										}
										break
									}
									// end block comment context
									case STAR: {
										if (code === FOWARDSLASH && tail === STAR && length + 2 !== caret) {
											// /*<!> ... */, !
											if (body.charCodeAt(length+2) === 33) {
												out += body.substring(length, caret+1)
											}
											char = ''
											comment = 0
										}
									}
								}
							}
						}
	
						// ignore comment blocks
						if (comment === 0) {
							// aggressive isolation mode, divide each individual selector
							// including selectors in :not function but excluding selectors in :global function
							if (cascade + quote + bracket + atrule === 0 && id !== KEYFRAME && code !== SEMICOLON) {
								switch (code) {
									case COMMA:
									case TILDE:
									case GREATERTHAN:
									case PLUS:
									case CLOSEPARENTHESES:
									case OPENPARENTHESES: {
										if (context === 0) {
											// outside of an isolated context i.e nth-child(<...>)
											switch (tail) {
												case TAB:
												case SPACE:
												case NEWLINE:
												case CARRIAGE: {
													char = char + '\0'
													break
												}
												default: {
													char = '\0' + char + (code === COMMA ? '' : '\0')
												}
											}
											format = 1
										} else {
											// within an isolated context, sleep untill it's terminated
											switch (code) {
												case OPENPARENTHESES: {
													// :globa<l>(
													if (pseudo + 7 === caret && tail === 108) {
														pseudo = 0
													}
													context = ++counter
													break
												}
												case CLOSEPARENTHESES: {
													if ((context = --counter) === 0) {
														format = 1
														char += '\0'
													}
													break
												}
											}
										}
										break
									}
									case TAB:
									case SPACE: {
										switch (tail) {
											case NULL:
											case OPENBRACES:
											case CLOSEBRACES:
											case SEMICOLON:
											case COMMA:
											case FORMFEED:
											case TAB:
											case SPACE:
											case NEWLINE:
											case CARRIAGE: {
												break
											}
											default: {
												// ignore in isolated contexts
												if (context === 0) {
													format = 1
													char += '\0'
												}
											}
										}
									}
								}
							}
	
							// concat buffer of characters
							chars += char
	
							// previous non-whitespace character code
							if (code !== SPACE && code !== TAB) {
								peak = code
							}
						}
					}
				}
	
				// tail character codes
				trail = tail
				tail = code
	
				// visit every character
				caret++
			}
	
			length = out.length
	
			// preserve empty selector
	 		if (preserve > 0) {
	 			if (length === 0 && children.length === 0 && (current[0].length === 0) === false) {
	 				if (id !== MEDIA || (current.length === 1 && (cascade > 0 ? nscopealt : nscope) === current[0])) {
						length = current.join(',').length + 2
	 				}
	 			}
			}
	
			if (length > 0) {
				// cascade isolation mode?
				selector = cascade === 0 && id !== KEYFRAME ? isolate(current) : current
	
				// execute plugins, block context
				if (plugged > 0) {
					result = proxy(BLCKS, out, selector, parent, line, column, length, id, depth, id)
	
					if (result !== void 0 && (out = result).length === 0) {
						return flat + out + children
					}
				}
	
				out = selector.join(',') + '{' + out + '}'
	
				if (prefix*pattern !== 0) {
					if (prefix === 2 && !vendor(out, 2))
						pattern = 0
	
					switch (pattern) {
						// ::read-only
						case READONLY: {
							out = out.replace(readonlyptn, ':'+moz+'$1')+out
							break
						}
						// ::placeholder
						case PLACEHOLDER: {
							out = (
								out.replace(plcholdrptn, '::' + webkit + 'input-$1') +
								out.replace(plcholdrptn, '::' + moz + '$1') +
								out.replace(plcholdrptn, ':' + ms + 'input-$1') + out
							)
							break
						}
					}
	
					pattern = 0
				}
			}
	
			return flat + out + children
		}
	
		/**
		 * Select
		 *
		 * @param {Array<string>} parent
		 * @param {string} current
		 * @param {number} invert
		 * @return {Array<string>}
		 */
		function select (parent, current, invert) {
			var selectors = current.trim().split(selectorptn)
			var out = selectors
	
			var length = selectors.length
			var l = parent.length
	
			switch (l) {
				// 0-1 parent selectors
				case 0:
				case 1: {
					for (var i = 0, selector = l === 0 ? '' : parent[0] + ' '; i < length; ++i) {
						out[i] = scope(selector, out[i], invert, l).trim()
					}
					break
				}
				// >2 parent selectors, nested
				default: {
					for (var i = 0, j = 0, out = []; i < length; ++i) {
						for (var k = 0; k < l; ++k) {
							out[j++] = scope(parent[k] + ' ', selectors[i], invert, l).trim()
						}
					}
				}
			}
	
			return out
		}
	
		/**
		 * Scope
		 *
		 * @param {string} parent
		 * @param {string} current
		 * @param {number} invert
		 * @param {number} level
		 * @return {string}
		 */
		function scope (parent, current, invert, level) {
			var selector = current
			var code = selector.charCodeAt(0)
	
			// trim leading whitespace
			if (code < 33) {
				code = (selector = selector.trim()).charCodeAt(0)
			}
	
			switch (code) {
				// &
				case AND: {
					switch (cascade + level) {
						case 0:
						case 1: {
							if (parent.trim().length === 0) {
								break
							}
						}
						default: {
							return selector.replace(andptn, '$1'+parent.trim())
						}
					}
					break
				}
				// :
				case COLON: {
					switch (selector.charCodeAt(1)) {
						// g in :global
						case 103: {
							if (escape > 0 && cascade > 0) {
								return selector.replace(escapeptn, '$1').replace(andptn, '$1'+nscope)
							}
							break
						}
						default: {
							// :hover
							return parent.trim() + selector.replace(andptn, '$1'+parent.trim())
						}
					}
				}
				default: {
					// html &
					if (invert*cascade > 0 && selector.indexOf('\f') > 0) {
						return selector.replace(andptn, (parent.charCodeAt(0) === COLON ? '' : '$1')+parent.trim())
					}
				}
			}
	
			return parent + selector
		}
	
		/**
		 * Property
		 *
		 * @param {string} input
		 * @param {number} first
		 * @param {number} second
		 * @param {number} third
		 * @return {string}
		 */
		function property (input, first, second, third) {
			var index = 0
			var out = input + ';'
			var hash = (first*2) + (second*3) + (third*4)
			var cache
	
			// animation: a, n, i characters
			if (hash === 944) {
				return animation(out)
			} else if (prefix === 0 || (prefix === 2 && !vendor(out, 1))) {
				return out
			}
	
			// vendor prefix
			switch (hash) {
				// text-decoration/text-size-adjust/text-shadow/text-align/text-transform: t, e, x
				case 1015: {
					// text-shadow/text-align/text-transform, a
					return out.charCodeAt(10) === 97 ? webkit + out + out : out
				}
				// filter/fill f, i, l
				case 951: {
					// filter, t
					return out.charCodeAt(3) === 116 ? webkit + out + out : out
				}
				// color/column, c, o, l
				case 963: {
					// column, n
					return out.charCodeAt(5) === 110 ? webkit + out + out : out
				}
				// box-decoration-break, b, o, x
				case 1009: {
					if (out.charCodeAt(4) !== 100) {
						break
					}
				}
				// mask, m, a, s
				// clip-path, c, l, i
				case 969:
				case 942: {
					return webkit + out + out
				}
				// appearance: a, p, p
				case 978: {
					return webkit + out + moz + out + out
				}
				// hyphens: h, y, p
				// user-select: u, s, e
				case 1019:
				case 983: {
					return webkit + out + moz + out + ms + out + out
				}
				// background/backface-visibility, b, a, c
				case 883: {
					// backface-visibility, -
					if (out.charCodeAt(8) === DASH) {
						return webkit + out + out
					}
	
					// image-set(...)
					if (out.indexOf('image-set(', 11) > 0) {
						return out.replace(imgsrcptn, '$1'+webkit+'$2') + out
					}
	
					return out
				}
				// flex: f, l, e
				case 932: {
					if (out.charCodeAt(4) === DASH) {
						switch (out.charCodeAt(5)) {
							// flex-grow, g
							case 103: {
								return webkit + 'box-' + out.replace('-grow', '') + webkit + out + ms + out.replace('grow', 'positive') + out
							}
							// flex-shrink, s
							case 115: {
								return webkit + out + ms + out.replace('shrink', 'negative') + out
							}
							// flex-basis, b
							case 98: {
								return webkit + out + ms + out.replace('basis', 'preferred-size') + out
							}
						}
					}
	
					return webkit + out + ms + out + out
				}
				// order: o, r, d
				case 964: {
					return webkit + out + ms + 'flex' + '-' + out + out
				}
				// justify-items/justify-content, j, u, s
				case 1023: {
					// justify-content, c
					if (out.charCodeAt(8) !== 99) {
						break
					}
	
					cache = out.substring(out.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify')
					return webkit + 'box-pack' + cache + webkit + out + ms + 'flex-pack' + cache + out
				}
				// cursor, c, u, r
				case 1005: {
					return cursorptn.test(out) ? out.replace(colonptn, ':' + webkit) + out.replace(colonptn, ':' + moz) + out : out
				}
				// writing-mode, w, r, i
				case 1000: {
					cache = out.substring(13).trim()
					index = cache.indexOf('-') + 1
	
					switch (cache.charCodeAt(0)+cache.charCodeAt(index)) {
						// vertical-lr
						case 226: {
							cache = out.replace(writingptn, 'tb')
							break
						}
						// vertical-rl
						case 232: {
							cache = out.replace(writingptn, 'tb-rl')
							break
						}
						// horizontal-tb
						case 220: {
							cache = out.replace(writingptn, 'lr')
							break
						}
						default: {
							return out
						}
					}
	
					return webkit + out + ms + cache + out
				}
				// position: sticky
				case 1017: {
					if (out.indexOf('sticky', 9) === -1) {
						return out
					}
				}
				// display(flex/inline-flex/inline-box): d, i, s
				case 975: {
					index = (out = input).length - 10
					cache = (out.charCodeAt(index) === 33 ? out.substring(0, index) : out).substring(input.indexOf(':', 7) + 1).trim()
	
					switch (hash = cache.charCodeAt(0) + (cache.charCodeAt(7)|0)) {
						// inline-
						case 203: {
							// inline-box
							if (cache.charCodeAt(8) < 111) {
								break
							}
						}
						// inline-box/sticky
						case 115: {
							out = out.replace(cache, webkit+cache)+';'+out
							break
						}
						// inline-flex
						// flex
						case 207:
						case 102: {
							out = (
								out.replace(cache, webkit+(hash > 102 ? 'inline-' : '')+'box')+';'+
								out.replace(cache, webkit+cache)+';'+
								out.replace(cache, ms+cache+'box')+';'+
								out
							)
						}
					}
	
					return out + ';'
				}
				// align-items, align-center, align-self: a, l, i, -
				case 938: {
					if (out.charCodeAt(5) === DASH) {
						switch (out.charCodeAt(6)) {
							// align-items, i
							case 105: {
								cache = out.replace('-items', '')
								return webkit + out + webkit + 'box-' + cache + ms + 'flex-' + cache + out
							}
							// align-self, s
							case 115: {
								return webkit + out + ms + 'flex-item-' + out.replace(selfptn, '') + out
							}
							// align-content
							default: {
								return webkit + out + ms + 'flex-line-pack' + out.replace('align-content', '').replace(selfptn, '') + out
							}
						}
					}
					break
				}
				// min/max
				case 973:
				case 989: {
					// min-/max- height/width/block-size/inline-size
					if (out.charCodeAt(3) !== DASH || out.charCodeAt(4) === 122) {
						break
					}
				}
				// height/width: min-content / width: max-content
				case 931:
				case 953: {
					if (dimensionptn.test(input) === true) {
						// stretch
						if ((cache = input.substring(input.indexOf(':') + 1)).charCodeAt(0) === 115)
							return property(input.replace('stretch', 'fill-available'), first, second, third).replace(':fill-available', ':stretch')
						else
							return out.replace(cache, webkit + cache) + out.replace(cache, moz + cache.replace('fill-', '')) + out
					}
					break
				}
				// transform, transition: t, r, a
				case 962: {
					out = webkit + out + (out.charCodeAt(5) === 102 ? ms + out : '') + out
	
					// transitions
					if (second + third === 211 && out.charCodeAt(13) === 105 && out.indexOf('transform', 10) > 0) {
						return out.substring(0, out.indexOf(';', 27) + 1).replace(transformptn, '$1' + webkit + '$2') + out
					}
	
					break
				}
			}
	
			return out
		}
	
		/**
		 * Vendor
		 *
		 * @param {string} content
		 * @param {number} context
		 * @return {boolean}
		 */
		function vendor (content, context) {
			var index = content.indexOf(context === 1 ? ':' : '{')
			var key = content.substring(0, context !== 3 ? index : 10)
			var value = content.substring(index + 1, content.length - 1)
	
			return should(context !== 2 ? key : key.replace(pseudofmt, '$1'), value, context)
		}
	
		/**
		 * Supports
		 *
		 * @param {string} match
		 * @param {string} group
		 * @return {string}
		 */
		function supports (match, group) {
			var out = property(group, group.charCodeAt(0), group.charCodeAt(1), group.charCodeAt(2))
	
			return out !== group+';' ? out.replace(propertyptn, ' or ($1)').substring(4) : '('+group+')'
		}
	
		/**
		 * Animation
		 *
		 * @param {string} input
		 * @return {string}
		 */
		function animation (input) {
			var length = input.length
			var index = input.indexOf(':', 9) + 1
			var declare = input.substring(0, index).trim()
			var out = input.substring(index, length-1).trim()
	
			switch (input.charCodeAt(9)*keyed) {
				case 0: {
					break
				}
				// animation-*, -
				case DASH: {
					// animation-name, n
					if (input.charCodeAt(10) !== 110) {
						break
					}
				}
				// animation/animation-name
				default: {
					// split in case of multiple animations
					var list = out.split((out = '', animationptn))
	
					for (var i = 0, index = 0, length = list.length; i < length; index = 0, ++i) {
						var value = list[i]
						var items = value.split(propertiesptn)
	
						while (value = items[index]) {
							var peak = value.charCodeAt(0)
	
							if (keyed === 1 && (
								// letters
								(peak > AT && peak < 90) || (peak > 96 && peak < 123) || peak === UNDERSCORE ||
								// dash but not in sequence i.e --
								(peak === DASH && value.charCodeAt(1) !== DASH)
							)) {
								// not a number/function
								switch (isNaN(parseFloat(value)) + (value.indexOf('(') !== -1)) {
									case 1: {
										switch (value) {
											// not a valid reserved keyword
											case 'infinite': case 'alternate': case 'backwards': case 'running':
											case 'normal': case 'forwards': case 'both': case 'none': case 'linear':
											case 'ease': case 'ease-in': case 'ease-out': case 'ease-in-out':
											case 'paused': case 'reverse': case 'alternate-reverse': case 'inherit':
											case 'initial': case 'unset': case 'step-start': case 'step-end': {
												break
											}
											default: {
												value += key
											}
										}
									}
								}
							}
	
							items[index++] = value
						}
	
						out += (i === 0 ? '' : ',') + items.join(' ')
					}
				}
			}
	
			out = declare + out + ';'
	
			if (prefix === 1 || (prefix === 2 && vendor(out, 1)))
				return webkit + out + out
	
			return out
		}
	
		/**
		 * Isolate
		 *
		 * @param {Array<string>} current
		 */
		function isolate (current) {
			for (var i = 0, length = current.length, selector = Array(length), padding, element; i < length; ++i) {
				// split individual elements in a selector i.e h1 h2 === [h1, h2]
				var elements = current[i].split(elementptn)
				var out = ''
	
				for (var j = 0, size = 0, tail = 0, code = 0, l = elements.length; j < l; ++j) {
					// empty element
					if ((size = (element = elements[j]).length) === 0 && l > 1) {
						continue
					}
	
					tail = out.charCodeAt(out.length-1)
					code = element.charCodeAt(0)
					padding = ''
	
					if (j !== 0) {
						// determine if we need padding
						switch (tail) {
							case STAR:
							case TILDE:
							case GREATERTHAN:
							case PLUS:
							case SPACE:
							case OPENPARENTHESES:  {
								break
							}
							default: {
								padding = ' '
							}
						}
					}
	
					switch (code) {
						case AND: {
							element = padding + nscopealt
						}
						case TILDE:
						case GREATERTHAN:
						case PLUS:
						case SPACE:
						case CLOSEPARENTHESES:
						case OPENPARENTHESES: {
							break
						}
						case OPENBRACKET: {
							element = padding + element + nscopealt
							break
						}
						case COLON: {
							switch (element.charCodeAt(1)*2 + element.charCodeAt(2)*3) {
								// :global
								case 530: {
									if (escape > 0) {
										element = padding + element.substring(8, size - 1)
										break
									}
								}
								// :hover, :nth-child(), ...
								default: {
									if (j < 1 || elements[j-1].length < 1) {
										element = padding + nscopealt + element
									}
								}
							}
							break
						}
						case COMMA: {
							padding = ''
						}
						default: {
							if (size > 1 && element.indexOf(':') > 0) {
								element = padding + element.replace(pseudoptn, '$1' + nscopealt + '$2')
							} else {
								element = padding + element + nscopealt
							}
						}
					}
	
					out += element
				}
	
				selector[i] = out.replace(formatptn, '').trim()
			}
	
			return selector
		}
	
		/**
		 * Proxy
		 *
		 * @param {number} context
		 * @param {string} content
		 * @param {Array<string>} selectors
		 * @param {Array<string>} parents
		 * @param {number} line
		 * @param {number} column
		 * @param {number} length
		 * @param {number} id
		 * @param {number} depth
		 * @param {number} at
		 * @return {(string|void|*)}
		 */
		function proxy (context, content, selectors, parents, line, column, length, id, depth, at) {
			for (var i = 0, out = content, next; i < plugged; ++i) {
				switch (next = plugins[i].call(stylis, context, out, selectors, parents, line, column, length, id, depth, at)) {
					case void 0:
					case false:
					case true:
					case null: {
						break
					}
					default: {
						out = next
					}
				}
			}
			if (out !== content) {
			  return out
			}
		}
	
		/**
		 * @param {number} code
		 * @param {number} index
		 * @param {number} length
		 * @param {string} body
		 * @return {number}
		 */
		function delimited (code, index, length, body) {
			for (var i = index + 1; i < length; ++i) {
				switch (body.charCodeAt(i)) {
					// /*
					case FOWARDSLASH: {
						if (code === STAR) {
							if (body.charCodeAt(i - 1) === STAR &&  index + 2 !== i) {
								return i + 1
							}
						}
						break
					}
					// //
					case NEWLINE: {
						if (code === FOWARDSLASH) {
							return i + 1
						}
					}
				}
			}
	
			return i
		}
	
		/**
		 * @param {number} type
		 * @param {number} index
		 * @param {number} length
		 * @param {number} find
		 * @param {string} body
		 * @return {number}
		 */
		function match (type, index, length, body) {
			for (var i = index + 1; i < length; ++i) {
				switch (body.charCodeAt(i)) {
					case type: {
						return i
					}
				}
			}
	
			return i
		}
	
		/**
		 * Minify
		 *
		 * @param {(string|*)} output
		 * @return {string}
		 */
		function minify (output) {
			return output
				.replace(formatptn, '')
				.replace(beforeptn, '')
				.replace(afterptn, '$1')
				.replace(tailptn, '$1')
				.replace(whiteptn, ' ')
		}
	
		/**
		 * Use
		 *
		 * @param {(Array<function(...?)>|function(...?)|number|void)?} plugin
		 */
		function use (plugin) {
			switch (plugin) {
				case void 0:
				case null: {
					plugged = plugins.length = 0
					break
				}
				default: {
					if (typeof plugin === 'function') {
						plugins[plugged++] = plugin
					}	else if (typeof plugin === 'object') {
						for (var i = 0, length = plugin.length; i < length; ++i) {
							use(plugin[i])
						}
					} else {
						unkwn = !!plugin|0
					}
				}
	 		}
	
	 		return use
		}
	
		/**
		 * Set
		 *
		 * @param {*} options
		 */
		function set (options) {
			for (var name in options) {
				var value = options[name]
				switch (name) {
					case 'keyframe': keyed = value|0; break
					case 'global': escape = value|0; break
					case 'cascade': cascade = value|0; break
					case 'compress': compress = value|0; break
					case 'semicolon': semicolon = value|0; break
					case 'preserve': preserve = value|0; break
					case 'prefix':
						should = null
	
						if (!value) {
							prefix = 0
						} else if (typeof value !== 'function') {
							prefix = 1
						} else {
							prefix = 2
							should = value
						}
				}
			}
	
			return set
		}
	
		/**
		 * Stylis
		 *
		 * @param {string} selector
		 * @param {string} input
		 * @return {*}
		 */
		function stylis (selector, input) {
			if (this !== void 0 && this.constructor === stylis) {
				return factory(selector)
			}
	
			// setup
			var ns = selector
			var code = ns.charCodeAt(0)
	
			// trim leading whitespace
			if (code < 33) {
				code = (ns = ns.trim()).charCodeAt(0)
			}
	
			// keyframe/animation namespace
			if (keyed > 0) {
				key = ns.replace(invalidptn, code === OPENBRACKET ? '' : '-')
			}
	
			// reset, used to assert if a plugin is moneky-patching the return value
			code = 1
	
			// cascade/isolate
			if (cascade === 1) {
				nscope = ns
			} else {
				nscopealt = ns
			}
	
			var selectors = [nscope]
			var result
	
			// execute plugins, pre-process context
			if (plugged > 0) {
				result = proxy(PREPS, input, selectors, selectors, line, column, 0, 0, 0, 0)
	
				if (result !== void 0 && typeof result === 'string') {
					input = result
				}
			}
	
			// build
			var output = compile(array, selectors, input, 0, 0)
	
			// execute plugins, post-process context
			if (plugged > 0) {
				result = proxy(POSTS, output, selectors, selectors, line, column, output.length, 0, 0, 0)
	
				// bypass minification
				if (result !== void 0 && typeof(output = result) !== 'string') {
					code = 0
				}
			}
	
			// reset
			key = ''
			nscope = ''
			nscopealt = ''
			pattern = 0
			line = 1
			column = 1
	
			return compress*code === 0 ? output : minify(output)
		}
	
		stylis['use'] = use
		stylis['set'] = set
	
		if (options !== void 0) {
			set(options)
		}
	
		return stylis
	}));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(23)(module)))

/***/ }),

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var isProduction = ("production") === 'production';
	var prefix = 'Invariant failed';
	function invariant(condition, message) {
	    if (condition) {
	        return;
	    }
	    if (isProduction) {
	        throw new Error(prefix);
	    }
	    throw new Error(prefix + ": " + (message || ''));
	}
	exports.default = invariant;


/***/ }),

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isProduction = ("production") === 'production';
	function warning(condition, message) {
	  if (!isProduction) {
	    if (condition) {
	      return;
	    }
	
	    var text = "Warning: " + message;
	
	    if (typeof console !== 'undefined') {
	      console.warn(text);
	    }
	
	    try {
	      throw Error(text);
	    } catch (x) {}
	  }
	}
	
	module.exports = warning;


/***/ }),

/***/ 481:
/***/ (function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define("to-querystring",[],t):"object"==typeof exports?exports["to-querystring"]=t():e["to-querystring"]=t()}("undefined"!=typeof self?self:this,function(){return function(e){function t(o){if(n[o])return n[o].exports;var r=n[o]={i:o,l:!1,exports:{}};return e[o].call(r.exports,r,r.exports,t),r.l=!0,r.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,o){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:o})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=0)}([function(e,t,n){"use strict";function o(e,t,n){if("object"===(void 0===t?"undefined":i(t))){return""+u(t,""+n+(""+e+(n&&"]")+"["))}return n&&n.length?""+n+e+"]="+encodeURIComponent(t):e+"="+encodeURIComponent(t)}function r(e,t,n){return t.map(function(t){return o(e,t,n)}).join("&")}function u(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"",n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},u=n.arrayPrefix||"",i=[];return i=Array.isArray(e)?e.map(function(e,n){return o(""+n+u,e,t)}):Object.keys(e).filter(function(t){return void 0!==e[t]}).map(function(n){return e[n]&&Array.isArray(e[n])?r(""+n+u,e[n],t):o(n,e[n],t)}),i.join("&").replace(/%20/g,"+")}Object.defineProperty(t,"__esModule",{value:!0});var i="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};t.default=u}])});

/***/ }),

/***/ 23:
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),

/***/ 227:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\ndisplay: flex;\njustify-content: center;\nflex-flow: column;\n'], ['\ndisplay: flex;\njustify-content: center;\nflex-flow: column;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\nwidth: 80%;\ndisplay: flex;\nflex-flow: column;\nalign-items: center;\nmargin: auto;\nmargin-top: 3em;\n'], ['\nwidth: 80%;\ndisplay: flex;\nflex-flow: column;\nalign-items: center;\nmargin: auto;\nmargin-top: 3em;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\ntext-align: center;\nmargin: 20px;\nh1 {\nfont-size: 1.5em;\n}\n'], ['\ntext-align: center;\nmargin: 20px;\nh1 {\nfont-size: 1.5em;\n}\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\ndisplay: flex;\njustify-content: center;\n\n@media (max-width: 850px) {\n  flex-flow: column;\n  align-items: center;\n}\n\nimg {\n  width: 180px;\n  height: 130px;\n  margin: 10px;\n  object-fit: contain;\n}\n'], ['\ndisplay: flex;\njustify-content: center;\n\n@media (max-width: 850px) {\n  flex-flow: column;\n  align-items: center;\n}\n\nimg {\n  width: 180px;\n  height: 130px;\n  margin: 10px;\n  object-fit: contain;\n}\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\ndisplay: flex;\njustify-content: center;\nflex-flow: column;\n\n@media (max-width: 850px) {\n  h2 {\n    font-size: 1em;\n  }\n\n  p {\n    font-size: 0.8em;\n  }\n}\n\n'], ['\ndisplay: flex;\njustify-content: center;\nflex-flow: column;\n\n@media (max-width: 850px) {\n  h2 {\n    font-size: 1em;\n  }\n\n  p {\n    font-size: 0.8em;\n  }\n}\n\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\ndisplay: flex;\nmargin: 20px;\nbackground-color: ', ';\ncolor: #000;\npadding: 20px;\nborder-radius: 33px;\n\n:hover {\n  cursor: pointer;\n}\n\n@media (max-width: 850px) {\n  width: 345px;\n}\n\n'], ['\ndisplay: flex;\nmargin: 20px;\nbackground-color: ', ';\ncolor: #000;\npadding: 20px;\nborder-radius: 33px;\n\n:hover {\n  cursor: pointer;\n}\n\n@media (max-width: 850px) {\n  width: 345px;\n}\n\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _pip_logo = __webpack_require__(505);
	
	var _pip_logo2 = _interopRequireDefault(_pip_logo);
	
	var _fish = __webpack_require__(498);
	
	var _fish2 = _interopRequireDefault(_fish);
	
	var _gofundme = __webpack_require__(499);
	
	var _gofundme2 = _interopRequireDefault(_gofundme);
	
	var _coloring_book_flyer = __webpack_require__(493);
	
	var _coloring_book_flyer2 = _interopRequireDefault(_coloring_book_flyer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Container = _styledComponents2.default.div(_templateObject);
	
	var ColoringPages = _styledComponents2.default.div(_templateObject2);
	var WorkInProgress = _styledComponents2.default.div(_templateObject3);
	
	var Adverts = _styledComponents2.default.div(_templateObject4);
	
	var Description = _styledComponents2.default.div(_templateObject5);
	
	var Single = _styledComponents2.default.div(_templateObject6, function (props) {
	  return props.background;
	});
	
	var Banner = function Banner() {
	  return _react2.default.createElement(
	    Container,
	    null,
	    _react2.default.createElement(
	      Adverts,
	      null,
	      _react2.default.createElement(
	        Single,
	        {
	          background: '#1EB1F3',
	          onClick: function onClick() {
	            return window.open('https://youtu.be/S36BuGngZjc');
	          }
	        },
	        _react2.default.createElement('img', { src: _pip_logo2.default }),
	        _react2.default.createElement(
	          Description,
	          null,
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Watch the Papah\u0101naumoku\u0101kea'
	          ),
	          _react2.default.createElement(
	            'h2',
	            null,
	            'TV Episode Here!'
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Banner;
	module.exports = exports['default'];

/***/ }),

/***/ 228:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\ndisplay: flex;\njustify-content: center;\nmargin: 2em 0 0 0;\n\n@media (max-width: 850px) {\n  flex-flow: column;\n  align-items: center;\n}\n'], ['\ndisplay: flex;\njustify-content: center;\nmargin: 2em 0 0 0;\n\n@media (max-width: 850px) {\n  flex-flow: column;\n  align-items: center;\n}\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\nwidth: 650px;\nmargin-left: -85px;\ndisplay: flex;\nflex-flow: column;\nalign-items: center;\n\n@media (max-width: 850px) {\n  width: 450px;\n  margin-left: 0;\n}\n\n\n@media (max-width: 380px) {\n  width: 360px;\n  margin-bottom: 25px;\n}\n'], ['\nwidth: 650px;\nmargin-left: -85px;\ndisplay: flex;\nflex-flow: column;\nalign-items: center;\n\n@media (max-width: 850px) {\n  width: 450px;\n  margin-left: 0;\n}\n\n\n@media (max-width: 380px) {\n  width: 360px;\n  margin-bottom: 25px;\n}\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\nwidth: 530px;\n\ndisplay: flex;\nalign-items: center;\nflex-flow: column;\n'], ['\nwidth: 530px;\n\ndisplay: flex;\nalign-items: center;\nflex-flow: column;\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\ndisplay: ', ';\npadding: 0 50px;\n\n@media (max-width: 850px) {\n  padding: 0;\n}\n'], ['\ndisplay: ', ';\npadding: 0 50px;\n\n@media (max-width: 850px) {\n  padding: 0;\n}\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\ndisplay: ', ';\n'], ['\ndisplay: ', ';\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\nbackground-color: #FFB347;\nborder: #FFB347 solid 3px;\ncolor: #002348;\ncursor: pointer;\nborder-radius: 5px;\nwidth: 100px;\nfloat: ', '\ndisplay: flex;\njustify-content: center;\n'], ['\nbackground-color: #FFB347;\nborder: #FFB347 solid 3px;\ncolor: #002348;\ncursor: pointer;\nborder-radius: 5px;\nwidth: 100px;\nfloat: ', '\ndisplay: flex;\njustify-content: center;\n']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\ndisplay: flex;\njustify-content: center;\nalign-items: center;\nh4 {\n  width: 130px;\n}\n\nselect {\n  width: 170px;\n  overflow: hidden;\n}\n'], ['\ndisplay: flex;\njustify-content: center;\nalign-items: center;\nh4 {\n  width: 130px;\n}\n\nselect {\n  width: 170px;\n  overflow: hidden;\n}\n']),
	    _templateObject8 = _taggedTemplateLiteralLoose(['\ndisplay: inline-block;\nmargin: 15px;\n\na {\n  color: #FFB347;\n}\n'], ['\ndisplay: inline-block;\nmargin: 15px;\n\na {\n  color: #FFB347;\n}\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyPluginMailchimp = __webpack_require__(355);
	
	var _gatsbyPluginMailchimp2 = _interopRequireDefault(_gatsbyPluginMailchimp);
	
	var _bumper_sticker = __webpack_require__(491);
	
	var _bumper_sticker2 = _interopRequireDefault(_bumper_sticker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var BumperContainer = _styledComponents2.default.div(_templateObject);
	
	var BumperAd = _styledComponents2.default.div(_templateObject2);
	
	var BumperForm = _styledComponents2.default.form(_templateObject3);
	
	var Form1 = _styledComponents2.default.div(_templateObject4, function (props) {
	    return props.is2ndForm ? 'none' : 'block';
	});
	var Form2 = Form1.extend(_templateObject5, function (props) {
	    return props.is2ndForm ? 'block' : 'none';
	});
	
	var Button = _styledComponents2.default.button(_templateObject6, function (props) {
	    return props.float;
	});
	
	var BumperLabel = _styledComponents2.default.label(_templateObject7);
	
	var FormMessages = _styledComponents2.default.h3(_templateObject8);
	
	var BumperStickerSignUp = function (_React$Component) {
	    _inherits(BumperStickerSignUp, _React$Component);
	
	    function BumperStickerSignUp(props) {
	        _classCallCheck(this, BumperStickerSignUp);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this._handleSubmit = function (e) {
	            e.preventDefault();
	            //Address field is standard textbox because of errors with traditional Address field in MailChimp
	            (0, _gatsbyPluginMailchimp2.default)(_this.state.email, {
	                'FNAME': _this.state.fName,
	                'LNAME': _this.state.lName,
	                "ADDRESS": _this.state.address1 + ' ' + _this.state.address2 + ' ' + _this.state.cityValue + ' ' + _this.state.stateValue + ' ' + _this.state.zipValue + ' ' + _this.state.countryValue,
	                'SIGNUP': _this.state.signUp
	            }).then(function (result) {
	                if (result.result !== 'success') {
	                    _this.setState({
	                        status: 'error',
	                        msg: result.msg
	                    });
	                } else {
	                    // Email address succesfully subcribed to Mailchimp
	                    _this.setState({
	                        status: 'success',
	                        msg: result.msg
	                    });
	                }
	            }).catch(function (err) {
	                // Network failures, timeouts, etc
	                _this.setState({
	                    status: 'error',
	                    msg: err
	                });
	            });
	        };
	
	        _this.state = {
	            email: '',
	            fName: '',
	            lName: '',
	            address1: '',
	            address2: '',
	            cityValue: '',
	            stateValue: '',
	            zipValue: '',
	            countryValue: '164',
	            signUp: 'bumper',
	            is2ndForm: false,
	            show1stFormWarning: false,
	            msg: '',
	            status: ''
	        };
	        _this._handleSubmit = _this._handleSubmit.bind(_this);
	        _this.handleChange = _this.handleChange.bind(_this);
	        _this.checkForm1 = _this.checkForm1.bind(_this);
	        _this.goBackTo1 = _this.goBackTo1.bind(_this);
	        return _this;
	    }
	
	    BumperStickerSignUp.prototype.handleChange = function handleChange(event) {
	        var _setState;
	
	        var target = event.target;
	        var value = target.value;
	        var name = target.name;
	        this.setState((_setState = {}, _setState[name] = value, _setState));
	    };
	
	    BumperStickerSignUp.prototype.checkForm1 = function checkForm1(e) {
	        e.preventDefault();
	        if (this.state.email.indexOf('.') === -1 || this.state.email.indexOf('@') === -1) {
	            this.setState({ msg: 'Please Enter a valid email' });
	        } else {
	            this.state.email !== '' && this.state.fName !== '' ? this.setState({ is2ndForm: true, msg: "" }) : this.setState({ msg: "Did you forget a field?" });
	        }
	    };
	
	    BumperStickerSignUp.prototype.goBackTo1 = function goBackTo1(e) {
	        e.preventDefault();
	        this.setState({ is2ndForm: false, show1stFormWarning: false });
	    };
	
	    BumperStickerSignUp.prototype.render = function render() {
	        return _react2.default.createElement(
	            BumperContainer,
	            null,
	            _react2.default.createElement(
	                BumperAd,
	                null,
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Get your Papahanaumokuakea Sticker FREE '
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Send us an Email at Aloha@PapahanaumokuakeaSong.com'
	                ),
	                _react2.default.createElement('img', { src: _bumper_sticker2.default })
	            ),
	            '           '
	        );
	    };
	
	    return BumperStickerSignUp;
	}(_react2.default.Component);
	
	exports.default = BumperStickerSignUp;
	module.exports = exports['default'];

/***/ }),

/***/ 229:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\npadding: 0px 25px 0 25px;\nmargin: auto;\n\ndisplay: flex;\nmax-width: 1200px;\njustify-content: space-around;\nalign-items: center;\n\na{\ncolor: #f48df7;\ntext-decoration: none;\n}\n\n', '\n\ndiv {\n    padding: 20px;\n\n  h1 {\n  margin-bottom: 4px;\n  }\n\n  hr {\n  border-bottom: 3px solid #fff;\n  width: 270px;\n  margin-right: auto;\n  }\n\n  p {\n  font-size: 1em;\n  max-width: 555px;\n  }\n\n}\n'], ['\npadding: 0px 25px 0 25px;\nmargin: auto;\n\ndisplay: flex;\nmax-width: 1200px;\njustify-content: space-around;\nalign-items: center;\n\na{\ncolor: #f48df7;\ntext-decoration: none;\n}\n\n', '\n\ndiv {\n    padding: 20px;\n\n  h1 {\n  margin-bottom: 4px;\n  }\n\n  hr {\n  border-bottom: 3px solid #fff;\n  width: 270px;\n  margin-right: auto;\n  }\n\n  p {\n  font-size: 1em;\n  max-width: 555px;\n  }\n\n}\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\nflex-flow: column-reverse;\njustify-content: center;\npadding-top: 0px;\n\ndiv {\n    padding: 5px !important;\n    margin: auto;\n    h1 {\n        font-size: 1.5em !important;\n    }\n\n    p {\n        font-size: 1em !important;\n    }\n}\n\n'], ['\nflex-flow: column-reverse;\njustify-content: center;\npadding-top: 0px;\n\ndiv {\n    padding: 5px !important;\n    margin: auto;\n    h1 {\n        font-size: 1.5em !important;\n    }\n\n    p {\n        font-size: 1em !important;\n    }\n}\n\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n    cursor: pointer;\n    margin-left: 0px !important;\n\n    :hover {\n        box-shadow: inset 0 0 100px 100px rgba(255, 255, 255, 0.1);\n    }\n\n    p {\n      position: relative;\n    }\n    embed {\n      position: absolute;\n      bottom: 0;\n      right: 5px;\n      width: 58px;\n      z-index: -1000;\n\n        @media (max-width: 1090px) {\n          bottom: 33px;\n          right: 18px;\n          width: 46px;\n        }\n\n        ', '\n    }\n'], ['\n    cursor: pointer;\n    margin-left: 0px !important;\n\n    :hover {\n        box-shadow: inset 0 0 100px 100px rgba(255, 255, 255, 0.1);\n    }\n\n    p {\n      position: relative;\n    }\n    embed {\n      position: absolute;\n      bottom: 0;\n      right: 5px;\n      width: 58px;\n      z-index: -1000;\n\n        @media (max-width: 1090px) {\n          bottom: 33px;\n          right: 18px;\n          width: 46px;\n        }\n\n        ', '\n    }\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n            width: 26px;\n            bottom: 52px;\n        '], ['\n            width: 26px;\n            bottom: 52px;\n        ']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  object-fit: cover;\n  width: 100%;\n  min-width: 400px;\n  border: 3px solid #fff;\n  margin-bottom: 0;\n  width: 420px;\n\n\n  ', '\n'], ['\n  object-fit: cover;\n  width: 100%;\n  min-width: 400px;\n  border: 3px solid #fff;\n  margin-bottom: 0;\n  width: 420px;\n\n\n  ', '\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n    width: 70%;\n    min-width: unset;\n    height: unset;\n    margin: auto;\n    '], ['\n    width: 70%;\n    min-width: unset;\n    height: unset;\n    margin: auto;\n    ']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\nmargin-left: 0px !important;\nposition: relative;\npadding-top: 26px;\ncursor: pointer;\n\n\n :hover {\n        box-shadow: inset 0 0 100px 100px rgba(255, 255, 255, 0.1);\n    }\n\nimg {\n  width: 100px;\n  position: absolute;\n  right: 0;\n  top: 31px;\n  z-index: -1000;\n\n  @media (max-width: 950px) {\n      top: 85px;\n  }\n\n  ', '\n\n}\n\n'], ['\nmargin-left: 0px !important;\nposition: relative;\npadding-top: 26px;\ncursor: pointer;\n\n\n :hover {\n        box-shadow: inset 0 0 100px 100px rgba(255, 255, 255, 0.1);\n    }\n\nimg {\n  width: 100px;\n  position: absolute;\n  right: 0;\n  top: 31px;\n  z-index: -1000;\n\n  @media (max-width: 950px) {\n      top: 85px;\n  }\n\n  ', '\n\n}\n\n']),
	    _templateObject8 = _taggedTemplateLiteralLoose(['\n      right: 106px;\n      top: 47px;\n  '], ['\n      right: 106px;\n      top: 47px;\n  ']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _ColorCover = __webpack_require__(483);
	
	var _ColorCover2 = _interopRequireDefault(_ColorCover);
	
	var _layouts = __webpack_require__(14);
	
	var _doc = __webpack_require__(216);
	
	var _doc2 = _interopRequireDefault(_doc);
	
	var _ColoringPages = __webpack_require__(342);
	
	var _ColoringPages2 = _interopRequireDefault(_ColoringPages);
	
	var _camera = __webpack_require__(144);
	
	var _camera2 = _interopRequireDefault(_camera);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Container = _styledComponents2.default.div(_templateObject, _layouts.media.phone(_templateObject2));
	
	var PressRelease = _styledComponents2.default.div(_templateObject3, _layouts.media.phone(_templateObject4));
	
	var Painting = _styledComponents2.default.img(_templateObject5, _layouts.media.phone(_templateObject6));
	
	var VideoBlock = _styledComponents2.default.div(_templateObject7, _layouts.media.phone(_templateObject8));
	
	var Mission = function Mission(props) {
	    return _react2.default.createElement(
	        Container,
	        { id: 'mission' },
	        _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'h1',
	                    null,
	                    'Download the Free Papah\u0101naumoku\u0101kea Song Coloring Book'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    ' The Papah\u0101naumoku\u0101kea Coloring Book is a Work In Progress. Here are the initial coloring book pages and more are coming as we illustrate the long version of the song that includes the atolls. Feel Free to share it, print it, sing it, and use it to teach and enjoy.'
	                )
	            ),
	            _react2.default.createElement(
	                'a',
	                { href: 'https://www.bitsofaloha.com/ColoringBookPages2.pdf' },
	                _react2.default.createElement(
	                    PressRelease,
	                    null,
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        'Download Coloring Book'
	                    ),
	                    _react2.default.createElement('hr', null),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Includes lyrics and ukulele chords to the song',
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            _react2.default.createElement('embed', { src: _doc2.default })
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'a',
	                { href: 'https://www.bitsofaloha.com/ColoringBookPages2.pdf' },
	                _react2.default.createElement(Painting, { src: _ColorCover2.default })
	            )
	        )
	    );
	};
	
	exports.default = Mission;
	module.exports = exports['default'];

/***/ }),

/***/ 230:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  padding-top: 100px;\n  display: flex;\n  flex-flow: column;\n  justify-content: center;\n  align-items: center;\n  max-width: 935px;\n  margin: 0 auto 150px auto;\n\n  ', '\n\n'], ['\n  padding-top: 100px;\n  display: flex;\n  flex-flow: column;\n  justify-content: center;\n  align-items: center;\n  max-width: 935px;\n  margin: 0 auto 150px auto;\n\n  ', '\n\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n        padding-top: 55px;\n    '], ['\n        padding-top: 55px;\n    ']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  display: block;\n'], ['\n  display: block;\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-flow: row;\n  justify-content: space-between;\n\n  ', '\n'], ['\n  display: flex;\n  flex-flow: row;\n  justify-content: space-between;\n\n  ', '\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n    flex-flow: column;\n\n    '], ['\n    flex-flow: column;\n\n    ']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-flow: column;\n  margin: 20px;\n  h3 {\n    font-size: 1.2em;\n  }\n\n  ', '\n\n  div {\n  flex: 1;\n  padding: 0 15px;\n\n  ', '\n  }\n\n  embed {\n    width: 40px;\n    margin: 0 10px 10px 0;\n  }\n\n'], ['\n  display: flex;\n  flex-flow: column;\n  margin: 20px;\n  h3 {\n    font-size: 1.2em;\n  }\n\n  ', '\n\n  div {\n  flex: 1;\n  padding: 0 15px;\n\n  ', '\n  }\n\n  embed {\n    width: 40px;\n    margin: 0 10px 10px 0;\n  }\n\n']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\n    margin: 20px 0;\n    h2 {\n        font-size: 1.2em;\n    }\n    h3 {\n        font-size: 0.8em;\n    }\n    '], ['\n    margin: 20px 0;\n    h2 {\n        font-size: 1.2em;\n    }\n    h3 {\n        font-size: 0.8em;\n    }\n    ']),
	    _templateObject8 = _taggedTemplateLiteralLoose(['\n    padding: 0 10px;\n    '], ['\n    padding: 0 10px;\n    ']),
	    _templateObject9 = _taggedTemplateLiteralLoose(['\nposition: relative;\n\n\n\nh3:first-of-type {user-select: none; }\n\nh3:last-of-type{\nposition: absolute;\nz-index: 333;\ncolor: #ffe4c400;\nbottom: 0px;\n}\n'], ['\nposition: relative;\n\n\n\nh3:first-of-type {user-select: none; }\n\nh3:last-of-type{\nposition: absolute;\nz-index: 333;\ncolor: #ffe4c400;\nbottom: 0px;\n}\n']),
	    _templateObject10 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-flow: column;\n  margin: 20px;\n\n    ', '\n\n\n  div {\n  padding: 0 15px;\n  }\n'], ['\n  display: flex;\n  flex-flow: column;\n  margin: 20px;\n\n    ', '\n\n\n  div {\n  padding: 0 15px;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _layouts = __webpack_require__(14);
	
	var _facebook = __webpack_require__(496);
	
	var _facebook2 = _interopRequireDefault(_facebook);
	
	var _patreon = __webpack_require__(502);
	
	var _patreon2 = _interopRequireDefault(_patreon);
	
	var _Email = __webpack_require__(233);
	
	var _Email2 = _interopRequireDefault(_Email);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Container = _styledComponents2.default.div(_templateObject, _layouts.media.phone(_templateObject2));
	
	var Title = _styledComponents2.default.div(_templateObject3);
	
	var Block = _styledComponents2.default.div(_templateObject4, _layouts.media.phone(_templateObject5));
	
	var Info = _styledComponents2.default.div(_templateObject6, _layouts.media.phone(_templateObject7), _layouts.media.phone(_templateObject8));
	
	var TextProtection = _styledComponents2.default.span(_templateObject9);
	
	var Subscribe = _styledComponents2.default.div(_templateObject10, _layouts.media.phone(_templateObject7));
	
	var Contact = function Contact() {
	    return _react2.default.createElement(
	        Container,
	        { id: 'contact' },
	        _react2.default.createElement(
	            Title,
	            null,
	            _react2.default.createElement(
	                'h1',
	                null,
	                'Contact'
	            )
	        ),
	        _react2.default.createElement(
	            Block,
	            null,
	            _react2.default.createElement(
	                Info,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'h2',
	                        null,
	                        'Social'
	                    ),
	                    _react2.default.createElement('embed', { className: 'embed-last', src: _facebook2.default })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'h2',
	                        null,
	                        'Email:'
	                    ),
	                    _react2.default.createElement(
	                        TextProtection,
	                        null,
	                        _react2.default.createElement(
	                            'h3',
	                            null,
	                            'Aloha@PapahanaumokuakeaSong.com'
	                        ),
	                        _react2.default.createElement(
	                            'h3',
	                            null,
	                            'Aloha@PapahanaumokuakeaSong.com'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'h2',
	                        null,
	                        'Phone number:'
	                    ),
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        '808-259-5354'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                Subscribe,
	                null,
	                _react2.default.createElement(
	                    'h2',
	                    null,
	                    'Get project update email notifications:'
	                ),
	                _react2.default.createElement(
	                    'h2',
	                    null,
	                    'Get project update email notifications:'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'h4',
	                        null,
	                        'Get project update email notifications via ',
	                        _react2.default.createElement(
	                            'a',
	                            { href: 'www.PatrickChing.com' },
	                            'PatrickChing.com'
	                        ),
	                        ' art newsletter.'
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = Contact;
	module.exports = exports['default'];

/***/ }),

/***/ 231:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\ndisplay: flex;\nflex-flow: column;\ntext-align: center;\nmargin: 0 auto 25px auto;\npadding-top: 100px;\n\n', '\n\nimg {\nwidth: 200px;\n}\n'], ['\ndisplay: flex;\nflex-flow: column;\ntext-align: center;\nmargin: 0 auto 25px auto;\npadding-top: 100px;\n\n', '\n\nimg {\nwidth: 200px;\n}\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    padding-top: 55px;\n'], ['\n    padding-top: 55px;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\ndisplay: flex;\nmax-width: 1120px;\nmargin: 0 auto;\n\n', '\n\n\n\ndiv {\nwidth: 40%;\nmargin: 30px 50px;\n}\n\nembed {\nwidth: 200px;\n}\n'], ['\ndisplay: flex;\nmax-width: 1120px;\nmargin: 0 auto;\n\n', '\n\n\n\ndiv {\nwidth: 40%;\nmargin: 30px 50px;\n}\n\nembed {\nwidth: 200px;\n}\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\nflex-flow: column;\n\n    div {\n        margin: 13px auto !important;\n        width: 85% !important;\n    }\n\n    embed {\n        width: 125px !important;\n    }\n'], ['\nflex-flow: column;\n\n    div {\n        margin: 13px auto !important;\n        width: 85% !important;\n    }\n\n    embed {\n        width: 125px !important;\n    }\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\ndisplay: flex;\ntext-align: left;\njustify-content: center;\nalign-items: center;\nmargin: 30px auto;\nflex-flow: column;\n\n', '\n\n\nli {\nmargin-bottom: 0.325rem;\n}\n'], ['\ndisplay: flex;\ntext-align: left;\njustify-content: center;\nalign-items: center;\nmargin: 30px auto;\nflex-flow: column;\n\n', '\n\n\nli {\nmargin-bottom: 0.325rem;\n}\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\nmargin: 15px !important;\n'], ['\nmargin: 15px !important;\n']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\ndisplay: flex;\njustify-content: center;\nalign-items: center;\ndiv {\n  display: flex;\n  align-items: center;\n  margin: auto;\n\n  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n     margin: 0;\n  }\n\n\n  img {\n  width: 50px;\n  margin-right: 10px;\n  }\n}\n\n'], ['\ndisplay: flex;\njustify-content: center;\nalign-items: center;\ndiv {\n  display: flex;\n  align-items: center;\n  margin: auto;\n\n  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n     margin: 0;\n  }\n\n\n  img {\n  width: 50px;\n  margin-right: 10px;\n  }\n}\n\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _SignUp = __webpack_require__(239);
	
	var _SignUp2 = _interopRequireDefault(_SignUp);
	
	var _layouts = __webpack_require__(14);
	
	var _camera = __webpack_require__(144);
	
	var _camera2 = _interopRequireDefault(_camera);
	
	var _film_strip = __webpack_require__(497);
	
	var _film_strip2 = _interopRequireDefault(_film_strip);
	
	var _download = __webpack_require__(217);
	
	var _download2 = _interopRequireDefault(_download);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Container = _styledComponents2.default.div(_templateObject, _layouts.media.phone(_templateObject2));
	
	var Description = _styledComponents2.default.div(_templateObject3, _layouts.media.phone(_templateObject4));
	
	var Awards = _styledComponents2.default.div(_templateObject5, _layouts.media.phone(_templateObject6));
	
	// TODO IE fix
	
	var Supplemental = _styledComponents2.default.div(_templateObject7);
	
	var Contest = function Contest() {
	    return _react2.default.createElement(
	        Container,
	        { id: 'contest' },
	        _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement('a', { name: 'video' }),
	            _react2.default.createElement('img', { src: _camera2.default }),
	            _react2.default.createElement('a', { name: '#video' }),
	            _react2.default.createElement(
	                'h1',
	                null,
	                'Music Video Send-In'
	            ),
	            _react2.default.createElement(
	                Description,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement('embed', { src: _film_strip2.default }),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Film your group performing a song about Papah\u0101naumoku\u0101kea.'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement('embed', { src: _film_strip2.default }),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Sing the song as written, remix it or create your very own. We\u2019ll provide the  art and photos. How about a May Day performance?'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                Supplemental,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(_SignUp2.default, null)
	                )
	            )
	        )
	    );
	};
	
	exports.default = Contest;
	module.exports = exports['default'];

/***/ }),

/***/ 232:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    color: #002348;\n    font-size: 20px;\n    position: relative;\n    top: 19px;\n    cursor: pointer;\n    \n     @media (max-width: 992px) {\n        font-size: 1.7vw;\n      }\n      \n     @media (max-width: 500px) {\n        font-size: 20px;\n      }\n'], ['\n    color: #002348;\n    font-size: 20px;\n    position: relative;\n    top: 19px;\n    cursor: pointer;\n    \n     @media (max-width: 992px) {\n        font-size: 1.7vw;\n      }\n      \n     @media (max-width: 500px) {\n        font-size: 20px;\n      }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\nbackground: rgba(0,0,0,0.7);\nposition: fixed;\ntop: 0;\nleft: 0;\nwidth: 100%;\nheight: 100%;\ndisplay: flex;\njustify-content: center;\nalign-items: center;\n'], ['\nbackground: rgba(0,0,0,0.7);\nposition: fixed;\ntop: 0;\nleft: 0;\nwidth: 100%;\nheight: 100%;\ndisplay: flex;\njustify-content: center;\nalign-items: center;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\nwidth: 700px;\nheight: ', '\nbackground-color: #fff;\npadding: 15px;\ntransition: all 300ms ease;\n\n@media (max-width: 414px) {\n    width: 100% !important;\n    height: 90% !important;\n    margin-top: 14%;\n  }\n\nh1, h3, p {\ncolor: black;\n}\n\n@media (max-width: 600px) {\n  height: ', ';\n    \n  h3 {\n    margin: 0;\n  }\n}\n\np {\nfont-size: 18px;\n}\n\n@media (max-width: 414px) {\n    \n    font-size: 16px !important;\n    \n    \n    h3 {\n      font-size: 12px !important;\n    }\n    \n    a {\n      font-size: 12px !important;\n    }\n    \n    p {\n      font-size: 12px !important;\n    }\n    \n  }\n\n'], ['\nwidth: 700px;\nheight: ', '\nbackground-color: #fff;\npadding: 15px;\ntransition: all 300ms ease;\n\n@media (max-width: 414px) {\n    width: 100% !important;\n    height: 90% !important;\n    margin-top: 14%;\n  }\n\nh1, h3, p {\ncolor: black;\n}\n\n@media (max-width: 600px) {\n  height: ', ';\n    \n  h3 {\n    margin: 0;\n  }\n}\n\np {\nfont-size: 18px;\n}\n\n@media (max-width: 414px) {\n    \n    font-size: 16px !important;\n    \n    \n    h3 {\n      font-size: 12px !important;\n    }\n    \n    a {\n      font-size: 12px !important;\n    }\n    \n    p {\n      font-size: 12px !important;\n    }\n    \n  }\n\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\nmargin: 0;\ndisplay: flex;\nflex-flow: row;\nalign-items: center;\njustify-content: space-between;\n\n'], ['\nmargin: 0;\ndisplay: flex;\nflex-flow: row;\nalign-items: center;\njustify-content: space-between;\n\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n    padding: 5px;\n    background-color: #FFB347;\n    border: 3px solid #FFB347;\n    border-radius: 5px;\n    margin: 15px 0;\n    \n    @media (max-width: 600px) {\n      margin: 0;\n    }\n    \n    @media (max-width: 414px) {\n        margin: 5px auto !important;\n      }\n  \n'], ['\n    padding: 5px;\n    background-color: #FFB347;\n    border: 3px solid #FFB347;\n    border-radius: 5px;\n    margin: 15px 0;\n    \n    @media (max-width: 600px) {\n      margin: 0;\n    }\n    \n    @media (max-width: 414px) {\n        margin: 5px auto !important;\n      }\n  \n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n    display: flex;\n    justify-content: space-around;\n    \n    @media (max-width: 600px) {\n      flex-flow: column;\n      margin: 0 auto;\n      width: 315px;\n    }\n    \n'], ['\n    display: flex;\n    justify-content: space-around;\n    \n    @media (max-width: 600px) {\n      flex-flow: column;\n      margin: 0 auto;\n      width: 315px;\n    }\n    \n']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\ntext-align: center;\n'], ['\ntext-align: center;\n']),
	    _templateObject8 = _taggedTemplateLiteralLoose(['\nmargin: 0 5px;\n\nimg {\nwidth: 25px;\nheight: 25px;\nmargin: 15px 10px;\ncursor: pointer;\n}\n\n'], ['\nmargin: 0 5px;\n\nimg {\nwidth: 25px;\nheight: 25px;\nmargin: 15px 10px;\ncursor: pointer;\n}\n\n']),
	    _templateObject9 = _taggedTemplateLiteralLoose(['\nbackground: url("', '") no-repeat;\nbackground-size: 35px;\nwidth: 40px;\nheight: 40px;\nfloat: right;\nposition: relative;\ntransform: translateX(-40px);\nmargin-right: -40px;\ncursor: pointer;\n'], ['\nbackground: url("', '") no-repeat;\nbackground-size: 35px;\nwidth: 40px;\nheight: 40px;\nfloat: right;\nposition: relative;\ntransform: translateX(-40px);\nmargin-right: -40px;\ncursor: pointer;\n']),
	    _templateObject10 = _taggedTemplateLiteralLoose(['\n  display: flex; \n  justify-content: center;\n  max-height: 330px;\n  overflow: hidden;\n  img {\n    object-fit: contain;\n  }\n  \n  @media (max-width: 600px) {\n    max-height: 175px;\n  }\n'], ['\n  display: flex; \n  justify-content: center;\n  max-height: 330px;\n  overflow: hidden;\n  img {\n    object-fit: contain;\n  }\n  \n  @media (max-width: 600px) {\n    max-height: 175px;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _cloudDownload = __webpack_require__(492);
	
	var _cloudDownload2 = _interopRequireDefault(_cloudDownload);
	
	var _playCircle = __webpack_require__(506);
	
	var _playCircle2 = _interopRequireDefault(_playCircle);
	
	var _pauseCircle = __webpack_require__(503);
	
	var _pauseCircle2 = _interopRequireDefault(_pauseCircle);
	
	var _timesCircle = __webpack_require__(511);
	
	var _timesCircle2 = _interopRequireDefault(_timesCircle);
	
	var _KawikaPatrickShaka = __webpack_require__(486);
	
	var _KawikaPatrickShaka2 = _interopRequireDefault(_KawikaPatrickShaka);
	
	var _KawikaShaka = __webpack_require__(487);
	
	var _KawikaShaka2 = _interopRequireDefault(_KawikaShaka);
	
	var _IMG_ = __webpack_require__(485);
	
	var _IMG_2 = _interopRequireDefault(_IMG_);
	
	var _bumper_sticker_final = __webpack_require__(488);
	
	var _bumper_sticker_final2 = _interopRequireDefault(_bumper_sticker_final);
	
	var _Papa_long_version_master = __webpack_require__(215);
	
	var _Papa_long_version_master2 = _interopRequireDefault(_Papa_long_version_master);
	
	var _Papa_Instumental_Long_Version = __webpack_require__(212);
	
	var _Papa_Instumental_Long_Version2 = _interopRequireDefault(_Papa_Instumental_Long_Version);
	
	var _Papa_Song_Short_Version_Instrumental = __webpack_require__(214);
	
	var _Papa_Song_Short_Version_Instrumental2 = _interopRequireDefault(_Papa_Song_Short_Version_Instrumental);
	
	var _Papa_Main_Version = __webpack_require__(213);
	
	var _Papa_Main_Version2 = _interopRequireDefault(_Papa_Main_Version);
	
	var _Song_Lyrics_Short_Version_with_Chords_G = __webpack_require__(344);
	
	var _Song_Lyrics_Short_Version_with_Chords_G2 = _interopRequireDefault(_Song_Lyrics_Short_Version_with_Chords_G);
	
	var _Long_Version_with_Chords_G = __webpack_require__(343);
	
	var _Long_Version_with_Chords_G2 = _interopRequireDefault(_Long_Version_with_Chords_G);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var ImageDict = {
	    'LongVocal': _KawikaPatrickShaka2.default, 'LongInstrumental': _IMG_2.default,
	    'ShortInstrumental': _bumper_sticker_final2.default, 'ShortVocal': _KawikaShaka2.default
	};
	
	var ContestButton = _styledComponents2.default.div(_templateObject);
	
	var Overlay = _styledComponents2.default.div(_templateObject2);
	
	var Modal = _styledComponents2.default.div(_templateObject3, function (props) {
	    return props.modalWindowExtend ? '800px' : '500px';
	}, function (props) {
	    return props.modalWindowExtend ? '800px;' : '600px;';
	});
	
	var PlayRow = _styledComponents2.default.div(_templateObject4);
	var TitleButton = _styledComponents2.default.a(_templateObject5);
	
	var SongColumns = _styledComponents2.default.div(_templateObject6);
	
	var CenterTitle = _styledComponents2.default.div(_templateObject7);
	
	var Icons = _styledComponents2.default.div(_templateObject8);
	
	var CloseWindow = _styledComponents2.default.div(_templateObject9, _timesCircle2.default);
	
	var PlayingImageWindow = _styledComponents2.default.div(_templateObject10);
	
	var DownloadModal = function (_React$Component) {
	    _inherits(DownloadModal, _React$Component);
	
	    function DownloadModal(props) {
	        _classCallCheck(this, DownloadModal);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.state = {
	            visible: true,
	            modalWindowExtend: false,
	            displayImages: false
	        };
	        _this.togglePlayingImage = _this.togglePlayingImage.bind(_this);
	        return _this;
	    }
	
	    DownloadModal.prototype.togglePlayingImage = function togglePlayingImage() {
	        var _this2 = this;
	
	        this.setState(function (prevState) {
	            return {
	                modalWindowExtend: true
	            };
	        });
	        if (!this.state.displayImages) {
	            console.log('isRunning');
	            var checkHeight = setInterval(function () {
	                if (_this2.divRef.clientHeight !== undefined && _this2.divRef.clientHeight === 800) {
	                    _this2.setState(function (prevState) {
	                        return {
	                            displayImages: true
	                        };
	                    });
	                    clearInterval(checkHeight);
	                }
	            }, 12);
	        }
	    };
	
	    DownloadModal.prototype.render = function render() {
	        var _this3 = this;
	
	        return _react2.default.createElement(
	            Overlay,
	            { onClick: this.props.toggleSongModal },
	            _react2.default.createElement(
	                Modal,
	                {
	                    innerRef: function innerRef(element) {
	                        return _this3.divRef = element;
	                    },
	                    onClick: function onClick(e) {
	                        return e.stopPropagation();
	                    },
	                    modalWindowExtend: this.state.modalWindowExtend
	                },
	                _react2.default.createElement(CloseWindow, { onClick: this.props.toggleSongModal }),
	                _react2.default.createElement(
	                    CenterTitle,
	                    null,
	                    _react2.default.createElement(
	                        'h1',
	                        null,
	                        'Download ',
	                        _react2.default.createElement('br', null),
	                        'Papah\u0101naumoku\u0101kea song'
	                    )
	                ),
	                _react2.default.createElement(
	                    SongColumns,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'h3',
	                            null,
	                            'Short Version - 2:40 '
	                        ),
	                        _react2.default.createElement(
	                            PlayRow,
	                            null,
	                            _react2.default.createElement(
	                                TitleButton,
	                                null,
	                                'Original'
	                            ),
	                            _react2.default.createElement(
	                                Icons,
	                                { onClick: this.togglePlayingImage },
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: _Papa_Main_Version2.default, download: _Papa_Main_Version2.default },
	                                    _react2.default.createElement('img', { src: _cloudDownload2.default })
	                                ),
	                                this.props.currentSong === 'ShortVocal' && this.props.playing === true ? _react2.default.createElement('img', { onClick: this.props.stopPlaying, src: _pauseCircle2.default }) : _react2.default.createElement('img', {
	                                    onClick: function onClick() {
	                                        return _this3.props.switchSongTo('ShortVocal');
	                                    },
	                                    src: _playCircle2.default
	                                })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            PlayRow,
	                            null,
	                            _react2.default.createElement(
	                                TitleButton,
	                                null,
	                                'Instrumental'
	                            ),
	                            _react2.default.createElement(
	                                Icons,
	                                { onClick: this.togglePlayingImage },
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: _Papa_Song_Short_Version_Instrumental2.default, download: _Papa_Song_Short_Version_Instrumental2.default },
	                                    _react2.default.createElement('img', { src: _cloudDownload2.default })
	                                ),
	                                this.props.currentSong === 'ShortInstrumental' && this.props.playing === true ? _react2.default.createElement('img', { onClick: this.props.stopPlaying, src: _pauseCircle2.default }) : _react2.default.createElement('img', {
	                                    onClick: function onClick() {
	                                        return _this3.props.switchSongTo('ShortInstrumental');
	                                    },
	                                    src: _playCircle2.default
	                                })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            PlayRow,
	                            null,
	                            _react2.default.createElement(
	                                TitleButton,
	                                null,
	                                'Lyric Sheet'
	                            ),
	                            _react2.default.createElement(
	                                Icons,
	                                null,
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: _Song_Lyrics_Short_Version_with_Chords_G2.default, download: _Song_Lyrics_Short_Version_with_Chords_G2.default },
	                                    _react2.default.createElement('img', { src: _cloudDownload2.default })
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'h3',
	                            null,
	                            'Long Version - 8:27'
	                        ),
	                        _react2.default.createElement(
	                            PlayRow,
	                            null,
	                            _react2.default.createElement(
	                                TitleButton,
	                                null,
	                                'Original'
	                            ),
	                            _react2.default.createElement(
	                                Icons,
	                                { onClick: this.togglePlayingImage },
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: _Papa_long_version_master2.default, download: _Papa_long_version_master2.default },
	                                    _react2.default.createElement('img', { src: _cloudDownload2.default })
	                                ),
	                                this.props.currentSong === 'LongVocal' && this.props.playing === true ? _react2.default.createElement('img', { onClick: this.props.stopPlaying, src: _pauseCircle2.default }) : _react2.default.createElement('img', {
	                                    onClick: function onClick() {
	                                        return _this3.props.switchSongTo('LongVocal');
	                                    },
	                                    src: _playCircle2.default
	                                })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            PlayRow,
	                            null,
	                            _react2.default.createElement(
	                                TitleButton,
	                                null,
	                                'Instrumental'
	                            ),
	                            _react2.default.createElement(
	                                Icons,
	                                { onClick: this.togglePlayingImage },
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: _Papa_Instumental_Long_Version2.default, download: _Papa_Instumental_Long_Version2.default },
	                                    _react2.default.createElement('img', { src: _cloudDownload2.default })
	                                ),
	                                this.props.currentSong === 'LongInstrumental' && this.props.playing === true ? _react2.default.createElement('img', { onClick: this.props.stopPlaying, src: _pauseCircle2.default }) : _react2.default.createElement('img', {
	                                    onClick: function onClick() {
	                                        return _this3.props.switchSongTo('LongInstrumental');
	                                    },
	                                    src: _playCircle2.default
	                                })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            PlayRow,
	                            null,
	                            _react2.default.createElement(
	                                TitleButton,
	                                null,
	                                'Lyric Sheet'
	                            ),
	                            _react2.default.createElement(
	                                Icons,
	                                null,
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: _Long_Version_with_Chords_G2.default, download: _Long_Version_with_Chords_G2.default },
	                                    _react2.default.createElement('img', { src: _cloudDownload2.default })
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    CenterTitle,
	                    null,
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Kawika Kahiapo \u2013 Lead Musician'
	                    )
	                ),
	                this.state.displayImages && _react2.default.createElement(
	                    PlayingImageWindow,
	                    null,
	                    _react2.default.createElement('img', { src: ImageDict[this.props.currentSong] })
	                )
	            )
	        );
	    };
	
	    return DownloadModal;
	}(_react2.default.Component);
	
	exports.default = DownloadModal;
	module.exports = exports['default'];

/***/ }),

/***/ 233:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(71);
	
	var _reactMailchimpSubscribe = __webpack_require__(438);
	
	var _reactMailchimpSubscribe2 = _interopRequireDefault(_reactMailchimpSubscribe);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// a basic form
	var CustomForm = function CustomForm(_ref) {
	    var status = _ref.status,
	        message = _ref.message,
	        onValidated = _ref.onValidated;
	
	    var email = void 0,
	        name = void 0;
	    var submit = function submit() {
	        return email && name && email.value.indexOf("@") > -1 && onValidated({
	            EMAIL: email.value,
	            NAME: name.value
	        });
	    };
	
	    return _react2.default.createElement(
	        "div",
	        {
	            style: {
	                borderRadius: 2,
	                padding: 10,
	                display: "inline-block"
	            }
	        },
	        status === "sending" && _react2.default.createElement(
	            "div",
	            { style: { color: "blue" } },
	            "sending..."
	        ),
	        status === "error" && _react2.default.createElement(
	            "div",
	            { style: { color: "red" } },
	            message
	        ),
	        status === "success" && _react2.default.createElement(
	            "div",
	            { style: { color: "green" } },
	            message
	        ),
	        _react2.default.createElement("input", {
	            style: { fontSize: "1em", padding: 5 },
	            ref: function ref(node) {
	                return name = node;
	            },
	            type: "text",
	            placeholder: "Your name"
	        }),
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("input", {
	            style: { fontSize: "1em", padding: 5 },
	            ref: function ref(node) {
	                return email = node;
	            },
	            type: "email",
	            placeholder: "Your email"
	        }),
	        _react2.default.createElement("br", null),
	        _react2.default.createElement(
	            "button",
	            { style: { fontSize: "1em", padding: 5 }, onClick: submit },
	            "Submit"
	        )
	    );
	};
	
	var Email = function (_Component) {
	    _inherits(Email, _Component);
	
	    function Email() {
	        _classCallCheck(this, Email);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    Email.prototype.render = function render() {
	        var url = "https://patrickteachingart.us11.list-manage.com/subscribe/post?u=00bb906f4310de403db0d029c&amp;id=a3f38ddde1";
	        return _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_reactMailchimpSubscribe2.default, {
	                url: url,
	                render: function render(_ref2) {
	                    var subscribe = _ref2.subscribe,
	                        status = _ref2.status,
	                        message = _ref2.message;
	                    return _react2.default.createElement(CustomForm, {
	                        status: status,
	                        message: message,
	                        onValidated: function onValidated(formData) {
	                            return subscribe(formData);
	                        }
	                    });
	                }
	            })
	        );
	    };
	
	    return Email;
	}(_react.Component);
	
	exports.default = Email;
	module.exports = exports["default"];

/***/ }),

/***/ 234:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    position: fixed;\n    display: flex;\n    justify-content: center;\n    width: 100vw;\n    top: 0;\n    height: 100vh;\n    background-color: rgba(0, 0, 0, 0.65);\n    z-index: 999999999999;\n'], ['\n    position: fixed;\n    display: flex;\n    justify-content: center;\n    width: 100vw;\n    top: 0;\n    height: 100vh;\n    background-color: rgba(0, 0, 0, 0.65);\n    z-index: 999999999999;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  img{\n    margin-top: 100px;\n  }\n'], ['\n  img{\n    margin-top: 100px;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _WaikikiAquarium = __webpack_require__(489);
	
	var _WaikikiAquarium2 = _interopRequireDefault(_WaikikiAquarium);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Backdrop = _styledComponents2.default.div(_templateObject);
	
	var Container = _styledComponents2.default.div(_templateObject2);
	
	var EventModal = function (_React$Component) {
	    _inherits(EventModal, _React$Component);
	
	    function EventModal(props) {
	        _classCallCheck(this, EventModal);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    EventModal.prototype.render = function render() {
	        return _react2.default.createElement(
	            Backdrop,
	            { onClick: this.props.toggleEventModal },
	            _react2.default.createElement(
	                Container,
	                { onClick: function onClick(e) {
	                        return e.stopPropagation();
	                    } },
	                _react2.default.createElement('img', { src: _WaikikiAquarium2.default })
	            )
	        );
	    };
	
	    return EventModal;
	}(_react2.default.Component);
	
	exports.default = EventModal;
	module.exports = exports['default'];

/***/ }),

/***/ 80:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\ntext-align: center;\ncolor: #fff;\nfont-weight: 600;\nfont-family: "Arial", Arial, sans-serif;\n'], ['\ntext-align: center;\ncolor: #fff;\nfont-weight: 600;\nfont-family: "Arial", Arial, sans-serif;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(115);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Copyright = _styledComponents2.default.div(_templateObject);
	
	var Footer = function Footer() {
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            Copyright,
	            null,
	            '\xA9',
	            ' Patrick Ching 2018'
	        )
	    );
	};
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 235:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\nmargin-bottom: 1.45rem;\nbackground: #ffb347;\nz-index: 999999;\ntransition: all .3s ease-out;\nposition: fixed;\nwidth: 100%;\ntop: -57px;\n\n@media (max-width: 600px) {\n    position: fixed;\n    z-index: 6;\n    width: 200px;\n    margin: 15px auto -5px auto;\n    flex-flow: column;\n    transform: ', '\n  }\n\n\n'], ['\nmargin-bottom: 1.45rem;\nbackground: #ffb347;\nz-index: 999999;\ntransition: all .3s ease-out;\nposition: fixed;\nwidth: 100%;\ntop: -57px;\n\n@media (max-width: 600px) {\n    position: fixed;\n    z-index: 6;\n    width: 200px;\n    margin: 15px auto -5px auto;\n    flex-flow: column;\n    transform: ', '\n  }\n\n\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\nmargin: 3px auto -5px auto;\nmax-width: 1500px;\npadding: 0.875rem 1.0875rem;\ndisplay: flex;\njustify-content: space-between;\n\n@media (max-width: 600px) {\n    flex-flow: column;\n    padding-top: 55px;\n}\n\nembed{\n    height: 25px;\n    top: 6px;\n    position: relative;\n    right: 62px;\n\n   svg {\n    cursor: pointer;\n   }\n}\n\n.embed-last {\n    right: 0 !important;\n    width: 25px;\n    height: 25px;\n}\n\nspan:first-of-type {\n    margin-left: 100px;\n\n    @media (max-width: 1150px) {\n      margin-left: 0;\n    }\n\n}\n\nspan:last-of-type {\n    margin-right: 100px;\n\n    @media (max-width: 1150px) {\n      margin-right: 0;\n    }\n}\n\nspan {\n    flex:2;\n    display: flex;\n    justify-content: space-evenly;\n\n    h1 {\n      margin: 0 10px;\n    }\n\n    @media (max-width: 600px) {\n      flex-flow: column;\n    }\n}\n\n@media (max-width: 600px) {\n    flex-flow: column;\n}\n\nspan:first-of-type:after,\nspan:last-of-type {\n  :before{\n    content:\'\';\n    display:inline-block;\n  }\n\n   @media (max-width: 600px) {\n    margin-top: 20px;\n  }\n}\n\na {\ncolor: #002348;\nfont-size: 20px;\n\n  @media (max-width: 1150px) {\n    font-size: 1.5vw;\n  }\n\n  @media (max-width: 600px) {\n    font-size: 20px;\n  }\n\n}\n\n#DownloadDiv {\n  margin: 1px 10px !important;\n\n  @media (max-width: 414px) {\n    margin: 0px !important;\n  }\n\n}\n\n\n\n'], ['\nmargin: 3px auto -5px auto;\nmax-width: 1500px;\npadding: 0.875rem 1.0875rem;\ndisplay: flex;\njustify-content: space-between;\n\n@media (max-width: 600px) {\n    flex-flow: column;\n    padding-top: 55px;\n}\n\nembed{\n    height: 25px;\n    top: 6px;\n    position: relative;\n    right: 62px;\n\n   svg {\n    cursor: pointer;\n   }\n}\n\n.embed-last {\n    right: 0 !important;\n    width: 25px;\n    height: 25px;\n}\n\nspan:first-of-type {\n    margin-left: 100px;\n\n    @media (max-width: 1150px) {\n      margin-left: 0;\n    }\n\n}\n\nspan:last-of-type {\n    margin-right: 100px;\n\n    @media (max-width: 1150px) {\n      margin-right: 0;\n    }\n}\n\nspan {\n    flex:2;\n    display: flex;\n    justify-content: space-evenly;\n\n    h1 {\n      margin: 0 10px;\n    }\n\n    @media (max-width: 600px) {\n      flex-flow: column;\n    }\n}\n\n@media (max-width: 600px) {\n    flex-flow: column;\n}\n\nspan:first-of-type:after,\nspan:last-of-type {\n  :before{\n    content:\'\';\n    display:inline-block;\n  }\n\n   @media (max-width: 600px) {\n    margin-top: 20px;\n  }\n}\n\na {\ncolor: #002348;\nfont-size: 20px;\n\n  @media (max-width: 1150px) {\n    font-size: 1.5vw;\n  }\n\n  @media (max-width: 600px) {\n    font-size: 20px;\n  }\n\n}\n\n#DownloadDiv {\n  margin: 1px 10px !important;\n\n  @media (max-width: 414px) {\n    margin: 0px !important;\n  }\n\n}\n\n\n\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n\twidth: 100px;\n\theight: 90px;\n\tposition: fixed;\n\tmargin: auto;\n\ttext-align: center;\n    z-index: 3333;\n\tleft: 0;\n\tright: 0;\n    top: -15px;\n\tbackground: #ffb347;\n\t-moz-border-radius: 50px;\n\t-webkit-border-radius: 50px;\n\tborder-radius: 50px;\n\n    @media (max-width: 600px) {\n      width: 52px;\n      height: 52px;\n      top: 0;\n      left: 85%;\n      margin: 0;\n    }\n\n    #note {\n        top: 45px;\n        position: fixed;\n        left: 7px;\n        right: 0;\n        z-index: 3333;\n        background-size: 24px;\n\n        @media (max-width: 600px) {\n          top: 14px;\n          position: absolute;\n          left: -8px;\n        }\n\n      p {\n        opacity: 0;\n        transition: all .3s ease-out;\n        }\n    }\n\n\tp {\n\tposition: absolute;\n\tcolor: #002348;\n\ttop: 68px;\n    left: 0;\n    right: 0;\n    font-size: 75%;\n    font-weight: 600;\n\t}\n\n\n'], ['\n\twidth: 100px;\n\theight: 90px;\n\tposition: fixed;\n\tmargin: auto;\n\ttext-align: center;\n    z-index: 3333;\n\tleft: 0;\n\tright: 0;\n    top: -15px;\n\tbackground: #ffb347;\n\t-moz-border-radius: 50px;\n\t-webkit-border-radius: 50px;\n\tborder-radius: 50px;\n\n    @media (max-width: 600px) {\n      width: 52px;\n      height: 52px;\n      top: 0;\n      left: 85%;\n      margin: 0;\n    }\n\n    #note {\n        top: 45px;\n        position: fixed;\n        left: 7px;\n        right: 0;\n        z-index: 3333;\n        background-size: 24px;\n\n        @media (max-width: 600px) {\n          top: 14px;\n          position: absolute;\n          left: -8px;\n        }\n\n      p {\n        opacity: 0;\n        transition: all .3s ease-out;\n        }\n    }\n\n\tp {\n\tposition: absolute;\n\tcolor: #002348;\n\ttop: 68px;\n    left: 0;\n    right: 0;\n    font-size: 75%;\n    font-weight: 600;\n\t}\n\n\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\nwidth: 100px;\n'], ['\nwidth: 100px;\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\nbackground-image: url("', '");\nbackground-repeat: no-repeat;\nbackground-size: 24px;\nbackground-position: 22px 1px;\nwidth: 76px;\nheight: 33px;\nmargin: 0 auto;\n'], ['\nbackground-image: url("', '");\nbackground-repeat: no-repeat;\nbackground-size: 24px;\nbackground-position: 22px 1px;\nwidth: 76px;\nheight: 33px;\nmargin: 0 auto;\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n\n@media (max-width: 600px) {\n    position: fixed;\n    height: 48px;\n    width: 60px;\n    background-color: #ffb347;\n    margin: 0;\n    padding: 1px;\n    z-index: 30;\n}\n\n\n'], ['\n\n@media (max-width: 600px) {\n    position: fixed;\n    height: 48px;\n    width: 60px;\n    background-color: #ffb347;\n    margin: 0;\n    padding: 1px;\n    z-index: 30;\n}\n\n\n']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\nmargin: 11px;\nz-index: 5;\nbackground-color: #ffb347;\n\n  div {\n    margin: 6px 0;\n    width: 35px;\n    height: 5px;\n    background-color: white;\n    transition: 0.4s;\n  }\n'], ['\nmargin: 11px;\nz-index: 5;\nbackground-color: #ffb347;\n\n  div {\n    margin: 6px 0;\n    width: 35px;\n    height: 5px;\n    background-color: white;\n    transition: 0.4s;\n  }\n']),
	    _templateObject8 = _taggedTemplateLiteralLoose(['\n    svg {\n      z-index: -33;\n      position: relative;\n      width: ', ';\n      top: ', ';\n        :hover {\n          cursor: pointer;\n        }\n    }\n\n'], ['\n    svg {\n      z-index: -33;\n      position: relative;\n      width: ', ';\n      top: ', ';\n        :hover {\n          cursor: pointer;\n        }\n    }\n\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(71);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _gatsbyLink = __webpack_require__(115);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _DownloadModal = __webpack_require__(232);
	
	var _DownloadModal2 = _interopRequireDefault(_DownloadModal);
	
	var _Song = __webpack_require__(240);
	
	var _Song2 = _interopRequireDefault(_Song);
	
	var _EventModal = __webpack_require__(234);
	
	var _EventModal2 = _interopRequireDefault(_EventModal);
	
	var _songNote = __webpack_require__(218);
	
	var _songNote2 = _interopRequireDefault(_songNote);
	
	var _play = __webpack_require__(507);
	
	var _play2 = _interopRequireDefault(_play);
	
	var _pause = __webpack_require__(504);
	
	var _pause2 = _interopRequireDefault(_pause);
	
	var _layouts = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	if (typeof window !== 'undefined') {
	    // Make scroll behavior of internal links smooth
	    // eslint-disable-next-line global-require
	    __webpack_require__(479)('a[href*="#"]');
	}
	
	var Container = _styledComponents2.default.div(_templateObject, function (props) {
	    return props.hide ? 'translateX(-400px);' : 'none;';
	});
	
	var Inner = _styledComponents2.default.div(_templateObject2);
	
	var Circle = _styledComponents2.default.div(_templateObject3);
	
	var PlaceholderCircle = _styledComponents2.default.div(_templateObject4);
	
	var MusicNote = _styledComponents2.default.div(_templateObject5, function (props) {
	    return props.playing ? '' + _pause2.default : '' + _play2.default;
	});
	
	var Hamburger = _styledComponents2.default.div(_templateObject6);
	
	var HamburgerLines = _styledComponents2.default.div(_templateObject7);
	
	var Social = _styledComponents2.default.a(_templateObject8, function (props) {
	    return props.width;
	}, function (props) {
	    return props.top;
	});
	
	var Header = function (_React$Component) {
	    _inherits(Header, _React$Component);
	
	    function Header(props) {
	        _classCallCheck(this, Header);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.state = {
	            currentSong: 'IntroShort',
	            playing: true,
	            hamburger: true,
	            showEvent: false,
	            showSongModal: false
	        };
	        _this.toggleHamburger = _this.toggleHamburger.bind(_this);
	        // this.stopPlaying = this.stopPlaying.bind(this);
	        _this.toggleEventModal = _this.toggleEventModal.bind(_this);
	        _this.toggleSongModal = _this.toggleSongModal.bind(_this);
	        _this.switchSongTo = _this.switchSongTo.bind(_this);
	        return _this;
	    }
	
	    Header.prototype.toggleHamburger = function toggleHamburger() {
	        this.setState(function (prevState) {
	            return {
	                hamburger: !prevState.hamburger
	            };
	        });
	    };
	
	    Header.prototype.toggleEventModal = function toggleEventModal() {
	        this.setState(function (prevState) {
	            return {
	                showEvent: !prevState.showEvent
	            };
	        });
	    };
	
	    Header.prototype.toggleSongModal = function toggleSongModal() {
	        this.setState(function (prevState) {
	            return {
	                showSongModal: !prevState.showSongModal
	            };
	        });
	    };
	
	    Header.prototype.switchSongTo = function switchSongTo(title) {
	        if (!this.props.playing) {
	            this.props.togglePlaying();
	        }
	        this.setState(function (prevState) {
	            return {
	                currentSong: title
	            };
	        });
	    };
	
	    // stopPlaying() {
	    //     this.setState({
	    //         playing: false,
	    //     })
	    // }
	    //
	
	
	    Header.prototype.render = function render() {
	        var _this2 = this;
	
	        var headerDiv = ["header"];
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                Hamburger,
	                { hide: this.state.hamburger },
	                _react2.default.createElement(
	                    HamburgerLines,
	                    { onClick: this.toggleHamburger },
	                    _react2.default.createElement('div', null),
	                    _react2.default.createElement('div', null),
	                    _react2.default.createElement('div', null)
	                )
	            ),
	            _react2.default.createElement(
	                Circle,
	                { onClick: this.props.togglePlaying },
	                _react2.default.createElement(MusicNote, { id: 'note',
	                    playing: this.props.playing,
	                    ref: function ref(el) {
	                        return _this2._note = el;
	                    } }),
	                _react2.default.createElement(_Song2.default, {
	                    currentSong: this.state.currentSong,
	                    playing: this.props.playing
	                }),
	                _react2.default.createElement('p', { ref: function ref(el) {
	                        return _this2._menu = el;
	                    } })
	            ),
	            _react2.default.createElement(
	                Container,
	                {
	                    className: headerDiv.join(' '),
	                    ref: function ref(el) {
	                        return _this2._input = el;
	                    },
	                    hide: this.state.hamburger
	                },
	                '>',
	                _react2.default.createElement(
	                    Inner,
	                    { id: 'ieCompat' },
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        _react2.default.createElement(
	                            'h1',
	                            { style: { margin: 0 } },
	                            _react2.default.createElement(
	                                Social,
	                                {
	                                    onClick: this.toggleHamburger,
	                                    width: '27px',
	                                    top: '5px',
	                                    href: 'https://www.facebook.com/PapahanaumokuakeaSongandColorBook/',
	                                    target: '_blank'
	                                },
	                                _react2.default.createElement(
	                                    'svg',
	                                    { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 1024 1024' },
	                                    _react2.default.createElement('rect', { x: '-1', y: '-1', width: '1026', height: '1026', fill: 'none' }),
	                                    _react2.default.createElement('path', {
	                                        d: 'M563.1 372.8c5.6-8.8 2.4-8.2 54.4-8.8l46-0.5 0.3-47.3L664 269l-47.2 0.1c-50.9 0.2-57.1 0.5-71.5 4.4 -39.5 10.5-73.1 45.4-85.7 88.8 -4.6 15.9-5.6 26.7-5.6 61.6V456h-46 -46v44.5V545h46 46v133 133h51.5H557V678 545h53.5H664v-44.5V456h-53.5H557v-33.8C557 385 557.4 381.9 563.1 372.8z',
	                                        fill: '#FFF' }),
	                                    _react2.default.createElement('path', {
	                                        d: 'M903.6 324.5c-42.4-87.8-114.3-159.7-202.1-202.1C635 90.2 560.8 75.6 486.9 80.1c-55.9 3.3-111.5 17.8-161.8 42C203 180.9 114.9 294 88 426.5c-18.9 92.9-6.7 190 34.4 275C181.3 823.4 294.2 911.2 426.5 938c92.9 18.9 190 6.7 275-34.4 87.8-42.4 159.7-114.3 202.1-202.1 20.2-41.8 33.5-86.5 39.4-132.4C953.9 485.1 940.2 400.1 903.6 324.5zM610.5 456H664v44.5V545h-53.5H557v133 133h-51.5H454V678 545h-46 -46v-44.5V456h46 46v-32.1c0-34.9 1-45.7 5.6-61.6 12.6-43.4 46.2-78.3 85.7-88.8 14.4-3.9 20.6-4.2 71.5-4.4L664 269l-0.2 47.2 -0.3 47.3 -46 0.5c-52 0.6-48.8 0-54.4 8.8 -5.7 9.1-6.1 12.2-6.1 49.4V456H610.5z',
	                                        fill: '#3B5998' })
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'h1',
	                            null,
	                            _react2.default.createElement(
	                                'a',
	                                {
	                                    href: '/#',
	                                    style: {
	                                        textDecoration: 'none'
	                                    },
	                                    onClick: this.toggleHamburger
	                                },
	                                'Home'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'h1',
	                            null,
	                            _react2.default.createElement(
	                                'a',
	                                {
	                                    href: '/#video',
	                                    style: {
	                                        textDecoration: 'none'
	                                    },
	                                    onClick: this.toggleHamburger
	                                },
	                                'Video'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'h1',
	                            null,
	                            _react2.default.createElement(
	                                'a',
	                                {
	                                    href: '/#purpose',
	                                    style: {
	                                        textDecoration: 'none'
	                                    },
	                                    onClick: this.toggleHamburger
	                                },
	                                'Purpose'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'h1',
	                        { id: 'DownloadDiv', style: { margin: 0 } },
	                        this.state.showSongModal && _react2.default.createElement(_DownloadModal2.default, {
	                            stopPlaying: this.props.stopPlaying,
	                            toggleSongModal: this.toggleSongModal,
	                            switchSongTo: this.switchSongTo,
	                            currentSong: this.state.currentSong,
	                            playing: this.props.playing
	                        }),
	                        _react2.default.createElement(
	                            'a',
	                            {
	                                style: {
	                                    textDecoration: 'none'
	                                },
	                                onClick: this.toggleSongModal
	                            },
	                            'Song & Lyrics'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        _react2.default.createElement(
	                            'h1',
	                            null,
	                            _react2.default.createElement(
	                                'a',
	                                {
	                                    href: 'https://youtu.be/S36BuGngZjc',
	                                    target: '_blank',
	                                    style: {
	                                        textDecoration: 'none'
	                                    }
	
	                                },
	                                'TV Show'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'h1',
	                            null,
	                            _react2.default.createElement(
	                                'a',
	                                {
	                                    href: '/#contact',
	                                    style: {
	                                        textDecoration: 'none'
	                                    },
	                                    onClick: this.toggleHamburger
	                                },
	                                'Contact'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'h1',
	                            { style: { margin: 0 } },
	                            _react2.default.createElement(
	                                Social,
	                                {
	                                    onClick: this.toggleHamburger,
	                                    width: '55px;',
	                                    top: '3px',
	                                    href: 'https://www.patreon.com/naturallyhawaiian',
	                                    target: '_blank'
	                                },
	                                _react2.default.createElement(
	                                    'svg',
	                                    { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 1903 681' },
	                                    _react2.default.createElement('path', {
	                                        d: 'M908.3 189.8c76.5-22.7 165.7 19.8 192.6 100.5 28.1 86.4-12.8 144.5-60.9 179.9 -48.5 35.4-123.4 35.4-172.8 1.4v111.9c32.4 15.8 73.6 20 103.4 18.3 107.3-15.3 191.1-76.2 226.4-168.5 36.6-97.5 11.1-211.1-65.1-281.8 -91.9-75.3-192.8-93.6-300.1-41.3 -75.3 38.3-127.7 116.2-140.5 201.3V681H640v0h155V354.1C796.5 281.9 820.6 219.5 908.3 189.8z',
	                                        fill: '#FFF' }),
	                                    _react2.default.createElement('path', {
	                                        d: 'M1290.6 309.9c-8.5-85-43.9-157.3-103.3-213.9 -63.7-60.9-155.8-107.6-277.5-93.5C739.8 23.8 611 172.5 611 331.1l1.3 349.9H640h51.4V311.6c12.8-85.1 65.1-163 140.5-201.3 107.3-52.4 208.1-34.1 300.1 41.3 76.2 70.6 101.7 184.3 65.1 281.8 -35.3 92.4-119.2 153.2-226.4 168.5 -29.8 1.7-71.1-2.6-103.4-18.3V471.6c49.4 34 124.3 34 172.8-1.4 48.1-35.4 88.9-93.5 60.9-179.9 -26.9-80.7-116.1-123.2-192.6-100.5 -87.7 29.7-111.8 92.1-113.2 164.3V681h72 93.7c121.7 0 219.5-74.9 269-143C1279.2 468.7 1297.6 395 1290.6 309.9z',
	                                        fill: '#E6461A' })
	                                )
	                            )
	                        )
	                    )
	                )
	            ),
	            this.state.showEvent && _react2.default.createElement(_EventModal2.default, { toggleEventModal: this.toggleEventModal })
	        );
	    };
	
	    return Header;
	}(_react2.default.Component);
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 236:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\npadding: 0px 25px 0 25px;\nmargin: auto;\n\ndisplay: flex;\nmax-width: 1200px;\njustify-content: space-around;\nalign-items: center;\n\na{\ncolor: white;\ntext-decoration: none;\n}\n\n', '\n\ndiv {\n    padding: 20px;\n\n  h1 {\n  margin-bottom: 4px;\n  }\n\n  hr {\n  border-bottom: 3px solid #fff;\n  width: 270px;\n  margin-right: auto;\n  }\n\n  p {\n  font-size: 1.5em;\n  max-width: 555px;\n  }\n\n}\n'], ['\npadding: 0px 25px 0 25px;\nmargin: auto;\n\ndisplay: flex;\nmax-width: 1200px;\njustify-content: space-around;\nalign-items: center;\n\na{\ncolor: white;\ntext-decoration: none;\n}\n\n', '\n\ndiv {\n    padding: 20px;\n\n  h1 {\n  margin-bottom: 4px;\n  }\n\n  hr {\n  border-bottom: 3px solid #fff;\n  width: 270px;\n  margin-right: auto;\n  }\n\n  p {\n  font-size: 1.5em;\n  max-width: 555px;\n  }\n\n}\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\nflex-flow: column-reverse;\njustify-content: center;\npadding-top: 0px;\n\ndiv {\n    padding: 5px !important;\n    margin: auto;\n    h1 {\n        font-size: 1.5em !important;\n    }\n\n    p {\n        font-size: 1em !important;\n    }\n}\n\n'], ['\nflex-flow: column-reverse;\njustify-content: center;\npadding-top: 0px;\n\ndiv {\n    padding: 5px !important;\n    margin: auto;\n    h1 {\n        font-size: 1.5em !important;\n    }\n\n    p {\n        font-size: 1em !important;\n    }\n}\n\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n    cursor: pointer;\n    margin-left: 0px !important;\n\n    :hover {\n        box-shadow: inset 0 0 100px 100px rgba(255, 255, 255, 0.1);\n    }\n\n    p {\n      position: relative;\n    }\n    embed {\n      position: absolute;\n      bottom: 0;\n      right: 5px;\n      width: 58px;\n      z-index: -1000;\n\n        @media (max-width: 1090px) {\n          bottom: 33px;\n          right: 18px;\n          width: 46px;\n        }\n\n        ', '\n    }\n'], ['\n    cursor: pointer;\n    margin-left: 0px !important;\n\n    :hover {\n        box-shadow: inset 0 0 100px 100px rgba(255, 255, 255, 0.1);\n    }\n\n    p {\n      position: relative;\n    }\n    embed {\n      position: absolute;\n      bottom: 0;\n      right: 5px;\n      width: 58px;\n      z-index: -1000;\n\n        @media (max-width: 1090px) {\n          bottom: 33px;\n          right: 18px;\n          width: 46px;\n        }\n\n        ', '\n    }\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n            width: 26px;\n            bottom: 52px;\n        '], ['\n            width: 26px;\n            bottom: 52px;\n        ']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  object-fit: cover;\n  width: 100%;\n  min-width: 400px;\n  border: 3px solid #fff;\n  margin-bottom: 0;\n  width: 420px;\n  height: 330px;\n\n  ', '\n'], ['\n  object-fit: cover;\n  width: 100%;\n  min-width: 400px;\n  border: 3px solid #fff;\n  margin-bottom: 0;\n  width: 420px;\n  height: 330px;\n\n  ', '\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n    width: 70%;\n    min-width: unset;\n    height: unset;\n    margin: auto;\n    '], ['\n    width: 70%;\n    min-width: unset;\n    height: unset;\n    margin: auto;\n    ']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\nmargin-left: 0px !important;\nposition: relative;\npadding-top: 26px;\ncursor: pointer;\n\n\n :hover {\n        box-shadow: inset 0 0 100px 100px rgba(255, 255, 255, 0.1);\n    }\n\nimg {\n  width: 100px;\n  position: absolute;\n  right: 0;\n  top: 31px;\n  z-index: -1000;\n\n  @media (max-width: 950px) {\n      top: 85px;\n  }\n\n  ', '\n\n}\n\n'], ['\nmargin-left: 0px !important;\nposition: relative;\npadding-top: 26px;\ncursor: pointer;\n\n\n :hover {\n        box-shadow: inset 0 0 100px 100px rgba(255, 255, 255, 0.1);\n    }\n\nimg {\n  width: 100px;\n  position: absolute;\n  right: 0;\n  top: 31px;\n  z-index: -1000;\n\n  @media (max-width: 950px) {\n      top: 85px;\n  }\n\n  ', '\n\n}\n\n']),
	    _templateObject8 = _taggedTemplateLiteralLoose(['\n      right: 106px;\n      top: 47px;\n  '], ['\n      right: 106px;\n      top: 47px;\n  ']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _dreams_of_paradise = __webpack_require__(495);
	
	var _dreams_of_paradise2 = _interopRequireDefault(_dreams_of_paradise);
	
	var _layouts = __webpack_require__(14);
	
	var _doc = __webpack_require__(216);
	
	var _doc2 = _interopRequireDefault(_doc);
	
	var _press_release = __webpack_require__(346);
	
	var _press_release2 = _interopRequireDefault(_press_release);
	
	var _camera = __webpack_require__(144);
	
	var _camera2 = _interopRequireDefault(_camera);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Container = _styledComponents2.default.div(_templateObject, _layouts.media.phone(_templateObject2));
	
	var PressRelease = _styledComponents2.default.div(_templateObject3, _layouts.media.phone(_templateObject4));
	
	var Painting = _styledComponents2.default.img(_templateObject5, _layouts.media.phone(_templateObject6));
	
	var VideoBlock = _styledComponents2.default.div(_templateObject7, _layouts.media.phone(_templateObject8));
	
	var Mission = function Mission(props) {
	    return _react2.default.createElement(
	        Container,
	        { id: 'mission' },
	        _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'h1',
	                    null,
	                    'Our mission'
	                ),
	                _react2.default.createElement('hr', null),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'To spread the aloha for Papah\u0101naumoku\u0101kea that will help to protect and preserve it.'
	                )
	            ),
	            _react2.default.createElement(
	                PressRelease,
	                { onClick: function onClick() {
	                        return window.open('' + _press_release2.default);
	                    } },
	                _react2.default.createElement(
	                    'h1',
	                    null,
	                    'Press Release'
	                ),
	                _react2.default.createElement('hr', null),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'Download our project info document.',
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        _react2.default.createElement('embed', { src: _doc2.default })
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'a',
	                { target: '_blank', href: 'https://vimeo.com/262913637' },
	                _react2.default.createElement(
	                    VideoBlock,
	                    { onClick: props.stopPlaying },
	                    _react2.default.createElement(
	                        'h1',
	                        null,
	                        'See our video'
	                    ),
	                    _react2.default.createElement('hr', null),
	                    _react2.default.createElement('img', { src: _camera2.default })
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(Painting, { src: _dreams_of_paradise2.default })
	        )
	    );
	};
	
	exports.default = Mission;
	module.exports = exports['default'];

/***/ }),

/***/ 237:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\npadding-top: 100px;\nmax-width: 1000px;\ndisplay: flex;\nflex-direction: column;\njustify-items: center;\nmargin: auto;\ntext-align: center;\nfont-size: 1.5em;\n\n', '\n\np {\n text-align: justify;\n}\n'], ['\npadding-top: 100px;\nmax-width: 1000px;\ndisplay: flex;\nflex-direction: column;\njustify-items: center;\nmargin: auto;\ntext-align: center;\nfont-size: 1.5em;\n\n', '\n\np {\n text-align: justify;\n}\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\npadding-top: 130px;\n'], ['\npadding-top: 130px;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\nimg {\n  width: 75%;\n  margin: auto;\n}\n\n', '\n'], ['\nimg {\n  width: 75%;\n  margin: auto;\n}\n\n', '\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n\n    p {\n        margin: 15px 25px;\n    }\n'], ['\n\n    p {\n        margin: 15px 25px;\n    }\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\ndisplay: flex;\nflex-direction: column;\nmax-width: 875px;\nmargin: auto;\n\n\n@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n     width: 875px;\n}\n\n\ndiv {\n  display: flex;\n  text-align: left;\n  align-items: center;\n  margin: 5px 0;\n  font-size: .75em;\n\n  ', '\n}\n\n'], ['\ndisplay: flex;\nflex-direction: column;\nmax-width: 875px;\nmargin: auto;\n\n\n@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n     width: 875px;\n}\n\n\ndiv {\n  display: flex;\n  text-align: left;\n  align-items: center;\n  margin: 5px 0;\n  font-size: .75em;\n\n  ', '\n}\n\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n\n\n    p {\n        margin: 0 15px;\n    }\n    '], ['\n\n\n    p {\n        margin: 0 15px;\n    }\n    ']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\nmin-width: 120px;\nheight: 120px;\n\nimg {\n  width: 55%;\n  margin: auto;\n}\n\n'], ['\nmin-width: 120px;\nheight: 120px;\n\nimg {\n  width: 55%;\n  margin: auto;\n}\n\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _layouts = __webpack_require__(14);
	
	var _papa_reserve = __webpack_require__(501);
	
	var _papa_reserve2 = _interopRequireDefault(_papa_reserve);
	
	var _book = __webpack_require__(508);
	
	var _book2 = _interopRequireDefault(_book);
	
	var _songNote = __webpack_require__(218);
	
	var _songNote2 = _interopRequireDefault(_songNote);
	
	var _sun_mountains = __webpack_require__(509);
	
	var _sun_mountains2 = _interopRequireDefault(_sun_mountains);
	
	var _think = __webpack_require__(510);
	
	var _think2 = _interopRequireDefault(_think);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Container = _styledComponents2.default.div(_templateObject, _layouts.media.phone(_templateObject2));
	
	var PurposeInfo = _styledComponents2.default.div(_templateObject3, _layouts.media.phone(_templateObject4));
	
	/* TODO mixin for IE properties */
	
	var PurposeList = _styledComponents2.default.div(_templateObject5, _layouts.media.phone(_templateObject6));
	
	var Icon = _styledComponents2.default.div(_templateObject7);
	
	var Purpose = function Purpose() {
	    return _react2.default.createElement(
	        Container,
	        { id: 'purpose' },
	        _react2.default.createElement(
	            PurposeInfo,
	            null,
	            _react2.default.createElement(
	                'h1',
	                null,
	                'Song Purpose'
	            ),
	            _react2.default.createElement('img', { src: _papa_reserve2.default }),
	            _react2.default.createElement(
	                'p',
	                null,
	                'To help people learn the name and important aspects of Papah\u0101naumoku\u0101kea, the Northwest Hawaiian Islands and surrounding ocean area recently dedicated as a Marine National Monument.'
	            )
	        ),
	        _react2.default.createElement(
	            PurposeList,
	            null,
	            _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    Icon,
	                    null,
	                    _react2.default.createElement('img', { src: _sun_mountains2.default, alt: 'Island' })
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'The name acknowledges the union of the Hawaiian entities Papa (Earth mother) and W\u0101kea (sky father) who birthed the Hawaiian Islands.'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    Icon,
	                    null,
	                    _react2.default.createElement('img', { src: _think2.default, alt: 'Thinking' })
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'The name is somewhat long and takes effort to remember, especially for people who don\'t speak Hawaiian. The initial goal of this song project is to help people to learn and remember the name after hearing the song for the first time.'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    Icon,
	                    null,
	                    _react2.default.createElement('img', { src: _songNote2.default, alt: 'Note' })
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'We can help make it easy to learn and remember with a catchy song. The song is geared for children but meant for adults as well.'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    Icon,
	                    null,
	                    _react2.default.createElement('img', { src: _book2.default, alt: 'Book' })
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'A coloring book can illustrate the information with the song as its text. The song and coloring book text can be written in English and \u2018\u014Clelo Hawai\u2018i (Hawaiian Language).'
	                )
	            )
	        )
	    );
	};
	
	exports.default = Purpose;
	module.exports = exports['default'];

/***/ }),

/***/ 238:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\npadding-top: 100px;\ndisplay: flex;\nflex-flow: column;\nalign-items: center;\njustify-items: center;\n\n', '\n\nh1 {\ntext-align: center;\n}\n'], ['\npadding-top: 100px;\ndisplay: flex;\nflex-flow: column;\nalign-items: center;\njustify-items: center;\n\n', '\n\nh1 {\ntext-align: center;\n}\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n\npadding-top: 55px;\nwidth: 100%;\n'], ['\n\npadding-top: 55px;\nwidth: 100%;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\nwidth: 80%;\n\n', '\n\ndisplay: flex;\nflex-direction: row;\nflex-wrap: wrap;\n\n  ', '\n}\n'], ['\nwidth: 80%;\n\n', '\n\ndisplay: flex;\nflex-direction: row;\nflex-wrap: wrap;\n\n  ', '\n}\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\nwidth: 100%;\n'], ['\nwidth: 100%;\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n    flex-direction: column;\n  '], ['\n    flex-direction: column;\n  ']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\ncursor: pointer;\n    display: flex;\n    flex: 1 1 45%;\n    background-color: ', ';\n    padding: 10px;\n    margin: 20px 10px;\n    border-radius: 25px;\n    color: #002348;\n\n    ', '\n\n    div {\n        margin: 0 35px;\n        }\n\n\n'], ['\ncursor: pointer;\n    display: flex;\n    flex: 1 1 45%;\n    background-color: ', ';\n    padding: 10px;\n    margin: 20px 10px;\n    border-radius: 25px;\n    color: #002348;\n\n    ', '\n\n    div {\n        margin: 0 35px;\n        }\n\n\n']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\n        width: 80%;\n        display: block;\n\n        margin: 5px auto;\n\n        h2 {\n            font-size: 1em;\n            margin-bottom: -0.55rem;\n        }\n\n        p {\n            display: none;\n        }\n    '], ['\n        width: 80%;\n        display: block;\n\n        margin: 5px auto;\n\n        h2 {\n            font-size: 1em;\n            margin-bottom: -0.55rem;\n        }\n\n        p {\n            display: none;\n        }\n    ']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _layouts = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Container = _styledComponents2.default.div(_templateObject, _layouts.media.phone(_templateObject2));
	
	var LinkList = _styledComponents2.default.ul(_templateObject3, _layouts.media.phone(_templateObject4), _layouts.media.phone(_templateObject5));
	
	var LinkItem = _styledComponents2.default.li(_templateObject6, function (props) {
	    return props.color || '#ffb347;';
	}, _layouts.media.phone(_templateObject7));
	
	var RelatedLinks = function RelatedLinks() {
	    return _react2.default.createElement(
	        Container,
	        { id: 'links' },
	        _react2.default.createElement(
	            'h1',
	            null,
	            'Links'
	        ),
	        _react2.default.createElement(
	            LinkList,
	            null,
	            _react2.default.createElement(
	                LinkItem,
	                { color: '#33ccff', onClick: function onClick() {
	                        return window.open('https://www.papahanaumokuakea.gov/');
	                    } },
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'h2',
	                        null,
	                        'Papah\u0101naumoku\u0101kea Marine National Monument'
	                    ),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'https://www.papahanaumokuakea.gov/'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                LinkItem,
	                { color: '#ff66ff', onClick: function onClick() {
	                        return window.open('https://marinesanctuary.org/explore/papahanaumokuakea/');
	                    } },
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'h2',
	                        null,
	                        'National Marine Sanctuary Foundation'
	                    ),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'https://marinesanctuary.org/explore/papahanaumokuakea/'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                LinkItem,
	                { color: '#66ff33', onClick: function onClick() {
	                        return window.open('http://www.hokulea.com/malamahonua/');
	                    } },
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'h2',
	                        null,
	                        'Polynesian Voyaging Society H\u014Dk\u016Ble\u2018a'
	                    ),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'http://www.hokulea.com/malamahonua/'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                LinkItem,
	                { color: '#ff9900', onClick: function onClick() {
	                        return window.open('http://www.PatrickChing.com/');
	                    } },
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'h2',
	                        null,
	                        'Patrick Ching Art'
	                    ),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'www.PatrickChing.com/'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                LinkItem,
	                { color: '#9999ff', onClick: function onClick() {
	                        return window.open('http://www.PatrickChing.com/');
	                    } },
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'h2',
	                        null,
	                        'Patrick Ching Art Lessons'
	                    ),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'www.PatrickChing.com'
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = RelatedLinks;
	module.exports = exports['default'];

/***/ }),

/***/ 239:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n background-color: #FFB347;\n cursor: pointer;\n border: #FFB347 solid 3px;\n border-radius: 5px;\n margin: 0 !important;\n padding: 5px;\n     img, p {\n       margin: 0 5px;\n        }\n'], ['\n background-color: #FFB347;\n cursor: pointer;\n border: #FFB347 solid 3px;\n border-radius: 5px;\n margin: 0 !important;\n padding: 5px;\n     img, p {\n       margin: 0 5px;\n        }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  &&&&&&  {\ndisplay: unset;\nalign-items: unset;\n\nh1, p {\ncolor: black;\n}\n\np {\nfont-size: 18px;\n}\n\n\n.rodal, .rodal-fade-enter, .rodal-mask, .rodal-dialog {\n  margin: auto;\n  \n}\n\n\n@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n     .rodal-dialog .rodal-zoom-enter {\n        margin: auto !important;\n     }\n     \n}\n\n\n.rodal-dialog{\nwidth: 700px !important;\nheight: 400px !important;\n\n@media (max-width: 414px) {\n        width: 100% !important;\n        height: 80% !important;\n        align-items: initial !important;\n      }\n\n}\n}\n'], ['\n  &&&&&&  {\ndisplay: unset;\nalign-items: unset;\n\nh1, p {\ncolor: black;\n}\n\np {\nfont-size: 18px;\n}\n\n\n.rodal, .rodal-fade-enter, .rodal-mask, .rodal-dialog {\n  margin: auto;\n  \n}\n\n\n@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n     .rodal-dialog .rodal-zoom-enter {\n        margin: auto !important;\n     }\n     \n}\n\n\n.rodal-dialog{\nwidth: 700px !important;\nheight: 400px !important;\n\n@media (max-width: 414px) {\n        width: 100% !important;\n        height: 80% !important;\n        align-items: initial !important;\n      }\n\n}\n}\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n&&&&&&  {\nmargin: 0 !important;\npadding: 15px !important;\ndisplay: flex;\nflex-flow: column;\njustify-content: center;\nalign-items: center;\ncolor: black;\nwidth: 700px;\nheight: 400px;\n\n@media (max-width: 414px) {\n        width: 100% !important;\n        height: 80% !important;\n        \n        h1 {\n          font-size: 1.5rem;\n        }\n        \n        h3 {\n          font-size: 1rem;\n        }\n        \n        p {\n          font-size: 0.7rem;\n          line-height: 0.9rem;\n        }\n      }\n\n}\n'], ['\n&&&&&&  {\nmargin: 0 !important;\npadding: 15px !important;\ndisplay: flex;\nflex-flow: column;\njustify-content: center;\nalign-items: center;\ncolor: black;\nwidth: 700px;\nheight: 400px;\n\n@media (max-width: 414px) {\n        width: 100% !important;\n        height: 80% !important;\n        \n        h1 {\n          font-size: 1.5rem;\n        }\n        \n        h3 {\n          font-size: 1rem;\n        }\n        \n        p {\n          font-size: 0.7rem;\n          line-height: 0.9rem;\n        }\n      }\n\n}\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n&&&&&&  {\ndisplay: flex !important;\nmargin: 0 !important;\n\n@media (max-width: 414px) {\n        flex-flow: column;\n        \n        \n        \n        div:last-of-type {\n        margin-top: 140px !important;\n          div {\n            margin: 0 !important;\n          }\n        }\n      }\n\n  div {\n  margin: 25px 32px !important;\n  height: 250px;\n  width: 244px;\n  display: flex;\n  flex-flow: column;\n  \n  @media (max-width: 414px) {\n        margin: 5px 32px !important;\n      }\n  \n        p {\n          position: relative;\n          margin-bottom: 0;\n          \n          @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n            width: 250px;\n          }\n\n          \n              span:first-of-type {\n                  user-select: none;\n                }\n                 \n              span:last-of-type {\n                  position: absolute;\n                  top: 26px;\n                  left: -1px;\n                  color: #00000000 !important;\n                }\n             }\n        \n    div:last-of-type {\n        img {\n                width: 80px !important;\n                border: 3px solid black!important;\n                border-radius: 13px !important;\n              }\n          \n    }\n  }\n}\n'], ['\n&&&&&&  {\ndisplay: flex !important;\nmargin: 0 !important;\n\n@media (max-width: 414px) {\n        flex-flow: column;\n        \n        \n        \n        div:last-of-type {\n        margin-top: 140px !important;\n          div {\n            margin: 0 !important;\n          }\n        }\n      }\n\n  div {\n  margin: 25px 32px !important;\n  height: 250px;\n  width: 244px;\n  display: flex;\n  flex-flow: column;\n  \n  @media (max-width: 414px) {\n        margin: 5px 32px !important;\n      }\n  \n        p {\n          position: relative;\n          margin-bottom: 0;\n          \n          @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n            width: 250px;\n          }\n\n          \n              span:first-of-type {\n                  user-select: none;\n                }\n                 \n              span:last-of-type {\n                  position: absolute;\n                  top: 26px;\n                  left: -1px;\n                  color: #00000000 !important;\n                }\n             }\n        \n    div:last-of-type {\n        img {\n                width: 80px !important;\n                border: 3px solid black!important;\n                border-radius: 13px !important;\n              }\n          \n    }\n  }\n}\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rodal = __webpack_require__(475);
	
	var _rodal2 = _interopRequireDefault(_rodal);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	__webpack_require__(330);
	
	var _doc = __webpack_require__(494);
	
	var _doc2 = _interopRequireDefault(_doc);
	
	var _typeform = __webpack_require__(512);
	
	var _typeform2 = _interopRequireDefault(_typeform);
	
	var _musicVideoContest = __webpack_require__(345);
	
	var _musicVideoContest2 = _interopRequireDefault(_musicVideoContest);
	
	var _download = __webpack_require__(217);
	
	var _download2 = _interopRequireDefault(_download);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var ContestButton = _styledComponents2.default.div(_templateObject);
	
	var Modal = _styledComponents2.default.div(_templateObject2);
	
	var SignupForm = _styledComponents2.default.div(_templateObject3);
	
	var Block = _styledComponents2.default.div(_templateObject4);
	
	var SignUp = function (_React$Component) {
	    _inherits(SignUp, _React$Component);
	
	    function SignUp(props) {
	        _classCallCheck(this, SignUp);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.state = { visible: false };
	        return _this;
	    }
	
	    SignUp.prototype.show = function show() {
	        this.setState({ visible: true });
	    };
	
	    SignUp.prototype.hide = function hide() {
	        this.setState({ visible: false });
	    };
	
	    SignUp.prototype.render = function render() {
	        return _react2.default.createElement(
	            Modal,
	            null,
	            _react2.default.createElement(
	                ContestButton,
	                { onClick: this.show.bind(this) },
	                _react2.default.createElement('img', { src: _download2.default }),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'Sign Up!'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _rodal2.default,
	                    { visible: this.state.visible, onClose: this.hide.bind(this) },
	                    _react2.default.createElement(
	                        SignupForm,
	                        null,
	                        _react2.default.createElement(
	                            'h1',
	                            null,
	                            'Contest Sign Up'
	                        ),
	                        _react2.default.createElement(
	                            Block,
	                            null,
	                            _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(
	                                    'h3',
	                                    null,
	                                    'Sign up via Print out'
	                                ),
	                                _react2.default.createElement(
	                                    'a',
	                                    { target: '_blank', href: _musicVideoContest2.default },
	                                    _react2.default.createElement('img', { src: _doc2.default })
	                                ),
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    'Please email to ',
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        'aloha@Papah\u0101naumoku\u0101kea.com'
	                                    ),
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        'aloha@Papahanaumokuakea.com'
	                                    ),
	                                    ' upon completion'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(
	                                    'h3',
	                                    null,
	                                    'Sign up online here:'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    _react2.default.createElement(
	                                        'a',
	                                        { target: '_blank', href: 'https://papahnaumokukea.typeform.com/to/ZgMXVA' },
	                                        _react2.default.createElement('img', { src: _typeform2.default })
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return SignUp;
	}(_react2.default.Component);
	
	exports.default = SignUp;
	module.exports = exports['default'];

/***/ }),

/***/ 240:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSound = __webpack_require__(460);
	
	var _reactSound2 = _interopRequireDefault(_reactSound);
	
	var _ShortVersion = __webpack_require__(482);
	
	var _ShortVersion2 = _interopRequireDefault(_ShortVersion);
	
	var _Papa_long_version_master = __webpack_require__(215);
	
	var _Papa_long_version_master2 = _interopRequireDefault(_Papa_long_version_master);
	
	var _Papa_Instumental_Long_Version = __webpack_require__(212);
	
	var _Papa_Instumental_Long_Version2 = _interopRequireDefault(_Papa_Instumental_Long_Version);
	
	var _Papa_Song_Short_Version_Instrumental = __webpack_require__(214);
	
	var _Papa_Song_Short_Version_Instrumental2 = _interopRequireDefault(_Papa_Song_Short_Version_Instrumental);
	
	var _Papa_Main_Version = __webpack_require__(213);
	
	var _Papa_Main_Version2 = _interopRequireDefault(_Papa_Main_Version);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SongArray = { 'IntroShort': _ShortVersion2.default, 'LongVocal': _Papa_long_version_master2.default,
	    'LongInstrumental': _Papa_Instumental_Long_Version2.default, 'ShortInstrumental': _Papa_Song_Short_Version_Instrumental2.default, 'ShortVocal': _Papa_Main_Version2.default };
	
	var Song = function (_React$Component) {
	    _inherits(Song, _React$Component);
	
	    function Song() {
	        _classCallCheck(this, Song);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this));
	
	        _this.state = {
	            currentTrack: _ShortVersion2.default
	        };
	        return _this;
	    }
	
	    Song.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_reactSound2.default, {
	                url: SongArray[this.props.currentSong],
	                playStatus: this.props.playing ? _reactSound2.default.status.PLAYING : _reactSound2.default.status.PAUSED,
	                onPlaying: _reactSound2.default.handleSongPlaying,
	                volume: 50,
	                loop: false
	            })
	        );
	    };
	
	    return Song;
	}(_react2.default.Component);
	
	exports.default = Song;
	module.exports = exports['default'];

/***/ }),

/***/ 241:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\ntext-align: center;\nheight: 100vh;\npadding-top: 35px;\nmargin-bottom: 30px;\n\n', '\n\nembed {\nposition: absolute;\n}\n'], ['\ntext-align: center;\nheight: 100vh;\npadding-top: 35px;\nmargin-bottom: 30px;\n\n', '\n\nembed {\nposition: absolute;\n}\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\nz-index: -3333;\nposition: relative\npadding-top: 60px;\n'], ['\nz-index: -3333;\nposition: relative\npadding-top: 60px;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\nmargin: 0 auto;\nheight: 70vh;\nbackground: url(\'', '\') no-repeat center;\nbackground-position-y: 288px;\nbackground-size: 113%;\n\n//calculate for narrow screen\n@media (max-height: 920px) {\n        background-position-y: 250px;\n        img {\n         width: 60vw;\n        }\n      }\n\n', '\n\nimg {\nobject-fit: cover;\nmax-width: 80%;\nheight: 70vh;\nborder: solid #ffb347 3px;\nborder-radius: 2px;\n}\n'], ['\nmargin: 0 auto;\nheight: 70vh;\nbackground: url(\'', '\') no-repeat center;\nbackground-position-y: 288px;\nbackground-size: 113%;\n\n//calculate for narrow screen\n@media (max-height: 920px) {\n        background-position-y: 250px;\n        img {\n         width: 60vw;\n        }\n      }\n\n', '\n\nimg {\nobject-fit: cover;\nmax-width: 80%;\nheight: 70vh;\nborder: solid #ffb347 3px;\nborder-radius: 2px;\n}\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\nimg {\n    max-width: 70%;\n}\n'], ['\nimg {\n    max-width: 70%;\n}\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\nbackground: url("', '") no-repeat center;\nbackground-size: contain;\n\n', '\n\nh1 {\nopacity: 0;\nfont-size: 10vh;\nmargin-bottom: 20px;\n\n  @media (max-width: 1370px) {\n        font-size: 7vh;\n      }\n   \n   ', '\n\n}\n\n'], ['\nbackground: url("', '") no-repeat center;\nbackground-size: contain;\n\n', '\n\nh1 {\nopacity: 0;\nfont-size: 10vh;\nmargin-bottom: 20px;\n\n  @media (max-width: 1370px) {\n        font-size: 7vh;\n      }\n   \n   ', '\n\n}\n\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\nh1 {\n}\n'], ['\nh1 {\n}\n']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\n        font-size: 5vh;\n    '], ['\n        font-size: 5vh;\n    ']),
	    _templateObject8 = _taggedTemplateLiteralLoose(['\n\n', '\n\n', '\n\np:first-of-type {\n  font-family: "Comic Sans MS", Arial, sans-serif;\n  font-style: italic;\n  font-size: 4.5vh;\n  font-weight: 900;\n  color: #fff;\n  margin-bottom: 18px;\n}\np:last-of-type {\n  color: #fff;\n  font-size: 2.7vh;\n  font-weight: 600;\n  font-family: "Arial", Arial, sans-serif;\n  }\n'], ['\n\n', '\n\n', '\n\np:first-of-type {\n  font-family: "Comic Sans MS", Arial, sans-serif;\n  font-style: italic;\n  font-size: 4.5vh;\n  font-weight: 900;\n  color: #fff;\n  margin-bottom: 18px;\n}\np:last-of-type {\n  color: #fff;\n  font-size: 2.7vh;\n  font-weight: 600;\n  font-family: "Arial", Arial, sans-serif;\n  }\n']),
	    _templateObject9 = _taggedTemplateLiteralLoose(['\n\np:first-of-type {\n    font-size: 2.5vh !important;\n    margin-bottom: 3px !important;\n}\n\np:last-of-type {\n    font-size: 1.5vh !important;\n}\n\n'], ['\n\np:first-of-type {\n    font-size: 2.5vh !important;\n    margin-bottom: 3px !important;\n}\n\np:last-of-type {\n    font-size: 1.5vh !important;\n}\n\n']),
	    _templateObject10 = _taggedTemplateLiteralLoose(['\n\np:first-of-type {\n    font-size: 3.5vh;\n    margin-bottom: 12px;\n}\n\np:last-of-type {\n    font-size: 2.5vh !important;\n    padding: 3px 50px !important;\n}\n\n'], ['\n\np:first-of-type {\n    font-size: 3.5vh;\n    margin-bottom: 12px;\n}\n\np:last-of-type {\n    font-size: 2.5vh !important;\n    padding: 3px 50px !important;\n}\n\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _layouts = __webpack_require__(14);
	
	var _main = __webpack_require__(500);
	
	var _main2 = _interopRequireDefault(_main);
	
	var _PAPAHANAUMOKUAKEA = __webpack_require__(484);
	
	var _PAPAHANAUMOKUAKEA2 = _interopRequireDefault(_PAPAHANAUMOKUAKEA);
	
	var _background_painting = __webpack_require__(490);
	
	var _background_painting2 = _interopRequireDefault(_background_painting);
	
	var _wavy_music_sheet = __webpack_require__(513);
	
	var _wavy_music_sheet2 = _interopRequireDefault(_wavy_music_sheet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Container = _styledComponents2.default.div(_templateObject, _layouts.media.phone(_templateObject2));
	
	var Painting = _styledComponents2.default.div(_templateObject3, _wavy_music_sheet2.default, _layouts.media.desktop(_templateObject4));
	
	var PapaHeading = _styledComponents2.default.div(_templateObject5, _PAPAHANAUMOKUAKEA2.default, _layouts.media.desktop(_templateObject6), _layouts.media.desktop(_templateObject7));
	
	var PapaSubheading = _styledComponents2.default.div(_templateObject8, _layouts.media.tablet(_templateObject9), _layouts.media.desktop(_templateObject10));
	
	var Title = function Title() {
	    return _react2.default.createElement(
	        Container,
	        { id: '#t' },
	        _react2.default.createElement(
	            Painting,
	            null,
	            _react2.default.createElement('img', { src: _main2.default })
	        ),
	        _react2.default.createElement(
	            PapaHeading,
	            null,
	            _react2.default.createElement(
	                'h1',
	                null,
	                'Papah\u0101naumoku\u0101kea'
	            )
	        ),
	        _react2.default.createElement(
	            PapaSubheading,
	            null,
	            _react2.default.createElement(
	                'p',
	                null,
	                'Sacred Places Need Our Kay-yah!'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'Papah\u0101naumoku\u0101kea Song and coloring book project'
	            )
	        )
	    );
	};
	
	exports.default = Title;
	module.exports = exports['default'];

/***/ }),

/***/ 342:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ColoringPages.d31fa090.pdf";

/***/ }),

/***/ 343:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Long_Version_with_Chords_G.cd893fbb.pdf";

/***/ }),

/***/ 212:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Papa_Instumental_Long_Version.a45c3b2e.mp3";

/***/ }),

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Papa_Main_Version.5095f73b.mp3";

/***/ }),

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Papa_Song_Short_Version_Instrumental.d1913f23.mp3";

/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Papa_long_version_master.a3a43723.mp3";

/***/ }),

/***/ 482:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ShortVersion.41457e79.mp3";

/***/ }),

/***/ 344:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Song_Lyrics_Short_Version_with_Chords_G.7931d1e3.pdf";

/***/ }),

/***/ 345:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/music-video-contest.c96ab94e.pdf";

/***/ }),

/***/ 346:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/press_release.66ed079f.pdf";

/***/ }),

/***/ 483:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ColorCover.015bd67e.jpg";

/***/ }),

/***/ 484:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iODYyIiBoZWlnaHQ9IjgxIiB2aWV3Qm94PSIwIDAgODYyIDgxIj4KICA8bWV0YWRhdGE+PD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxNDIgNzkuMTYwOTI0LCAyMDE3LzA3LzEzLTAxOjA2OjM5ICAgICAgICAiPgogICA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPgogICAgICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIi8+CiAgIDwvcmRmOlJERj4KPC94OnhtcG1ldGE+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAKPD94cGFja2V0IGVuZD0idyI/PjwvbWV0YWRhdGE+CjxkZWZzPgogICAgPGltYWdlIGlkPSJpbWFnZSIgd2lkdGg9IjMzIiBoZWlnaHQ9IjYiIHhsaW5rOmhyZWY9ImRhdGE6aW1hZ2UvcG5nO2Jhc2U2NCxpVkJPUncwS0dnb0FBQUFOU1VoRVVnQUFBQ0VBQUFBR0NBTUFBQUI2a3dmVEFBQUFCR2RCVFVFQUFMR1BDL3hoQlFBQUFDQmpTRkpOQUFCNkpnQUFnSVFBQVBvQUFBQ0E2QUFBZFRBQUFPcGdBQUE2bUFBQUYzQ2N1bEU4QUFBQXhsQk1WRVgvczBmLy8vL1ZrU1RWa1NUVmtTVFZrU1RWa1NUVmtTVFZrU1RWa1NUVmtTVFZrU1RWa1NUVmtTVFZrU1RWa1NUVmtTVFZrU1RWa1NUVmtTVFZrU1RWa1NUVmtTVFZrU1RWa1NUVmtTVFZrU1RWa1NUVmtTVFZrU1RWa1NUVmtTVFZrU1RWa1NUVmtTVFZrU1RWa1NUVmtTVFZrU1RWa1NUVmtTVFZrU1RWa1NUVmtTVFZrU1RWa1NUVmtTVFZrU1RWa1NUVmtTVFZrU1RWa1NUVmtTVFZrU1RWa1NUVmtTVFZrU1RWa1NUVmtTVFZrU1RWa1NUVmtTVFZrU1RWa1NUVmtTUUFBQUJFSmljWkFBQUFRSFJTVGxNQUFEbHRjWUIyY0dOS0x4TWlWWUtkdU0zZzlOZjU4c1NNVEJaQm0rZks4Y2pBek9yODBLaUhlR2hnVFRVSURTa0NDaTFPWjZ1NWR6NEdmLzZJZE80YWxIS2crd0FBQUFGaVMwZEVRWW5lYkU0QUFBQUpjRWhaY3dBQUN4SUFBQXNTQWRMZGZ2d0FBQUFIZEVsTlJRZmlBeGNXRkJWRzd1bWpBQUFBY2tsRVFWUUkxMk5nWW1aaFpXVmxZK2ZnNU9KbWdBSWVYajUrQVVFaFlRY2dFR0VRZFVBQU1YRUpTU2xwR1Zra0lhQUtPUWQ1QlVWRkpXVUhGS0NpcXFhdXdhNnBwYTJqeTZDbmJ3QTIyZERJMklUUEZLelF6TnpDRUdZaEF5TURLckMwc25hd1FSRkJWOEhBWUd0bmo2b0NBTGlxRkV2Mnc4MnJBQUFBQUVsRlRrU3VRbUNDIi8+CiAgPC9kZWZzPgogIDxpbWFnZSBpZD0iUEFQQUhBTkFVTU9LVUFLRUFfIiBkYXRhLW5hbWU9IlBBUEFIQU5BVU1PS1VBS0VBICIgeT0iMTkiIHdpZHRoPSI4NjIiIGhlaWdodD0iNjIiIHhsaW5rOmhyZWY9ImRhdGE6aW1hZ2UvcG5nO2Jhc2U2NCxpVkJPUncwS0dnb0FBQUFOU1VoRVVnQUFBMTRBQUFBK0NBTUFBQUFNR2pvSEFBQUFCR2RCVFVFQUFMR1BDL3hoQlFBQUFDQmpTRkpOQUFCNkpnQUFnSVFBQVBvQUFBQ0E2QUFBZFRBQUFPcGdBQUE2bUFBQUYzQ2N1bEU4QUFBQU0xQk1WRVVBQUFEL3MwZi9zMGYvczBmL3MwZi9zMGYvczBmL3MwZi9zMGYvczBmL3MwZi9zMGYvczBmL3MwZi9zMGYvczBjQUFBQkVpSE44QUFBQUQzUlNUbE1BSW5mZFpoRzdpTzVWekRORW1hb1VidysvQUFBQUFXSkxSMFFBaUFVZFNBQUFBQWx3U0ZsekFBQUxFZ0FBQ3hJQjB0MSsvQUFBQUFkMFNVMUZCK0lERnhZVUZVYnU2YU1BQUErOVNVUkJWSGphN1YzcG11T3FEclR4dnFYZi8yMVBKL0hDVWhLUzRqQno3emY2MTIxYkcxVWdNTUZWOVpUYS9Vcno0OG52MzIxMW4zemR3RCs1U3pybityMk5CdWYrdERmLzg5SzY4WWVTNFk3MGZ0M0FQN2xONnFTdGVrTUxUYitkWi8yblEvazdYSE0vdk14Y2VoZjh6UHFYR0JqWTY1dldFTklVS05tQ1M3VldmWTl2T2hXbDVuc2l1akhOWkExdWl6Ty9QS0Q5K0RZNjRYczlNcnorZUxpcCtqeSt1N0RBdTVZREtjcUVxRTNidk5LaG85QlBQT3orRWdPT1RaMUVpY3Q2NC9NcnRLUldiNElmMXB6VzNWdjJyZzZUNjFmRzhFWTY0VHUwcmhGd2RLNzdMTDY3c01DN0pnQnBrakF6WkJJWkNQUVArUGF0cUlHVjFLcWdsOFFRdHVTcG9la2xVcCtEWDR1ZW4rQWpBUzVmM0VFRmV0Q0ZyM1FKLzl2ZCt4M2dSTjcyeG5EY3JmZjdGTTRVbnk2SFZ0Y3M5TEpESnBFbUhQSU9JZnE3K1M4eDBMS3BhN1dHaUhMZzRsZGdxVkdycDBZUHFQNGxHeGw5bkU2WHV5bFRIalZlcVVzbnZLWlZiWXN0dnJ1d3dMc21BMm1ZVlZHYkNoWGo4YVVoYnU1S0dxaEpsVzhDVVQzYXBEVkVXVHI1RlZocTFPbzM0aVk2a3h2cFU5aUgra1dSSng1YXNwT1Bac24wTWs5NVkzaUd6eHZqMCtYUTZwb1FwSXZXSDhhaFNCNHArRHVKRzE4M1FOTnJaZm05YWcxVkZYSFR3YS9BVXE5V3I0ZmZRS3NPbDhmYXpEMkNxZjAxZnRFSlo0SnRqZkhkaFFYZU5mbzVNcW15TmhVcS9nSDFQTTBjVjlKQVJTcVUwMHRtcU1yY0ZXanAxZXFKWXY2RVh3MGZKeDRLaXdIYzA1NW9vYWNzbmpSZExnMC9ORlViYzN3M1lZRjNUUWhTMFVBWitOUEpGRDhsR1Y1YXlaMWZOMENuZEdINVhhc05rZlhBbnRMQTBxWldUd3doNXlvN2hoL2gwOWpsN1orS3VWVU40Q3gxdzl0VE9DZVp6UEhkZzRXTWF6U0dZTUlVa0pFcFRxS3RtTzRvbk41OTNRQUorbHBNTDVraFhMcGZucFAwa3FrbjRIZE40cUJWeWllWHoxQStyRkJhWHQzYlU5aWQ5dmI0N3NGQ3hqVVpTSVBwdEJBeXd0UytKSnlKa0N1dDRTajZkUU1aZWxIRHA5NFFjOXNMQ1FHOUJyVjZvajlrNE5jeXVwdXM0bVBZRUw1VHZVWkVpbzR2WU1GQ2M3WEhwOHVoMGJWS05INEg5QkpDcHBFbzNpV2FIZEUrVFNVTmtJSHkvTlliSXBlV24rSWllam0xK2l6OGtreTJuRStuQTEzREt1NWtwZUZUQmo3aFBaV2ovb1A0N3NGQ3hqVVpTQU4wQ2lHalFYLzRKRE1mRkZRbTl4a2dBY1ltb3RFYkl0ZStqanVKQjRYcWlUV1lEUHhJbjg3WkZ6VTZ6ZnhsSkIyYjhBZEYxdVdEK083QlFzWTFXWDNzejZxa2tPa2xpZzhKK011c056MUtHcUFBZGhRL21OK04zaEJkYis5cDlmOXExZW9KK0YyMWZKSkpac0hnNTJ4bWNuVHErY3UwU2lyaHora21zM0hNRnQ4OVdNaTRKZ09wUDUyV1FrYUYvbUJ5eEhSN1kwa0RWRW9QQW1GNjlYcER1WTQrdU55cTFSTWQ0dVZva3NtVlZUN1diSHI0a28xemwrcGxudkJEdzBmOVNYeTZIQnBkWTh2K1UvenB0QlF5SXNXbmlJcXluMkI2OTNVRFZLUUh2VEMvZTcwaEZSUlh0WHBpRGVaeWRFTTJHSjgyQnRUSFpXWHZOM0VKZHppRzdhUDQ3c0ZDeGpXKzdQZVVxQ0VqVW55S3YrcklUYXFtZ2dhb2xCN3RoZ0gwMEJ1eTBrdXFuZytEZ0IvM1NuaGw2Yk14bUdlZm9kTGdZRnVNOVVmeDZYSm9kVTFOTDJtYjZ0RHZNWk50bUtHZ0FTcWxQZXVBVjBoTERZbjNUejZsMXF2SHM2QUxmZzdaNEh5YTJjc3YwNklORzVlTVhNSmJTR2IzV1h6M1lDSG5tbWg5eDZ2M3hXMnFXVGo2OGVkR2JNUDBCUTFRS1QzR3B5eTlwSWFNOUJLcnowMFNJZnpZUFowdDE4dSt3TVd2MXFTeU1HbG9VU1hxYlI4eHhhZkxvZFUxRVVpOXdWVGNwa3IwdDdJSHg0SUdxSlFlQk1JSWNrSVBCWXNQVUlSTmwxOEVldENLNnB4UEk4ZWVWd2FrT3piOGgraGRuQTQvOEVsODkyQWg1NXFXWHVJMlZhTC9jb2xmc2xqS0djalJDenZnNVZacVNFVXZnM3A4NHpYTUpzUDBrOExLeVpNbnJlWHBnVW5EQ3NnNlpoZTVNdkhwY21oMVRUU3JyZzF0cWxxWTlldEsvbld4SzJkZ3lkeUI2ZVVWMGxKRHFnMWVCdlc1S3JhRk5uVHBqVElnL3JuUUlUT0Q0UVZvODdObmkwK1ZRNnRySXBCMmVuKzA2RCtUa2VuM2huSUdxSlE2MW9HTFhtSkRHaWczQnZXNEg3amdsd3pUci85cVhnc0hrbHQzaERJeUVkVnBBTUUyUFZ0OHFoeGFYUlBOcWl1OVA1VGk5d3Bzai85ZjVSdG1MbWZBUnE5cjlWUnNTQVBseHFEZUJqL1Zwak5mK0pmU2xEQzlETmpjR0p5NFlLZVhQSWRHMXloNjdXY0kvTXJnVDZuay9uRG9CeG5aK0Z4NUFSVXpRS1cwWlIyNDVxbHlRd29vendiMXVORXUrTVVGenB2QzJzV0pVNTR6Qkx6MDhYZ05iSGgrVWRPOVRGcUFCU09FTVQ1ZERvMnVVZlNxc01qOUlhcnZJK2k0WGo3THl0eG1qTFdZZ1UvcEpUZWtnSEp2VUk4ZHZWYlc0bUg2alJEZHRndFA2b3FZRGgySmc4UCtRdll5WUpreVBNSE5GcDh1aDBiWHFBcUlvSmZjSDBMeFVUN0c1RGpSbjZ1VFhERURGTDFXd3NKYnJtVWd1U0VGbEh1RCtqcWpxUkM5K0pldGF5VWZ4S1BmRjluaTArWHdWdGVpSWE0eStKTTcvaWpTTlBHUFhmSW9ab0JLNmNwcUVwek1raGhTN0ovY0RPcnhoRGtIUCtXdW1Fc0lidnFRQXBsOVpsVTZpRWZId2RuaTArWFE2QnBoSWZ6bGNlNXU1QS9SOXp2QzMyTkpQN3ZrTkpZelFOQnJZWk54bHNjS1F3b29TMWRvQXZYd09nMi8vaXYwOHRlcndmREY3Mk1rUFA4a1BsME9qYTVsdHhzSDhuR2JYa251OFhQNXpUUkxNUU1FdmZpdHBKWEJrSVZlR3ZVd2tLdUpPM2hGdTYwcHlBQVlqak9uNkNub0ZSM3RZSXhQbDBPcmEvaTIrTGhJUTV2aTZ5ZjZ3NVNjbzE1K0VKNktHU0JTeXRMcjZsOFVoaFRyMk02aUhnYmk5YUR3aW41dC9TME4wVjhFUUVvbkdXc2xyWkZUYkpyaTArWFE2cHJnSVUwRmVyVXA3dnNQZUhTaWZ5TVppaGtnNk1WR2VOYjFHa01HZXFuVXc4R3hNTDNDMlh5YTJxV1NEdUxwaDM1TThlbHlhSFZOOE5CMWVJbkNId0w5eE9Mc01XTVJ2TzJmaXhuNGlGNGFRd1o2cWRURG91T3I5TXA4bFFRTUJ1UnlmaXpnVkhOVGZMb2NXbDBUckRpZUJaK3FUWG4wRTZWYmtDaGkyMU5YeWdBdUNQanlyN0VZVW16d2NoYjFrQ2swL0I1S240RGVITDFTdEVveFBJS3ZTcG5pMCtYUTZwcUFYdWRUcWpiRmZYOEx2VDJYTTMzRVBnamZwbElHY0VxdktnYzVNRnNNS2FEY1d0VERicEdHMy9ZNXZWS0w0YlFrU1cyVDRJc1E5RlZFVTN5NkhGcGR5OVByR3BCVWJjcWd2NDZ1blpub1FrMjRoWWRTQmpMMGd1Zjg5UlpEaXQ5VHRoYjE4QVc0Qjc4b2tCdm9sVm9NejNEZTRGT1NMejZnVHlLYTR0UGwwT3BhZnNYeGJDVmRtMkxGVTFXN3BPaUNaLzZQMUdGZWN5a0RscVhwM21KSVR5K2Qrb3EvaXVHbjN2Uyt5d05iek15OUJpR0c4WGZwTGZIcGNtaDFMVSt2OHpGZG04cmY1VnlEcWcvb2dRUjRWOGlBWlhMZld3d3BmaDQxV2RUeml6QUUvRFFuRktSUEovUFNjT1V3dWR6S0VrN3NKckxFZHpjV3NHdDVlcDByRzdvMkZhT2YyQnowTklzM1JxeUZERmpvdFZrTVJWZGJadXZaYWxFUEYybStTNjhVRzM3cGxDNUJ2MENXcjBmSGRPbmJHcDh1aDFiWDh1L0xPblJydmsybDZKKzl2SHU0bW1ueXUwSUdNTDM0L21pekdJb3kyWFcwamRXaUhuYUUzZ2FiTDlBckxTMzlZOFNTcTZNUXczaUNZNHBQbDBPcmExbVF3djNGZ2pZVjl2MCsrSmRFRFl6cVVjZ0FUcWxqK2JWWkRFV1RCeTYyMWFRZXpxTXk4SXM2VDJaRURTKzlKOS9wK09TL0ZOcndSY2xxQ3R3TmE0bnZEaXprWGNQMDJ1ZGJxM09QYzA2cWJGTVorbnVmOHY0aisxZCtVS3VPaFF3UTlHSzdkV2N4bE5Lcld0ajl4RnIxc002NGloa0p2ZWlWamtmWUVIc0drcXJJSzlaU1oxY3hodEhIZkUzeDNZR0Z2R3VZWGhPSVFkbW1JdlNIcndxOEpwazU5NVl5QmdoNnNlOHluTVZRdEFlUHdLZVhlSzM2YXVRdXhsVUlwRmROcFh2c0lMM1M1REZiTEhmTXlPcFI5REY2UTN5NkhGcGR3MWxiUVFqS05oV2dmNDQyR0h0SllqZi91RElHY0VwYjFyQ3pHSXI2Vis2QjJxUWVUazZ1aGVRSWZyQzhxNmxaK2xSQmVxVmQ3MWs3cFplY2hsN285YTBodmp1d2tIZE5UaTlsbTJhSDB6a2VJdjNxaysxM2hidDJQalZBMFl2N3RvNnpHTUwwcW1xdzY2bzJxWWNOZFhXMUVmejJCb3dONDgvbERSV21Gd0RXY1FWdk9KUmpHTHhoMHNkM0N4YnlybUY2SmI5YjBiY3BqLzdScFNZOFY2NUNuVjRVK3JvQmlsN3ZRYnR4RGwvVkc0b0FVREdQMUNiMXNLSElEMkJCZW5YNFUrUk5SZEVMeklkV0FuSEhjaXQrL1FkS3BKUmY2dmlVT2JTNmhrRUsxdkMxYlVyUGhUZm40UEtxMTZzZFBjK0UzNjB0UlF6Z2xMYXZDOCtSc2NWWDlZWkNBUGhuSGEveGlHRlRqeHZxYkdRSnZZaU1Md2xmV3NiazgwdTJvTVk4SE1GdmVoWkFuWVJmNnZpVU9iUzZKcWFYdGsxeDMxOHg0dm42Qks5ejVNL0xYQkVET0tXdkw2Tk9WT29taTZHd1hncGUvOGV2d0d6cWNTeG42WWpwRlRJYmc5aWxlVGpoSmY0KzVjQTUrWXRGdWh1N1JCM2ZMVmpJdTRicGRYNC85eW56YkdsVE5mb1ZCeWMvaWhpZzZVV25iclVZQ3RlSW90MDFJYVJ0Nml1OENrVnNqcWJwRlc5bVFwTmdQajlBcnRleDFPRkFhTklYODBzWjN6MVl5THNtMmJrNVdOb1VQa0NkUVBXaXN0ekNXTVFBL3ZYb3RWNUMwa3RyaUtWWHRmcWpnRTA5aFkvNVZVUzdDQ01NdmNMcDE3NFBpS0tYOElBS2J3RUtYaWM2MG9oZnl2alVPVFM2SmxrU21Teit3SGc1OUd1KzVycVVNSUJUeWgvUHVaZ01CZGxOUXZCV0VFZWJlaDBwZDNxRkl4WHFqU2ZVelhoc3FTWGxZZmFzL1lwNEFSUXRndXZpdXdjTGVkY2s5T29zL3FqUjc3VkY5cWNnYlFrREZuclZKa004dmJ6a056YjFnQzZNN09BSXhwNXpHUFE4UFlnUjBzdC9weU1BVjdDVENONVJVZE80NkNXdUtyNTdzSkIzVFpvQnRUODFxUXFMVit2TjJWbnhVTUtBbFY1NlF6bDZuZGNibS9xWGlNYVNweUI2Z1lPanp6a1RUYS84OUN2Y0J3dHZvZldFbTVBMDhkMkVoYnhyZ2srM1JWTXZhWnVpSzhUNWlSSENuUGRIMDZMWjQxekVBSHlQeXRPck14a0syZ2lHc0UvQUdwdjZ2WDhSNG8rbjEvbDJlY0Y1Q0hja1pFcTJKbHlpcG4rM2hZdW5zRDVVeEhjUEZnU3VDZWdWVGIya2JZcFVNZWozdkZ5dVZRVkgvS3lzSzJFZ1F5K1VPcHVoUEwzMkNWaGpVMy9nVDNaU092ckJqemVrTHNGZEdYcngvSnFqRjBBMGhrR1hQaVk3a09UeDNZTUZnV3NDZWtWVEwybWJvZ3RvdS9NdWw1UGoyYmFQcmlKV0NLY1NCbUJyOFY4RXRSa0tWZ3lvSG1MYkc5U2cvcEJPdEphWG9kZWJNZVIzdmVQOWRDczlwdlR4eTMvbVY4ZnhDbmVQZHAyTDQ3c0hDeExYc3Q1RVV5OXhteUtIaU5OL1F6M2JBZDBwNXNVbFF3a0RzTEd1RGhkOUZONW1LRUFvT1FCUHIyc1c5WjRPUVFlZm85ZXpyL1YvbTh2VEt6bFg2SlIwYXhOM3RGM1Fqdy80Vjh2UytBdzV0THFXOVNhYWVvbmJWSWQrcjRpWTNvMTcxdVZvZ0p4TEdORFRxN0Vaa3RIcnQvanBiZXFEUEdSVzJOeUIrbzFVOHp2OThqdm9rRjRBK0JNeXVZRjlhN0tqN1Vhd1pWNFgzMDFZa0xqMms1UG9MWnlwVGZWUzk5M25TdjZvZ1M4WTZnQ3c5T29YQ29HTmN6SU45U0M3NzVRcGVqMDBPbjFPOXQ1c2JuTTM2dVA3dEluRXJrbjFsY0xtUC9tT3JNN2Y4RDgrOTc1OTJlTGt0dFBZWXRMd2RMaGZaZmNXamsvajJqLzVKMytsYkE4YkwvL3ZYUHNQQU5Bb0pHOTVQQ2dBQUFBQVNVVk9SSzVDWUlJPSIvPgogIDx1c2UgaWQ9ImJpcmRfbWFjcm9uIiB4PSIyNTkiIHk9IjEyIiB4bGluazpocmVmPSIjaW1hZ2UiLz4KICA8dXNlIGlkPSJiaXJkX21hY3Jvbi0yIiBkYXRhLW5hbWU9ImJpcmRfbWFjcm9uIiB4PSI2NzYiIHk9IjEyIiB4bGluazpocmVmPSIjaW1hZ2UiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ 485:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/IMG_3585.c3acbf9e.jpg";

/***/ }),

/***/ 486:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Kawika-Patrick-Shaka.66c116ac.jpg";

/***/ }),

/***/ 487:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Kawika-Shaka.b05d5d6c.jpg";

/***/ }),

/***/ 488:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/bumper_sticker_final.fba91ccd.jpg";

/***/ }),

/***/ 489:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Waikiki Aquarium.708a7b53.jpg";

/***/ }),

/***/ 490:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/background_painting.70884aa0.svg";

/***/ }),

/***/ 491:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/bumper_sticker.f852b9a9.png";

/***/ }),

/***/ 144:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/camera.cee7947b.png";

/***/ }),

/***/ 492:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2NDAgNTEyIj48cGF0aCBkPSJNNTM3LjYgMjI2LjZjNC4xLTEwLjcgNi40LTIyLjQgNi40LTM0LjYgMC01My00My05Ni05Ni05Ni0xOS43IDAtMzguMSA2LTUzLjMgMTYuMkMzNjcgNjQuMiAzMTUuMyAzMiAyNTYgMzJjLTg4LjQgMC0xNjAgNzEuNi0xNjAgMTYwIDAgMi43LjEgNS40LjIgOC4xQzQwLjIgMjE5LjggMCAyNzMuMiAwIDMzNmMwIDc5LjUgNjQuNSAxNDQgMTQ0IDE0NGgzNjhjNzAuNyAwIDEyOC01Ny4zIDEyOC0xMjggMC02MS45LTQ0LTExMy42LTEwMi40LTEyNS40em0tMTMyLjkgODguN0wyOTkuMyA0MjAuN2MtNi4yIDYuMi0xNi40IDYuMi0yMi42IDBMMTcxLjMgMzE1LjNjLTEwLjEtMTAuMS0yLjktMjcuMyAxMS4zLTI3LjNIMjQ4VjE3NmMwLTguOCA3LjItMTYgMTYtMTZoNDhjOC44IDAgMTYgNy4yIDE2IDE2djExMmg2NS40YzE0LjIgMCAyMS40IDE3LjIgMTEuMyAyNy4zeiIvPjwvc3ZnPg=="

/***/ }),

/***/ 493:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/coloring_book_flyer.d6849a14.jpg";

/***/ }),

/***/ 494:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEsAAABkCAQAAABkvQWCAAAB8klEQVR42u3XA6xdURCF4b+2otq2FKON9GKrjC3VthvXts04tW3bdqc7am54NO/caTNrhZff0QYA9GUpF7nGFaVeZxeF2c0NNtOfRBmIqPcthXmLEMo4YqcTgn6vUJgrf1+fS8ysz5UlTCZW7uXJin/GrufOEqYQmStFYAnTbbICzCZLmGuTFWA2WQFmkyVMtskS5tpkCVNssoTpNlkBZpMlTLHJEubaZAmTbbKEuTZZwnibLKHEJut8DqwUC/Mv+bBuIYn6qrRYlyhMCzrRLnY70iqHs5UmpcV6TxmLLKGHTdYpmyzhEJ0tskI5xSoWsDhRlzETAstebbIeOstZzsq5znLWD65xkSupezn0nTZrIw3IntqM02R9oTJaOaPHuoheVthkLdO8iNXQykXNW34vrcmeusxXH7cyDhCXuMwXH+Uz1VnO+sJMhjKAwak7kEGM5aEuqwSdNOGdHushetmixzplc6p+gl52aN5bQ9BJTz7rDhALFZ7Eqfz8/8YtZznLt69rlbavIzRZnymHVk7qsS7YnBOv2GR9ow5auaZ5yx+hPeUpS7nUDd+lPkv1x61HPOBhpn7/F4dTZznLWc5ylrOc5SxnOeuqQdYjuG+Q9QwOG2Q9hn4GWcMAZhhD7QcAGMRxHvCYh0Xto9BzDAP4A9rLBVVf818UAAAAAElFTkSuQmCC"

/***/ }),

/***/ 216:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 217:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAQAAAC0NkA6AAACwklEQVR42qyWAWRbQRjH771uL3l96ZJs2GZotzIsK9LWlBUFWkBRAIApoBSNAQqgigB0BalNBh36YAXRTkPoQNEqBhGmkGiLCu+/Ty6XJnn3cpf1fh9c7r5+vzS5fO9jOrjz3ppdSBylG6wd6UbiyC54a+48ezjejLPtXFpgEWHBuXS2vZn/Fyw5vg2mETYc31saWuBOxvZl738ULylGpf9TbN+dZPqMrVp33QUcLOIzfJRQQ5OiRiufdhbh9IruxlY1FdZe9x9mkUcVUVTpNNsr2lMKJlJepVtwAB0OekReZSLFonmTci/uk7cwDFtdGvfidbTG/S3SxnGKYTnFeEdDleQ8KoqUOdQRptEXYeqY62ioWphnn8TxNAL08xcZPOmLDO32E2C6o6GKvbx6Lo5e4BphSmCSKCHMNVUQ51S1m8RPcXAOGSdSyQlknHfOqeo9Tz+qblRZKikrbxpVFri/+NZbwIgEVIlnUGVOckp0qUNjksNOR0tOtSSxPN94BxiTgKrxnHieS6r85Y5RyY6QVEmRyvIXj1E3KqlTRZ6VzLJkji8XAKMSYEFIcmzkO19uGpdstrPIwL7wpW9c4rezyDDygy+PjUuO21lksG9bdwA145Ia4lxyy9gNb4tN45KmaJU3NoszDZzIXTVksP7ofFxnYJI40/q4yMB2o7/4AOt4j1l8QEYqydDJLGWsIxjwxVu7jBWir3DA34sy4ggGXeGC4sdY1pKUFT9GZVspKhVFdVtRN8iNgYoNjQap1epXIhUreq1e66EVebu0H1o6j98rpEOKNK60Hr/agwRQCUkqgP4goRqJBF97FN9A6I9E6uFOkIPIykGgPdypx1TBcitnGQL1mKoYuOVkKOQoB+5/w+w6EAQEuw506ATRpTtHx44p/bvYhAcLKjAGCyqwDhbQYdiDvgM49B+KosugGgDppXv1sb/UiwAAAABJRU5ErkJggg=="

/***/ }),

/***/ 495:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/dreams_of_paradise.bc75ba4c.jpg";

/***/ }),

/***/ 496:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 497:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/film_strip.71b465f3.svg";

/***/ }),

/***/ 498:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 499:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/gofundme.dca8e60b.png";

/***/ }),

/***/ 500:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/main.8a95814b.jpg";

/***/ }),

/***/ 501:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/papa_reserve.f6caa0f2.png";

/***/ }),

/***/ 502:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/patreon.865acfd6.svg";

/***/ }),

/***/ 503:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MTIgNTEyIj48cGF0aCBkPSJNMjU2IDhDMTE5IDggOCAxMTkgOCAyNTZzMTExIDI0OCAyNDggMjQ4IDI0OC0xMTEgMjQ4LTI0OFMzOTMgOCAyNTYgOHptLTE2IDMyOGMwIDguOC03LjIgMTYtMTYgMTZoLTQ4Yy04LjggMC0xNi03LjItMTYtMTZWMTc2YzAtOC44IDcuMi0xNiAxNi0xNmg0OGM4LjggMCAxNiA3LjIgMTYgMTZ2MTYwem0xMTIgMGMwIDguOC03LjIgMTYtMTYgMTZoLTQ4Yy04LjggMC0xNi03LjItMTYtMTZWMTc2YzAtOC44IDcuMi0xNiAxNi0xNmg0OGM4LjggMCAxNiA3LjIgMTYgMTZ2MTYweiIvPjwvc3ZnPg=="

/***/ }),

/***/ 504:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0NDggNTEyIj48cGF0aCBzdHlsZT0iZmlsbDojMDAyMzQ4IiBkPSJNMTQ0IDQ3OUg0OGMtMjYuNSAwLTQ4LTIxLjUtNDgtNDhWNzljMC0yNi41IDIxLjUtNDggNDgtNDhoOTZjMjYuNSAwIDQ4IDIxLjUgNDggNDh2MzUyYzAgMjYuNS0yMS41IDQ4LTQ4IDQ4em0zMDQtNDhWNzljMC0yNi41LTIxLjUtNDgtNDgtNDhoLTk2Yy0yNi41IDAtNDggMjEuNS00OCA0OHYzNTJjMCAyNi41IDIxLjUgNDggNDggNDhoOTZjMjYuNSAwIDQ4LTIxLjUgNDgtNDh6Ii8+PC9zdmc+"

/***/ }),

/***/ 505:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pip_logo.217e0754.png";

/***/ }),

/***/ 506:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MTIgNTEyIj48cGF0aCBkPSJNMjU2IDhDMTE5IDggOCAxMTkgOCAyNTZzMTExIDI0OCAyNDggMjQ4IDI0OC0xMTEgMjQ4LTI0OFMzOTMgOCAyNTYgOHptMTE1LjcgMjcybC0xNzYgMTAxYy0xNS44IDguOC0zNS43LTIuNS0zNS43LTIxVjE1MmMwLTE4LjQgMTkuOC0yOS44IDM1LjctMjFsMTc2IDEwN2MxNi40IDkuMiAxNi40IDMyLjkgMCA0MnoiLz48L3N2Zz4="

/***/ }),

/***/ 507:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0NDggNTEyIj48cGF0aCBzdHlsZT0iZmlsbDojMDAyMzQ4IiBkPSJNNDI0LjQgMjE0LjdMNzIuNCA2LjZDNDMuOC0xMC4zIDAgNi4xIDAgNDcuOVY0NjRjMCAzNy41IDQwLjcgNjAuMSA3Mi40IDQxLjNsMzUyLTIwOGMzMS40LTE4LjUgMzEuNS02NC4xIDAtODIuNnoiLz48L3N2Zz4="

/***/ }),

/***/ 508:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 218:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iODAiIGhlaWdodD0iOTIiIHZpZXdCb3g9IjAgMCA4MCA5MiI+CiAgPG1ldGFkYXRhPjw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+Cjx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQyIDc5LjE2MDkyNCwgMjAxNy8wNy8xMy0wMTowNjozOSAgICAgICAgIj4KICAgPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICAgICAgPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIvPgogICA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgCjw/eHBhY2tldCBlbmQ9InciPz48L21ldGFkYXRhPgo8aW1hZ2UgaWQ9InNvbmctbm90ZSIgd2lkdGg9IjgwIiBoZWlnaHQ9IjkyIiB4bGluazpocmVmPSJkYXRhOmltYWdlL3BuZztiYXNlNjQsaVZCT1J3MEtHZ29BQUFBTlNVaEVVZ0FBQUZBQUFBQmNDQVFBQUFCVDJ2cGRBQUFBQkdkQlRVRUFBTEdQQy94aEJRQUFBQ0JqU0ZKTkFBQjZKZ0FBZ0lRQUFQb0FBQUNBNkFBQWRUQUFBT3BnQUFBNm1BQUFGM0NjdWxFOEFBQUFBbUpMUjBRQUFLcU5JeklBQUFBSmNFaFpjd0FBQ3hJQUFBc1NBZExkZnZ3QUFBQUhkRWxOUlFmaUF4a05DQU9rNFRvTkFBQUR6VWxFUVZSbzN1M2FTMHhVVnh6SDhlOU1xWFVhb2tYU1l0RHBJQ0NJU0J3R0h5aTFhVk9yTldsamlPbXVxWnZLVnBZMjFYVFJyYTJyUHBJbVhaa21qUVlYR25WanFqRm9BNm1JUERvNnRDQ0J4a2V4QWFQTTFBNy9MaVl3Z0RQbG5uTmZzemkvdTJESVBmOHpuM3VZY3gvRENRZ0ZtUlUwc0lrbzY0cjhsaXpJU2lyWXhCdHNwSW8xQUV3VUF2QVZJclFRbzVaS1ZoTmNzQy9wSDdDRUNQVnNvWmtJcXdua2ErWTFzSXdJMVd5bWdVYks4ck84Qm9hb3A0RmFZc1FvVlN0MUV4Z2lUQ1BOMUxHZVN0MU9uQWNXVTg0V2RsRkRCV3Q0eVc1M1RnR0xxYUNLSnQ2a2t0ZnNzNXdDcnFTYWRkU3htU2JDdk9BY3l4NndpUFUwVVVzZDJ3aTdnZElITHVkVG9sUlJ3NHR1dzJZVFVMb1dsM0xQNHpQbmVGQ3B1VERsS1E5UUEvb1FBelJBdjJPQUJ1aDNDaDVZQ0U5MTJkeGxpSDUrNWlDdGhRUjhSQyszNk9NbWNaNEFzRGU3MHovZ245d2t6Z0FEakhCLzBiNmluQzg5eVFRSnJ0SERIUkw4YmFYQUMyQ2F2eGhoa0M2NkdlV2hXckdid0RGR0dhU1RYeG5ua1c0bnpnTW42YWVmUVhyb2RlTDIxaW5nRk4wTWNKdEJFb3c3ZWJ6MmdKUGM1VHBkSlBqRFdaWVR3QzRPTThvOVp0eUIyUWZHK2NWZFdpYjYxMktQbm93TC9tYkJBQTNRN3hpZ0Fmb2RBelJBdjJPQUJ1aDNETkFBL1k0QkdxRGZNVUM3OGZ0Yi9oVlVFcU9SRW9La3VjOTFlaGtpVlJqQXR6akFmdFl1V3NFMVRTZXIvQWNlb0kwOU9mZUUyRDMvVnorQTFaemdmYXVOdlFlMjhpMWwxcHN2TllzRExHUFozS2NrYlp2WHpta1ZYdjRSTENOR2xHWmVKNFNRWkpoT3V2a2RlMnR5UCtHRWNvMDh2NzBqcCtTaDVNcUkvRFAzK2tkQmNkc3VUMFUxWTR0SGNCZkhlRGZ2MFVSc2pON0xmRU5Jdld3K3NJUXZhSFB0eS9FUGlXbFVTUmE0Z1pNMHVZU0RJSWUwNnA3TkFqZHkwZFcxZ0RWczE2b2J5NXhtMW5MVzVhV0tVYzB6YmxjRytJUCtLbDJMZVZXcmFvYU9JUERSLzh6Yi9MR3dTRnU3OVd6T2NTMUlpS05heGROS3JSOW92RU9TSXhCa0w3VmFRTFYvN2Zmd3IvSTdmTVp2RUZ4NGM2T1FHMHF0YjNOZXNmL2pmQVdBWEZXKy9JaUlwS1JhOFVMWEltbUYvby9QMWlGeExlQlB5bGRpNUxERnZoL0l4OWtxcEUrRE55TXRHa0NrWFpJV0RuM0Izd2JwMEFCK3JjVkRrQjF5V1dieTlEb3BGK1R0eFJYV0J6NmJUZ2xwQXhGa3Azd3ZOMlJxcnI5bmtwRHpja1FpdVZvSHBKeSsrVTlSUzJhQUR4alduUG5aQkFoVFJ6RUJVZ3d6UkRKdlMwSGFGRWJ2a29SdGpaN3lsdm54blNWY1dyNlU1ZDd5Wk82Vy8vTWw1OWVWNXovQVhnS1JiWEpHVWpscGo2VkQ5dm1CeTB5UytSL0lLTyt4bFJyS0FVZ3hSSnh1THBPd1BTbTA4eCtRRlA1UGFYWUxXZ0FBQUFCSlJVNUVya0pnZ2c9PSIvPgo8L3N2Zz4K"

/***/ }),

/***/ 509:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 510:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 511:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MTIgNTEyIj48cGF0aCBkPSJNMjU2IDhDMTE5IDggOCAxMTkgOCAyNTZzMTExIDI0OCAyNDggMjQ4IDI0OC0xMTEgMjQ4LTI0OFMzOTMgOCAyNTYgOHptMTIxLjYgMzEzLjFjNC43IDQuNyA0LjcgMTIuMyAwIDE3TDMzOCAzNzcuNmMtNC43IDQuNy0xMi4zIDQuNy0xNyAwTDI1NiAzMTJsLTY1LjEgNjUuNmMtNC43IDQuNy0xMi4zIDQuNy0xNyAwTDEzNC40IDMzOGMtNC43LTQuNy00LjctMTIuMyAwLTE3bDY1LjYtNjUtNjUuNi02NS4xYy00LjctNC43LTQuNy0xMi4zIDAtMTdsMzkuNi0zOS42YzQuNy00LjcgMTIuMy00LjcgMTcgMGw2NSA2NS43IDY1LjEtNjUuNmM0LjctNC43IDEyLjMtNC43IDE3IDBsMzkuNiAzOS42YzQuNyA0LjcgNC43IDEyLjMgMCAxN0wzMTIgMjU2bDY1LjYgNjUuMXoiLz48L3N2Zz4="

/***/ }),

/***/ 512:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 513:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/wavy_music_sheet.e4a0113f.png";

/***/ }),

/***/ 112:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 14:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.media = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    @media (max-width: ', 'em) {\n      ', '\n    }\n  '], ['\n    @media (max-width: ', 'em) {\n      ', '\n    }\n  ']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(10);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(133);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _styledComponents = __webpack_require__(7);
	
	var _Footer = __webpack_require__(80);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	__webpack_require__(112);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var sizes = {
	  giant: 1170,
	  desktop: 992,
	  tablet: 768,
	  phone: 814
	};
	
	// iterate through the sizes and create a media template
	var media = exports.media = Object.keys(sizes).reduce(function (accumulator, label) {
	  // use em in breakpoints to work properly cross-browser and support users
	  // changing their browsers font-size: https://zellwk.com/blog/media-query-units/
	  var emSize = sizes[label] / 16;
	  accumulator[label] = function () {
	    return (0, _styledComponents.css)(_templateObject, emSize, _styledComponents.css.apply(undefined, arguments));
	  };
	  return accumulator;
	}, {});
	
	var TemplateWrapper = function TemplateWrapper(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: 'Papahanaumokuakea',
	      meta: [{ name: 'description', content: 'Sample' }, { name: 'keywords', content: 'sample, something' }]
	    }),
	    _react2.default.createElement(
	      'div',
	      {
	        style: {
	          margin: '0 auto',
	          paddingTop: 0
	        }
	      },
	      children()
	    )
	  );
	};
	
	TemplateWrapper.propTypes = {
	  children: _propTypes2.default.func
	};
	
	exports.default = TemplateWrapper;

/***/ }),

/***/ 243:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n\nopacity: ', '\ntransition: opacity 1s;\n\n'], ['\n\nopacity: ', '\ntransition: opacity 1s;\n\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Header = __webpack_require__(235);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Title = __webpack_require__(241);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	var _Mission = __webpack_require__(236);
	
	var _Mission2 = _interopRequireDefault(_Mission);
	
	var _Purpose = __webpack_require__(237);
	
	var _Purpose2 = _interopRequireDefault(_Purpose);
	
	var _Contest = __webpack_require__(231);
	
	var _Contest2 = _interopRequireDefault(_Contest);
	
	var _Related_Links = __webpack_require__(238);
	
	var _Related_Links2 = _interopRequireDefault(_Related_Links);
	
	var _Contact = __webpack_require__(230);
	
	var _Contact2 = _interopRequireDefault(_Contact);
	
	var _Banner = __webpack_require__(227);
	
	var _Banner2 = _interopRequireDefault(_Banner);
	
	var _BumperStickerSignUp = __webpack_require__(228);
	
	var _BumperStickerSignUp2 = _interopRequireDefault(_BumperStickerSignUp);
	
	var _Coloring = __webpack_require__(229);
	
	var _Coloring2 = _interopRequireDefault(_Coloring);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Page = _styledComponents2.default.div(_templateObject, function (props) {
	    return props.mounted ? '1;' : '0;';
	});
	
	var IndexPage = function (_React$Component) {
	    _inherits(IndexPage, _React$Component);
	
	    function IndexPage(props) {
	        _classCallCheck(this, IndexPage);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.state = {
	            mounted: false,
	            playing: true,
	            showEvent: true
	        };
	        _this.stopPlaying = _this.stopPlaying.bind(_this);
	        _this.togglePlaying = _this.togglePlaying.bind(_this);
	        return _this;
	    }
	
	    IndexPage.prototype.togglePlaying = function togglePlaying() {
	        this.setState(function (prevState, props) {
	            var playing = !prevState.playing;
	            return { playing: playing };
	        });
	    };
	
	    IndexPage.prototype.stopPlaying = function stopPlaying() {
	        this.setState({
	            playing: false
	        });
	    };
	
	    IndexPage.prototype.componentDidMount = function componentDidMount() {
	        var _this2 = this;
	
	        setTimeout(function () {
	            _this2.setState({ mounted: true });
	        }, 250);
	    };
	
	    IndexPage.prototype.render = function render() {
	        var _this3 = this;
	
	        return _react2.default.createElement(
	            Page,
	            { mounted: this.state.mounted },
	            _react2.default.createElement(_Header2.default, {
	                togglePlaying: function togglePlaying() {
	                    return _this3.togglePlaying();
	                },
	                playing: this.state.playing,
	                stopPlaying: function stopPlaying() {
	                    return _this3.stopPlaying();
	                }
	            }),
	            _react2.default.createElement(_Title2.default, null),
	            _react2.default.createElement(_Coloring2.default, null),
	            _react2.default.createElement(_Banner2.default, null),
	            _react2.default.createElement(_BumperStickerSignUp2.default, null),
	            _react2.default.createElement(_Mission2.default, { stopPlaying: function stopPlaying() {
	                    return _this3.stopPlaying();
	                } }),
	            _react2.default.createElement(_Purpose2.default, null),
	            _react2.default.createElement(_Contest2.default, null),
	            _react2.default.createElement(_Related_Links2.default, null),
	            _react2.default.createElement(_Contact2.default, null)
	        );
	    };
	
	    return IndexPage;
	}(_react2.default.Component);
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-0c8312f37f23bcd57ff4.js